export const codingPracticesData = {
  python: [
    {
      id: "practice-python-1",
      title: "Coding Practice - 1",
      description: "Introduction to Python basic concepts",
      accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
      questions: [
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1-001",
          title: "Hello World",
          difficulty: "Easy",
          description: "Write a program that prints Hello World as output.",
          sampleInput: "Hello World",
          sampleOutput: "Hello World",
          testCases: [
            { input: "Hello World", output: "Hello World", visible: true },
          ],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1-002",
          title: "Three Hashes",
          difficulty: "Easy",
          description:
            "Write a program that prints three hashes (#) as output.",
          sampleInput: "",
          sampleOutput: "###",
          testCases: [{ input: "", output: "###", visible: true }],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1-003",
          title: "Simple Addition",
          difficulty: "Easy",
          description:
            "Write a program that takes two numbers as input and prints their sum.",
          sampleInput: "5\n3",
          sampleOutput: "8",
          testCases: [
            { input: "5\n3", output: "8", visible: true },
            { input: "10\n20", output: "30", visible: true },
            { input: "-5\n8", output: "3", visible: false },
            { input: "0\n0", output: "0", visible: false },
            { input: "100\n200", output: "300", visible: false },
          ],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "practice-python-2",
      title: "Coding Practice - 2",
      description: "Variables and Data Types",
      accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
      questions: [
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-2-001",
          title: "Sum of 2495 and 789358",
          difficulty: "Easy",
          description:
            "Write a program that prints two numbers, 2495 and 789358",
          sampleInput: "",
          sampleOutput: "791853",
          testCases: [
            {
              input: "",
              output: "791853",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-2-002",
          title: "Substraction",
          difficulty: "Easy",
          description: "Subtract 596 from 193856",
          sampleInput: "",
          sampleOutput: "193260",
          testCases: [{ input: "", output: "193260", visible: true }],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "practice-python-3",
      title: "Coding Practice - 3",
      description: "Sequence of Instructions",
      accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
      questions: [
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-3-001",
          title: "Product of 37, 61 and 391",
          difficulty: "Medium",
          description:
            "Write a program that prints the product of three numbers, 37, 61, and 391",
          sampleInput: "",
          sampleOutput: "882487",
          testCases: [{ input: "", output: "882487", visible: true }],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-3-002",
          title: "Division",
          difficulty: "Easy",
          description: "Divide 33968 by 176",
          sampleInput: "",
          sampleOutput: "193.0",
          testCases: [{ input: "", output: "193.0", visible: true }],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-1A",
      title: "Coding Practice - 1A",
      description: "Input or output Basics",
      accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
      questions: [
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-001",
          title: "Print the Input",
          difficulty: "Easy",
          description:
            "Write a program that reads a single line of input and print the given input.",
          sampleInput: "Bat",
          sampleOutput: "Bat",
          testCases: [
            { input: "5", output: "5", visible: true },
            { input: "Ball", output: "Ball", visible: true },
            { input: "10", output: "10", visible: false },
            { input: "Number", output: "Number", visible: false },
            { input: "20", output: "20", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-002",
          title: "Print the Input - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the word and `###` on two lines.\n Input: The input will be a single line containing a string.\n Output: The first line of output should be a string containing the given word.\n The second line of output should be string containing `###` ",
          sampleInput: "Algebra",
          sampleOutput: `Algebra\n###`,
          testCases: [
            { input: "5", output: "5\n###", visible: true },
            { input: "Ball", output: "Ball\n###", visible: true },
            { input: "10", output: "10\n###", visible: false },
            { input: "Number", output: "Number\n###", visible: false },
            { input: "20", output: "20\n###", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-003",
          title: "Print the Input - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads the two words and prints the two words on two lines. ",
          sampleInput: "Apple\nBanana",
          sampleOutput: "Apple\nBanana",
          testCases: [
            { input: "Hi\nhello", output: "Hi\nhello", visible: true },
            { input: "Dog\nCat", output: "Dog\nCat", visible: true },
            { input: "Fruits\nveg", output: "Fruits\nveg", visible: false },
            { input: "Number\ndigit", output: "Number\ndigit", visible: false },
            {
              input: "Banglore\nHyderbad",
              output: "Banglore\nHyderbad",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-004",
          title: "Second Line",
          difficulty: "Easy",
          description:
            "For this problem,you need to write code to read two lines of input and print the second line of input.",
          sampleInput: "Fundamentals\nPython",
          sampleOutput: "Python",
          testCases: [
            { input: "Hi\nhello", output: "hello", visible: true },
            { input: "50\n100", output: "100", visible: true },
            { input: "Fruits\nveg", output: "veg", visible: false },
            { input: "Number\ndigit", output: "digit", visible: false },
            { input: "Banglore\nHyderbad", output: "Hyderbad", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-005",
          title: "Print in Reverse Order",
          difficulty: "Easy",
          description:
            "Write a program that reads two lines of input and prints those lines in reverse order.\n(Print the message given in the second line of input before the first line of input).",
          sampleInput: "Book\nPen",
          sampleOutput: "Pen\nBook",
          testCases: [
            { input: "300\n400", output: "400\n300", visible: true },
            { input: "Java\npython", output: "python\nJava", visible: true },
            { input: "Fruits\nveg", output: "veg\nFruits", visible: false },
            { input: "Number\ndigit", output: "digit\nNumber", visible: false },
            {
              input: "Banglore\nHyderbad",
              output: "Hyderbad\nBanglore",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-006",
          title: "Hello World",
          difficulty: "Medium",
          description:
            "Write a program that takes a word W as input and Prints `Hello` followed by the given word W.\nand There should be space after Hello.",
          sampleInput: "World",
          sampleOutput: "Hello World",
          testCases: [
            { input: "Ganesh", output: "Hello Ganesh", visible: true },
            { input: "Python", output: "Hello Python", visible: true },
            { input: "10", output: " Hello 10", visible: false },
            { input: "Number", output: " Hello Number", visible: false },
            { input: "20", output: "Hello 20", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-007",
          title: "Print the input - 4",
          difficulty: "Easy",
          description:
            "For this problem,you need to write code to read a single line of input and print the line after the message `Given input:`.",
          sampleInput: "World",
          sampleOutput: "Given input: World",
          testCases: [
            {
              input: "happy new year",
              output: "Given input: happy new year",
              visible: true,
            },
            { input: "Python", output: "Given input: Python", visible: true },
            { input: "10", output: "Given input: 10", visible: false },
            { input: "Number", output: "Given input: Number", visible: false },
            { input: "20", output: "Given input: 20", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-008",
          title: "Join Words",
          difficulty: "Easy",
          description:
            "Write a program that reads two words and prints the resultant word by joining the two words.",
          sampleInput: "Milk\nshake",
          sampleOutput: "Milkshake",
          testCases: [
            { input: "Hand\nshake", output: "Handshake", visible: true },
            {
              input: "Python\nProgram",
              output: "PythonProgram",
              visible: true,
            },
            {
              input: "Java\nFundamentals",
              output: "JavaFundamentals",
              visible: false,
            },
            { input: "Number\none", output: " Numberone", visible: false },
            { input: "20\n40", output: "2040", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-009",
          title: "Full Name",
          difficulty: "Easy",
          description:
            "A Job applicant is filling out an application form.He entered his first name and last name.\nYour task is to print his full name by joining his first name and last name with a space.",
          sampleInput: "Harry\nPotter",
          sampleOutput: "Harry Potter",
          testCases: [
            { input: "Hand\nshake", output: "Hand shake", visible: true },
            {
              input: "Python\nProgram",
              output: "Python Program",
              visible: true,
            },
            {
              input: "Java\nFundamentals",
              output: "Java Fundamentals",
              visible: false,
            },
            { input: "Number\none", output: " Number one", visible: false },
            { input: "20\n40", output: "20 40", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1A-0010",
          title: "Print Name and Age",
          difficulty: "Medium",
          description:
            "Write a program that reads the name and age of a person and prints them in the given format.\nInput:The first line of input contains a string.Second line of input contains an intiger.\nOutput:The output should be a single line containing a string in the format shown in the output sample.",
          sampleInput: "John\n24",
          sampleOutput: "John is 24 years old",
          testCases: [
            {
              input: "Oliver\n25",
              output: "Oliver is 25 years old",
              visible: true,
            },
            {
              input: "Arthur\n23",
              output: "Arthur is 23 years old",
              visible: true,
            },
            {
              input: "Henry\n22",
              output: "Henry is 22 years old",
              visible: false,
            },
            {
              input: "Emma\n28",
              output: "Emma is 28 years old",
              visible: false,
            },
            {
              input: "Eleanor\n30",
              output: "Eleanor is 30 years old",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-1B",
      title: "Coding Practice - 1B",
      description: "Input or output Basics",
      questions: [
        {
          id: "q-python-1B-001",
          title: "String Repetition",
          difficulty: "Easy",
          description:
            "Write a program to print the given input word three times in a single line separed by spaces",
          sampleInput: "orange",
          sampleOutput: "orange orange orange",
          testCases: [
            { input: "Apple", output: "Apple Apple Apple", visible: true },
            { input: "100", output: "100 100 100", visible: true },
            { input: "bat", output: "bat bat bat", visible: false },
            { input: "car", output: "car car car", visible: false },
            { input: "van", output: "van van van", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1B-002",
          title: "Simple Square",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple square using star(*).",
          sampleInput: "",
          sampleOutput: "**\n**",
          testCases: [{ input: "", output: "**\n**", visible: true }],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1B-003",
          title: "Simple Square - 2",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple square using star(*).\nNote:There is a space after every star.",
          sampleInput: "",
          sampleOutput: "* *\n* *",
          testCases: [{ input: "", output: "* * \n* * ", visible: true }],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1B-004",
          title: "Simple Triangle",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple Triangle using star(*).\nPrint a star on the first line and two stars on the second line.",
          sampleInput: "",
          sampleOutput: "*\n**",
          testCases: [{ input: "", output: "*\n**", visible: true }],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1B-005",
          title: "Simple Triangle - 2",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple Triangle using star(*).\nPrint a star on the first line and two stars on the second line.\nNote:There is a space after every star.",
          sampleInput: "",
          sampleOutput: "*\n* * ",
          testCases: [{ input: "", output: "*\n* * ", visible: true }],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1B-006",
          title: "Stars",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the word in `* * * Word * * *` format.\nInput:The input will be a single line cpntaining a string.\nOutput:Output should be a single line containing a string in the format shown in the sample output.",
          sampleInput: "Welcome",
          sampleOutput: "* * * Welcome * * *",
          testCases: [
            {
              input: "OneSolution",
              output: "* * * OneSolution * * *",
              visible: true,
            },
            {
              input: "Hyderbad",
              output: "* * * Hyderbad * * *",
              visible: true,
            },
            { input: "Ganesh", output: "* * * Ganesh * * *", visible: false },
            { input: "apple", output: "* * * apple * * *", visible: false },
            { input: "Mysore", output: "* * * Mysore * * *", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1B-007",
          title: "First Character",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the first Character of the word",
          sampleInput: "Python",
          sampleOutput: "P",
          testCases: [
            { input: "Apple", output: "A", visible: true },
            { input: "Mango", output: "M", visible: true },
            { input: "bat", output: "b", visible: false },
            { input: "car", output: "c", visible: false },
            { input: "van", output: "v", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1B-008",
          title: "Third Character",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the Third Character of the word",
          sampleInput: "java",
          sampleOutput: "v",
          testCases: [
            { input: "Microbio", output: "c", visible: true },
            { input: "Ramesh", output: "m", visible: true },
            { input: "bat", output: "t", visible: false },
            { input: "Driver", output: "i", visible: false },
            { input: "heart", output: "a", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1B-009",
          title: "First and Last digits",
          difficulty: "Easy",
          description:
            "Given a four-digit Number `N` as input.Write a program to print first and last digit of the number.\nOutput:Print the first digit in the first line and the last digit in the second line.",
          sampleInput: "1246",
          sampleOutput: "1\n6",
          testCases: [
            { input: "6578", output: "6\n8", visible: true },
            { input: "2479", output: "2\n9", visible: true },
            { input: "3458", output: "3\n8", visible: false },
            { input: "9876", output: "9\n6", visible: false },
            { input: "3271", output: "3\n1", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1B-0010",
          title: "Reverse the digits",
          difficulty: "Medium",
          description:
            "Write a program to reverse the digits of a given two-digit number.",
          sampleInput: "56",
          sampleOutput: "65",
          testCases: [
            { input: "95", output: "59", visible: true },
            { input: "24", output: "42", visible: true },
            { input: "34", output: "43", visible: false },
            { input: "98", output: "89", visible: false },
            { input: "38", output: "83", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-1C",
      title: "Coding Practice - 1C",
      description: "Input or output Basics",
      questions: [
        {
          id: "q-python-1C-001",
          title: "Length of the String",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the Length of the word.\nInput:The input will be a single line containing a string.\nOutput:Prints the number of Characters in the word.",
          sampleInput: "Software",
          sampleOutput: "8",
          testCases: [
            { input: "python", output: "6", visible: true },
            { input: "Bhumi", output: "5", visible: true },
            { input: "Ravi", output: "4", visible: false },
            { input: "kushi", output: "5", visible: false },
            { input: "dev", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1C-002",
          title: "Star Repetition",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints Stars(*) equal to the Length of the word.",
          sampleInput: "Simple",
          sampleOutput: "******",
          testCases: [
            { input: "python", output: "******", visible: true },
            { input: "Bhumi", output: "*****", visible: true },
            { input: "Ravi", output: "****", visible: false },
            { input: "kushi", output: "*****", visible: false },
            { input: "dev", output: "***", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1C-003",
          title: "Substract 1 from String Length",
          difficulty: "Medium",
          description:
            "Write a program that reads a word and prints L-1 ,where `L` is the Length of the word.\nInput:Input will be a single line containing a string.\nOutput:The output should be a single line containing an integer obtained after subtracting 1 from the Length of the word.",
          sampleInput: "Ice",
          sampleOutput: "2",
          testCases: [
            { input: "cake", output: "3", visible: true },
            { input: "man", output: "2", visible: true },
            { input: "Ravi", output: "3", visible: false },
            { input: "kushi", output: "4", visible: false },
            { input: "dev", output: "2", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1C-004",
          title: "Index of last Character",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the index of last Character of the word.",
          sampleInput: "orange",
          sampleOutput: "5",
          testCases: [
            { input: "lion", output: "3", visible: true },
            { input: "rabbit", output: "5", visible: true },
            { input: "Ravi", output: "3", visible: false },
            { input: "kushi", output: "4", visible: false },
            { input: "dev", output: "2", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1C-005",
          title: "Last Character",
          difficulty: "Easy",
          description:
            "Write a program which prints the last character of a given word.",
          sampleInput: "january",
          sampleOutput: "y",
          testCases: [
            { input: "boat", output: "t", visible: true },
            { input: "tiger", output: "r", visible: true },
            { input: "Ravi", output: "i", visible: false },
            { input: "kushi", output: "i", visible: false },
            { input: "dev", output: "v", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1C-006",
          title: "Length excluding Characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the Length of the word excluding the first and last character.",
          sampleInput: "April",
          sampleOutput: "3",
          testCases: [
            { input: "boating", output: "5", visible: true },
            { input: "donkey", output: "4", visible: true },
            { input: "Ravi", output: "2", visible: false },
            { input: "kushi", output: "3", visible: false },
            { input: "dev", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1C-007",
          title: "Star Repetition - 2",
          difficulty: "Medium",
          description:
            "Write a program that reads a word  and prints the first letter of the given word and stars (*) instead of other letters.",
          sampleInput: "November",
          sampleOutput: "N*******",
          testCases: [
            { input: "December", output: "D*******", visible: true },
            { input: "June", output: "J***", visible: true },
            { input: "Ravi", output: "R***", visible: false },
            { input: "kushi", output: "k****", visible: false },
            { input: "dev", output: "d**", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1C-008",
          title: "Half length of string",
          difficulty: "Easy",
          description:
            "Write a program that reads a word  and prints half the length of the word.",
          sampleInput: "zebra",
          sampleOutput: "2.5",
          testCases: [
            { input: "mysore", output: "3.0", visible: true },
            { input: "June", output: "2.0", visible: true },
            { input: "Ravi", output: "2.0", visible: false },
            { input: "kushi", output: "2.5", visible: false },
            { input: "dev", output: "1.5", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-1A",
      title: "Assignment-1A",
      description: "Input or output Basics",
      questions: [
        {
          id: "q-python-Assignment-1A-001",
          title: "Simple Rectangle",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple Rectangle using stars(*).\nNote:There is a space after every star.",
          sampleInput: "",
          sampleOutput: "* * \n* * \n* * \n* * \n* * ",
          testCases: [
            {
              input: "",
              output: "* * \n* * \n* * \n* * \n* * ",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-1A-002",
          title: "Simple Square -3",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple square using stars(*).\nNote:Print three stars on the first line,Three stars on the second line , Three stars on the third line and There is a space after every star.",
          sampleInput: "",
          sampleOutput: "* * * \n* * * \n* * * \n* * * \n* * * ",
          testCases: [
            {
              input: "",
              output: "* * * \n* * * \n* * * \n* * * \n* * * ",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-1A-003",
          title: "Simple Triangle -3",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple Triangle using stars(*).\nNote:There is a space after every star.",
          sampleInput: "",
          sampleOutput: "* \n* * \n* * * ",
          testCases: [
            {
              input: "",
              output: "* \n* * \n* * * ",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-1A-004",
          title: "Star - 2",
          difficulty: "Medium",
          description:
            "Write a program that reads a word and prints the word in the given format.\nNote:Number of stars before and after the word is equal to the length of the word.\nExplanation:If the given word is `code`.\nThe length of the word `code`is 4.\nAdd 4 stars and a space before the word `code`.\nAdd a space and 4 stars aafter the word `code`.",
          sampleInput: "Code",
          sampleOutput: "**** Code ****",
          testCases: [
            { input: "dog", output: "*** dog ***", visible: true },
            { input: "number", output: "****** number ******", visible: true },
            { input: "cat", output: "*** cat ***", visible: false },
            { input: "animal", output: "****** animal ******", visible: false },
            { input: "xerox", output: "***** xerox *****", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1A-005",
          title: "Second word in first word",
          difficulty: "Medium",
          description:
            "Write a program that reads two words w1 and w2. w2 is the at the beginning of w1.\nInput:The first line of input contains a string representing w1.The second line of input contains a string representing w2.\nOutput:The output should be a single line containing an integer that is the index at which the word `W2` ends in the word `w1`.",
          sampleInput: "midterm\nmid",
          sampleOutput: "2",
          testCases: [
            { input: "unkind\nun", output: "1", visible: true },
            { input: "number\nnum", output: "2", visible: true },
            { input: "catdog\ncat", output: "2", visible: false },
            { input: "number\nnum", output: "2", visible: false },
            { input: "number\nnum", output: "2", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1A-006",
          title: "Print in reverse order - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two words `A` and `B`,and prints the given words in reverse order separated by `###`.",
          sampleInput: "cat\nrat",
          sampleOutput: "rat\n###\ncat",
          testCases: [
            { input: "man\ngirl", output: "girl\n###\nman", visible: true },
            { input: "dog\nsnake", output: "snake\n###\ndog", visible: true },
            { input: "bus\ncar", output: "car\n###\nbus", visible: false },
            { input: "num\nbun", output: "bun\n###\nnum", visible: false },
            { input: "buss\ncars", output: "cars\n###\nbuss", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1A-007",
          title: "First and last Characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints the first and last characters of the word on two lines",
          sampleInput: "lemon",
          sampleOutput: "l\nn",
          testCases: [
            { input: "manage", output: "m\ne", visible: true },
            { input: "snake", output: "s\ne", visible: true },
            { input: "carrot", output: "c\nt", visible: false },
            { input: "num", output: "n\nm", visible: false },
            { input: "buss", output: "b\ns", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1A-008",
          title: "First letters",
          difficulty: "Easy",
          description:
            "You are given three strings as input.Write a program to print the first character of each string.\nNote:print output in a single line.",
          sampleInput: "lemon\nbag\nball",
          sampleOutput: "lbb",
          testCases: [
            { input: "manage\ndoll\nbig", output: "mdb", visible: true },
            { input: "snake\nrat\neagle", output: "sre", visible: true },
            { input: "csnake\nrat\neagle", output: "cre", visible: false },
            { input: "num\nlove\nhate", output: "nlh", visible: false },
            { input: "apple\ngrapes\nmango", output: "agm", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1A-009",
          title: "Star Repetition - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints first and last characters of the given string and prints the stars(*)instead of the remaining characters.",
          sampleInput: "Apple",
          sampleOutput: "A***e",
          testCases: [
            { input: "Manage", output: "M****e", visible: true },
            { input: "banana", output: "b****a", visible: true },
            { input: "Experiment", output: "E********t", visible: false },
            { input: "Bingo", output: "B***o", visible: false },
            { input: "Fox", output: "F*x", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-1D",
      title: "Coding Practice - 1D",
      description: "Type Conversions",
      questions: [
        {
          id: "q-python-1D-001",
          title: "Sum of two numbers",
          difficulty: "Easy",
          description:
            "Write a program to print the sum od two integer inputs A and B.",
          sampleInput: "20\n40",
          sampleOutput: "60",
          testCases: [
            { input: "2\n5", output: "7", visible: true },
            { input: "8\n4", output: "12", visible: true },
            { input: "30\n5", output: "35", visible: false },
            { input: "10\n5", output: "15", visible: false },
            { input: "6\n5", output: "11", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1D-002",
          title: "Division of two numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and prints the Division of two numbers (A/B).",
          sampleInput: "15\n5",
          sampleOutput: "3.0",
          testCases: [
            { input: "25\n5", output: "5.0", visible: true },
            { input: "8\n4", output: "2.0", visible: true },
            { input: "30\n5", output: "6.0", visible: false },
            { input: "10\n5", output: "2.0", visible: false },
            { input: "45\n5", output: "9.0", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1D-003",
          title: "Area of reactnagle",
          difficulty: "Easy",
          description:
            "Write a program to calculate the area of Rectangle.\nInput:The first line of input contains the length of rectangle,which is an integer.The second line of  input contains the breadth of rectangle,which is an integer.\nOutput:Print the area of rectangle.\nNote:Area of rectangle= Length * breadth",
          sampleInput: "5\n3",
          sampleOutput: "15",
          testCases: [
            { input: "5\n5", output: "25", visible: true },
            { input: "8\n4", output: "32", visible: true },
            { input: "30\n5", output: "150", visible: false },
            { input: "10\n5", output: "50", visible: false },
            { input: "4\n5", output: "20", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1D-004",
          title: "Perimeter of reactnagle",
          difficulty: "Easy",
          description:
            "Write a program to calculate the perimeter of Rectangle.\nInput:The first line of input contains the length of the rectangle,which is an integer.The second line of input contains the breadth of the rectangle,which is an integer.\nOutput:Print the perimeter of rectangle.\nNote:Perimeter of rectangle=2(length+Breadth).",
          sampleInput: "3\n5",
          sampleOutput: "16",
          testCases: [
            { input: "5\n5", output: "20", visible: true },
            { input: "8\n4", output: "24", visible: true },
            { input: "3\n5", output: "16", visible: false },
            { input: "10\n5", output: "30", visible: false },
            { input: "4\n5", output: "18", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1D-005",
          title: "Division of two numbers - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and prints the division of two numbers(A/B)as an integer.\nInput:First line of input contains an integer.Second line of input contains an integer.\nOutput:The output should be a single line containing an integer that is integer value of the result obtained from the division of two numbers.",
          sampleInput: "10\n4",
          sampleOutput: "2",
          testCases: [
            { input: "10\n5", output: "2", visible: true },
            { input: "15\n4", output: "3", visible: true },
            { input: "10\n5", output: "2", visible: false },
            { input: "25\n5", output: "5", visible: false },
            { input: "50\n5", output: "10", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1D-006",
          title: "Substraction of two numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and prints the Substraction of two numbers(A-B).\nInput:First line of input contains an float.Second line of input contains an float.\nOutput:The output should be a single line containing an float obtained by the Substraction of two numbers.",
          sampleInput: "5.5\n2.3",
          sampleOutput: "3.2",
          testCases: [
            { input: "6.5\n3.2", output: "3.3", visible: true },
            { input: "8.4\n5.3", output: "3.1", visible: true },
            { input: "8.4\n5.3", output: "3.1", visible: false },
            { input: "2.5\n1.1", output: "1.4", visible: false },
            { input: "5.6\n5.6", output: "0.0", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1D-007",
          title: "Percentage of boys",
          difficulty: "Easy",
          description:
            "Write a program that reads the Percentage of girls in a class and prints the Percentage of boys in the class.\nInput:The Input will be a single line containing an integer.\nOutput:The output should be a single line containing an integer that is the percentage of boys in the class.\nNote:Total percentage of boys and girls in a class is 100.",
          sampleInput: "30",
          sampleOutput: "70",
          testCases: [
            { input: "40", output: "60", visible: true },
            { input: "20", output: "80", visible: true },
            { input: "50", output: "50", visible: false },
            { input: "30", output: "70", visible: false },
            { input: "25", output: "75", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1D-008",
          title: "Sum of two numbers - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers and prints the sum of two numbers in the given format.\nInput:The first line of input contains a float,The second line of input contains a float.\nOutput:The output should be a single line containing a string in the format shown in the sample output.",
          sampleInput: "30.0\n40.0",
          sampleOutput: "sum: 70.0",
          testCases: [
            { input: "40.3\n20.0", output: "sum: 60.3", visible: true },
            { input: "20.0\n10.0", output: "sum: 30.0", visible: true },
            { input: "50.4\n10.3", output: "sum: 60.7", visible: false },
            { input: "20.0\n10.0", output: "sum: 30.0", visible: false },
            { input: "50.4\n10.3", output: "sum: 60.7", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1D-009",
          title: "Kilometers to meter",
          difficulty: "Medium",
          description:
            "Write a program to take the number of Kilometers as an input and convert into meters and prints the number of meter.\nInput:The first line of input contains the number of Kilometers.The input will have decimal part.\nOutput:The first lie of output contains the number of meters.The output should be an integer.",
          sampleInput: "1.2",
          sampleOutput: "1200",
          testCases: [
            { input: "4.3", output: "4300", visible: true },
            { input: "2.5", output: "2500", visible: true },
            { input: "50.2", output: "50200", visible: false },
            { input: "2.1", output: "2100", visible: false },
            { input: "1.1", output: "1100", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1D-0010",
          title: "Percentage",
          difficulty: "Medium",
          description:
            "Write a program that reads a percentage `P` and prints the percentage `p` of the number 200.\nInput:The input will be a single line containing an integer.\nOutput:The output should be a single line containing a float that is the P percentage of 200.\nNote:Percentage(p)=(n/100)*number",
          sampleInput: "50",
          sampleOutput: "100.0",
          testCases: [
            { input: "40", output: "80.0", visible: true },
            { input: "30", output: "60.0", visible: true },
            { input: "40", output: "80.0", visible: false },
            { input: "30", output: "60.0", visible: false },
            { input: "50", output: "100.0", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1D-0011",
          title: "Remainder",
          difficulty: "Easy",
          description:
            "Write a program that reads a dividend and divisor and prints the remainder.",
          sampleInput: "7\n2",
          sampleOutput: "1",
          testCases: [
            { input: "10\n2", output: "0", visible: true },
            { input: "30\n5", output: "0", visible: true },
            { input: "8\n3", output: "2", visible: false },
            { input: "30\n5", output: "0", visible: false },
            { input: "50\n2", output: "0", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-1E",
      title: "Coding Practice - 1E",
      description: "Type Conversions",
      questions: [
        {
          id: "q-python-1E-001",
          title: "Sum of the digits",
          difficulty: "Easy",
          description:
            "Write a program that prints the sum of the digits of given three-digit number.\nInput:The input will be a single line containing a three-digit number.\nOutput:The output should be a single line containing the sum of the three digits of the given number.",
          sampleInput: "564",
          sampleOutput: "15",
          testCases: [
            { input: "234", output: "9", visible: true },
            { input: "713", output: "11", visible: true },
            { input: "212", output: "5", visible: false },
            { input: "114", output: "6", visible: false },
            { input: "412", output: "7", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1E-002",
          title: "Indexing",
          difficulty: "Easy",
          description:
            "Given a word `W` and an integer N,Write a program to print the character present at the index N in the word `W`.",
          sampleInput: "dog\n1",
          sampleOutput: "o",
          testCases: [
            { input: "animal\n3", output: "m", visible: true },
            { input: "fox\n0", output: "f", visible: true },
            { input: "dear\n2", output: "a", visible: false },
            { input: "horse\n1", output: "o", visible: false },
            { input: "cat\n2", output: "t", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1E-003",
          title: "String Repetition - 2",
          difficulty: "Easy",
          description:
            "Given a word and number N,write a program to print the given word,N number of times in a single line.",
          sampleInput: "maths\n2",
          sampleOutput: "mathsmaths",
          testCases: [
            { input: "animal\n3", output: "animalanimalanimal", visible: true },
            { input: "dear\n2", output: "deardear", visible: true },
            { input: "fox\n2", output: "foxfox", visible: false },
            { input: "horse\n1", output: "horse", visible: false },
            { input: "cat\n2", output: "catcat", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1E-004",
          title: "First three characters",
          difficulty: "Easy",
          description:
            "Write a program to read a single line of input and print first three characters in it.",
          sampleInput: "maths",
          sampleOutput: "mat",
          testCases: [
            { input: "bhumika", output: "bhu", visible: true },
            { input: "ganesh", output: "gan", visible: true },
            { input: "python", output: "pyt", visible: false },
            { input: "horse", output: "hor", visible: false },
            { input: "billing", output: "bil", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1E-005",
          title: "part of a string",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and an index and prints a part of the word from the given index to the end of the word.",
          sampleInput: "goodnight\n4",
          sampleOutput: "night",
          testCases: [
            { input: "helloo\n2", output: "lloo", visible: true },
            { input: "unhappy\n2", output: "happy", visible: true },
            { input: "bhumika\n4", output: "ika", visible: false },
            { input: "horse\n1", output: "orse", visible: false },
            { input: "billing\n2", output: "lling", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1E-006",
          title: "part of a string - 2",
          difficulty: "medium",
          description:
            "Write a program that reads a word and two indices(x,y) and prints a part of the word from the index X to the index Y.",
          sampleInput: "goodnight\n4\n8",
          sampleOutput: "night",
          testCases: [
            { input: "helloo\n2\n4", output: "llo", visible: true },
            { input: "unhappy\n2\n6", output: "happy", visible: true },
            { input: "bhumika\n4\n6", output: "ika", visible: false },
            { input: "horse\n1\n4", output: "orse", visible: false },
            { input: "billing\n2\n6", output: "lling", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1E-007",
          title: "First N characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and number N and prints the first N characters of the word.\nInput:The first line of input contains a string.second line of input contains an integer.\nOutput:The output should be a single line containing a string that is the part of the word",
          sampleInput: "superman\n5",
          sampleOutput: "super",
          testCases: [
            { input: "manage\n3", output: "man", visible: true },
            { input: "unhappy\n2", output: "un", visible: true },
            { input: "bhumika\n5", output: "bhumi", visible: false },
            { input: "horse\n3", output: "hor", visible: false },
            { input: "billing\n4", output: "bill", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1E-008",
          title: "Last N characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and number N and prints the Last N characters of the word.\nInput:The first line of input contains a string.second line of input contains an integer.\nOutput:The output should be a single line containing a string that is the part of the word",
          sampleInput: "barber\n3",
          sampleOutput: "ber",
          testCases: [
            { input: "manago\n3", output: "ago", visible: true },
            { input: "unhappy\n2", output: "py", visible: true },
            { input: "bhumika\n5", output: "umika", visible: false },
            { input: "horse\n3", output: "rse", visible: false },
            { input: "billing\n4", output: "ling", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1E-009",
          title: "Second part of a string",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the second part of the string that has digits.\nNote:Given string contains two part-The first part contains only two characters.The second part contains only digits.",
          sampleInput: "of21",
          sampleOutput: "21",
          testCases: [
            { input: "ma55", output: "55", visible: true },
            { input: "un33", output: "33", visible: true },
            { input: "bh21", output: "21", visible: false },
            { input: "ho20", output: "20", visible: false },
            { input: "bi17", output: "17", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1E-0010",
          title: "First part of a string",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the First part of the string that has numbers.\nNote:Given string contains two part-The first part contains only digits .The second part contains only one character.",
          sampleInput: "15y",
          sampleOutput: "15",
          testCases: [
            { input: "21B", output: "21", visible: true },
            { input: "20G", output: "20", visible: true },
            { input: "12D", output: "12", visible: false },
            { input: "11M", output: "11", visible: false },
            { input: "32C", output: "32", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-1F",
      title: "Coding Practice - 1F",
      description: "Type Conversions",
      questions: [
        {
          id: "q-python-1F-001",
          title: "Half String",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the first half part of the string.",
          sampleInput: "amazon",
          sampleOutput: "ama",
          testCases: [
            { input: "bottle", output: "bot", visible: true },
            { input: "ganesh", output: "gan", visible: true },
            { input: "bhumik", output: "bhu", visible: false },
            { input: "applee", output: "app", visible: false },
            { input: "mangoo", output: "man", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1F-002",
          title: "String Repetition - 3",
          difficulty: "Easy",
          description:
            "Given a word and a number (N), write a program to print the last three characters of the word N times in a single line.\nInput:The first line of input contains a word.The second line of input contains the integer N which denotes the number of times the last three characters of word has to be repeated.\nOutput:The first line of output contains the last three characters of the given word repeated N times.\nNote:Note: There should not be any spaces between the repetitions.",
          sampleInput: "amazon\n2",
          sampleOutput: "zonzon",
          testCases: [
            { input: "bottle\n3", output: "tletletle", visible: true },
            { input: "cattle\n2", output: "tletle", visible: true },
            { input: "bhumika\n2", output: "ikaika", visible: false },
            { input: "applee\n3", output: "leeleelee", visible: false },
            { input: "mangoo\n2", output: "googoo", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1F-003",
          title: "String Repetition - 4",
          difficulty: "Medium",
          description:
            "You are given a string.Repeat the same string N times separate by space.",
          sampleInput: "message\n2",
          sampleOutput: "messaage message",
          testCases: [
            {
              input: "bottle\n3",
              output: "bottle bottle bottle ",
              visible: true,
            },
            { input: "ganesh\n2", output: "ganesh ganesh ", visible: true },
            { input: "bhumi\n2", output: "bhumi bhumi ", visible: false },
            { input: "car\n1", output: "car ", visible: false },
            { input: "mangoo\n2", output: "mangoo mangoo ", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-1F-004",
          title: "Star Repetition - 4",
          difficulty: "Medium",
          description:
            "Write a program that reads a word and prints the first two and last two letters of the word and prints the stars(*)instead of the remaining letters.",
          sampleInput: "manage",
          sampleOutput: "ma**ge",
          testCases: [
            {
              input: "waterr",
              output: "wa**rr",
              visible: true,
            },
            { input: "ganesh", output: "ga**sh", visible: true },
            { input: "bhumi", output: "bh*mi", visible: false },
            { input: "apple", output: "ap*le", visible: false },
            { input: "mangoo", output: "ma**oo", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1F-005",
          title: "Skip the fourth character",
          difficulty: "Medium",
          description:
            "Write a program that reads a word and prints the word excluding the fourth letter of the word.",
          sampleInput: "manage",
          sampleOutput: "mange",
          testCases: [
            {
              input: "bottle",
              output: "botle",
              visible: true,
            },
            { input: "ganesh", output: "gansh", visible: true },
            { input: "bhumii", output: "bhuii", visible: false },
            { input: "apple", output: "appe", visible: false },
            { input: "mangoo", output: "manoo", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1F-006",
          title: "Simple square - 4",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple square using the (#).",
          sampleInput: "",
          sampleOutput: "###\n###\n###",
          testCases: [
            {
              input: "",
              output: "###\n###\n###",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1F-007",
          title: "Simple Triangle - 4",
          difficulty: "Easy",
          description:
            "Write a program that prints a simple Triangle using the (+).",
          sampleInput: "",
          sampleOutput: "+\n++\n+++",
          testCases: [
            {
              input: "",
              output: "+\n++\n+++",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1F-008",
          title: "Stars - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints three lines with each line containing  N stars (*).\nNote:There is a space after every stars.",
          sampleInput: "2",
          sampleOutput: "* * \n* * \n* * ",
          testCases: [
            { input: "3", output: "* * * \n* * * \n* * * ", visible: true },
            { input: "2", output: "* * \n* * \n* * ", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-1F-009",
          title: "Skipping letters",
          difficulty: "Easy",
          description:
            "You are given a word and an index position of a character.You need to write a program that prints the given word without the character at the given index.",
          sampleInput: "combine\n4",
          sampleOutput: "combne",
          testCases: [
            { input: "apple\n2", output: "aple", visible: true },
            { input: "cat\n1", output: "ct", visible: true },
            { input: "bag\n1", output: "bg", visible: false },
            { input: "mouse\n1", output: "muse", visible: false },
            { input: "cat\n1", output: "ct", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-1B",
      title: "Assignment-1B",
      description: "Type Conversions",
      questions: [
        {
          id: "q-python-Assignment-1B-001",
          title: "Shape",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints three lines with each line containing N pluses(+).\nNote:There is a space after every + symbol.",
          sampleInput: "2",
          sampleOutput: "+ + \n+ + \n+ + ",
          testCases: [
            { input: "3", output: "+ + + \n+ + + \n+ + + ", visible: true },
            { input: "2", output: "+ + \n+ + \n+ + ", visible: true },
            { input: "1", output: "+ \n+ \n+ ", visible: true },
            {
              input: "5",
              output: "+ + + + + \n+ + + + + \n+ + + + + ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-1B-002",
          title: "Percentage - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N. N is divided into two parts X and Y.\nX is 30 percent of N.\n Y is the remaining percentage of N.print Y.\nNote:value=(percentage/100)*number",
          sampleInput: "50",
          sampleOutput: "35.o",
          testCases: [
            { input: "40", output: "28.0", visible: true },
            { input: "60", output: "42.0", visible: true },
            { input: "50", output: "35.0", visible: false },
            { input: "30", output: "21.0", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-1B-003",
          title: "Basic arithmetic",
          difficulty: "Easy",
          description:
            "Write a program to take two integer inputs (say A and B) and print the result of the following operations\n1.Addition\n2.Substraction\n3.Multiplication.",
          sampleInput: "4\n3",
          sampleOutput: "7\n1\n12",
          testCases: [
            { input: "4\n2", output: "6\n2\n8", visible: true },
            { input: "5\n3", output: "8\n2\n15", visible: true },
            { input: "10\n4", output: "14\n6\n40", visible: false },
            { input: "7\n7", output: "14\n0\n49", visible: false },
            { input: "2\n9", output: "11\n-7\n18", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1B-004",
          title: "Area and Perimeter of square",
          difficulty: "Easy",
          description:
            "You are given a side of square as input.Write a program to find the perimeter and area of the square.\nNote:Area of square = side * side \nPerimeter of square=4* side.",
          sampleInput: "3",
          sampleOutput: "area of square is:9\nperimeter of square is:12",
          testCases: [
            {
              input: "4",
              output: "area of square is:16\nperimeter of square is:16",
              visible: true,
            },
            {
              input: "5",
              output: "area of square is:25\nperimeter of square is:20",
              visible: true,
            },
            {
              input: "3",
              output: "area of square is:9\nperimeter of square is:12",
              visible: false,
            },
            {
              input: "3",
              output: "area of square is:9\nperimeter of square is:12",
              visible: false,
            },
            {
              input: "6",
              output: "area of square is:36\nperimeter of square is:24",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1B-005",
          title: "Part of a string - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a string A and prints the string A by excluding the first two and last two Characters of the string.",
          sampleInput: "#@gani#@",
          sampleOutput: "gani",
          testCases: [
            {
              input: "**uday**",
              output: "uday",
              visible: true,
            },
            {
              input: "@@pratibha**",
              output: "pratibha",
              visible: true,
            },
            {
              input: "##ekam##",
              output: "ekam",
              visible: false,
            },
            {
              input: "**dude**",
              output: "dude",
              visible: false,
            },
            {
              input: "&&ball&&",
              output: "ball",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1B-006",
          title: "Replace a letter",
          difficulty: "Medium",
          description:
            "Write a program that reads a word W,an Index I,and a letter C.Print the word W by replacing the letter at the index I with the given letter C.\nInputThe first line of input contains a string.The second line of input contains an intiger.The third line of input contains a string.\nOutput:The output should be a single line containing a string obtained by replacing the letter at the index `I` of the word `W` with the letter `C`",
          sampleInput: "prime\n3\nz",
          sampleOutput: "prize",
          testCases: [
            {
              input: "cell\n2\ni",
              output: "ceil",
              visible: true,
            },
            {
              input: "manage\n3\ne",
              output: "manege",
              visible: true,
            },
            {
              input: "manage\n3\ne",
              output: "manege",
              visible: false,
            },
            {
              input: "manage\n3\ne",
              output: "manege",
              visible: false,
            },
            {
              input: "manage\n3\ne",
              output: "manege",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1B-007",
          title: "Half string - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the second half part of the string",
          sampleInput: "football",
          sampleOutput: "ball",
          testCases: [
            {
              input: "heaven",
              output: "ven",
              visible: true,
            },
            {
              input: "call",
              output: "ll",
              visible: true,
            },
            {
              input: "ball",
              output: "ll",
              visible: false,
            },
            {
              input: "shalvi",
              output: "lvi",
              visible: false,
            },
            {
              input: "door",
              output: "or",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-1B-008",
          title: "Star Repetition - 5",
          difficulty: "Easy",
          description:
            "Write a program that reads two words W1 and W2.\nW1 contains two parts.The first part contains W2 and the second part contains the remaining letters in W1.\nPrint W1 with the first part as stars( * ).",
          sampleInput: "subway\nsub",
          sampleOutput: "***way",
          testCases: [
            {
              input: "volleyball\nvolley",
              output: "******ball",
              visible: true,
            },
            { input: "welcome\nwel", output: "***come", visible: true },
            { input: "subway\nsub", output: "***way", visible: false },
            { input: "subway\nsub", output: "***way", visible: false },
            { input: "subway\nsub", output: "***way", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-2A",
      title: "Coding Practice - 2A",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-2A-001",
          title: "Greater than 70",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and checks if the given number is greater than 70.\nInput:The input will be a single line containing  an integer.\nOutput:The output should be a single line containing a boolean.",
          sampleInput: "86",
          sampleOutput: "True",
          testCases: [
            { input: "40", output: "False", visible: true },
            { input: "87", output: "True", visible: true },
            { input: "60", output: "False", visible: false },
            { input: "30", output: "False", visible: false },
            { input: "90", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2A-002",
          title: "Greatest among two numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and checks if the first number is greater than the second number.",
          sampleInput: "86\n100",
          sampleOutput: "False",
          testCases: [
            { input: "40\n29", output: "True", visible: true },
            { input: "53\n90", output: "False", visible: true },
            { input: "40\n20", output: "True", visible: false },
            { input: "30\n10", output: "True", visible: false },
            { input: "90\n2", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2A-003",
          title: "Negative number",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and checks if the Given number is a Negative number.",
          sampleInput: "-21",
          sampleOutput: "True",
          testCases: [
            { input: "-2", output: "True", visible: true },
            { input: "4", output: "False", visible: true },
            { input: "-12", output: "True", visible: false },
            { input: "-3", output: "True", visible: false },
            { input: "-11", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2A-004",
          title: "equal to",
          difficulty: "Easy",
          description:
            "Write a program that reads two words and checks if the given two words are the same.\nInput:first and second line of input contains a string.\nOutput:The output should be a single line containing a boolean.",
          sampleInput: "jam\njam",
          sampleOutput: "True",
          testCases: [
            { input: "gan\ngan", output: "True", visible: true },
            { input: "ban\ngan", output: "False", visible: true },
            { input: "abc\nabc", output: "True", visible: false },
            { input: "abd\nabd", output: "True", visible: false },
            { input: "ab\nab", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2A-005",
          title: "Sunday",
          difficulty: "Easy",
          description:
            "Write a program that reads a day number and checks if the given day is a sunday.\nNote:If the given number is 7 than is True.(7=Sunday)",
          sampleInput: "7",
          sampleOutput: "True",
          testCases: [
            { input: "6", output: "False", visible: true },
            { input: "7", output: "True", visible: true },
            { input: "7", output: "True", visible: false },
            { input: "7", output: "True", visible: false },
            { input: "7", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2A-006",
          title: "Not Equal to",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers(integer) and checks if the given two numbers are not the same.",
          sampleInput: "7\n3",
          sampleOutput: "True",
          testCases: [
            { input: "6\n6", output: "False", visible: true },
            { input: "7\n3", output: "True", visible: true },
            { input: "7\n4", output: "True", visible: false },
            { input: "7\n5", output: "True", visible: false },
            { input: "7\n2", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2A-007",
          title: "Greater than or equal to",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if `A` is greater than or equal to `B`.Print the result as shown in the sample output.\nInput:first and second line of input contains a `float`.",
          sampleInput: "4.5\n2.3",
          sampleOutput: "A>=B is True",
          testCases: [
            { input: "6.9\n3.6", output: "A>=B is True", visible: true },
            { input: "7.2\n9.5", output: "A>=B is False", visible: true },
            { input: "7.2\n4.3", output: "A>=B is True", visible: false },
            { input: "7.9\n5.3", output: "A>=B is True", visible: false },
            { input: "7.3\n2.2", output: "A>=B is True", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2A-008",
          title: "Less than or equal to",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if `A` is Less than or equal to `B`.Print the result as shown in the sample output.\nInput:First  line of input contains an integer and second line of input contains a `float`.",
          sampleInput: "3\n4.2",
          sampleOutput: "True",
          testCases: [
            { input: "2\n3.6", output: "True", visible: true },
            { input: "7\n3.3", output: "False", visible: true },
            { input: "7\n3.3", output: "False", visible: false },
            { input: "7\n3.3", output: "False", visible: false },
            { input: "8\n2.2", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-2B",
      title: "Coding Practice - 2B",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-2B-001",
          title: "Greater than - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers(integer) A and B and checks if the A is greater than B.Prints the result as shown in the sample output.",
          sampleInput: "8\n7",
          sampleOutput: "A > B is True",
          testCases: [
            { input: "40\n39", output: "A > B is True", visible: true },
            { input: "57\n100", output: "A > B is False", visible: true },
            { input: "96\n29", output: "A > B is True", visible: false },
            { input: "30\n20", output: "A > B is True", visible: false },
            { input: "73\n10", output: "A > B is True", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2B-002",
          title: "Check one greater",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers(integer) A and B,and checks if B is greater than A by `one`.",
          sampleInput: "5\n6",
          sampleOutput: "True",
          testCases: [
            { input: "40\n39", output: "False", visible: true },
            { input: "81\n82", output: "True", visible: true },
            { input: "60\n91", output: "False", visible: false },
            { input: "30\n40", output: "False", visible: false },
            { input: "90\n91", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2B-003",
          title: "Compare first and last letters",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and checks if the first letter and last letter of the word are not the same.\nInput:The input will be a single line containing a string.\nOutput:Output should be a single line containing a boolean.True should be printed if the first letter and last letter of the word are not same,otherwise False should be printed.",
          sampleInput: "python",
          sampleOutput: "True",
          testCases: [
            { input: "label", output: "False", visible: true },
            { input: "gagan", output: "True", visible: true },
            { input: "bob", output: "False", visible: false },
            { input: "labe", output: "True", visible: false },
            { input: "camel", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2B-004",
          title: "Compare sum of the digits",
          difficulty: "Easy",
          description:
            "Write a program that reads a two digit number N. The N consist of only 2 digits.Check if the sum of the digits of N is greater than 7.",
          sampleInput: "45",
          sampleOutput: "True",
          testCases: [
            { input: "35", output: "True", visible: true },
            { input: "21", output: "False", visible: true },
            { input: "78", output: "True", visible: false },
            { input: "36", output: "True", visible: false },
            { input: "67", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2B-005",
          title: "Validate Password",
          difficulty: "Easy",
          description:
            "Write a program to check if the given string is a valid Password or not.A string is considered as a valid Password if the number of characters present is greater than 7",
          sampleInput: "12345",
          sampleOutput: "False",
          testCases: [
            { input: "ganesh23", output: "True", visible: true },
            { input: "21dhd", output: "False", visible: true },
            { input: "78hjdh", output: "False", visible: false },
            { input: "36hsh", output: "False", visible: false },
            { input: "67jdk", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2B-006",
          title: "Check Last Part of a String",
          difficulty: "Easy",
          description:
            "Write a program that reads two words A and B and checks if the second word B is the last part of the first word A.",
          sampleInput: "blackhole\nhole",
          sampleOutput: "True",
          testCases: [
            { input: "holesale\nsale", output: "True", visible: true },
            { input: "volleyball\nval", output: "False", visible: true },
            { input: "carll\ncar", output: "False", visible: false },
            { input: "axell\nax", output: "False", visible: false },
            { input: "abchdh\nav", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2B-007",
          title: "Check Part of a String",
          difficulty: "Easy",
          description:
            "Write a program that reads two words `A`,`B`,and an Index `I`.Check if `B` starts at index `I` in `A`",
          sampleInput: "black\nack\n2",
          sampleOutput: "True",
          testCases: [
            { input: "black\nack\n2", output: "True", visible: true },
            { input: "volleyball\nval\n3", output: "False", visible: true },
            { input: "black\nack\n2", output: "True", visible: false },
            { input: "black\nack\n2", output: "True", visible: false },
            { input: "black\nack\n2", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2B-008",
          title: "Compare first three characters",
          difficulty: "Easy",
          description:
            "Write a program to check if the first three characters in the two given strings are the same.",
          sampleInput: "apple\napps",
          sampleOutput: "True",
          testCases: [
            { input: "rabbit\nrabbis", output: "True", visible: true },
            { input: "catt\ncammel", output: "False", visible: true },
            { input: "book\nblood", output: "False", visible: false },
            { input: "calcium\nbed", output: "False", visible: false },
            { input: "mango\nmanage", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-2A",
      title: "Assignment-2A",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-Assignment-2A-001",
          title: "Compare digits",
          difficulty: "Easy",
          description:
            "Write a program that reads a two-digit number N and checks,if the number N is greater than 25.if the first digit of N is greater than the second digit of N.",
          sampleInput: "85",
          sampleOutput: "True\nTrue",
          testCases: [
            { input: "68", output: "True\nFalse", visible: true },
            { input: "14", output: "False\nFalse", visible: true },
            { input: "69", output: "True\nFalse", visible: false },
            { input: "58", output: "True\nFalse", visible: false },
            { input: "48", output: "True\nFalse", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-2A-002",
          title: "Compare first digit and last digit",
          difficulty: "Medium",
          description:
            "Write a program that reads two three-digit numbers A and B and checks if the first digit of A is less than the last digit of B.",
          sampleInput: "254\n353",
          sampleOutput: "True",
          testCases: [
            { input: "68\n23", output: "False", visible: true },
            { input: "14\n55", output: "True", visible: true },
            { input: "682\n234", output: "False", visible: false },
            { input: "68\n21", output: "False", visible: false },
            { input: "68\n29", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-2A-003",
          title: "Compare Last three characters",
          difficulty: "Medium",
          description:
            "Write a program to check if the last three characters in the two given strings are the same.",
          sampleInput: "apple\npimple",
          sampleOutput: "True",
          testCases: [
            { input: "sample\ndimple", output: "True", visible: true },
            { input: "cat\nbat", output: "False", visible: true },
            { input: "bangle\nsingle", output: "True", visible: false },
            { input: "bangle\nbus", output: "False", visible: false },
            { input: "bangle\nman", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-2A-004",
          title: "Percentage - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a percentage P and a number N and checks if the P percentage of 500 is equal to the number N.\nNote:Percentage(p)of 500 can be calculated as\nValue=(percentage/100)*500.\nInput:first line of input contains an integer representing P.The second line of input contains an integer representing N.\nOutput:The output should be a single line containing a boolean.True should be printed if the `P` percentage of 500 is equal to the number N,otherwise False should be printed.",
          sampleInput: "50\n250",
          sampleOutput: "True",
          testCases: [
            { input: "100\n500", output: "True", visible: true },
            { input: "10\n50", output: "True", visible: true },
            { input: "4\n20", output: "True", visible: false },
            { input: "5\n30", output: "False", visible: false },
            { input: "8\n40", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2A-005",
          title: "Compare area and perimeter",
          difficulty: "Easy",
          description:
            "Write a program that reads the length and breadth of the reactangle and checks if the area of the reactangle is less than or equal to the perimeter of the rectangle.\nNote:Area of rectangle=length * breadth \nPerimeter of Rectangle=2*(length+ breadth)",
          sampleInput: "3\n4",
          sampleOutput: "True",
          testCases: [
            { input: "4\n4", output: "True", visible: true },
            { input: "6\n4", output: "False", visible: true },
            { input: "4\n4", output: "True", visible: false },
            { input: "4\n4", output: "True", visible: false },
            { input: "4\n4", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2A-006",
          title: "Less than or equal to - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks, If A is less than or equal to B,If B is less than or equal to A.",
          sampleInput: "3\n4",
          sampleOutput: "A<=B is True\nB<=A is False",
          testCases: [
            {
              input: "8\n4",
              output: "A<=B is False\nB<=A is True",
              visible: true,
            },
            {
              input: "6\n4",
              output: "A<=B is False\nB<=A is True",
              visible: true,
            },
            {
              input: "3\n4",
              output: "A<=B is True\nB<=A is False",
              visible: false,
            },
            {
              input: "2\n4",
              output: "A<=B is True\nB<=A is False",
              visible: false,
            },
            {
              input: "1\n4",
              output: "A<=B is True\nB<=A is False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2A-007",
          title: "Profit",
          difficulty: "Easy",
          description:
            "Write a program that reads the selling price S and buying  price B of a product and checks if s is greater than B.\nInput: The first line of input contains an integer representing the selling price S.The second line of input contains  an integer representing the buying price B.\nOutput:output should be a single line containing a boolean ,True should be printed if S is greater than B,otherwise False should be printed",
          sampleInput: "300\n200",
          sampleOutput: "True",
          testCases: [
            {
              input: "800\n500",
              output: "True",
              visible: true,
            },
            {
              input: "600\n900",
              output: "False",
              visible: true,
            },
            {
              input: "800\n500",
              output: "True",
              visible: false,
            },
            {
              input: "800\n500",
              output: "True",
              visible: false,
            },
            {
              input: "800\n500",
              output: "True",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2A-008",
          title: "Check first part of a string",
          difficulty: "Easy",
          description:
            "Write a program that reads two strings S1 and S2,and checks if S2 is the first part of S1\nInput:The first line of input contains a string representing S1.The second line of input contains a string representing S2.\nOutput:The output should be a single line containing a boolean.True should be printed if S2 is the first part of S1, Otherwise False should be Printed .\nNote:No of characters in the first part of S1 is equal to the number of characters in S2",
          sampleInput: "rainbow\nrain",
          sampleOutput: "True",
          testCases: [
            {
              input: "heaven\nhea",
              output: "True",
              visible: true,
            },
            {
              input: "snake\nshall",
              output: "False",
              visible: true,
            },
            {
              input: "computer\ncom",
              output: "True",
              visible: false,
            },
            {
              input: "apple\napp",
              output: "True",
              visible: false,
            },
            {
              input: "python\njava",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2A-009",
          title: "Compare first N and Last N characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and a number N and checks if the first N characters of the string and the last N characters of the string are,not the same.\nInput:The first line of input contains a string.The second line of input contains an integer.\nOutput:The output should be a single line containing a boolean.True should be printed if the first N charactersof the string and the last N characters of the string are not the same,otherwise False should be printed.",
          sampleInput: "toronto\n2",
          sampleOutput: "False",
          testCases: [
            { input: "mango\n2", output: "True", visible: true },
            { input: "bulb\n1", output: "False", visible: true },
            { input: "toronto\n2", output: "False", visible: false },
            { input: "toronto\n2", output: "False", visible: false },
            { input: "toronto\n2", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-2C",
      title: "Coding Practice - 2C",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-2C-001",
          title: "Greater than 9",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if both the given numbers are greater than 9.",
          sampleInput: "11\n20",
          sampleOutput: "True",
          testCases: [
            { input: "8\n10", output: "False", visible: true },
            { input: "12\n10", output: "True", visible: true },
            { input: "10\n15", output: "True", visible: false },
            { input: "9\n20", output: "False", visible: false },
            { input: "5\n8", output: "False", visible: false },
            { input: "12\n9", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2C-002",
          title: "Negative numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if both the given numbers are Negative numbers",
          sampleInput: "-11\n-20",
          sampleOutput: "True",
          testCases: [
            { input: "-8\n10", output: "False", visible: true },
            { input: "-12\n-10", output: "True", visible: true },
            { input: "-5\n10", output: "False", visible: false },
            { input: "7\n20", output: "False", visible: false },
            { input: "8\n80", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2C-003",
          title: "positive number",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if one of the given numbers is positive number",
          sampleInput: "-11\n20",
          sampleOutput: "True",
          testCases: [
            { input: "-8\n-10", output: "False", visible: true },
            { input: "-12\n10", output: "True", visible: true },
            { input: "-6\n-10", output: "False", visible: false },
            { input: "-2\n-10", output: "False", visible: false },
            { input: "8\n15", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2C-004",
          title: "Not greater than 100",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if the sum of A and B is not greater than 100.",
          sampleInput: "11\n20",
          sampleOutput: "True",
          testCases: [
            { input: "60\n50", output: "False", visible: true },
            { input: "12\n10", output: "True", visible: true },
            { input: "89\n20", output: "False", visible: false },
            { input: "22\n90", output: "False", visible: false },
            { input: "8\n10", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2C-005",
          title: "Compare numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if both A and B are greater than 35 or A is greater than B.",
          sampleInput: "48\n20",
          sampleOutput: "True",
          testCases: [
            { input: "60\n50", output: "True", visible: true },
            { input: "8\n10", output: "False", visible: true },
            { input: "8\n10", output: "False", visible: false },
            { input: "8\n10", output: "False", visible: false },
            { input: "38\n10", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2C-006",
          title: "Compare numbers - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if one of the given number is a negative number and the sum of the given number is greater than 7",
          sampleInput: "13\n-3",
          sampleOutput: "True",
          testCases: [
            { input: "14\n-2", output: "True", visible: true },
            { input: "8\n10", output: "False", visible: true },
            { input: "8\n10", output: "False", visible: false },
            { input: "8\n10", output: "False", visible: false },
            { input: "38\n-10", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2C-007",
          title: "Compare numbers - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if both A and B are positive numbers or both A and B are less than 70.",
          sampleInput: "20\n50",
          sampleOutput: "True",
          testCases: [
            { input: "14\n80", output: "True", visible: true },
            { input: "8\n-10", output: "True", visible: true },
            { input: "18\n-10", output: "True", visible: false },
            { input: "-28\n10", output: "True", visible: false },
            { input: "90\n100", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2C-008",
          title: "Compare numbers - 4",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if one of A and B is less than 60 and one of A and B is greater than 80.",
          sampleInput: "50\n90",
          sampleOutput: "True",
          testCases: [
            { input: "40\n90", output: "True", visible: true },
            { input: "230\n70", output: "False", visible: true },
            { input: "180\n110", output: "False", visible: false },
            { input: "230\n70", output: "False", visible: false },
            { input: "238\n70", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-2D",
      title: "Coding Practice - 2D",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-2D-001",
          title: "between 25 and 75",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and checks if the given number is between 25 and 75",
          sampleInput: "30",
          sampleOutput: "True",
          testCases: [
            { input: "10", output: "False", visible: true },
            { input: "70", output: "True", visible: true },
            { input: "7", output: "False", visible: false },
            { input: "10", output: "False", visible: false },
            { input: "15", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2D-002",
          title: "Women",
          difficulty: "Easy",
          description:
            "Write a program that reads Three strings A,B and C, and checks if one of the given string is equal to `WOMEN`",
          sampleInput: "man\nmen\nwomen",
          sampleOutput: "True",
          testCases: [
            { input: "dog\ncat\nbus", output: "False", visible: true },
            { input: "man\nhen\nwomen", output: "True", visible: true },
            { input: "maan\nmen\nwomana", output: "False", visible: false },
            { input: "min\nman\nwomana", output: "False", visible: false },
            { input: "man\nmen\nwomana", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2D-003",
          title: "Less than 15",
          difficulty: "Easy",
          description:
            "Write a program that reads Three numbers A,B and C and checks if any of the given number is less than 15",
          sampleInput: "8\n12\n10",
          sampleOutput: "True",
          testCases: [
            { input: "18\n10\n20", output: "True", visible: true },
            { input: "25\n30\n30", output: "False", visible: true },
            { input: "20\n30\n26", output: "False", visible: false },
            { input: "18\n26\n40", output: "False", visible: false },
            { input: "22\n22\n77", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2D-004",
          title: "Not negative",
          difficulty: "Easy",
          description:
            "Write a program  that reads two numbers A and B,checks if both the given numbers are not negative.",
          sampleInput: "10\n15",
          sampleOutput: "True",
          testCases: [
            { input: "18\n20", output: "True", visible: true },
            { input: "25\n-30", output: "False", visible: true },
            { input: "20\n-22", output: "False", visible: false },
            { input: "18\n-22", output: "False", visible: false },
            { input: "22\n-11", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2D-005",
          title: "Not Less than 15",
          difficulty: "Easy",
          description:
            "Write a program  that reads two numbers A and B,checks if any of the given number is not less than 15",
          sampleInput: "10\n26",
          sampleOutput: "True",
          testCases: [
            { input: "18\n20", output: "True", visible: true },
            { input: "5\n10", output: "False", visible: true },
            { input: "2\n2", output: "False", visible: false },
            { input: "1\n2", output: "False", visible: false },
            { input: "2\n1", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2D-006",
          title: "Entrance",
          difficulty: "Easy",
          description:
            "Write a program  that reads an age A and guardian status s, and checks if the age A is between 12 and 60 or if the guardian status S is equal to Yes.\nNote:The guardian status will be either Yes or No",
          sampleInput: "15\nno",
          sampleOutput: "True",
          testCases: [
            { input: "18\nyes", output: "True", visible: true },
            { input: "12\nno", output: "False", visible: true },
            { input: "2\nno", output: "False", visible: false },
            { input: "1\nno", output: "False", visible: false },
            { input: "2\nno", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2D-007",
          title: "Compare numbers - 5",
          difficulty: "Easy",
          description:
            "Write a program  that reads two numbers A and B and checks if one of the given number is negative and product of the number is greater than or equal to `-46`.",
          sampleInput: "-15\n2",
          sampleOutput: "True",
          testCases: [
            { input: "18\n-1", output: "True", visible: true },
            { input: "12\n22", output: "False", visible: true },
            { input: "2\n-3", output: "True", visible: false },
            { input: "1\n80", output: "False", visible: false },
            { input: "2\n48", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2D-008",
          title: "Eligibility criteria",
          difficulty: "Medium",
          description:
            "Write a program  that reads the marks in Maths M,physics P and chemistry C,and checks if any of the below conditions is satisfied.\nM>=7o and P>=60 and C>=60 \nM+C+P>=180.",
          sampleInput: "100\n90\n0",
          sampleOutput: "True",
          testCases: [
            { input: "80\n80\n80", output: "True", visible: true },
            { input: "12\n22\n50", output: "False", visible: true },
            { input: "2\n10\n20", output: "False", visible: false },
            { input: "1\n80\n40", output: "False", visible: false },
            { input: "2\n40\n50", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2D-009",
          title: "Greater than Five",
          difficulty: "Easy",
          description:
            "Write a program to check if both of the given numbers are positive and if atleast one of them is greater than 5.\nNote:Zero is not a positive number.",
          sampleInput: "10\n90",
          sampleOutput: "True",
          testCases: [
            { input: "80\n-10", output: "False", visible: true },
            { input: "12\n15", output: "True", visible: true },
            { input: "2\n-10", output: "False", visible: false },
            { input: "1\n-20", output: "False", visible: false },
            { input: "2\n-23", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2D-0010",
          title: "Compare with 10",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and check if any one of the below conditions is satisfied.\nThe sum of A and B is less than 10.\nThe difference between A and B is less than 10.\nA is between 5 and 30.",
          sampleInput: "2\n70",
          sampleOutput: "True",
          testCases: [
            { input: "80\n10", output: "False", visible: true },
            { input: "2\n10", output: "True", visible: true },
            { input: "2\n70", output: "True", visible: false },
            { input: "1\n70", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-2E",
      title: "Coding Practice - 2E",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-2E-001",
          title: "Greater than five - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads Three numbers A,B and C,and checks if each of the given number is greater than 5.",
          sampleInput: "30\n6\n10",
          sampleOutput: "True",
          testCases: [
            { input: "10\n4\n3", output: "False", visible: true },
            { input: "70\n50\n6", output: "True", visible: true },
            { input: "8\n30\n2", output: "False", visible: false },
            { input: "8\n3\n2", output: "False", visible: false },
            { input: "3\n3\n6", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2E-002",
          title: "Greater than or equal to 20",
          difficulty: "Easy",
          description:
            "Write a program that reads Three numbers A,B and C,and checks if each of the given number is greater than or equal to 20",
          sampleInput: "30\n20\n22",
          sampleOutput: "True",
          testCases: [
            { input: "10\n4\n3", output: "False", visible: true },
            { input: "70\n50\n26", output: "True", visible: true },
            { input: "8\n30\n2", output: "False", visible: false },
            { input: "8\n3\n2", output: "False", visible: false },
            { input: "3\n3\n6", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2E-003",
          title: "Compare digits - 2",
          difficulty: "Easy",
          description:
            "Write a program to check  if the given  two digit number is greater than 25 and its first digit is greater than its second digit.",
          sampleInput: "42",
          sampleOutput: "True",
          testCases: [
            { input: "10", output: "False", visible: true },
            { input: "70", output: "True", visible: true },
            { input: "22", output: "False", visible: false },
            { input: "21", output: "False", visible: false },
            { input: "16", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-2E-004",
          title: "Sum and product check",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if both the sum and the product of the given numbers have less than three digits.",
          sampleInput: "17\n4",
          sampleOutput: "True",
          testCases: [
            { input: "100\n3", output: "False", visible: true },
            { input: "70\n1", output: "True", visible: true },
            { input: "22\n100", output: "False", visible: false },
            { input: "22\n555", output: "False", visible: false },
            { input: "16\n100", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2E-005",
          title: "Digit zero",
          difficulty: "Easy",
          description:
            "Write a program that reads a three-digit number and check if the given number contains `0`.",
          sampleInput: "170",
          sampleOutput: "True",
          testCases: [
            { input: "121", output: "False", visible: true },
            { input: "701", output: "True", visible: true },
            { input: "222", output: "False", visible: false },
            { input: "244", output: "False", visible: false },
            { input: "163", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2E-006",
          title: "Compare with Ten - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads Three numbers A,B and C and checks if the sum of any two Number is always greater than 10.",
          sampleInput: "4\n8\n10",
          sampleOutput: "True",
          testCases: [
            { input: "1\n111\n6", output: "False", visible: true },
            { input: "3\n8\n22", output: "True", visible: true },
            { input: "22\n2\n3", output: "False", visible: false },
            { input: "2\n2\n2", output: "False", visible: false },
            { input: "3\n4\n1", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2E-007",
          title: "Compares number - 6",
          difficulty: "Easy",
          description:
            "Write a program that reads three digit number and checks if any of the below conditions is satisfied\nEach digit of the given number is greater than 7.\nThe product  of any two digit is always less than or equal to 30.",
          sampleInput: "832",
          sampleOutput: "True",
          testCases: [
            { input: "649", output: "False", visible: true },
            { input: "832", output: "True", visible: true },
            { input: "649", output: "False", visible: false },
            { input: "649", output: "False", visible: false },
            { input: "649", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2E-008",
          title: "Eligibility criteria - 2",
          difficulty: "Medium",
          description:
            "Write a program that reads the marks in maths M, physics P,chemistry C,and checks if all the below conditions are satisfied.\nM+P>=100 or P+C>=100 orM+C>=100\nM+P+C>=180",
          sampleInput: "82\n55\n45",
          sampleOutput: "True",
          testCases: [
            { input: "70\n30\n60", output: "False", visible: true },
            { input: "82\n55\n45", output: "True", visible: true },
            { input: "70\n30\n60", output: "False", visible: false },
            { input: "70\n30\n60", output: "False", visible: false },
            { input: "70\n30\n60", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2E-009",
          title: "Compares number - 7",
          difficulty: "Easy",
          description:
            "Write a program that reads three digit number and checks if each digit is greater than 4 or first digit is equal to 6.",
          sampleInput: "623",
          sampleOutput: "True",
          testCases: [
            { input: "123", output: "False", visible: true },
            { input: "578", output: "True", visible: true },
            { input: "135", output: "False", visible: false },
            { input: "111", output: "False", visible: false },
            { input: "222", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2E-0010",
          title: "Compares number - 8",
          difficulty: "Easy",
          description:
            "Write a program that reads four-digit number and checks if the first two digits of the number is 19 and the last two digits of the number is between 30 and 60.",
          sampleInput: "1935",
          sampleOutput: "True",
          testCases: [
            { input: "1633", output: "False", visible: true },
            { input: "1940", output: "True", visible: true },
            { input: "1333", output: "False", visible: false },
            { input: "1114", output: "False", visible: false },
            { input: "2224", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-2E-0011",
          title: "Compares number - 9",
          difficulty: "Easy",
          description:
            "Write a program that reads a three-digit number and checks if all the below conditions are satisfied.\nThe number contains 1.\nThe sum of all the digits of the number is less than 12.\nThe last digit of the number is equal to 5.",
          sampleInput: "315",
          sampleOutput: "True",
          testCases: [
            { input: "628", output: "False", visible: true },
            { input: "415", output: "True", visible: true },
            { input: "276", output: "False", visible: false },
            { input: "324", output: "False", visible: false },
            { input: "228", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-2B",
      title: "Assignment-2B",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-Assignment-2B-001",
          title: "same digits",
          difficulty: "Easy",
          description:
            "Write a program that reads a three digits number and checks if all the digits of the number are the same.",
          sampleInput: "333",
          sampleOutput: "True",
          testCases: [
            { input: "345", output: "False", visible: true },
            { input: "888", output: "True", visible: true },
            { input: "823", output: "False", visible: false },
            { input: "832", output: "False", visible: false },
            { input: "223", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-2B-002",
          title: "Sum and product check - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if the sum of A and B is negative or the product of A and B is negative",
          sampleInput: "3\n-2",
          sampleOutput: "True",
          testCases: [
            { input: "3\n4", output: "False", visible: true },
            { input: "8\n-3", output: "True", visible: true },
            { input: "8\n3", output: "False", visible: false },
            { input: "5\n2", output: "False", visible: false },
            { input: "2\n3", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-2B-003",
          title: "Valid Triangle",
          difficulty: "Easy",
          description:
            "Write a program that reads three sides A,B and C of a triangle and checks if the sum of any two sides of the triangle is always greater than the third side.",
          sampleInput: "3\n4\n5",
          sampleOutput: "True",
          testCases: [
            { input: "2\n1\n10", output: "False", visible: true },
            { input: "6\n7\n8", output: "True", visible: true },
            { input: "3\n4\n5", output: "True", visible: false },
            { input: "1\n2\n3", output: "False", visible: false },
            { input: "5\n5\n5", output: "True", visible: false },
            { input: "2\n2\n5", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2B-004",
          title: "Required number",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if the number N is between  50 and 100 or if the first digit of N is equal to 7.",
          sampleInput: "54",
          sampleOutput: "True",
          testCases: [
            { input: "203", output: "False", visible: true },
            { input: "7", output: "True", visible: true },
            { input: "22", output: "False", visible: false },
            { input: "25", output: "False", visible: false },
            { input: "22", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2B-005",
          title: "Compare Numbers - 10",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if both the below conditions are satisfied.\nOne of A and B is less than 20.\nOne of A and B is greater than 30.",
          sampleInput: "15\n32",
          sampleOutput: "True",
          testCases: [
            { input: "8\n21", output: "False", visible: true },
            { input: "16\n33", output: "True", visible: true },
            { input: "7\n22", output: "False", visible: false },
            { input: "25\n7", output: "False", visible: false },
            { input: "22\n7", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2B-006",
          title: "Eligibility criteria - 3",
          difficulty: "Medium",
          description:
            "Write a program that reads the marks M in maths,marks P in Physics and marks C in chemistry and checks if both the below conditions are satisfied.\nM>=35 and P>=35 and C>=35.\nM+P>=90 or P+C>=90 or M+C>=90.",
          sampleInput: "50\n35\n40",
          sampleOutput: "True",
          testCases: [
            { input: "82\n20\n20", output: "False", visible: true },
            { input: "50\n35\n48", output: "True", visible: true },
            { input: "82\n20\n20", output: "False", visible: false },
            { input: "82\n20\n20", output: "False", visible: false },
            { input: "82\n20\n20", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-2B-007",
          title: "Eligibility criteria - 4",
          difficulty: "Medium",
          description:
            "Write a program that reads the marks M in maths,marks P in Physics and marks C in chemistry and checks if both the below conditions are satisfied.\nM>=60 and P>=50 and C>=45 and M+P+C>=180.\nM+P>=120 or C+P>=110.",
          sampleInput: "72\n65\n52",
          sampleOutput: "True",
          testCases: [
            { input: "70\n0\n72", output: "False", visible: true },
            { input: "72\n65\n52", output: "True", visible: true },
            { input: "70\n0\n72", output: "False", visible: false },
            { input: "70\n0\n72", output: "False", visible: false },
            { input: "70\n0\n72", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-3A",
      title: "Coding Practice - 3A",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-3A-001",
          title: "Positive Integer",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and converts it to a positive number.If the given number is negative,convert it to a positive number and print it.otherwise,print the given number.",
          sampleInput: "-10",
          sampleOutput: "10",
          testCases: [
            { input: "10", output: "10", visible: true },
            { input: "-6", output: "6", visible: true },
            { input: "8", output: "8", visible: false },
            { input: "3", output: "3", visible: false },
            { input: "-2", output: "2", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3A-002",
          title: "Exam Result",
          difficulty: "Easy",
          description:
            "Write a program that reads the students marks as input and prints PASS or FAIL.If the student has scored more than 50, print pass.In all other cases print fail.",
          sampleInput: "60",
          sampleOutput: "Pass",
          testCases: [
            { input: "10", output: "Fail", visible: true },
            { input: "77", output: "Pass", visible: true },
            { input: "30", output: "Fail", visible: false },
            { input: "33", output: "Fail", visible: false },
            { input: "78", output: "Pass", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3A-003",
          title: "Greatest among two numbers - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and prints the Greatest among the two numbers",
          sampleInput: "60\n22",
          sampleOutput: "60",
          testCases: [
            { input: "5\n40", output: "40", visible: true },
            { input: "66\n22", output: "66", visible: true },
            { input: "40\n22", output: "40", visible: false },
            { input: "33\n34", output: "34", visible: false },
            { input: "78\n22", output: "78", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3A-004",
          title: "Vote Eligibility",
          difficulty: "Easy",
          description:
            "Write a program that reads the age of a person and checks if the age of the person is greater than or equal to 18 for eligibility to vote.Print Eligible if the age of the person is greater than or equal to 18,otherwise print not Eligible.",
          sampleInput: "19",
          sampleOutput: "Eligible",
          testCases: [
            { input: "10", output: "Not Eligible", visible: true },
            { input: "35", output: "Eligible", visible: true },
            { input: "11", output: "Not Eligible", visible: false },
            { input: "2", output: "Not Eligible", visible: false },
            { input: "10", output: "Not Eligible", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3A-005",
          title: "Relation between Numbers",
          difficulty: "Easy",
          description:
            "Write a program to print the Relation between two numbers,X and Y.",
          sampleInput: "2\n6",
          sampleOutput: "x<y",
          testCases: [
            { input: "10\n5", output: "x>=y", visible: true },
            { input: "3\n8", output: "x<y", visible: true },
            { input: "11\n15", output: "x<y", visible: false },
            { input: "2\n8", output: "x<y", visible: false },
            { input: "10\n22", output: "x<y", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3A-006",
          title: "Equal numbers",
          difficulty: "Easy",
          description:
            "Write a program to check if the given two numbers are equal.",
          sampleInput: "2\n6",
          sampleOutput: "not equal",
          testCases: [
            { input: "5\n5", output: "equal", visible: true },
            { input: "3\n8", output: "not equal", visible: true },
            { input: "11\n15", output: "not equal", visible: false },
            { input: "2\n8", output: "not equal", visible: false },
            { input: "10\n22", output: "not equal", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3A-007",
          title: "Square or Rectangle",
          difficulty: "Easy",
          description:
            "Given the length and breadth of a box,check if it is a Rectangle or Square.\nNOte:If it is equal length and breadth than it is Square.",
          sampleInput: "6\n6",
          sampleOutput: "Square",
          testCases: [
            { input: "5\n5", output: "Square", visible: true },
            { input: "3\n8", output: "Rectangle", visible: true },
            { input: "11\n15", output: "Rectangle", visible: false },
            { input: "2\n8", output: "Rectangle", visible: false },
            { input: "10\n22", output: "Rectangle", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3A-008",
          title: "Go for a walk",
          difficulty: "Easy",
          description:
            "Write a program that reads a temperature and checks if the given temperature is between 15 and 40.Print `can go for a walk`if the given temperature is between 15 and 40,otherwise print `cannot go for a walk`. ",
          sampleInput: "15",
          sampleOutput: "Can go for a walk",
          testCases: [
            { input: "10", output: "cannot go for a walk", visible: true },
            { input: "25", output: "Can go for a walk", visible: true },
            { input: "11", output: "cannot go for a walk", visible: false },
            { input: "2", output: "cannot go for a walk", visible: false },
            { input: "10", output: "cannot go for a walk", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3A-009",
          title: "Buy a Book",
          difficulty: "Easy",
          description:
            "Write a program that reads the size S and page count C of a book and checks if S is equal to large or C is Greater than or equal to 300.\nPrint Buy a book if S is equal to large or C is greater than or equal to 300.Otherwise,print do not buy a book.",
          sampleInput: "large\n80",
          sampleOutput: "buy a book",
          testCases: [
            { input: "small\n200", output: "do not buy a book", visible: true },
            { input: "large\n90", output: "buy a book", visible: true },
            {
              input: "small\n200",
              output: "do not buy a book",
              visible: false,
            },
            {
              input: "small\n200",
              output: "do not buy a book",
              visible: false,
            },
            {
              input: "small\n200",
              output: "do not buy a book",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3A-0010",
          title: "Pair of Numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if both A and B are less than or equal to 1000 or B is greater than 500.\nPrint Pair if both A and B are less than or equal to 1000 or B is greater than 500.Otherwise,print Not a Pair.",
          sampleInput: "300\n200",
          sampleOutput: "pair",
          testCases: [
            { input: "1434\n23", output: "not a pair", visible: true },
            { input: "250\n300", output: "pair", visible: true },
            { input: "1434\n23", output: "not a pair", visible: false },
            { input: "1434\n23", output: "not a pair", visible: false },
            { input: "1434\n23", output: "not a pair", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3A-0011",
          title: "Team Up",
          difficulty: "Easy",
          description:
            "Write a program that reads the scores A and B of two players and checks if one of the scores is greater than 300 and the sum of the scores is less than 500.\nPrint Can team up if one of the scores is greater than 300 and the sum of the scores is less than 500,otherwise print cannot team up.",
          sampleInput: "350\n134",
          sampleOutput: "can team up",
          testCases: [
            { input: "450\n90", output: "cannot team up", visible: true },
            { input: "320\n120", output: "can team up", visible: true },
            { input: "470\n90", output: "cannot team up", visible: false },
            { input: "490\n90", output: "cannot team up", visible: false },
            { input: "500\n90", output: "cannot team up", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3A-0012",
          title: "Zero or Positive",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and checks if the given number is zero or positive",
          sampleInput: "35",
          sampleOutput: "positive",
          testCases: [
            { input: "0", output: "zero", visible: true },
            { input: "65", output: "positive", visible: true },
            { input: "0", output: "zero", visible: false },
            { input: "0", output: "zero", visible: false },
            { input: "0", output: "zero", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3A-0013",
          title: "Zero or Positive or negative",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and checks if the given number is zero,positive or negative.",
          sampleInput: "87",
          sampleOutput: "positive",
          testCases: [
            { input: "-12", output: "negative", visible: true },
            { input: "0", output: "zero", visible: true },
            { input: "47", output: "positive", visible: false },
            { input: "49", output: "positive", visible: false },
            { input: "50", output: "positive", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-3B",
      title: "Coding Practice - 3B",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-3B-001",
          title: "Increment the number",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if N is greater than 10.Print the result of N+5 if N is greater than 10.otherwise,print the result of N+1.",
          sampleInput: "11",
          sampleOutput: "16",
          testCases: [
            { input: "8", output: "9", visible: true },
            { input: "16", output: "21", visible: true },
            { input: "7", output: "8", visible: false },
            { input: "3", output: "4", visible: false },
            { input: "2", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3B-002",
          title: "Valid Triangle - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads the three angles A,B, and C of a Triangle and checks if the sum of the three angle of the Triangle is equal to 180.Print the triangle as given below if the sum of the three angles of the Triangle is equal to 180.otherwise,Print Not a Valid Triangle.",
          sampleInput: "60\n45\n75",
          sampleOutput: "*\n**\n***",
          testCases: [
            {
              input: "20\n30\n60",
              output: "not a valid triangle",
              visible: true,
            },
            { input: "59\n46\n75", output: "*\n**\n***", visible: true },
            {
              input: "8\n53\n12",
              output: "not a valid triangle",
              visible: false,
            },
            {
              input: "3\n23\n33",
              output: "not a valid triangle",
              visible: false,
            },
            {
              input: "2\n22\n25",
              output: "not a valid triangle",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3B-003",
          title: "Greater than 100",
          difficulty: "Easy",
          description:
            "Write a program that reads three numbers A,B, and C, and checks if each number is greater than 100.Print all are greater than 100 if each number is greater than 100.otherwise, print Not all are greater than 100.",
          sampleInput: "111\n334\n545",
          sampleOutput: "All are greater than 100",
          testCases: [
            {
              input: "80\n23\n220",
              output: "not all are greater than 100",
              visible: true,
            },
            {
              input: "161\n111\n232",
              output: "All are greater than 100",
              visible: true,
            },
            {
              input: "8\n23\n111",
              output: "not all are greater than 100",
              visible: false,
            },
            {
              input: "3\n22\n232",
              output: "not all are greater than 100",
              visible: false,
            },
            {
              input: "2\n23\n22",
              output: "not all are greater than 100",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-3B-004",
          title: "Floor",
          difficulty: "Easy",
          description:
            "Write a program that reads a Room Number and checks if the number in the given room number is less than 30.The room Numbers are in the format of  R1,R35,etc,Print ground floor if the number is less than 30.Otherwise,print not ground floor.",
          sampleInput: "R27",
          sampleOutput: "Ground floor",
          testCases: [
            {
              input: "R39",
              output: "not ground floor",
              visible: true,
            },
            {
              input: "R22",
              output: "ground floor",
              visible: true,
            },
            {
              input: "R44",
              output: "not ground floor",
              visible: false,
            },
            {
              input: "R34",
              output: "not ground floor",
              visible: false,
            },
            {
              input: "R57",
              output: "not ground floor",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-005",
          title: "Valid string",
          difficulty: "Easy",
          description:
            "Write a program that reads a string S and checks if the length of S is between 2 and 7 or the first character of S is not equal to`a`.Print valid string if the length of s is between 2 and 7 or the first character of s is not equal to `a`.otherwise,print not a valid string.",
          sampleInput: "apple",
          sampleOutput: "valid string",
          testCases: [
            {
              input: "rat",
              output: "valid string",
              visible: true,
            },
            {
              input: "atlantic",
              output: " not a valid string",
              visible: true,
            },
            {
              input: "bag",
              output: "valid string",
              visible: false,
            },
            {
              input: "cat",
              output: "valid string",
              visible: false,
            },
            {
              input: "apple",
              output: "valid string",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-006",
          title: "Between 40 and 140",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if any of the given numbers is between 40 and 140.Print between 40 and 140:Yes if any of the given number is between 40 and 140.Otherwise, Print between 40 and 140:No.",
          sampleInput: "12\n110",
          sampleOutput: "between 40 and 140:Yes",
          testCases: [
            {
              input: "34\n120",
              output: "between 40 and 140:Yes",
              visible: true,
            },
            {
              input: "30\n20",
              output: "between 40 and 140:no",
              visible: true,
            },
            {
              input: "20\n122",
              output: "between 40 and 140:Yes",
              visible: false,
            },
            {
              input: "30\n55",
              output: "between 40 and 140:Yes",
              visible: false,
            },
            {
              input: "55\n55",
              output: "between 40 and 140:Yes",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-007",
          title: "Bonous salary",
          difficulty: "Easy",
          description:
            "A company is decided to give a bonus of 5% to an employee if his/her years of service is more than five years.write a program that reads an employee's salary and years of service and decides whether the employee gets the bonus or not.",
          sampleInput: "25000\n3",
          sampleOutput: "No bonus",
          testCases: [
            {
              input: "35000\n3",
              output: "No bonus",
              visible: true,
            },
            {
              input: "25000\n7",
              output: "1250.0",
              visible: true,
            },
            {
              input: "25000\n3",
              output: "No bonus",
              visible: false,
            },
            {
              input: "25000\n3",
              output: "No bonus",
              visible: false,
            },
            {
              input: "25000\n3",
              output: "No bonus",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-008",
          title: "Difference of two numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads three numbers A,B,and C,and checks if the difference between any two numbers(A-B, B-C and C-A) is always less than 25.\nPrint Difference is less than 25 if the difference between any two numbers(A-B ,B-C and C-A) is always less than 25.Otherwise,print difference is not less than 25.",
          sampleInput: "65\n60\n52",
          sampleOutput: "difference is less than 25",
          testCases: [
            {
              input: "70\n65\n65",
              output: "difference is less than 25",
              visible: true,
            },
            {
              input: "100\n70\n35",
              output: "difference is not less than 25",
              visible: true,
            },
            {
              input: "65\n60\n52",
              output: "difference is less than 25",
              visible: false,
            },
            {
              input: "65\n60\n52",
              output: "difference is less than 25",
              visible: false,
            },
            {
              input: "65\n60\n52",
              output: "difference is less than 25",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-009",
          title: "Valid Triangle - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads three sides A,B, and C of a triangle and checks if the sum of any two sides of the triangle is always greater than the third side.\nPrint Its a Triangle if the sum of any two sides of the triangle is always greater than the third side.Otherwise,print its not a triangle.",
          sampleInput: "4\n5\n3",
          sampleOutput: "It's a Triangle",
          testCases: [
            { input: "5\n6\n4", output: "It's a Triangle", visible: true },
            { input: "6\n3\n2", output: "It's not a Triangle", visible: true },
            { input: "5\n6\n4", output: "It's a Triangle", visible: false },
            { input: "5\n6\n4", output: "It's a Triangle", visible: false },
            { input: "5\n6\n4", output: "It's a Triangle", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-0010",
          title: "sum or numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B, and checks if one of the below conditions is satisfied.\none of A and B is less than 20.\nThe sum of A and B if one of the given conditions is satisfied.Otherwise,print A and B on each line.",
          sampleInput: "45\n7",
          sampleOutput: "52",
          testCases: [
            { input: "30\n100", output: "30\n100", visible: true },
            { input: "44\n6", output: "50", visible: true },
            { input: "30\n5", output: "35", visible: false },
            { input: "30\n100", output: "30\n100", visible: false },
            { input: "30\n100", output: "30\n100", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-0011",
          title: "Lucky number",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B, and checks if one of the below conditions is satisfied.\none of A and B is equal to 6.\nThe sum of A and B is equal to 6.\nThe difference between A and B is equal to 6.\nPrint Lucky if one of the given conditions is satisfied.Otherwise,print not lucky.\nNote:Both A-B and B-A is used to calculate the difference between A and B.",
          sampleInput: "10\n4",
          sampleOutput: "Lucky",
          testCases: [
            { input: "6\n1", output: "Not Lucky", visible: true },
            { input: "10\n4", output: "Lucky", visible: true },
            { input: "2\n8", output: "Lucky", visible: false },
            { input: "1\n1", output: "Not Lucky", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-0012",
          title: "Greatest Among three numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads three numbers A,B and C and prints the greatest among the three numbers.",
          sampleInput: "10\n4\n12",
          sampleOutput: "12",
          testCases: [
            { input: "2\n1\n5", output: "5", visible: true },
            { input: "6\n3\n8", output: "8", visible: true },
            { input: "2\n1\n7", output: "7", visible: false },
            { input: "3\n1\n4", output: "4", visible: false },
            { input: "2\n1\n6", output: "6", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-3B-0013",
          title: "Valid Triangle",
          difficulty: "Easy",
          description:
            "Given three angles of a triangle,write a program to check whether the triangle is valid or not.A triangle is valid if the sum of it's three angles is equal to 180 degrees.",
          sampleInput: "80\n90\n100",
          sampleOutput: "It's not a Triangle",
          testCases: [
            {
              input: "80\n100\n90",
              output: "It's not a Triangle",
              visible: true,
            },
            { input: "60\n60\n60", output: "It's a Triangle", visible: true },
            { input: "2\n1\n7", output: "It's not a Triangle", visible: false },
            { input: "3\n1\n4", output: "It's not a Triangle", visible: false },
            { input: "2\n1\n6", output: "It's not a Triangle", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-3A",
      title: "Assignment-3A",
      description: "Operators and Conditional Statements",
      questions: [
        {
          id: "q-python-Assignment-3A-001",
          title: "Top 10 Rankers",
          difficulty: "Easy",
          description:
            "Write a program that reads the rank of student of a student R and checks if R is less than 10.Print `honor student` if R is less than 10.Otherwise,print normal student.",
          sampleInput: "11",
          sampleOutput: "normal student",
          testCases: [
            { input: "8", output: "honor student", visible: true },
            { input: "16", output: "normal student", visible: true },
            { input: "17", output: "normal student", visible: false },
            { input: "15", output: "normal student", visible: false },
            { input: "22", output: "normal student", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-3A-002",
          title: "sum or product",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if the sum of A and B is less than 10.Print the sum of A and B if the sum of A and B is less than 10.Otherwise,print the product of A and B.",
          sampleInput: "3\n2",
          sampleOutput: "5",
          testCases: [
            { input: "8\n10", output: "80", visible: true },
            { input: "3\n5", output: "8", visible: true },
            { input: "2\n3", output: "5", visible: true },
            { input: "4\n5", output: "9", visible: true },
            { input: "5\n5", output: "25", visible: false },
            { input: "6\n4", output: "24", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-3A-003",
          title: "Discount",
          difficulty: "Easy",
          description:
            "Write a program that reads two coupon codes A and B and checks if the first three characters of one of the coupon codes is equal to `DIS`.Print Discount if the first three  characters of one of the coupon codes is equal to `DIS`.otherwise,print no discount.",
          sampleInput: "dishwhk\nqteh",
          sampleOutput: "discount",
          testCases: [
            { input: "dishello\ndishk", output: "discount", visible: true },
            { input: "hello\nnamaste", output: "no discount", visible: true },
            { input: "dishello\ndishk", output: "discount", visible: false },
            { input: "dishello\ndishk", output: "discount", visible: false },
            { input: "dishello\ndishk", output: "discount", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-3A-004",
          title: "qualified or not qualified",
          difficulty: "Easy",
          description:
            "Write a program that reads the marks M in maths and marks P in physics and checks if both M and P are greater than 35 or sum of M and p is greater than or equal to 100.Print qualified if both M and P are greater than 35 or sum of M and P is greater than or equal to 100.Otherwise,print not qualified.",
          sampleInput: "50\n40",
          sampleOutput: "qualified",
          testCases: [
            { input: "30\n40", output: "not qualified", visible: true },
            { input: "50\n40", output: "qualified", visible: true },
            { input: "50\n40", output: "qualified", visible: false },
            { input: "50\n40", output: "qualified", visible: false },
            { input: "50\n40", output: "qualified", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-3A-005",
          title: "between 9 and 21",
          difficulty: "Easy",
          description:
            "Write a program that reads three numbers A,B, and C and checks if any of the given numbers is between 9 and 21.",
          sampleInput: "2\n4\n10",
          sampleOutput: "True",
          testCases: [
            { input: "30\n5\n20", output: "True", visible: true },
            { input: "5\n3\n2", output: "False", visible: true },
            { input: "50\n21\n10", output: "True", visible: false },
            { input: "50\n40\n11", output: "True", visible: false },
            { input: "50\n40\n10", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-3A-006",
          title: "Valid number",
          difficulty: "Easy",
          description:
            "Write a program that reads a three-digit number N and checks if both the given conditions are satisfied.\nany of the digits of N is not equal to 5\nN is between 300 and 700\nPrint Valid Number if both the given conditions are satisfied.Otherwise,print Not a valid number.",
          sampleInput: "663",
          sampleOutput: "valid number",
          testCases: [
            { input: "947", output: "Not a valid number", visible: true },
            { input: "663", output: "valid number", visible: true },
            { input: "5947", output: "Not a valid number", visible: false },
            { input: "960", output: "Not a valid number", visible: false },
            { input: "880", output: "Not a valid number", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-4A",
      title: "Codingpractice - 4A",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Codingpractice-4A-001",
          title: "Find the remainder",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B,and prints the remainder when A is divided by B.",
          sampleInput: "11\n2",
          sampleOutput: "1",
          testCases: [
            { input: "8\n2", output: "0", visible: true },
            { input: "16\n3", output: "1", visible: true },
            { input: "15\n4", output: "3", visible: false },
            { input: "7\n5", output: "2", visible: false },
            { input: "100\n9", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-4A-002",
          title: "Divisible by 7",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if the number N is divisible by 7.Print Divisible By seven if  N is divisible by 7.Otherwise,print not divisible by seven.",
          sampleInput: "35",
          sampleOutput: "divisible by 7",
          testCases: [
            { input: "42", output: "divisible by 7", visible: true },
            { input: "16", output: "not divisible by 7", visible: true },
            { input: "15", output: "not divisible by 7", visible: false },
            { input: "14", output: "divisible by 7", visible: false },
            { input: "13", output: "not divisible by 7", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-4A-003",
          title: "quotient and remainder",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and prints the quotient and remainder when A is divided by B.",
          sampleInput: "35\n7",
          sampleOutput: "5\n0",
          testCases: [
            { input: "42\n8", output: "5\n2", visible: true },
            { input: "16\n4", output: "4\n0", visible: true },
            { input: "16\n2", output: "8\n0", visible: false },
            { input: "24\n8", output: "3\n0", visible: false },
            { input: "16\n3", output: "5\n1", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-4A-004",
          title: "Even or odd",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks  if N is divisible by 2.Print even if N is divisible by 2.otherwise,print odd.",
          sampleInput: "24",
          sampleOutput: "even",
          testCases: [
            { input: "42", output: "even", visible: true },
            { input: "17", output: "odd", visible: true },
            { input: "16", output: "even", visible: false },
            { input: "14", output: "even", visible: false },
            { input: "18", output: "even", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-005",
          title: "Greatest Among Remainders",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and finds the,remainder when N is divided by 4.remainder when N is divided by 5.Print the greatest remainder among the two remainders when N is divided by 4 and 5.",
          sampleInput: "12",
          sampleOutput: "2",
          testCases: [
            { input: "147", output: "3", visible: true },
            { input: "12", output: "2", visible: true },
            { input: "147", output: "3", visible: false },
            { input: "12", output: "2", visible: false },
            { input: "12", output: "2", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-006",
          title: "special eleven",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if the remainder is 0 or 1 when N is divided by 11.Print special even if the remainder is 0 or 1 when N is divided by 11.Otherwise,print normal number.",
          sampleInput: "22",
          sampleOutput: "special eleven",
          testCases: [
            { input: "23", output: "special eleven", visible: true },
            { input: "15", output: "normal number", visible: true },
            { input: "23", output: "special eleven", visible: false },
            { input: "23", output: "special eleven", visible: false },
            { input: "23", output: "special eleven", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-007",
          title: "special string",
          difficulty: "Easy",
          description:
            "Write a program that reads a string s and checks if all the given conditions are satisfied.The first three characters of S is NXT.The remaining characters of s contains a number.Number is divisible by 2 or 7. Print special string if all the given conditions are satisfied.Otherwise,print not a special string.\nNote:Example:s=nxt1234,The number in nxt1234 is 1234. 1234 should be converted into an integer before doing any operations.",
          sampleInput: "nxt1234",
          sampleOutput: "special string",
          testCases: [
            { input: "pra49", output: "not a special string", visible: true },
            { input: "nxt1234", output: "special string", visible: true },
            { input: "nxt1234", output: "special string", visible: false },
            { input: "nxt1234", output: "special string", visible: false },
            { input: "nxt1234", output: "special string", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-008",
          title: "special number",
          difficulty: "Easy",
          description:
            "Write a program that reads a two digit number N and checks if any of the given conditions is satisfied.\nThe sum of digits of N is equals to 7.\nOne of the digits of N IS Equal to 7.\nN is divisible by 7.\nPrint special number if any of the given conditions is satisfied.Otherwise print Normal number.",
          sampleInput: "77",
          sampleOutput: "special number",
          testCases: [
            { input: "33", output: "normal number", visible: true },
            { input: "27", output: "special number", visible: true },
            { input: "37", output: "special number", visible: false },
            { input: "25", output: "special number", visible: false },
            { input: "47", output: "special number", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-009",
          title: "2 digit Divisible Number",
          difficulty: "Easy",
          description:
            "Write a program that reads a two-digit number N and checks if N is divisible by both the digits of N.Print the double of N if N is divisible by both the digits of N.Otherwise,Print N.\nNote:The double of N is calculated as N*2.\nExample:N=15  ,N is divisible by 1,N is divisible by 5. ",
          sampleInput: "15",
          sampleOutput: "30",
          testCases: [
            { input: "15", output: "30", visible: true },
            { input: "12", output: "24", visible: true },
            { input: "24", output: "48", visible: false },
            { input: "18", output: "18", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-0010",
          title: "Lucky number - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a two-digit number N and checks if any of the given conditions is satisfied.\nThe number N is divisible by 9.\nOne of the digits of the number N is equal to 9.\nPrint Lucky Number if any of the given conditions is satisfied.Otherwise,print Unlucky Number.",
          sampleInput: "18",
          sampleOutput: "Lucky Number",
          testCases: [
            { input: "27", output: "Lucky Number", visible: true },
            { input: "13", output: "Unlucky Number", visible: true },
            { input: "36", output: "Lucky Number", visible: false },
            { input: "45", output: "Lucky Number", visible: false },
            { input: "72", output: "Lucky Number", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-0011",
          title: "Pair of Numbers - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a two numbers A and B, and checks if all the given conditions are satisfied.\nA and B are divisible by 3.\nA or B is divisible by 12.\nPrint Pair if all the given conditions are satisfied.Otherwise,print Not a Pair.",
          sampleInput: "15\n240",
          sampleOutput: "Pair",
          testCases: [
            { input: "18\n240", output: "Pair", visible: true },
            { input: "360\n7", output: "Not a Pair", visible: true },
            { input: "18\n240", output: "Pair", visible: false },
            { input: "18\n240", output: "Pair", visible: false },
            { input: "18\n240", output: "Pair", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4A-0012",
          title: "Lucky Number - 3",
          difficulty: "Easy",
          description:
            "Write a program to print if the given number is divisible by any of the lucky numbers 6,3,2 in decreasing order of priority(6 is luckier than 3 and 3 is luckier than 2).\nPrint `Number is divisible by` followed by the luckiest number among the above 3 which can divide the number.\nPrint `Number is not divisible by 2,3 or 6` if the number is not divisible by any of them.",
          sampleInput: "126",
          sampleOutput: "Number is divisible by 6",
          testCases: [
            { input: "27", output: "Number is divisible by 3", visible: true },
            {
              input: "55",
              output: "Number is not divisible by 2,3 or 6",
              visible: true,
            },
            { input: "27", output: "Number is divisible by 3", visible: false },
            { input: "27", output: "Number is divisible by 3", visible: false },
            { input: "27", output: "Number is divisible by 3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-4B",
      title: "Codingpractice - 4B",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Codingpractice-4B-001",
          title: "Print the score",
          difficulty: "Easy",
          description:
            "Write a program that reads a distance D in km and calculates the score.\nIf D is less than or equal to 10,the score is D.\nIf D is greater than 10,the score is (10+(d-10)*3).",
          sampleInput: "3",
          sampleOutput: "3",
          testCases: [
            { input: "25", output: "55", visible: true },
            { input: "4", output: "4", visible: true },
            { input: "3", output: "3", visible: false },
            { input: "5", output: "5", visible: false },
            { input: "2", output: "2", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-4B-002",
          title: "cube of a number",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the cube of N(N^3).",
          sampleInput: "4",
          sampleOutput: "64",
          testCases: [
            { input: "2", output: "8", visible: true },
            { input: "3", output: "27", visible: true },
            { input: "4", output: "64", visible: false },
            { input: "5", output: "125", visible: false },
            { input: "1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-4B-003",
          title: "exponent of a number",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and an exponent E and prints the result of N power E (N^E).",
          sampleInput: "4\n3",
          sampleOutput: "64",
          testCases: [
            { input: "2\n3", output: "8", visible: true },
            { input: "3\n2", output: "9", visible: true },
            { input: "3\n3", output: "27", visible: false },
            { input: "2\n2", output: "4", visible: false },
            { input: "5\n2", output: "25", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4B-004",
          title: "square root of a number",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the square root of N./nNote:square root of N=N^0.5",
          sampleInput: "4",
          sampleOutput: "2.0",
          testCases: [
            { input: "100", output: "10.0", visible: true },
            { input: "9", output: "3.0", visible: true },
            { input: "16", output: "4.0", visible: false },
            { input: "4", output: "2.0", visible: false },
            { input: "25", output: "5.0", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4B-005",
          title: "greatest among the exponents",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and finds the,\nResult of A power of B.\nResult of B power A.\nPrints the greatest among the results of A  power B and B power A.",
          sampleInput: "3\n2",
          sampleOutput: "9",
          testCases: [
            { input: "5\n2", output: "32", visible: true },
            { input: "2\n3", output: "9", visible: true },
            { input: "2\n3", output: "9", visible: false },
            { input: "2\n3", output: "9", visible: false },
            { input: "3\n2", output: "9", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4B-006",
          title: "Armstrong Number",
          difficulty: "Medium",
          description:
            "Write a program that reads three digits number N  and checks if N is an Armstrong Number.\nArmstrong numbers is said to be sum of power of all the digits of number(length of digits) is the number its self.",
          sampleInput: "371",
          sampleOutput: "True",
          testCases: [
            { input: "351", output: "False", visible: true },
            { input: "153", output: "True", visible: true },
            { input: "233", output: "False", visible: false },
            { input: "223", output: "False", visible: false },
            { input: "351", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4B-007",
          title: "Divisible By Number - 2",
          difficulty: "easy",
          description:
            "Write a program that reads a number N and checks if the triple of N is divisible by 6.Print the triple of N if the triple of N is divisible by 6,Otherwise print N.",
          sampleInput: "6",
          sampleOutput: "18",
          testCases: [
            { input: "9", output: "9", visible: true },
            { input: "6", output: "18", visible: true },
            { input: "6", output: "18", visible: false },
            { input: "6", output: "18", visible: false },
            { input: "9", output: "9", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4B-008",
          title: "Sum of squares",
          difficulty: "easy",
          description:
            "Write a program that reads two numbers A and B,and checks if A^2 + B^2(sum of square of A and the square of B)is greater than or equal to 60.\nPrint Greater than or equal to 60 if the sum of the square of A and the square of B is greater than or equal to 60.Otherwise,print Less than 60.",
          sampleInput: "10\n2",
          sampleOutput: "Greater than or equal to 60",
          testCases: [
            {
              input: "8\n7",
              output: "Greater than or equal to 60",
              visible: true,
            },
            { input: "2\n5", output: "Less than 60", visible: true },
            {
              input: "8\n7",
              output: "Greater than or equal to 60",
              visible: false,
            },
            {
              input: "8\n7",
              output: "Greater than or equal to 60",
              visible: false,
            },
            {
              input: "8\n7",
              output: "Greater than or equal to 60",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-4B-009",
          title: "Last digit of a square",
          difficulty: "easy",
          description:
            "Write a program that reads a number N and checks if the last digit of N is equal to the last digit of the square of N.\nPrint Equal if the last digit of N is equal to the last digit of the square of N.Otherwise,print Not equal.",
          sampleInput: "15",
          sampleOutput: "equal",
          testCases: [
            {
              input: "2",
              output: "Not Equal",
              visible: true,
            },
            { input: "2", output: "Not Equal", visible: true },
            {
              input: "5",
              output: "Equal",
              visible: false,
            },
            {
              input: "8",
              output: "Not Equal",
              visible: false,
            },
            {
              input: "8",
              output: "Not Equal",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-4",
      title: "Assignment-4",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Assignment-4-001",
          title: "calculate double or triple",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if N is divisible by 3.\nPrint the triple of N if N is divisible by 3.Otherwise,print the double of N.\nDouble of N is  N*2\nTriple of N is N*3.",
          sampleInput: "4",
          sampleOutput: "8",
          testCases: [
            { input: "9", output: "27", visible: true },
            { input: "4", output: "8", visible: true },
            { input: "5", output: "10", visible: false },
            { input: "6", output: "18", visible: false },
            { input: "7", output: "14", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-4-002",
          title: "smallest Remainder",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and finds the,\nRemainder when A is divided by B(A%B).\nRemainder when B is divided by A (B%A).\nPrint the smallest among the remainders A%B and B%A.",
          sampleInput: "3\n7",
          sampleOutput: "1",
          testCases: [
            { input: "12\n6", output: "0", visible: true },
            { input: "10\n3", output: "1", visible: true },
            { input: "7\n5", output: "2", visible: false },
            { input: "5\n10", output: "0", visible: false },
            { input: "8\n4", output: "0", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-4-003",
          title: "Not divisible by numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if N is not divisible by all the given numbers 2,3,5 and 7.",
          sampleInput: "5633",
          sampleOutput: "True",
          testCases: [
            { input: "1000", output: "False", visible: true },
            { input: "11", output: "True", visible: true },
            { input: "13", output: "True", visible: false },
            { input: "9", output: "False", visible: false },
            { input: "15", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-4-004",
          title: "Number or Remainder",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if one of the given conditions is satisfied.\nN is divisible by 5 and N is divisible by 7.\nN is less than 7.Print N if one of the given conditions is satisfied.Otherwise,print the remainder when N is divided by 5 and the remainder when N is divided by 7 on each line.",
          sampleInput: "9",
          sampleOutput: "4\n2",
          testCases: [
            { input: "3", output: "3", visible: true },
            { input: "9", output: "4\n2", visible: true },
            { input: "3", output: "3", visible: false },
            { input: "3", output: "3", visible: false },
            { input: "3", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-4-005",
          title: "Compute Hypotenuse",
          difficulty: "Easy",
          description:
            "Write a program that reads two sides A and B of a right-angled triangle and prints the Hypotenuse H of the right-angled triangle.",
          sampleInput: "3\n4",
          sampleOutput: "5",
          testCases: [
            { input: "12\n5", output: "13", visible: true },
            { input: "3\n4", output: "5", visible: true },
            { input: "12\n5", output: "13", visible: false },
            { input: "12\n5", output: "13", visible: false },
            { input: "12\n5", output: "13", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-4-006",
          title: "Square root of a number - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A and B and checks if the square root of A is equal to B.\nsquare root of a number=N^0.5.",
          sampleInput: "64\n8",
          sampleOutput: "square root of A is equal to B",
          testCases: [
            {
              input: "55\n5",
              output: "square root of A is not equal to B",
              visible: true,
            },
            {
              input: "25\n5",
              output: "square root of A is equal to B",
              visible: true,
            },
            {
              input: "25\n5",
              output: "square root of A is equal to B",
              visible: false,
            },
            {
              input: "25\n5",
              output: "square root of A is equal to B",
              visible: false,
            },
            {
              input: "25\n5",
              output: "square root of A is equal to B",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-4-007",
          title: "Years,Weeks and Days",
          difficulty: "Hard",
          description:
            "Given N number of days as input,write a program to convert N number of days to years(Y),weeks(W)and days(D).\nNote:Take 1 year=365 days.",
          sampleInput: "1329",
          sampleOutput: "3\n33\n3",
          testCases: [
            { input: "730", output: "2\n0\n0", visible: true },
            { input: "1328", output: "3\n33\n2", visible: true },
            { input: "500", output: "1\n19\n2", visible: true },
            { input: "6", output: "0\n0\n6", visible: false },
            { input: "1328", output: "3\n33\n2", visible: false },
            { input: "7", output: "0\n1\n0", visible: false },
            { input: "8", output: "0\n1\n1", visible: false },
            { input: "366", output: "1\n0\n1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-4-008",
          title: "Armstrong Number - 2",
          difficulty: "medium",
          description:
            "Write a program that reads a four-digit number N and checks if N is an Armstrong Number.",
          sampleInput: "1634",
          sampleOutput: "Armstrong Number",
          testCases: [
            { input: "1568", output: "Not an Armstrong Number", visible: true },
            { input: "1634", output: "Armstrong Number", visible: true },
            { input: "1634", output: "Armstrong Number", visible: false },
            { input: "1634", output: "Armstrong Number", visible: false },
            { input: "1634", output: "Armstrong Number", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Python_Codingpractice-python-5",
      title: "Codingpractice-5",
      description: "Nested conditions",
      accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

      questions: [
        {
          id: "q-python-Codingpractice-5-001",
          title: "Greater than 30 and 50",
          difficulty: "Easy",
          description:
            "Write a program that reads a number X and checks,\nif  is greater than 30.\nif X is greater than 30,check if X is also greater than 50.\nPrint X is greater than 30 if X is greater than 30./nPrint X is greater than 30 and X is greater than 50 on each line if X is greater than 50.",
          sampleInput: "45",
          sampleOutput: "X is greater than 30",
          testCases: [
            { input: "42", output: "X is greater than 30", visible: true },
            {
              input: "60",
              output: "X is greater than 30\nX is greater than 50",
              visible: true,
            },
            { input: "40", output: "X is greater than 30", visible: false },
            { input: "45", output: "X is greater than 30", visible: false },
            { input: "35", output: "X is greater than 30", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-002",
          title: "Rankers",
          difficulty: "Easy",
          description:
            "Write a program that reads the rank R of a student and checks,\nIf R is less than or equal to 3.\nIf R is not less than or equal to 3,check if R is less than or equal to 10.Print One of top 3 if the R is less than or equal to 3.\nPrint Not Top 3 but one of Top 10 if R is less than or equal to 10 but not less than or equal to 3.",
          sampleInput: "7",
          sampleOutput: "not top 3 but one of top 10",
          testCases: [
            { input: "3", output: "one of top 3", visible: true },
            {
              input: "8",
              output: "not top 3 but one of top 10",
              visible: true,
            },
            {
              input: "4",
              output: "not top 3 but one of top 10",
              visible: false,
            },
            {
              input: "4",
              output: "not top 3 but one of top 10",
              visible: false,
            },
            {
              input: "6",
              output: "not top 3 but one of top 10",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-003",
          title: "Weight",
          difficulty: "Easy",
          description:
            "Write a program that reads the weight W of a box in kg and checks,\nif W is greater than or equal to 100.\nif W is not greater than or equal to 100,check if W is greater than or equal to 30.\nPrint box is heavier if W is greater tthan or equal to 100.\nPrint box is heavy if W is not greater than or equal to 100 but greater than or equal to 30.",
          sampleInput: "60",
          sampleOutput: "Box is heavy",
          testCases: [
            { input: "150", output: "box is heavier", visible: true },
            { input: "50", output: "box is heavy", visible: true },
            { input: "150", output: "box is heavier", visible: false },
            { input: "150", output: "box is heavier", visible: false },
            { input: "150", output: "box is heavier", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-004",
          title: "Allowed to Exam",
          difficulty: "Easy",
          description:
            "Write a program that reads two strings H and I and checks,\nif H is equal to `Y`.\nif H is not equal to `Y`,check if I is equal to `Y`.\nPrint Allowed to exam - Has hall ticket if H is  equal to `Y`.\nPrint Allowed to exam -Has Identification Card if H is not equal to `Y` and I is equal to `Y`.",
          sampleInput: "Y\nN",
          sampleOutput: "allowed to exam - has hall ticket",
          testCases: [
            {
              input: "N\nY",
              output: "Allowed to Exam - Has Identification Card",
              visible: true,
            },
            {
              input: "Y\nN",
              output: "allowed to exam - has hall ticket",
              visible: true,
            },
            {
              input: "Y\nN",
              output: "allowed to exam - has hall ticket",
              visible: false,
            },
            {
              input: "Y\nN",
              output: "allowed to exam - has hall ticket",
              visible: false,
            },
            {
              input: "Y\nN",
              output: "allowed to exam - has hall ticket",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-005",
          title: "Divisible by 10 or 5",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if N is divisible by 5 and 10.\nPrint Divisible by 10 if N is divisible by 10.\nPrint divisible by 5 if N is divisible by 5 but not divisible by 10.\nPrint not divisible by 10 or 5 if N is not divisible by 10 and N is not divisible by 5.",
          sampleInput: "15",
          sampleOutput: "Divisible by 5",
          testCases: [
            { input: "10", output: "Divisible by 10", visible: true },
            { input: "10", output: "Divisible by 10", visible: true },
            { input: "20", output: "Divisible by 5", visible: false },
            { input: "25", output: "Divisible by 5", visible: false },
            { input: "30", output: "Divisible by 5", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-006",
          title: "Leap year",
          difficulty: "Hard",
          description:
            "Write a program that reads a year Y and checks if the year Y is a leap year.A year is a leap year if any of the given conditions are satisfied.\nY is divisible by 400.\nY is divisible by 4,and not divisible by 100.\nPrint True if any of the given conditions are satisfied.Otherwise,print false.",
          sampleInput: "2016",
          sampleOutput: "True",
          testCases: [
            { input: "1800", output: "False", visible: true },
            { input: "2024", output: "True", visible: true },
            { input: "1800", output: "False", visible: false },
            { input: "2000", output: "True", visible: false },
            { input: "1900", output: "False", visible: false },
            { input: "2400", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-007",
          title: "Electricity Bill",
          difficulty: "Hard",
          description:
            "In this problem, you need to write a program to calculate the Electricity bill for a household,based on the units of Electricity the household consumed.The price for unit varies based on the slab.The charges per unit for different slabs are as mentioned below:\nFor the first 50 units(0-50),the charge is 2/unit\nFor the next 100 units(51-150),the charge is 3/unit\nFor the next 100 units(151-250),the charge is 5/unit\nFor above 250 units(251 and above),the charge is 8/unit\nApart from these charges,there is also an additional surcharge of 20% on the total amount is added to the bill.",
          sampleInput: "50",
          sampleOutput: "120.0",
          testCases: [
            { input: "200", output: "780.0", visible: true },
            { input: "50", output: "120.0", visible: true },
            { input: "50", output: "120.0", visible: false },
            { input: "0", output: "0.0", visible: false },
            { input: "100", output: "300.0", visible: false },
            { input: "250", output: "1080.0", visible: false },
            { input: "300", output: "1560.0", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-008",
          title: "Greatest among three numbers - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads three numbers A,B,and C ,and prints the greatest number among the three given numbers.",
          sampleInput: "50\n22\n45",
          sampleOutput: "50",
          testCases: [
            { input: "20\n45\n65", output: "65", visible: true },
            { input: "50\n70\n45", output: "70", visible: true },
            { input: "50\n45\n55", output: "55", visible: false },
            { input: "50\n45\n56", output: "56", visible: false },
            { input: "20\n30\n44", output: "44", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-009",
          title: "Course Fee",
          difficulty: "Easy",
          description:
            "Write a program that reads the marks M of a student and checks,\nIf M is greater than or equal to 90.\nIf M is greater than or equal to 50 but not greater than or equal to 90.\nPrint Discount is 200 if M is greater than or equal to 90.\nPrint Discount is 100 if M is greater than or equal to 50 but not greater than or equal to 90.Print No discount if M is not greater than or equal to 50.",
          sampleInput: "93",
          sampleOutput: "Discount is 200",
          testCases: [
            { input: "93", output: "Discount is 200", visible: true },
            { input: "35", output: "No Discount", visible: true },
            { input: "93", output: "Discount is 200", visible: false },
            { input: "93", output: "Discount is 200", visible: false },
            { input: "93", output: "Discount is 200", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-0010",
          title: "Win or Lose or Draw",
          difficulty: "Easy",
          description:
            "Write a program that reads the two scores A and B and compares A with the B.\nPrint Win if A is greater than B.\nPrint Draw if A is equal to B.\nPrint Lose if A is less than B.",
          sampleInput: "26\n47",
          sampleOutput: "Lose",
          testCases: [
            { input: "29\n15", output: "Win", visible: true },
            { input: "25\n25", output: "Draw", visible: true },
            { input: "24\n17", output: "Win", visible: false },
            { input: "24\n18", output: "Win", visible: false },
            { input: "28\n15", output: "Win", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-0011",
          title: "Get Grades",
          difficulty: "Easy",
          description:
            "Write a program to calculate the grade of the student based on the marks he/she scored.\nInput:The input will be a single line containing a float value representing N.\nOutput:A should be printed if the given marks are greater  than 85.\nB should be printed if the given marks are greater than 70 and less than or equal to 85.\nC should be printed if the given marks are greater than or equal to 60 and less than or equal to 70.\nF shoud be printed if the given marks are less than 60.",
          sampleInput: "70.5",
          sampleOutput: "B",
          testCases: [
            { input: "90", output: "A", visible: true },
            { input: "55", output: "F", visible: true },
            { input: "64", output: "C", visible: false },
            { input: "24", output: "F", visible: false },
            { input: "72", output: "B", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-0012",
          title: "Greeting Message",
          difficulty: "Easy",
          description:
            "Write a program to print a greeting message based on the given time.\nInput:The first line of input will be an integer.\nOutput:If the time is greater than or equal to 4 and less than 12,Print `Good Morning`.\nIf the time is greater than or equal to 12 and less than 16,Print `Good Afternoon`.\nIf the time is greater than or equal to 16 and less than 20,Print `Good Evening`.\nIf the time is greater than or equal to 20 and less than 4,Print `Good Night`.",
          sampleInput: "9",
          sampleOutput: "Good Morning",
          testCases: [
            { input: "15", output: "Good Afternoon", visible: true },
            { input: "17", output: "Good Evening", visible: true },
            { input: "17", output: "Good Evening", visible: false },
            { input: "18", output: "Good Evening", visible: false },
            { input: "19", output: "Good Evening", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-0013",
          title: "Name of the polygon",
          difficulty: "Easy",
          description:
            "Write a program that reads the number N and prints the name of the polygon based on the N number of sides.\nA polygon is a closed shape made of straight lines that has three or more sides and angles.\nInput:The input will be a single line containing an integer N representing the number of sides.\nOutput:Not Polygon,should be printed if the given number of sides is less than 3.\nTriangle should be printed if the given number of sides is equal to 3.\nQuadrilateral should be printed if the given number of sides is equal to 4.\nPentagon should be printed if the given number of sides is equal to 5.\nBig Polygon should be printed if the given number of sides is greater than 5.",
          sampleInput: "4",
          sampleOutput: "nQuadrilateral",
          testCases: [
            { input: "2", output: "Not Polygon", visible: true },
            { input: "3", output: "Triangle", visible: true },
            { input: "2", output: "Not Polygon", visible: false },
            { input: "2", output: "Not Polygon", visible: false },
            { input: "2", output: "Not Polygon", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-5-0014",
          title: "Relation Between Two Numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers A,and B,and prints the relation between A and B by checking if any of the given conditions is satisfied.\nA is equal to B.\nA is greater than B.\nA is less than B.",
          sampleInput: "3\n5",
          sampleOutput: "A<B",
          testCases: [
            { input: "2\n2", output: "A == B", visible: true },
            { input: "5\n2", output: "A>B", visible: true },
            { input: "2\n2", output: "A == B", visible: false },
            { input: "2\n5", output: "A<B", visible: false },
            { input: "2\n3", output: "A<B", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-5",
      title: "Assignment-5",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Assignment-5-001",
          title: "Positive or Negative",
          difficulty: "Easy",
          description:
            "Write a program that reads a number(float) N and checks if the number N is a Negative number or a positive number.\nPrint positive if N is greater than 0.\nprint negative if N is less than 0.",
          sampleInput: "45.5",
          sampleOutput: "positive",
          testCases: [
            { input: "-4.2", output: "negative", visible: true },
            { input: "60", output: "positive", visible: true },
            { input: "40", output: "positive", visible: false },
            { input: "45", output: "positive", visible: false },
            { input: "35", output: "positive", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-5-002",
          title: "Profit or loss",
          difficulty: "Easy",
          description:
            "Write a program that reads the cost price cp and selling price sp of a product and compares sp with cp.\nprint profit if sp is greater than cp.\nprint loss if sp is less than cp.\nprint no profit-no loss if sp is equal to cp.",
          sampleInput: "100\n200",
          sampleOutput: "profit",
          testCases: [
            { input: "300\n200", output: "loss", visible: true },
            { input: "300\n300", output: "no profit-no loss", visible: true },
            { input: "40\n20", output: "loss", visible: false },
            { input: "45\n200", output: "profit", visible: false },
            { input: "35\n40", output: "profit", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-5-003",
          title: "Get season",
          difficulty: "Easy",
          description:
            "Write a program to find season for thr given month number.\nInput:\nThe first line of input will contain an integer that indicates the number of the month.if the given number of the month is 3,that indicates march month.\noutput:\nIf the given month is either november or december or january,print `winter`.\nIf the given month is either february or march,print `spring`.\nif the given month is either april or may or june print `summer`.\nif the given month is either july or august,print `Rainy`.\nIf the given month is either september or october,print ` Autumn`.",
          sampleInput: "1",
          sampleOutput: "winter",
          testCases: [
            { input: "4", output: "summer", visible: true },
            { input: "2", output: "spring", visible: true },
            { input: "1", output: "winter", visible: true },
            { input: "12", output: "winter", visible: false },
            { input: "2", output: "spring", visible: false },
            { input: "4", output: "summer", visible: false },
            { input: "7", output: "Rainy", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-5-004",
          title: "weather condition",
          difficulty: "Easy",
          description:
            "Write a program to display a customized message based on temperature T.\nInput:The first line is a real number T.\nOutput:Print freezing weather if T<0\nPrint very cold weather if 0<=T<10\nPrint cold weather if 10<=T<20\nPrint normal if 20<=T<30\nPrint hot if 30<=T<40\nPrint very hot if T>=40.",
          sampleInput: "-50.0",
          sampleOutput: "freezing weather",
          testCases: [
            { input: "5.7", output: "very cold weather", visible: true },
            { input: "15", output: "cold weather", visible: true },
            { input: "5.7", output: "very cold weather", visible: false },
            { input: "4.8", output: "very cold weather", visible: false },
            { input: "4.9", output: "very cold weather", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-5-005",
          title: "Relation between two numbers 2",
          difficulty: "Easy",
          description:
            "Write a program to Print the relation between two numbers ,A and B.\n Input:The first line is an integer A.\nThe second line is an integer B.\nOutput:Print A==B if A and B are equal.\nPrint A>B if A is greater than B.\nPrint A<B if A is less than B.",
          sampleInput: "3\n4",
          sampleOutput: "A<B",
          testCases: [
            { input: "4\n4", output: "A==B", visible: true },
            { input: "15\n13", output: "A>B", visible: true },
            { input: "5\n5", output: "A==B", visible: false },
            { input: "4\n4", output: "A==B", visible: false },
            { input: "4\n4", output: "A==B", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-5-006",
          title: "smallest among 3 numbers",
          difficulty: "Easy",
          description:
            "Write a program to Print the smallest value among the three numbers A,B, and C.",
          sampleInput: "3\n4\n2",
          sampleOutput: "2",
          testCases: [
            { input: "4\n4\n3", output: "3", visible: true },
            { input: "15\n13\n4", output: "4", visible: true },
            { input: "5\n5\n3", output: "3", visible: false },
            { input: "4\n4\n1", output: "1", visible: false },
            { input: "4\n4\n3", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-6A",
      title: "Codingpractice-6A",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Codingpractice-6A-001",
          title: "Day Name",
          difficulty: "Easy",
          description:
            "Write a program that reads a day number and prints the corresponding day name.(1=Monday)",
          sampleInput: "3",
          sampleOutput: "wednesday",
          testCases: [
            { input: "1", output: "monday", visible: true },
            { input: "6", output: "saturday", visible: true },
            { input: "4", output: "thursday", visible: false },
            { input: "5", output: "friday", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-6A-002",
          title: "Permission to attempt exam",
          difficulty: "Easy",
          description:
            "Write a program that reads the attendance percentage A and status of having medical report M of a student and checks if any of the below conditions is satisfied.\nA is greater than or equal to 75.\nM is equal to `Y`.\nPrint allowed to write exam if any of the given conditions is satified.Otherwise,print cannot write exam.",
          sampleInput: "80%\nY",
          sampleOutput: "allowed to write exam",
          testCases: [
            { input: "70%\nY", output: "allowed to write exam", visible: true },
            { input: "55%\nN", output: "cannot write exam", visible: true },
            { input: "50%\nN", output: "cannot write exam", visible: false },
            { input: "40%\nN", output: "cannot write exam", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-6A-003",
          title: "Sum of the digits - 2",
          difficulty: "Easy",
          description:
            "Given an integer between 0 and 10000,write a program to print the sum of its digits.",
          sampleInput: "25",
          sampleOutput: "7",
          testCases: [
            { input: "342", output: "9", visible: true },
            { input: "244", output: "10", visible: true },
            { input: "80", output: "8", visible: false },
            { input: "82", output: "10", visible: false },
            { input: "88", output: "16", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-6A-004",
          title: "simple calculator",
          difficulty: "Easy",
          description:
            "Write a program that reads an operator `O`,and two numbers A and B.Print the result by doing arithmetic operations on A and B based on the operator `O`.",
          sampleInput: "+\n2\n3",
          sampleOutput: "5",
          testCases: [
            { input: "*\n4\n2", output: "8", visible: true },
            { input: "+\n4\n3", output: "7", visible: true },
            { input: "+\n4\n3", output: "7", visible: false },
            { input: "+\n4\n3", output: "7", visible: false },
            { input: "+\n4\n3", output: "7", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-6A-005",
          title: "Print the score - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a distance D in km and calculates the total score.\nFor the first 50km(0-50km),te score for each km is 3.\nFor the distance above 50km,the score for each km is 5.",
          sampleInput: "75",
          sampleOutput: "275",
          testCases: [
            { input: "30", output: "90", visible: true },
            { input: "75", output: "275", visible: true },
            { input: "30", output: "90", visible: false },
            { input: "30", output: "90", visible: false },
            { input: "30", output: "90", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-6A-006",
          title: "Print the score - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a distance D in km and calculates the total score.\nFor the first 20km(0-20km),te score for each km is 2.\nFor the next 40km(21-60km),the score for each km is 4.\nFor the distance above 60km,the score for each km is 6.\nApart from the above scores,there is a bonus score of 30.",
          sampleInput: "125",
          sampleOutput: "620",
          testCases: [
            { input: "15", output: "60", visible: true },
            { input: "50", output: "190", visible: true },
            { input: "50", output: "190", visible: false },
            { input: "50", output: "190", visible: false },
            { input: "50", output: "190", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-6A-007",
          title: "Print the value",
          difficulty: "Easy",
          description:
            "Write a program that reads a string- S.The string S contains a number except the last character.The last Character of the string contains T or H or K.\nprint the value by multiplying the number in S with 10 or 100 or 1000 based on the last character.(T=10,H=100,K=1000).",
          sampleInput: "34T",
          sampleOutput: "340",
          testCases: [
            { input: "6H", output: "600", visible: true },
            { input: "7K", output: "7000", visible: true },
            { input: "50T", output: "500", visible: false },
            { input: "50T", output: "500", visible: false },
            { input: "10H", output: "1000", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-6A-008",
          title: "Print the Score - 4",
          difficulty: "Easy",
          description:
            "Write a program that reads a distance D in km and calculates the total score.\nFor the first 40km(0-40Km),the score for each km is 2.\nFor the next 20km(41-60km),the score for each km is 4.\nFor the next 60km(61-120km),the score for each km is 6.\nFor the distance above 120km,the score for each km is 8.\nApart from the above scores,there is a bonus score of 50.",
          sampleInput: "70",
          sampleOutput: "270",
          testCases: [
            { input: "4", output: "58", visible: true },
            { input: "135", output: "690", visible: true },
            { input: "135", output: "690", visible: false },
            { input: "135", output: "690", visible: false },
            { input: "135", output: "690", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-6B",
      title: "Codingpractice-6B",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Codingpractice-6B-001",
          title: "Find the Group",
          difficulty: "Easy",
          description:
            "The numbers from 1 to 10 are divided into two groups,Group A and Group B.\nGroupA:(1,3,5,7,9)\nGroupB:(2,4,6,8,10)\nwrite a program that reads a number N and prints the group in which the given number N is present.The number N is always from 1 to 10.",
          sampleInput: "6",
          sampleOutput: "Group B",
          testCases: [
            { input: "1", output: "Group A", visible: true },
            { input: "10", output: "Group B", visible: true },
            { input: "6", output: "Group B", visible: false },
            { input: "3", output: "Group A", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-6B-002",
          title: "Denominations",
          difficulty: "Easy",
          description:
            "Write a program that reads an amount A and prints the minimum number of 5 and 1rupee notes required for the given amount.",
          sampleInput: "16",
          sampleOutput: "5:3\n1:1",
          testCases: [
            { input: "102", output: "5:20\n1:2", visible: true },
            { input: "1", output: "5:0\n1:1", visible: true },
            { input: "5", output: "5:1\n1:0", visible: false },
            { input: "12", output: "5:2\n1:2", visible: false },
            { input: "23", output: "5:4\n1:3", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-6B-003",
          title: "Denominations- 2",
          difficulty: "Easy",
          description:
            "Write a program that reads an amount A and prints the minimum number of 100,50,10 and 1 rupee notes required for the given amount.",
          sampleInput: "893",
          sampleOutput: "100:8\n50:1\n10:4\n1:3",
          testCases: [
            { input: "552", output: "100:5\n50:1\n10:0\n1:2", visible: true },
            { input: "250", output: "100:2\n50:1\n10:0\n1:0", visible: true },
            { input: "1", output: "100:0\n50:0\n10:0\n1:1", visible: false },
            { input: "50", output: "100:0\n50:1\n10:0\n1:0", visible: false },
            { input: "178", output: "100:1\n50:1\n10:2\n1:8", visible: false },
            { input: "999", output: "100:9\n50:1\n10:4\n1:9", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-6B-004",
          title: "Denominations- 3",
          difficulty: "medium",
          description:
            "Write a program that reads an amount A and prints the minimum number of 500,50,10 and 1 rupee notes required for the given amount.",
          sampleInput: "1543",
          sampleOutput: "500:3\n50:\n10:4\n1:3",
          testCases: [
            { input: "1259", output: "500:2\n50:5\n10:0\n1:9", visible: true },
            { input: "1543", output: "500:3\n50:\n10:4\n1:3", visible: true },
            { input: "1259", output: "500:2\n50:5\n10:0\n1:9", visible: false },
            { input: "1259", output: "500:2\n50:5\n10:0\n1:9", visible: false },
            { input: "1259", output: "500:2\n50:5\n10:0\n1:9", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-6B-005",
          title: "Find the Group - 2",
          difficulty: "medium",
          description:
            "The numbers from 1 to 30 are divided into six groups,Group 1,Group 2,Group 3,Group 4,Group 5 and Group 6.\nGroup 1(1,7,13,19,25)\nGroup 2(2,8,14,20,26)\nGroup 3(3,9,15,21,27)\nGroup 4(4,10,16,22,28)\nGroup 5(5,11,17,23,29)\nGroup 6(6,12,18,24,30)",
          sampleInput: "29",
          sampleOutput: "Group 5",
          testCases: [
            { input: "3", output: "Group 3", visible: true },
            { input: "6", output: "Group 6", visible: true },
            { input: "3", output: "Group 3", visible: false },
            { input: "3", output: "Group 3", visible: false },
            { input: "3", output: "Group 3", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-6",
      title: "Assignment-6",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Assignment-6-001",
          title: "Week Day",
          difficulty: "Easy",
          description:
            "Write a program that reads a day number and checks if the day is Week Start,Weekend ,or Midweek.\nNote:Monday and Tuesday are Week start\nWednesday,Thursday and Friday are Midweek.\nSaturday and sunday are weekend.\n(IMP::1=Monday,2=Tuesday...)",
          sampleInput: "6",
          sampleOutput: "Weekend",
          testCases: [
            { input: "1", output: "Week Start", visible: true },
            { input: "6", output: "Weekend", visible: true },
            { input: "3", output: "Midweek", visible: false },
            { input: "4", output: "Midweek", visible: false },
            { input: "2", output: "Week Start", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-6-002",
          title: "Print the score - 5",
          difficulty: "Easy",
          description:
            "Write a program that reads a Distance D in Km and calculates the score.\nFor the first 50km(0-50km),the score for each km is 3.\nFor the next 50km(51-100km),the score for each km is 5.\nFor the next 100km(101-200km),the score for each km is 6.\nFor the distance above 200km,the score for each km is 10.\nApart from the above scores,there is a bonus score of 100.",
          sampleInput: "120",
          sampleOutput: "620",
          testCases: [
            { input: "250", output: "1600", visible: true },
            { input: "120", output: "620", visible: true },
            { input: "10", output: "130", visible: false },
            { input: "50", output: "250", visible: false },
            { input: "75", output: "375", visible: false },
            { input: "150", output: "800", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-6-003",
          title: "Denominations - 4",
          difficulty: "Medium",
          description:
            "Write a program that reads an amount A and prints the minimum number of 100,50,20 and 10 rupee notes required for the given amount.",
          sampleInput: "370",
          sampleOutput: "100 Notes:3\n50 Notes:1\n20 Notes:1\n10 Notes:0",
          testCases: [
            {
              input: "250",
              output: "100 Notes:2\n50 Notes:1\n20 Notes:0\n10 Notes:0",
              visible: true,
            },
            {
              input: "120",
              output: "100 Notes:1\n50 Notes:0\n20 Notes:1\n10 Notes:0",
              visible: true,
            },
            {
              input: "380",
              output: "100 Notes:3\n50 Notes:1\n20 Notes:1\n10 Notes:1",
              visible: false,
            },
            {
              input: "150",
              output: "100 Notes:1\n50 Notes:1\n20 Notes:0\n10 Notes:0",
              visible: false,
            },

            {
              input: "90",
              output: "100 Notes:0\n50 Notes:1\n20 Notes:2\n10 Notes:0",
              visible: false,
            },
            {
              input: "70",
              output: "100 Notes:0\n50 Notes:1\n20 Notes:1\n10 Notes:0",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-6-004",
          title: "Denominations - 5",
          difficulty: "Medium",
          description:
            "Write a program that reads an amount A and prints the minimum number of 2000,500,200,50,20,5,2 and 1 rupee notes required for the given amount.",
          sampleInput: "2257",
          sampleOutput: "2000:1 500:0 200:1 50:1 20:0 5:1 2:1 1:0",
          testCases: [
            {
              input: "4000",
              output: "2000:2 500:0 200:0 50:0 20:0 5:0 2:0 1:0",
              visible: true,
            },
            {
              input: "3000",
              output: "2000:1 500:2 200:0 50:0 20:0 5:0 2:0 1:0",
              visible: true,
            },
            {
              input: "3000",
              output: "2000:1 500:2 200:0 50:0 20:0 5:0 2:0 1:0",
              visible: false,
            },
            {
              input: "2500",
              output: "2000:1 500:1 200:0 50:0 20:0 5:0 2:0 1:0",
              visible: false,
            },
            {
              input: "1000",
              output: "2000:0 500:2 200:0 50:0 20:0 5:0 2:0 1:0",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-6-005",
          title: "Day name - 2",
          difficulty: "Hard",
          description:
            "Given the weekday of the first day of the month,determine the day of the week of the given date in that month.",
          sampleInput: "Monday\n16",
          sampleOutput: "Tuesday",
          testCases: [
            {
              input: "Tuesday\n17",
              output: "Thursday",
              visible: true,
            },
            {
              input: "Monday\n16",
              output: "Tuesday",
              visible: true,
            },
            { input: "Sunday\n1", output: "Sunday", visible: false },
            { input: "Monday\n3", output: "Wednesday", visible: false },
            { input: "Friday\n2", output: "Saturday", visible: false },
            { input: "Saturday\n1", output: "Saturday", visible: false },
            { input: "Wednesday\n7", output: "Tuesday", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-6-006",
          title: "Maximum number of Handshakes",
          difficulty: "Medium",
          description:
            "It was Raj's first day at school.His teacher Anu asked the students to meet every other student in the class and introduce themselves.The teacher asked them to do Handshake when they meet each other.Write a program that reads an integer N and prints the number of Handshakes made by the students.",
          sampleInput: "5",
          sampleOutput: "10",
          testCases: [
            {
              input: "3",
              output: "3",
              visible: true,
            },
            {
              input: "5",
              output: "10",
              visible: true,
            },
            {
              input: "5",
              output: "10",
              visible: false,
            },
            {
              input: "5",
              output: "10",
              visible: false,
            },
            {
              input: "5",
              output: "10",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Python-Grand-Assignment-1",
      title: "Grand-Assignment-1",
      description: "Nested conditions",
      questions: [
        {
          id: "q-python-Grand-Assignment-1-001",
          title: "string repetition",
          difficulty: "Easy",
          description:
            "Write a program to print the given input word N times in a single line separated by space.",
          sampleInput: "pen\n2",
          sampleOutput: "pen pen ",
          testCases: [
            { input: "cat\n3", output: "cat cat cat ", visible: true },
            { input: "one\n4", output: "one one one one ", visible: true },
            { input: "dog\n2", output: "dog dog ", visible: false },
            { input: "hen\n2", output: "hen hen ", visible: false },
            { input: "hello\n1", output: "hello ", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-1-002",
          title: "First place",
          difficulty: "Easy",
          description:
            "Given a positive integer,write a program to print the digit in it's one's place.",
          sampleInput: "25",
          sampleOutput: "5",
          testCases: [
            { input: "200", output: "0", visible: true },
            { input: "351", output: "1", visible: true },
            { input: "33", output: "3", visible: false },
            { input: "23", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-1-003",
          title: "Days Conversion",
          difficulty: "Easy",
          description:
            "Given a number of days (N) as input, write a program to convert N to years (Y),weeks (W),and days(D).",
          sampleInput: "1329",
          sampleOutput: "3 years 33 weeks 3 days",
          testCases: [
            { input: "960", output: "2 years 32 weeks 6 days", visible: true },
            { input: "1329", output: "3 years 33 weeks 3 days", visible: true },
            { input: "365", output: "1 years 0 weeks 0 days", visible: false },
            { input: "400", output: "1 years 5 weeks 0 days", visible: false },
            { input: "7", output: "0 years 1 weeks 0 days", visible: false },
            { input: "30", output: "0 years 4 weeks 2 days", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-1-004",
          title: "Finding difference",
          difficulty: "Easy",
          description:
            "write a program to print the absolute difference between the two given numbers.(absolute difference is the difference without the negative sign).",
          sampleInput: "200\n500",
          sampleOutput: "300",
          testCases: [
            { input: "-12\n-1", output: "11", visible: true },
            { input: "200\n300", output: "100", visible: true },
            { input: "400\n200", output: "200", visible: false },
            { input: "300\n100", output: "200", visible: false },
            { input: "100\n50", output: "50", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Grand-Assignment-1-005",
          title: "Hand Game",
          difficulty: "Easy",
          description:
            "Abhinav and Anjali are playing a game called Rock-Paper-Scissors.It's a hand game usually played between two people.In this game,they both show their hands in one of three ways:\nRock,Paper, or Scissors.\nFor Example,\nIf Abhinav shows Rock and Anjali shows Scissors,Abhinav wins because Rock blunts Scissors.\nIf Anjali shows Paper and Abhinav shows Scissors,Abhinav wins because Scissors cut Paper.\nIf Anjali shows shows Paper and Abhinav shows Scissors,Abhinav wins because Scissors cut Paper.If Abhinav shows Paper and Anjali shows Rock,Abhinav wins because Paper wraps Rock.If both players show the same thing,it's a tie.For Example,if Abhinav and Anjali both show Rock,It's a tie.",
          sampleInput: "Rock\nPaper",
          sampleOutput: "Anjali Wins",
          testCases: [
            { input: "Scissors\nRock", output: "Anjali Wins", visible: true },
            { input: "Rock\nPaper", output: "Anjali Wins", visible: true },
            { input: "Rock\nPaper", output: "Anjali Wins", visible: false },
            { input: "Rock\nPaper", output: "Anjali Wins", visible: false },
            { input: "Rock\nPaper", output: "Anjali Wins", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Grand-Assignment-1-006",
          title: "Name of Month",
          difficulty: "Easy",
          description:
            "Given the number of the month,write a program to print the name of the month.\nNote:\nJanuary - 1\nFebruary - 2\n.\n.\n.December - 12.\nIf the given number of the month is less than 1 or greater than 12,print `Invalid month number`.",
          sampleInput: "4",
          sampleOutput: "April",
          testCases: [
            { input: "1", output: "January", visible: true },
            { input: "13", output: "Invalid month number", visible: true },
            { input: "21", output: "Invalid month number", visible: false },
            { input: "-1", output: "Invalid month number", visible: false },
            { input: "14", output: "Invalid month number", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Grand-Assignment-1-007",
          title: "Triangles",
          difficulty: "Easy",
          description:
            "Given three sides of the triangle(a,b,c) as input.Write a program to determine whether the triangle is equilateral,Isosceles or Scalene.",
          sampleInput: "4\n4\n4",
          sampleOutput: "Equilateral",
          testCases: [
            { input: "3\n2\n3", output: "Isosceles", visible: true },
            { input: "4\n5\n6", output: "Scalene", visible: true },
            { input: "3\n2\n3", output: "Isosceles", visible: false },
            { input: "3\n2\n3", output: "Isosceles", visible: false },
            { input: "3\n2\n3", output: "Isosceles", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Grand-Assignment-1-008",
          title: "Denominations",
          difficulty: "Easy",
          description:
            "Given an amount,write a program to find a minimum number of currency notes of different Denominations that sum to the given amount.Available note Denominations are 1000,500,100,50,20,5,1.",
          sampleInput: "8593",
          sampleOutput: "1000:8\n500:1\n100:0\n50:1\n20:2\n5:0\n1:3",
          testCases: [
            {
              input: "6000",
              output: "1000:6\n500:0\n100:0\n50:0\n20:0\n5:0\n1:0",
              visible: true,
            },
            {
              input: "1000",
              output: "1000:1\n500:0\n100:0\n50:0\n20:0\n5:0\n1:0",
              visible: true,
            },
            {
              input: "3000",
              output: "1000:3\n500:0\n100:0\n50:0\n20:0\n5:0\n1:0",
              visible: false,
            },
            {
              input: "2200",
              output: "1000:2\n500:0\n100:2\n50:0\n20:0\n5:0\n1:0",
              visible: false,
            },
            {
              input: "1000",
              output: "1000:1\n500:0\n100:0\n50:0\n20:0\n5:0\n1:0",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-7A",
      title: "Codingpractice-7A",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-7A-001",
          title: "Print N times",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the number 0 N times on N lines.",
          sampleInput: "4",
          sampleOutput: "0\n0\n0\n0",
          testCases: [
            { input: "1", output: "0", visible: true },
            { input: "2", output: "0\n0", visible: true },
            { input: "3", output: "0\n0\n0", visible: false },
            { input: "4", output: "0\n0\n0\n0", visible: false },
            { input: "5", output: "0\n0\n0\n0\n0", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7A-002",
          title: "Print N Integers",
          difficulty: "Easy",
          description:
            "Write a program to print integers from 1 to the given integer (N).",
          sampleInput: "4",
          sampleOutput: "1\n2\n3\n4",
          testCases: [
            { input: "5", output: "1\n2\n3\n4\n5", visible: true },
            { input: "1", output: "1", visible: true },
            { input: "3", output: "1\n2\n3", visible: false },
            {
              input: "10",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9\n10",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7A-003",
          title: "First N Natural Numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints N natural number from 1.",
          sampleInput: "4",
          sampleOutput: "1\n2\n3\n4",
          testCases: [
            { input: "1", output: "1", visible: true },
            { input: "3", output: "1\n2\n3", visible: true },
            { input: "5", output: "1\n2\n3\n4\n5", visible: false },
            {
              input: "10",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9\n10",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7A-004",
          title: "Print Integers - 2",
          difficulty: "Easy",
          description:
            "Given two integer numbers M and N,Write a program to print the integers from M to N.",
          sampleInput: "4\n8",
          sampleOutput: "4\n5\n6\n7\n8",
          testCases: [
            { input: "3\n5", output: "3\n4\n5", visible: true },
            { input: "-2\n1", output: "-2\n-1\n0\n1", visible: true },
            { input: "2\n5", output: "2\n3\n4\n5", visible: false },
            { input: "2\n4", output: "2\n3\n4", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7A-005",
          title: "Average of the N Numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the average of N numbers from 1.",
          sampleInput: "4",
          sampleOutput: "2.5",
          testCases: [
            { input: "7", output: "4.0", visible: true },
            { input: "5", output: "3.0", visible: true },
            { input: "10", output: "5.5", visible: false },
            { input: "2", output: "1.5", visible: false },
            { input: "100", output: "50.5", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7A-006",
          title: "Cubes of N numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the cube of N numbers from 1.",
          sampleInput: "3",
          sampleOutput: "1\n8\n27",
          testCases: [
            { input: "4", output: "1\n8\n27\n64", visible: true },
            {
              input: "10",
              output: "1\n8\n27\n64\n125\n216\n343\n512\n729\n1000",
              visible: true,
            },
            {
              input: "15",
              output:
                "1\n8\n27\n64\n125\n216\n343\n512\n729\n1000\n1331\n1728\n2197\n2744\n3375",
              visible: false,
            },
            {
              input: "20",
              output:
                "1\n8\n27\n64\n125\n216\n343\n512\n729\n1000\n1331\n1728\n2197\n2744\n3375\n4096\n4913\n5832\n6859\n8000",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-007",
          title: "Solid Rectangle",
          difficulty: "Easy",
          description:
            "Given two integers M and N,write a program to print a solid rectangle pattern of M rows and N columns using the asterisk character(*).",
          sampleInput: "3\n2",
          sampleOutput: "* *\n* *\n* *",
          testCases: [
            { input: "2\n3", output: "* * * \n* * * ", visible: true },
            { input: "2\n2", output: "* * \n* * ", visible: true },
            { input: "3\n2", output: "* * \n* * \n* *", visible: false },
            { input: "1\n4", output: "* * * * ", visible: false },
            { input: "1\n2", output: "* * ", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-008",
          title: "10 Numbers after N",
          difficulty: "Easy",
          description:
            "Write a program That reads a number N and Prints 10 numbers after N.",
          sampleInput: "3",
          sampleOutput: "4\n5\n6\n7\n8\n9\n10\n11\n12\n13",
          testCases: [
            {
              input: "5",
              output: "6\n7\n8\n9\n10\n11\n12\n13\n14\n15",
              visible: true,
            },
            {
              input: "2",
              output: "3\n4\n5\n6\n7\n8\n9\n10\n11\n12",
              visible: true,
            },
            {
              input: "4",
              output: "5\n6\n7\n8\n9\n10\n11\n12\n13\n14",
              visible: false,
            },
            {
              input: "3",
              output: "4\n5\n6\n7\n8\n9\n10\n11\n12\n13",
              visible: false,
            },
            {
              input: "3",
              output: "4\n5\n6\n7\n8\n9\n10\n11\n12\n13",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-009",
          title: "N Numbers after M",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N and prints N number after M.",
          sampleInput: "3\n2",
          sampleOutput: "4\n5",
          testCases: [
            { input: "2\n3", output: "3\n4\n5", visible: true },
            { input: "2\n2", output: "3\n4", visible: true },
            { input: "3\n2", output: "4\n5", visible: false },
            { input: "1\n4", output: "2\n3\n4\n5", visible: false },
            { input: "1\n2", output: "2\n3", visible: false },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-0010",
          title: "Sum of N numbers from M",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N and prints the sum of N numbers from M.",
          sampleInput: "7\n3",
          sampleOutput: "24",
          testCases: [
            { input: "2\n3", output: "9", visible: true },
            { input: "2\n2", output: "5", visible: true },
            { input: "3\n2", output: "7", visible: false },
            { input: "1\n4", output: "10", visible: false },
            { input: "1\n2", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-0011",
          title: "Solid right angled triangle",
          difficulty: "Easy",
          description:
            "Given an integer number (N) as input.Write a program to print the right-angled triangular pattern of N lines using an asterisk(*) character.\nNote:There is a space after every *.",
          sampleInput: "3",
          sampleOutput: "* \n* * \n* * *",
          testCases: [
            { input: "2", output: "* \n* * ", visible: true },
            { input: "4", output: "* \n* * \n* * * \n* * * * ", visible: true },
            { input: "3", output: "* \n* * \n* * * ", visible: false },
            { input: "1", output: "*", visible: false },
            { input: "1", output: "*", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-0012",
          title: "Sum of N natural numbers",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and Prints the sum of N natural numbers.",
          sampleInput: "3",
          sampleOutput: "6",
          testCases: [
            { input: "4", output: "10", visible: true },
            { input: "5", output: "15", visible: true },
            { input: "3", output: "6", visible: false },
            { input: "1", output: "1", visible: false },
            { input: "1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-0013",
          title: "Read N inputs",
          difficulty: "Easy",
          description:
            "Given an Integer N, Write a program which reads N  inputs and prints them.inputs in the next 3 lines and print them.If the given input integers in the next three lines are 8,11, and 25,the output should be 8,11,25.",
          sampleInput: "3\n8\n11\n25",
          sampleOutput: "8\n11\n25",
          testCases: [
            { input: "2\n3\n5", output: "3\n5", visible: true },
            { input: "4\n3\n7\n5\n9", output: "3\n7\n5\n9", visible: true },
            { input: "2\n3\n5", output: "3\n5", visible: false },
            { input: "2\n3\n5", output: "3\n5", visible: false },
            { input: "2\n3\n5", output: "3\n5", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-0014",
          title: "Product of N inputs",
          difficulty: "Medium",
          description:
            "Given a number N,Write a program that reads N numbers as input and prints the product of the given N numbers.\nInput:The first line of input contains an integer representing N.\nThe next N lines of input contain integers.\nOutput:The output should be the product of the given N inputs.",
          sampleInput: "3\n2\n3\n7",
          sampleOutput: "42",
          testCases: [
            { input: "2\n3\n5", output: "15", visible: true },
            { input: "2\n3\n7", output: "21", visible: true },
            { input: "2\n3\n5", output: "15", visible: false },
            { input: "2\n3\n5", output: "15", visible: false },
            { input: "2\n3\n5", output: "15", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-0015",
          title: "Sum of the given numbers",
          difficulty: "Medium",
          description:
            "Given a number N,Write a program that reads N numbers as input and prints the product of the given N numbers.\nInput:The first line of input contains an integer representing N.\nThe next N lines of input contain integers.\nOutput:The output should be the product of the given N inputs.",
          sampleInput: "3\n2\n3\n7",
          sampleOutput: "12",
          testCases: [
            { input: "2\n3\n5", output: "8", visible: true },
            { input: "2\n3\n7", output: "10", visible: true },
            { input: "2\n3\n5", output: "8", visible: false },
            { input: "2\n3\n5", output: "8", visible: false },
            { input: "2\n3\n5", output: "8", visible: false },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7A-0016",
          title: "Identify the mistake - print characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a word and prints each character of the word in a new line.",
          sampleInput: "gani",
          sampleOutput: "g\na\nn\ni",
          testCases: [
            { input: "python", output: "p\ny\nt\nh\no\nn", visible: true },
            { input: "bhumi", output: "b\nh\nu\nm\ni", visible: true },
            { input: "python", output: "p\ny\nt\nh\no\nn", visible: false },
            { input: "python", output: "p\ny\nt\nh\no\nn", visible: false },
            { input: "python", output: "p\ny\nt\nh\no\nn", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-7B",
      title: "Codingpractice-7B",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-7B-001",
          title: "Print length times",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the first character of the given string on N lines,where N is the length of the given string.",
          sampleInput: "cool",
          sampleOutput: "c\nc\nc\nc",
          testCases: [
            { input: "program", output: "p\np\np\np\np\np\np", visible: true },
            { input: "simple", output: "s\ns\ns\ns\ns\ns", visible: true },
            { input: "a", output: "a", visible: false },
            { input: "123", output: "1\n1\n1", visible: false },
            { input: "Python", output: "P\nP\nP\nP\nP\nP", visible: false },
            { input: "Z", output: "Z", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7B-002",
          title: "Print the characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints each character of the given string on a new line.",
          sampleInput: "cool",
          sampleOutput: "c\no\no\nl",
          testCases: [
            { input: "program", output: "p\nr\no\ng\nr\na\nm", visible: true },
            { input: "hello", output: "h\ne\nl\nl\no", visible: true },
            { input: "123", output: "1\n2\n3", visible: false },
            { input: "Python", output: "P\ny\nt\nh\no\nn", visible: false },
            { input: "Z9", output: "Z\n9", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7B-003",
          title: "square - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints a square of N rows and N columns using numbers starting from 1.",
          sampleInput: "3",
          sampleOutput: "111\n222\n333",
          testCases: [
            { input: "2", output: "11\n22", visible: true },
            { input: "4", output: "1111\n2222\n3333\n4444", visible: true },
            {
              input: "5",
              output: "11111\n22222\n33333\n44444\n55555",
              visible: false,
            },
            {
              input: "7",
              output:
                "1111111\n2222222\n3333333\n4444444\n5555555\n6666666\n7777777",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-7B-004",
          title: "Rectangle",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints a Rectangle of M rows and N columns using stars(*).",
          sampleInput: "3\n2",
          sampleOutput: "**\n**\n**",
          testCases: [
            { input: "2\n4", output: "****\n****", visible: true },
            { input: "3\n5", output: "*****\n*****\n*****", visible: true },
            { input: "2\n1", output: "*\n*", visible: false },
            { input: "3\n2", output: "**\n**\n**", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7B-005",
          title: "Right angled triangle",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints a right angled triangle of N rows using stars (*).",
          sampleInput: "4",
          sampleOutput: "*\n**\n***\n****",
          testCases: [
            { input: "2", output: "*\n**", visible: true },
            { input: "3", output: "*\n**\n***", visible: true },
            { input: "2", output: "*\n**", visible: false },
            { input: "2", output: "*\n**", visible: false },
            { input: "2", output: "*\n**", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7B-006",
          title: "Right angled triangle - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints a right angled triangle of N rows using numbers starting from 1.\nNote:There is a space after every number.",
          sampleInput: "4",
          sampleOutput: "1 \n2 2 \n3 3 3 \n4 4 4 4 ",
          testCases: [
            { input: "2", output: "1 \n2 2 ", visible: true },
            { input: "3", output: "1 \n2 2 \n3 3 3 ", visible: true },
            {
              input: "4",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4 ",
              visible: false,
            },
            {
              input: "4",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4 ",
              visible: false,
            },
            {
              input: "4",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7B-007",
          title: "Right angled triangle - 3",
          difficulty: "Easy",
          description:
            "Write a Program that reads a number N and prints a right angled triangle of N rows using stars (*) and pluses(+).\nThe first N-1 rows contains stars (*) and the Nth row contains pluses(+).",
          sampleInput: "4",
          sampleOutput: "* \n* * \n* * * \n+ + + + ",
          testCases: [
            { input: "2", output: "* \n+ + ", visible: true },
            { input: "3", output: "* \n* * \n+ + + ", visible: true },
            {
              input: "4",
              output: "* \n* * \n* * * \n+ + + + ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n+ + + + ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n+ + + + ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7B-008",
          title: "Two right angled triangle",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints two right angled triangles of N rows,using numbers starting from 1.",
          sampleInput: "4",
          sampleOutput:
            "1 \n2 2 \n3 3 3 \n4 4 4 4\n1 \n2 2 \n3 3 3 \n4 4 4 4  ",
          testCases: [
            { input: "2", output: "1 \n2 2\n1 \n2 2 ", visible: true },
            {
              input: "3",
              output: "1 \n2 2 \n3 3 3\n1 \n2 2 \n3 3 3 ",
              visible: true,
            },
            {
              input: "4",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4\n1 \n2 2 \n3 3 3\n4 4 4 4 ",
              visible: false,
            },
            {
              input: "4",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4\n1 \n2 2 \n3 3 3 \n4 4 4 4 ",
              visible: false,
            },
            {
              input: "4",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4\n1 \n2 2 \n3 3 3 \n4 4 4 4 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7B-008",
          title: "square",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints two right angled triangles of N rows,using numbers starting from 1.",
          sampleInput: "4",
          sampleOutput: "* * * * \n* * * * \n* * * * \n* * * * ",
          testCases: [
            { input: "2", output: "* * \n* * ", visible: true },
            { input: "3", output: "* * * \n* * * \n* * * ", visible: true },
            {
              input: "4",
              output: "* * * * \n* * * * \n* * * * \n* * * * ",
              visible: false,
            },
            {
              input: "4",
              output: "* * * * \n* * * * \n* * * * \n* * * * ",
              visible: false,
            },
            {
              input: "4",
              output: "* * * * \n* * * * \n* * * * \n* * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-7B-009",
          title: "Rectangle - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints a rectangle of M rows and N columns using stars(*).",
          sampleInput: "2\n3",
          sampleOutput: "* * * \n* * * ",
          testCases: [
            { input: "2\n4", output: "* * * * \n* * * * ", visible: true },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: true },
            { input: "2\n4", output: "* * * * \n* * * * ", visible: false },
            { input: "2\n4", output: "* * * * \n* * * * ", visible: false },
            { input: "2\n4", output: "* * * * \n* * * * ", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-7",
      title: "Assignment-7",
      description: "Loops",
      questions: [
        {
          id: "q-python-Assignment-7-001",
          title: "Rectangle - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints a rectangle of M rows and N columns using the numbers from 1 as shown in the sample output.",
          sampleInput: "3\n2",
          sampleOutput: "1 1 \n2 2 \n3 3 ",
          testCases: [
            { input: "1\n5", output: "1 1 1 1 1 ", visible: true },
            { input: "3\n3", output: "1 1 1 \n2 2 2 \n3 3 3 ", visible: true },
            { input: "5\n1", output: "1 \n2 \n3 \n4 \n5 ", visible: false },
            {
              input: "7\n4",
              output:
                "1 1 1 1 \n2 2 2 2 \n3 3 3 3 \n4 4 4 4 \n5 5 5 5 \n6 6 6 6 \n7 7 7 7 ",
              visible: false,
            },
            {
              input: "10\n5",
              output:
                "1 1 1 1 1 \n2 2 2 2 2 \n3 3 3 3 3 \n4 4 4 4 4 \n5 5 5 5 5 \n6 6 6 6 6 \n7 7 7 7 7 \n8 8 8 8 8 \n9 9 9 9 9 \n10 10 10 10 10 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-7-002",
          title: "Print N numbers from 0",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and print N numbers starting from 0.",
          sampleInput: "5",
          sampleOutput: "0\n1\n2\n3\n4",
          testCases: [
            { input: "3", output: "0\n1\n2", visible: true },
            { input: "4", output: "0\n1\n2\n3", visible: true },
            { input: "-3", output: "No Output", visible: true },
            { input: "1", output: "0", visible: false },
            { input: "5", output: "0\n1\n2\n3\n4", visible: false },

            {
              input: "10",
              output: "0\n1\n2\n3\n4\n5\n6\n7\n8\n9",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-7-003",
          title: "Average of N inputs",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N inputs and prints the average of the N inputs.\nInput:\nThe first line of input contains an integer representing N,The next N lines of input contain integers.\nOutput:\nThe output should be a single line containing a float that is the average of N inputs.",
          sampleInput: "3\n10\n20\n30",
          sampleOutput: "20.0",
          testCases: [
            { input: "1\n5", output: "5.0", visible: true },
            { input: "2\n5\n2", output: "3.5", visible: true },
            { input: "5\n1\n2\n3\n4\n5", output: "3.0", visible: false },
            { input: "3\n10\n20\n30", output: "20.0", visible: false },
            { input: "4\n0\n0\n0\n0", output: "0.0", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-7-004",
          title: "Right angled triangle - 4",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and print two right angled triangles,each of N rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "* \n* * \n* * * \n* \n* * \n* * * ",
          testCases: [
            { input: "1", output: "* \n* ", visible: true },
            { input: "2", output: "* \n* * \n* \n* * ", visible: true },
            {
              input: "3",
              output: "* \n* * \n* * * \n* \n* * \n* * * ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n* * * * \n* \n* * \n* * * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* \n* * \n* * * \n* * * * \n* * * * * \n* \n* * \n* * * \n* * * * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-7-005",
          title: "Product of N number after X",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers X and N and prints the product of N numbers after X.\nExample:x=4 and n=2.\nthe 2 numbers after 4 are 5&6.\nThe product of the next 2 numbers from 4 is(5*6=30).\nThe output should be 30.",
          sampleInput: "3\n2",
          sampleOutput: "20",
          testCases: [
            { input: "4\n3", output: "210", visible: true },
            { input: "2\n3", output: "60", visible: true },
            { input: "4\n2", output: "30", visible: false },
            { input: "4\n2", output: "30", visible: false },
            { input: "4\n3", output: "90", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-7-006",
          title: "Sum of N squares",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the sum of squares of N numbers starting from 1.",
          sampleInput: "4",
          sampleOutput: "30",
          testCases: [
            { input: "7", output: "140", visible: true },
            { input: "4", output: "30", visible: true },
            { input: "4", output: "30", visible: false },
            { input: "4", output: "30", visible: false },
            { input: "4", output: "30", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-7-007",
          title: "Print integers - 3",
          difficulty: "Easy",
          description:
            "Given an integer N. Write a program to print integers from N to 1.",
          sampleInput: "4",
          sampleOutput: "4\n3\n2\n1",
          testCases: [
            { input: "7", output: "7\n6\n5\n4\n3\n2\n1", visible: true },
            { input: "4", output: "4\n3\n2\n1", visible: true },
            { input: "4", output: "4\n3\n2\n1", visible: false },
            { input: "5", output: "5\n4\n3\n2\n1", visible: false },
            { input: "4", output: "4\n3\n2\n1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-8A",
      title: "Codingpractice-8A",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-8A-001",
          title: "Print length times(For Loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the first character(The character at index 0)of the given string on N lines,where N is the length of the given string.",
          sampleInput: "eagle",
          sampleOutput: "e\ne\ne\ne\ne",
          testCases: [
            { input: "apple", output: "a\na\na\na\na", visible: true },
            { input: "cat", output: "c\nc\nc", visible: true },
            { input: "dog", output: "d\nd\nd", visible: false },
            { input: "duck", output: "d\nd\nd\nd", visible: false },
            { input: "dell", output: "d\nd\nd\nd", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-8A-002",
          title: "Print the Characters(For loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints each character of the given string on a new line.",
          sampleInput: "python",
          sampleOutput: "p\ny\nt\nh\no\nn",
          testCases: [
            { input: "hello", output: "h\ne\nl\nl\no", visible: true },
            { input: "123", output: "1\n2\n3", visible: true },
            { input: "Python", output: "P\ny\nt\nh\no\nn", visible: false },
            { input: "Z9", output: "Z\n9", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-8A-003",
          title: "Print N integers(For loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints numbers from 1 to N.",
          sampleInput: "3",
          sampleOutput: "1\n2\n3",
          testCases: [
            { input: "5", output: "1\n2\n3\n4\n5", visible: true },
            { input: "6", output: "1\n2\n3\n4\n5\n6", visible: true },
            { input: "4", output: "1\n2\n3\n4", visible: false },
            { input: "3", output: "1\n2\n3", visible: false },
            { input: "2", output: "1\n2", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-8A-004",
          title: "First N Natural Numbers(For loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints Natural Numbers from 1 to N.\nNote:all the positive numbers from 1 are called Natural Nummbers.\nUse the For loop to iterate over the range of numbers.",
          sampleInput: "3",
          sampleOutput: "1\n2\n3",
          testCases: [
            { input: "6", output: "1\n2\n3\n4\n5\n6", visible: true },
            {
              input: "10",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9\n10",
              visible: true,
            },
            { input: "2", output: "1\n2", visible: false },
            { input: "3", output: "1\n2\n3", visible: false },
            { input: "4", output: "1\n2\n3\n4", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-8A-005",
          title: "Sum of N Natural Numbers(For Loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the sum of natural numbers from 1 to N.",
          sampleInput: "6",
          sampleOutput: "21",
          testCases: [
            { input: "3", output: "6", visible: true },
            { input: "2", output: "3", visible: true },
            { input: "4", output: "10", visible: false },
            { input: "6", output: "21", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-006",
          title: "Average of the N numbers(For Loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the average of numbers from 1 to N.",
          sampleInput: "8",
          sampleOutput: "4.5",
          testCases: [
            { input: "15", output: "8.0", visible: true },
            { input: "3", output: "2", visible: true },
            { input: "8", output: "4.5", visible: false },
            { input: "8", output: "4.5", visible: false },
            { input: "8", output: "4.5", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-007",
          title: "Cubes of N numbers(For Loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the cube of numbers from 1 to N.",
          sampleInput: "3",
          sampleOutput: "1\n8\n27",
          testCases: [
            { input: "5", output: "1\n8\n27\n64\n125", visible: true },
            { input: "4", output: "1\n8\n27\n64", visible: true },
            { input: "3", output: "1\n8\n27", visible: false },
            { input: "5", output: "1\n8\n27\n64\n125", visible: false },
            { input: "5", output: "1\n8\n27\n64\n125", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-008",
          title: "Read N inputs(For Loop)",
          difficulty: "Easy",
          description:
            "Given an integer N,write a program which reads N inputs and print them.(use For loop)",
          sampleInput: "3\n8\n11\n25",
          sampleOutput: "8\n11\n25",
          testCases: [
            { input: "2\n23\n3", output: "23\n3", visible: true },
            {
              input: "4\n22\n33\n33\n44",
              output: "22\n33\n33\n44",
              visible: true,
            },
            { input: "3\n2\n4\n5", output: "2\n4\n5", visible: false },
            { input: "2\n4\n6", output: "4\n6", visible: false },
            { input: "2\n6\n8", output: "6\n8", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-009",
          title: "Product of N inputs(For Loop)",
          difficulty: "Medium",
          description:
            "Given an integer N,write a program that reads N inputs and prints the product of the given inputs.",
          sampleInput: "3\n2\n3\n7",
          sampleOutput: "42",
          testCases: [
            { input: "4\n11\n2\n4\n9", output: "792", visible: true },
            { input: "3\n2\n3\n7", output: "42", visible: true },
            { input: "4\n11\n2\n4\n9", output: "792", visible: false },
            { input: "4\n11\n2\n4\n9", output: "792", visible: false },
            { input: "4\n11\n2\n4\n9", output: "792", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-0010",
          title: "Solid Rectangle",
          difficulty: "Easy",
          description:
            "Given two integers M and N,write a program to print a solid rectangle pattern of M rows and N columns using the asterisk character(*).\nNote:use for loop.",
          sampleInput: "2\n3",
          sampleOutput: "* * * \n* * * ",
          testCases: [
            { input: "2\n4", output: "* * * * \n* * * * ", visible: true },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: true },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: false },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: false },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-0011",
          title: "Solid Right angled Triangle",
          difficulty: "Easy",
          description:
            "Given an integer number(N) as input.Write a program to print the right-angled triangular pattern of N lines using an asterisk(*) character.\nNote:use For loop. ",
          sampleInput: "3",
          sampleOutput: "* \n* * \n* * * ",
          testCases: [
            { input: "4", output: "* \n* * \n* * *\n* * * *  ", visible: true },
            { input: "2", output: "* \n* * ", visible: true },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: false },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: false },
            { input: "3\n2", output: "* * \n* * \n* * ", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-0012",
          title: "Sum of the given numbers",
          difficulty: "Easy",
          description:
            "Given an integer N,write a program which reads N inputs and prints the sum of the given input integers.\nNote:use for loop.",
          sampleInput: "3\n8\n11\n25",
          sampleOutput: "44",
          testCases: [
            { input: "2\n7\n20", output: "27", visible: true },
            { input: "2\n20\n10", output: "30", visible: true },
            { input: "3\n2\n3\n4", output: "9", visible: false },
            { input: "3\n2\n3\n5", output: "10", visible: false },
            { input: "2\n2\n12", output: "14", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8A-0013",
          title: "Identify the mistake - styled word",
          difficulty: "Easy",
          description:
            "Write a program that prints the individual characters of the given word separated with hyphens(`-`).",
          sampleInput: "python",
          sampleOutput: "p-y-t-h-o-n",
          testCases: [
            { input: "loops", output: "l-o-o-p-s", visible: true },
            { input: "danger", output: "d-a-n-g-e-r", visible: true },
            { input: "hello", output: "h-e-l-l-o", visible: false },
            { input: "cat", output: "c-a-t", visible: false },
            { input: "dumb", output: "d-u-m-b", visible: false },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-8B",
      title: "Codingpractice-8B",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-8B-001",
          title: "10 numbers after N(For Loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints 10 numbers after N.\nuse For loop.",
          sampleInput: "10",
          sampleOutput: "11\n12\n13\n14\n15\n16\n17\n18\n19\n20",
          testCases: [
            {
              input: "0",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9\n10",
              visible: true,
            },
            {
              input: "5",
              output: "6\n7\n8\n9\n10\n11\n12\n13\n14\n15",
              visible: true,
            },
            {
              input: "10",
              output: "11\n12\n13\n14\n15\n16\n17\n18\n19\n20",
              visible: false,
            },
            {
              input: "-3",
              output: "-2\n-1\n0\n1\n2\n3\n4\n5\n6\n7",
              visible: false,
            },
            {
              input: "100",
              output: "101\n102\n103\n104\n105\n106\n107\n108\n109\n110",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-8B-002",
          title: "Print from M to N(For loop)",
          difficulty: "Easy",
          description:
            "Given two integer numbers M and N,write a program to print the integers from M to N.\nUse for loop.",
          sampleInput: "4\n6",
          sampleOutput: "4\n5\n6",
          testCases: [
            { input: "5\n10", output: "5\n6\n7\n8\n9\n10", visible: true },
            { input: "1\n5", output: "1\n2\n3\n4\n5", visible: true },
            { input: "3\n3", output: "3", visible: true },
            { input: "0\n0", output: "0", visible: false },
            { input: "-2\n2", output: "-2\n-1\n0\n1\n2", visible: false },
            {
              input: "10\n15",
              output: "10\n11\n12\n13\n14\n15",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-8B-003",
          title: "sum of numbers from M to N(for loop)",
          difficulty: "Easy",
          description:
            "Given two integer numbers M and N,write a program to print the sum of the numbers from M to N.\nUse for loop.",
          sampleInput: "2\n6",
          sampleOutput: "20",
          testCases: [
            { input: "10\n20", output: "165", visible: true },
            { input: "2\n5", output: "14", visible: true },
            { input: "-2\n2", output: "0", visible: false },
            { input: "10\n15", output: "75", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-8B-004",
          title: "Square(for loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints a square of N rows and N columns using stars(*).",
          sampleInput: "2",
          sampleOutput: "* * \n* * ",
          testCases: [
            { input: "3", output: "* * * \n* * * \n* * * ", visible: true },
            {
              input: "4",
              output: "* * * * \n* * * * \n* * * * \n* * * * ",
              visible: true,
            },
            { input: "1", output: "* ", visible: false },
            { input: "3", output: "* * * \n* * * \n* * * ", visible: false },
            {
              input: "4",
              output: "* * * * \n* * * * \n* * * * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* * * * * \n* * * * * \n* * * * * \n* * * * * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8B-005",
          title: "Square - 2(For Loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number M and prints a square of M rows and M columns using numbers.\nuse for loop.",
          sampleInput: "2",
          sampleOutput: "11\n22",
          testCases: [
            { input: "3", output: "111\n222\n333", visible: true },
            { input: "4", output: "1111\n2222\n3333\n4444", visible: true },
            { input: "3", output: "111\n222\n333", visible: false },
            {
              input: "5",
              output: "11111\n22222\n33333\n44444\n55555",
              visible: false,
            },
            {
              input: "5",
              output: "11111\n22222\n33333\n44444\n55555",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8B-006",
          title: "Rectangle(for loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N, and prints a rectangle of M rows and N columns using stars(*).\nUse for loop.",
          sampleInput: "3\n4",
          sampleOutput: "****\n****\n****",
          testCases: [
            { input: "3\n2", output: "**\n**\n**", visible: true },
            { input: "4\n2", output: "**\n**\n**\n**", visible: true },
            { input: "3\n3", output: "***\n***\n***", visible: false },
            { input: "5\n2", output: "**\n**\n**\n**\n**", visible: false },
            { input: "5\n2", output: "**\n**\n**\n**\n**", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8B-007",
          title: "Right Angled Triangle(for loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints a right angled triangle of N rows using stars(*).\nuse for loop.",
          sampleInput: "3",
          sampleOutput: "*\n**\n***",
          testCases: [
            { input: "4", output: "**\n**\n***\n****", visible: true },
            { input: "5", output: "*\n**\n***\n****\n*****", visible: true },
            { input: "3", output: "*\n**\n***", visible: false },
            { input: "3", output: "*\n**\n***", visible: false },
            { input: "3", output: "*\n**\n***", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8B-008",
          title: "Right Angled Triangle - 2(for loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints a right angled triangle of N rows using numbers.\nThere is a space after every number.",
          sampleInput: "3",
          sampleOutput: "1 \n2 2 \n3 3 3 ",
          testCases: [
            { input: "4", output: "1 \n2 2 \n3 3 3 \n4 4 4 4 ", visible: true },
            {
              input: "5",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4 \n5 5 5 5 5 ",
              visible: true,
            },
            { input: "3", output: "1 \n2 2 \n3 3 3 ", visible: false },
            { input: "3", output: "1 \n2 2 \n3 3 3 ", visible: false },
            { input: "3", output: "1 \n2 2 \n3 3 3 ", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8B-009",
          title: "Right Angled Triangle - 3(for loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints a right angled triangle of N rows using stars(*) and Pluses(+).\nThe first N-1 rows contains stars9*) and the Nth row contains pluses(+).",
          sampleInput: "4",
          sampleOutput: "* \n* * \n* * * \n+ + + + ",
          testCases: [
            { input: "4", output: "* \n* * \n* * * \n+ + + + ", visible: true },
            { input: "3", output: "* \n* * \n+ + + ", visible: true },
            {
              input: "4",
              output: "* \n* * \n* * * \n+ + + + ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n+ + + + ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n+ + + + ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Codingpractice-8B-0010",
          title: "Two right angled triangles(for loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints two right angled triangles of N rows,using numbers starting from 1.\nuse for loop.",
          sampleInput: "4",
          sampleOutput: "1\n22\n333\n4444\n1\n22\n333\n4444\n",
          testCases: [
            {
              input: "5",
              output: "1\n22\n333\n4444\n55555\n1\n22\n333\n4444\n55555",
              visible: true,
            },
            {
              input: "4",
              output: "1\n22\n333\n4444\n1\n22\n333\n4444\n",
              visible: true,
            },
            {
              input: "4",
              output: "1\n22\n333\n4444\n1\n22\n333\n4444\n",
              visible: false,
            },
            {
              input: "4",
              output: "1\n22\n333\n4444\n1\n22\n333\n4444\n",
              visible: false,
            },
            {
              input: "4",
              output: "1\n22\n333\n4444\n1\n22\n333\n4444\n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-8",
      title: "Assignment-8",
      description: "Loops",
      questions: [
        {
          id: "q-python-Assignment-8-001",
          title: "Rectangle - 3(For Loop)",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints a Rectangle of M rows and N columns using numbers.",
          sampleInput: "2\n3",
          sampleOutput: "1 1 1 \n2 2 2 ",
          testCases: [
            { input: "2\n4", output: "1 1 1 1 \n2 2 2 2 ", visible: true },
            { input: "1\n3", output: "1 1 1 ", visible: true },
            { input: "3\n2", output: "1 1 \n2 2 \n3 3 ", visible: false },
            { input: "4\n1", output: "1 \n2 \n3 \n4 ", visible: false },
            {
              input: "5\n3",
              output: "1 1 1 \n2 2 2 \n3 3 3 \n4 4 4 \n5 5 5 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-8-002",
          title: "print from 0 to N",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the numbers from 0 to N.\nUse for loop for iteration.",
          sampleInput: "7",
          sampleOutput: "0\n1\n2\n3\n4\n5\n6\n7",
          testCases: [
            { input: "3", output: "0\n1\n2\n3", visible: true },
            { input: "4", output: "0\n1\n2\n3\n4", visible: true },
            { input: "0", output: "0", visible: false },
            { input: "3", output: "0\n1\n2\n3", visible: false },
            { input: "1", output: "0\n1", visible: false },
            { input: "5", output: "0\n1\n2\n3\n4\n5", visible: false },
            {
              input: "10",
              output: "0\n1\n2\n3\n4\n5\n6\n7\n8\n9\n10",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-8-003",
          title: "Average of N inputs",
          difficulty: "Easy",
          description:
            "Given a number N ,write a program that reads N inputs and prints the average of the given N inputs.\nUse For loop.",
          sampleInput: "2\n10\n20",
          sampleOutput: "15.0",
          testCases: [
            { input: "2\n24\n15", output: "19.5", visible: true },
            { input: "3\n2\n4\n6", output: "4.0", visible: true },
            { input: "5\n1\n2\n3\n4\n5", output: "3.0", visible: false },
            { input: "2\n10\n20", output: "15.0", visible: false },
            { input: "4\n0\n0\n0\n0", output: "0.0", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-8-004",
          title: "Right Angled Triangle - 4",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N,and prints two right angled triangles on N rows using stars(*).\nUse For loop.",
          sampleInput: "4",
          sampleOutput:
            "* \n* * \n* * * \n* * * * \n* \n* * \n* * * \n* * * * ",
          testCases: [
            { input: "2", output: "* \n* * \n* \n* * ", visible: true },
            {
              input: "3",
              output: "* \n* * \n* * * \n* \n* * \n* * * ",
              visible: true,
            },
            { input: "1", output: "* \n* ", visible: false },
            { input: "2", output: "* \n* * \n* \n* * ", visible: false },

            {
              input: "3",
              output: "* \n* * \n* * * \n* \n* * \n* * * ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n* * * * \n* \n* * \n* * * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* \n* * \n* * * \n* * * * \n* * * * * \n* \n* * \n* * * \n* * * * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-8-005",
          title: "Product of the numbers from M to N",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints the product of numbers from M to N.\nuse For loop.",
          sampleInput: "4\n5",
          sampleOutput: "20",
          testCases: [
            { input: "2\n4", output: "24", visible: true },
            { input: "3\n5", output: "60", visible: true },
            { input: "4\n5", output: "20", visible: false },
            { input: "5\n7", output: "210", visible: false },
            { input: "9\n14", output: "2162160", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

          id: "q-python-Assignment-8-006",
          title: "Sum of N squares(For loop)",
          difficulty: "Easy",
          description:
            "Write a program to print the sum of the squares of the first N natural numbers.",
          sampleInput: "6",
          sampleOutput: "91",
          testCases: [
            { input: "3", output: "14", visible: true },
            { input: "6", output: "91", visible: true },
            { input: "6", output: "91", visible: false },
            { input: "3", output: "14", visible: false },
            { input: "6", output: "91", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-8-007",
          title: "Print integers - 3",
          difficulty: "Easy",
          description:
            "You are given an integers N as input.Write a program to print integers from N to 1.\nUse for Loop.",
          sampleInput: "6",
          sampleOutput: "6\n5\n4\n3\n2\n1",
          testCases: [
            { input: "3", output: "3\n2\n1", visible: true },
            { input: "6", output: "6\n5\n4\n3\n2\n1", visible: true },
            { input: "6", output: "6\n5\n4\n3\n2\n1", visible: false },
            { input: "3", output: "3\n2\n1", visible: false },
            { input: "6", output: "6\n5\n4\n3\n2\n1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-8-008",
          title: "Solid rectangle - 2",
          difficulty: "Easy",
          description:
            "Write a program to print a rectangle pattern of M rows and N columns using the plus character(+).\nUse For Loop.",
          sampleInput: "3\n4",
          sampleOutput: "+ + + + \n+ + + + \n+ + + + ",
          testCases: [
            {
              input: "3\n4",
              output: "+ + + + \n+ + + + \n+ + + + ",
              visible: true,
            },
            { input: "2\n4", output: "+ + + + \n+ + + + ", visible: true },
            {
              input: "3\n4",
              output: "+ + + + \n+ + + + \n+ + + + ",
              visible: false,
            },
            {
              input: "3\n4",
              output: "+ + + + \n+ + + + \n+ + + + ",
              visible: false,
            },
            {
              input: "3\n4",
              output: "+ + + + \n+ + + + \n+ + + + ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-8-009",
          title: "Solid Right Angled Triangle-2",
          difficulty: "Medium",
          description:
            "Given an integer number N as input.Write a program to print the double triangular pattern of N lines using an asterisk(*)character as shown below.x\nUse for-loop.",
          sampleInput: "3",
          sampleOutput: "* \n* * \n* * * ",
          testCases: [
            { input: "3", output: "* \n* * \n* * * ", visible: true },
            { input: "2", output: "* \n* * ", visible: true },
            { input: "3", output: "* \n* * \n* * * ", visible: false },
            { input: "3", output: "* \n* * \n* * * ", visible: false },
            { input: "3", output: "* \n* * \n* * * ", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-9A",
      title: "Codingpractice-9A",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-9A-001",
          title: "Print the digits of a number",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and prints all the digits of the given number separated by a space.",
          sampleInput: "165",
          sampleOutput: "1 6 5 ",
          testCases: [
            { input: "345", output: "3 4 5 ", visible: true },
            { input: "234", output: "2 3 4 ", visible: true },
            { input: "294", output: "2 9 4 ", visible: false },
            { input: "2234", output: "2 2 3 4 ", visible: false },
            { input: "286", output: "2 8 6 ", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-9A-002",
          title: "Sum of the digits",
          difficulty: "Easy",
          description:
            "Write a program that reads a number and prints all the digits of the given number separated by a space.",
          sampleInput: "294",
          sampleOutput: "15",
          testCases: [
            { input: "345", output: "12", visible: true },
            { input: "234", output: "9", visible: true },
            { input: "294", output: "15", visible: false },
            { input: "2234", output: "11", visible: false },
            { input: "286", output: "16", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-9A-003",
          title: "Factorial",
          difficulty: "Easy",
          description:
            "Write a program to print the factorial of N.Factorial is the product of all positive integers less than or equal to N.\nNote:The factorial of 0 is 1.",
          sampleInput: "5",
          sampleOutput: "120",
          testCases: [
            { input: "1", output: "1", visible: true },
            { input: "3", output: "6", visible: true },
            { input: "5", output: "120", visible: false },
            { input: "7", output: "5040", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-9A-004",
          title: "Sum of Cubes",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N,and prints the sum of the cubes of numbers from 1 to N.",
          sampleInput: "3",
          sampleOutput: "36",
          testCases: [
            { input: "1", output: "1", visible: true },
            { input: "2", output: "9", visible: true },
            { input: "3", output: "36", visible: false },
            { input: "5", output: "225", visible: false },
            { input: "10", output: "3025", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-9A-005",
          title: "Sum and average of the 10 inputs",
          difficulty: "Easy",
          description:
            "Write a program that reads 10 inputs and prints the sum and average of the given 10 inputs.",
          sampleInput: "4\n7\n14\n25\n1\n8\n24\n38\n99\n10",
          sampleOutput: "230\n23.0",
          testCases: [
            {
              input: "1\n2\n3\n4\n5\n6\n7\n8\n9\n10",
              output: "55\n5.5",
              visible: true,
            },
            {
              input: "10\n10\n10\n10\n10\n10\n10\n10\n10\n10",
              output: "100\n10.0",
              visible: true,
            },
            {
              input: "0\n0\n0\n0\n0\n0\n0\n0\n0\n0",
              output: "0\n0.0",
              visible: false,
            },
            {
              input: "1\n1\n1\n1\n1\n1\n1\n1\n1\n1",
              output: "10\n1.0",
              visible: false,
            },
            {
              input: "5\n10\n15\n20\n25\n30\n35\n40\n45\n50",
              output: "275\n27.5",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-006",
          title: "Sum of squares from M to N",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints the sum of squares of numbers from M to N.",
          sampleInput: "2\n4",
          sampleOutput: "29",
          testCases: [
            { input: "3\n8", output: "199", visible: true },
            { input: "2\n4", output: "29", visible: true },
            { input: "3\n8", output: "199", visible: false },
            { input: "3\n8", output: "199", visible: false },
            { input: "3\n8", output: "199", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-007",
          title: "Print even numbers up to N",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints even numbers from 1 to N.",
          sampleInput: "7",
          sampleOutput: "2\n4\n6",
          testCases: [
            { input: "3", output: "2", visible: true },
            { input: "4", output: "2\n4", visible: true },
            { input: "8", output: "2\n4\n6\n8", visible: false },
            { input: "8", output: "2\n4\n6\n8", visible: false },
            { input: "3", output: "2", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-008",
          title: "Print odd numbers from M to N",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N and prints odd numbers from M to N separated by a space.",
          sampleInput: "5\n10",
          sampleOutput: "5 7 9",
          testCases: [
            { input: "3\n8", output: "3 5 7", visible: true },
            { input: "4\n9", output: "5 7 9", visible: true },
            { input: "8\n13", output: "9 11 13", visible: false },
            { input: "8\n10", output: "9", visible: false },
            { input: "3\n8", output: "3 5 7", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-009",
          title: "Sum of Even numbers upto N",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the sum of the even numbers from 1 to N.",
          sampleInput: "6",
          sampleOutput: "12",
          testCases: [
            { input: "10", output: "30", visible: true },
            { input: "6", output: "12", visible: true },
            { input: "6", output: "12", visible: false },
            { input: "6", output: "12", visible: false },
            { input: "6", output: "12", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-0010",
          title: "Sum of odd numbers upto N",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the sum of the odd numbers from 1 to N.",
          sampleInput: "6",
          sampleOutput: "9",
          testCases: [
            { input: "15", output: "64", visible: true },
            { input: "6", output: "9", visible: true },
            { input: "6", output: "9", visible: false },
            { input: "6", output: "9", visible: false },
            { input: "6", output: "9", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-0011",
          title: "Sum of even numbers from M to N",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N and prints the sum of the even numbers from M to N.",
          sampleInput: "2\n6",
          sampleOutput: "12",
          testCases: [
            { input: "10\n20", output: "90", visible: true },
            { input: "2\n6", output: "12", visible: true },
            { input: "10\n20", output: "90", visible: false },
            { input: "10\n20", output: "90", visible: false },
            { input: "10\n20", output: "90", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-0012",
          title: "Product of odd numbers from M to N",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints the product of odd numbers from M to N.",
          sampleInput: "2\n7",
          sampleOutput: "105",
          testCases: [
            { input: "4\n8", output: "35", visible: true },
            { input: "2\n7", output: "105", visible: true },
            { input: "4\n8", output: "35", visible: false },
            { input: "4\n8", output: "35", visible: false },
            { input: "4\n8", output: "35", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9A-0013",
          title: "Sum of odd numbers from M to N",
          difficulty: "Easy",
          description:
            "Given two integers M and N,write a program to print the sum of the odd numbers from M to N.",
          sampleInput: "5\n13",
          sampleOutput: "45",
          testCases: [
            { input: "5\n13", output: "45", visible: true },
            { input: "10\n20", output: "75", visible: true },
            { input: "5\n13", output: "45", visible: false },
            { input: "5\n13", output: "45", visible: false },
            { input: "5\n13", output: "45", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-9B",
      title: "Codingpractice-9B",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-9B-001",
          title: "Print Numbers Divisible by T",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers N and T,and prints all the numbers from 1 to N that are divisible by T.",
          sampleInput: "10\n3",
          sampleOutput: "3\n6\n9",
          testCases: [
            { input: "21\n5", output: "5\n10\n15\n20", visible: true },
            { input: "10\n2", output: "2\n4\n6\n8\n10", visible: true },
            { input: "15\n3", output: "3\n6\n9\n12\n15", visible: false },
            { input: "10\n3", output: "3\n6\n9", visible: false },
            { input: "20\n5", output: "5\n10\n15\n20", visible: false },
            { input: "1\n1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-9B-002",
          title: "Sum of Numbers Divisible by T",
          difficulty: "Easy",
          description:
            "Given three integers,write a program to print the sum of the numbers divisible by the given number T from M to N.",
          sampleInput: "2\n5\n9",
          sampleOutput: "14",
          testCases: [
            { input: "2\n2\n10", output: "30", visible: true },
            { input: "3\n3\n9", output: "18", visible: true },
            { input: "5\n1\n20", output: "50", visible: false },
            { input: "4\n1\n16", output: "40", visible: false },
            { input: "7\n1\n50", output: "196", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-9B-003",
          title: "Count of numbers divisible by T",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers N and T and prints the count of numbers from 1 to N that are divisible by T.",
          sampleInput: "12\n3",
          sampleOutput: "4",
          testCases: [
            { input: "25\n5", output: "5", visible: true },
            { input: "10\n2", output: "5", visible: true },
            { input: "15\n3", output: "5", visible: false },
            { input: "5\n7", output: "0", visible: false },
            { input: "20\n5", output: "4", visible: false },
            { input: "1\n1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-9B-004",
          title: "Print numbers divisible by 2 and 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints all the numbers from 1 to N that are divisible by both 2 and 3.",
          sampleInput: "15",
          sampleOutput: "6\n12",
          testCases: [
            { input: "9", output: "6", visible: true },
            { input: "10", output: "6", visible: true },
            { input: "20", output: "6\n12\n18", visible: false },
            { input: "36", output: "6\n12\n18\n24\n30\n36", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-005",
          title: "Count of numbers divisible by 2 and 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the count of numbers from 1 to N that are divisible by both 2 and 3.",
          sampleInput: "12",
          sampleOutput: "3",
          testCases: [
            { input: "21", output: "3", visible: true },
            { input: "100", output: "16", visible: true },
            { input: "9", output: "6", visible: false },
            { input: "24", output: "4", visible: false },
            { input: "21", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-006",
          title: "Print required characters",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the a and z characters in the string.",
          sampleInput: "zigzag",
          sampleOutput: "z\nz\na",
          testCases: [
            { input: "zap", output: "z\na", visible: true },
            { input: "zim", output: "z", visible: true },
            { input: "zal", output: "z\na", visible: false },
            { input: "zazm", output: "z\na\nz", visible: false },
            { input: "zmp", output: "z", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-007",
          title: "Print Vowels",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the vowel in the string.\nNote:a,e,i,o,u(Vowels).",
          sampleInput: "india",
          sampleOutput: "i\ni\na",
          testCases: [
            { input: "python", output: "o", visible: true },
            { input: "orange", output: "o\na\ne", visible: true },
            { input: "zal", output: "a", visible: false },
            { input: "zazm", output: "a", visible: false },
            { input: "next", output: "e", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-008",
          title: "Count Vowels",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the count of vowels in the string.",
          sampleInput: "india",
          sampleOutput: "3",
          testCases: [
            { input: "python", output: "1", visible: true },
            { input: "orange", output: "3", visible: true },
            { input: "zal", output: "1", visible: false },
            { input: "zazm", output: "1", visible: false },
            { input: "next", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-009",
          title: "Print N numbers in reverse",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints the numbers from N to 1.",
          sampleInput: "3",
          sampleOutput: "3\n2\n1",
          testCases: [
            { input: "4", output: "4\n3\n2\n1", visible: true },
            { input: "8", output: "8\n7\n6\n5\n4\n3\n2\n1", visible: true },
            { input: "4", output: "4\n3\n2\n1", visible: false },
            { input: "2", output: "2\n1", visible: false },
            { input: "5", output: "5\n4\n3\n2\n1", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-0010",
          title: "Print from M to N in reverse",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints the numbers from N to M.",
          sampleInput: "3\n7",
          sampleOutput: "7\n6\n5\n4\n3",
          testCases: [
            { input: "4\n8", output: "8\n7\n6\n5\n4", visible: true },
            { input: "8\n10", output: "10\n9\n8", visible: true },
            { input: "4\n6", output: "6\n5\n4", visible: false },
            { input: "2\n4", output: "4\n3\n2", visible: false },
            { input: "5\n7", output: "7\n6\n5", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-0011",
          title: "Print characters in reverse",
          difficulty: "Easy",
          description:
            "Write a program that reads a string and prints the characters of a string in reverse order.",
          sampleInput: "school",
          sampleOutput: "l\no\no\nh\nc\ns",
          testCases: [
            { input: "dog", output: "g\no\nd", visible: true },
            { input: "cat", output: "t\na\nc", visible: true },
            { input: "gani", output: "i\nn\na\ng", visible: false },
            { input: "hen", output: "n\ne\nh", visible: false },
            { input: "bel", output: "l\ne\nb", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-0012",
          title: "Print odd numbers from N to M",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and prints the odd numbers from N to M separated by a space.",
          sampleInput: "1\n10",
          sampleOutput: "9 7 5 3 1",
          testCases: [
            { input: "5\n15", output: "15 13 11 9 7 5", visible: true },
            { input: "3\n8", output: "7 5 3", visible: true },
            { input: "2\n8", output: "7 5 3", visible: false },
            { input: "5\n10", output: "9 7 5", visible: false },
            { input: "6\n8", output: "7", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-0013",
          title: "Inverted Right Angled Triangle",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints an Inverted Right Angled Triangle of N rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "***\n**\n*",
          testCases: [
            { input: "5", output: "*****\n****\n***\n**\n*", visible: true },
            { input: "2", output: "**\n*", visible: true },
            { input: "3", output: "***\n**\n*", visible: false },
            { input: "3", output: "***\n**\n*", visible: false },
            { input: "4", output: "****\n***\n**\n*", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-9B-0014",
          title: "Inverted Right Angled Triangle - 2",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and prints an Inverted Right Angled Triangle of N rows using Numbers.",
          sampleInput: "3",
          sampleOutput: "333\n22\n1",
          testCases: [
            { input: "5", output: "55555\n4444\n333\n22\n1", visible: true },
            { input: "2", output: "22\n1", visible: true },
            { input: "3", output: "333\n22\n1", visible: false },
            { input: "3", output: "333\n22\n1", visible: false },
            { input: "4", output: "4444\n333\n22\n11", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-9",
      title: "Assignment-9",
      description: "Loops",
      questions: [
        {
          id: "q-python-Assignment-9-001",
          title: "Product of numbers divisible by 3 from M to N",
          difficulty: "Easy",
          description:
            "Write a program that reads two numbers M and N,and finds the product of the numbers from M to N that are divisible by 3.\nPrint the product of the numbers from M to N that are divisible by 3.If there are no numbers that are divisible by 3 from M to N.Otherwise,print 1.",
          sampleInput: "2\n7",
          sampleOutput: "18",
          testCases: [
            { input: "1\n10", output: "162", visible: true },
            { input: "3\n6", output: "18", visible: true },
            { input: "1\n2", output: "1", visible: false },
            { input: "6\n12", output: "648", visible: false },
            { input: "10\n20", output: "3240", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-9-002",
          title: "Sum of K powers",
          difficulty: "Medium",
          description:
            "Write a program that reads two numbers N and K and prints the sum of the K^th power of all the numbers from 1 to N.",
          sampleInput: "5\n3",
          sampleOutput: "225",
          testCases: [
            { input: "2\n8", output: "257", visible: true },
            { input: "5\n3", output: "225", visible: true },
            { input: "3\n2", output: "14", visible: false },
            { input: "5\n1", output: "15", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-9-003",
          title: "Count of numbers divisible by 6 and 8",
          difficulty: "easy",
          description:
            "Write a program that reads a number N and prints the count of numbers from 1 to N that are divisible by both 6 and 8.",
          sampleInput: "50",
          sampleOutput: "2",
          testCases: [
            { input: "175", output: "7", visible: true },
            { input: "24", output: "1", visible: true },
            { input: "48", output: "2", visible: false },
            { input: "50", output: "2", visible: false },
            { input: "100", output: "4", visible: false },
          ],
          defaultCode: ``,
          score: 44,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-9-004",
          title: "Inverted right angled triangle - 3",
          difficulty: "easy",
          description:
            "Write a program that reads a number N and prints an Inverted right angled triangle of N rows using stars(*) and pluses(+).\nThe first row contains N stars (*)and the next N-1 rows contain pluses(+).",
          sampleInput: "4",
          sampleOutput: "****\n+++\n++\n+",
          testCases: [
            { input: "1", output: "*", visible: true },
            { input: "2", output: "**\n+", visible: true },
            { input: "3", output: "***\n++\n+", visible: false },
            { input: "4", output: "****\n+++\n++\n+", visible: false },
            { input: "5", output: "*****\n++++\n+++\n++\n+", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-9-005",
          title: "Two right angled triangle - 2",
          difficulty: "easy",
          description:
            "Write a program that reads a number N and prints a right angled triangle of N rows and an Inverted right angled of N rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "*\n**\n***\n***\n**\n*",
          testCases: [
            { input: "1", output: "*\n*", visible: true },
            { input: "2", output: "*\n**\n**\n*", visible: true },
            { input: "3", output: "*\n**\n***\n***\n**\n*", visible: false },
            {
              input: "4",
              output: "*\n**\n***\n****\n****\n***\n**\n*",
              visible: false,
            },
            {
              input: "5",
              output: "*\n**\n***\n****\n*****\n*****\n****\n***\n**\n*",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-9-006",
          title: "Find power of Number",
          difficulty: "easy",
          description:
            "Given an integer N,and exponent M as input,write a program to calculate N power M without using the power operator(**).",
          sampleInput: "2\n3",
          sampleOutput: "8",
          testCases: [
            { input: "3\n3", output: "27", visible: true },
            { input: "2\n3", output: "8", visible: true },
            { input: "3\n3", output: "27", visible: false },
            { input: "2\n1", output: "2", visible: false },
            { input: "5\n2", output: "25", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-9-007",
          title: "Product of Numbers from M to N",
          difficulty: "easy",
          description:
            "Given two integers M,N.Write a program to print the product of numbers in the range M and N(inclusive of M and N).",
          sampleInput: "2\n5",
          sampleOutput: "120",
          testCases: [
            { input: "1\n4", output: "24", visible: true },
            { input: "2\n6", output: "720", visible: true },
            { input: "3\n4", output: "12", visible: false },
            { input: "2\n3", output: "6", visible: false },
            { input: "5\n6", output: "30", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-10A",
      title: "Codingpractice-10A",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-10A-001",
          title: "Multiplication Table",
          difficulty: "Easy",
          description:
            "write a program to print the multiplication table of the given number(N)up to ten multiples in the format `N x i= M`.",
          sampleInput: "3",
          sampleOutput:
            "3x1=3\n3x2=6\n3x3=9\n3x4=12\n3x5=15\n3x6=18\n3x7=21\n3x8=24\n3x9=27\n3x10=30",
          testCases: [
            {
              input: "3",
              output:
                "3x1=3\n3x2=6\n3x3=9\n3x4=12\n3x5=15\n3x6=18\n3x7=21\n3x8=24\n3x9=27\n3x10=30",
              visible: true,
            },
            {
              input: "5",
              output:
                "5x1=5\n5x2=10\n5x3=15\n5x4=20\n5x5=25\n5x6=30\n5x7=35\n5x8=40\n5x9=45\n5x10=50",
              visible: true,
            },
            {
              input: "1",
              output:
                "1x1=1\n1x2=2\n1x3=3\n1x4=4\n1x5=5\n1x6=6\n1x7=7\n1x8=8\n1x9=9\n1x10=10",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10A-002",
          title: "Vowels in a string",
          difficulty: "Easy",
          description:
            "Given a string S,Write a program to find the vowels in the given string S.\nPrint the resultant string by joining all the vowels in the string S.",
          sampleInput: "cat",
          sampleOutput: "a",
          testCases: [
            { input: "dog", output: "o", visible: true },
            { input: "animal", output: "aia", visible: true },
            { input: "mango", output: "ao", visible: false },
            { input: "dell", output: "e", visible: false },
            { input: "long", output: "o", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10A-003",
          title: "Reverse the string",
          difficulty: "Easy",
          description:
            "Write a program to print the reverse of the given string.",
          sampleInput: "hello onesolutions!",
          sampleOutput: "!snoituloseno olleh",
          testCases: [
            { input: "python", output: "nohtyp", visible: true },
            { input: "OpenAI", output: "IAnepO", visible: true },
            { input: "Hello World", output: "dlroW olleH", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10A-004",
          title: "Sum of K Powers - 2",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print the sum of the Kth power of all the digits in the given number.\nK indicates the number of digits of the number N.",
          sampleInput: "24753",
          sampleOutput: "21231",
          testCases: [
            { input: "17", output: "50", visible: true },
            { input: "123", output: "36", visible: true },
            { input: "405", output: "189", visible: false },
            { input: "999", output: "2187", visible: false },
            { input: "1024", output: "273", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10A-005",
          title: "Armstrong Number - 3",
          difficulty: "Easy",
          description:
            "Write a program that reads a number N and checks if N is an Armstrong Number.Print Armstrong Number is the given number is an Armstrong Number.Otherwise,Print Not an Armstrong Number.",
          sampleInput: "54748",
          sampleOutput: "Armstrong Number",
          testCases: [
            { input: "24", output: "Not an Armstrong Number", visible: true },
            { input: "153", output: "Armstrong Number", visible: true },
            { input: "370", output: "Armstrong Number", visible: false },
            { input: "9474", output: "Armstrong Number", visible: false },
            { input: "123", output: "Not an Armstrong Number", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10A-006",
          title: "Factors of a number",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the factors of the number N.",
          sampleInput: "6",
          sampleOutput: "1\n2\n3\n6",
          testCases: [
            { input: "18", output: "1\n2\n3\n6\n9\n18", visible: true },
            { input: "10", output: "1\n2\n5\n10", visible: true },
            { input: "7", output: "1\n7", visible: false },
            { input: "12", output: "1\n2\n3\n4\n6\n12", visible: false },
            { input: "1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10A-007",
          title: "Factors of a number - 2",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print all the factors of N separated by a space as shown in the sample output.",
          sampleInput: "6",
          sampleOutput: "1 2 3 6",
          testCases: [
            { input: "15", output: "1 3 5 15", visible: true },
            { input: "10", output: "1 2 5 10", visible: true },
            { input: "7", output: "1 7", visible: false },
            { input: "12", output: "1 2 3 4 6 12", visible: false },
            { input: "1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10A-008",
          title: "Sum of all factors",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the sum of all the factors of the number N.",
          sampleInput: "12",
          sampleOutput: "28",
          testCases: [
            { input: "15", output: "24", visible: true },
            { input: "10", output: "18", visible: true },
            { input: "7", output: "8", visible: false },
            { input: "12", output: "28", visible: false },
            { input: "1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10A-009",
          title: "Greatest among N numbes",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N inputs and prints the greatest number among the given inputs.",
          sampleInput: "12\n22\n11\n45",
          sampleOutput: "45",
          testCases: [
            { input: "15\n20\n77", output: "77", visible: true },
            { input: "10\n33\n21\n65", output: "65", visible: true },
            { input: "72\n33\n45\n88", output: "88", visible: false },
            { input: "12\n28", output: "28", visible: false },
            { input: "1\n33", output: "33", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10A-0010",
          title: "Perfect number",
          difficulty: "Easy",
          description:
            "Write a program to check whether the given number is Perfect number or not.A number is considered as a perfect number if sum of all factors excluding itself is equal to the number.",
          sampleInput: "6",
          sampleOutput: "perfect number",
          testCases: [
            { input: "21", output: "not a perfect number", visible: true },
            { input: "28", output: "perfect number", visible: true },
            { input: "6", output: "perfect number", visible: false },
            { input: "12", output: "not a perfect number", visible: false },
            { input: "1", output: "not a perfect number", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-10B",
      title: "Codingpractice-10B",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-10B-001",
          title: "Number of digits from M to N",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print the count of the total number of digits from M to N.",
          sampleInput: "10\n20",
          sampleOutput: "22",
          testCases: [
            { input: "1\n10", output: "11", visible: true },
            { input: "5\n15", output: "17", visible: true },
            { input: "1\n1", output: "1", visible: false },
            { input: "10\n20", output: "22", visible: false },
            { input: "100\n105", output: "18", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10B-002",
          title: "Divisible by 6",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to find the count of numbers from M to N that are divisible by 6.\nPrint No numbers found if the count of numbers from M to N that are divisible by 6 is 0.Otherwise,print the numbers from M to N that are divisible by 6 separated by a space.",
          sampleInput: "6\n23",
          sampleOutput: "6 12 18",
          testCases: [
            { input: "2\n5", output: "no numbers found", visible: true },
            { input: "1\n6", output: "6", visible: true },
            { input: "10\n30", output: "12 18 24 30", visible: false },
            { input: "7\n11", output: "no numbers found", visible: false },
            { input: "6\n6", output: "6", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10B-003",
          title: "Vowels of a string - 2",
          difficulty: "Easy",
          description:
            "Given a string,write a program to find the count of vowels in the string.Print string has more than two vowels if the count of vowels is greater than 2.Otherwise,print string doesn't have more than two vowels.",
          sampleInput: "indian",
          sampleOutput: "string has more than two vowels",
          testCases: [
            {
              input: "code",
              output: "string doesn't have more than two vowels",
              visible: true,
            },
            {
              input: "sky",
              output: "string doesn't have more than two vowels",
              visible: true,
            },
            {
              input: "education",
              output: "string has more than two vowels",
              visible: false,
            },
            {
              input: "try",
              output: "string doesn't have more than two vowels",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10B-004",
          title: "Indivisible number",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that checks if N is not divisible by any number from 2 to 9.\nPrint divisible number if the number N is divisible by any of the numbers from 2 to 9.\nPrint divisible number if the number N is divisible by any of the numbers from 2 to 9.Print Indivisible number if the number N is not divisible by any of the numbers from 2 to 9.",
          sampleInput: "15",
          sampleOutput: "divisible number",
          testCases: [
            { input: "103", output: "Indivisible number", visible: true },
            { input: "14", output: "divisible number", visible: true },
            { input: "17", output: "Indivisible number", visible: false },
            { input: "81", output: "divisible number", visible: false },
            { input: "29", output: "Indivisible number", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10B-005",
          title: "smallest among N numbers",
          difficulty: "Easy",
          description:
            "Write a program to print the smallest among the given N numbers.",
          sampleInput: "8\n3\n5\n2",
          sampleOutput: "2",
          testCases: [
            { input: "1\n3\n4", output: "1", visible: true },
            { input: "9\n6\n12", output: "6", visible: true },
            { input: "5\n5\n5", output: "5", visible: false },
            { input: "10\n2\n8\n3", output: "2", visible: false },
            { input: "-1\n4\n0", output: "-1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10B-006",
          title: "Divisible by 9 in a range",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to find the count of numbers from M to N that are divisible by 9.\nPrint No numbers found if the count of numbers from M to N that are divisible by 9 is 0.Otherwise,print the numbers from M to N separated by a space that are divisible by 9.",
          sampleInput: "5\n25",
          sampleOutput: "9 18",
          testCases: [
            { input: "3\n8", output: "No numbers found", visible: true },
            { input: "1\n9", output: "9", visible: true },
            { input: "10\n30", output: "18 27", visible: false },
            { input: "9\n9", output: "9", visible: false },
            { input: "20\n25", output: "No numbers found", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10B-007",
          title: "2 series",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the N terms in the given series,each on a new line.",
          sampleInput: "6",
          sampleOutput: "2\n22\n222\n2222\n22222\n222222",
          testCases: [
            { input: "3", output: "2\n22\n222", visible: true },
            { input: "1", output: "2", visible: true },
            { input: "4", output: "2\n22\n222\n2222", visible: false },
            { input: "5", output: "2\n22\n222\n2222\n22222", visible: false },
            { input: "2", output: "2\n22", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10B-008",
          title: "Sum of N terms in 2 series",
          difficulty: "Easy",
          description:
            "Given an integer N,write a program to print the sum of N terms in the given series.\nNote:2 series ,N=3,\n2\n22\n222 \n(2+22+222=246).",
          sampleInput: "3",
          sampleOutput: "246",
          testCases: [
            { input: "8", output: "24691356", visible: true },
            { input: "1", output: "2", visible: true },
            { input: "8", output: "24691356", visible: false },
            { input: "8", output: "24691356", visible: false },
            { input: "8", output: "24691356", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10B-009",
          title: "Sum of N terms 1 series",
          difficulty: "Easy",
          description:
            "Given an integer N,write a program to print the sum of N terms in the given series.\nNote:1 series ,N=3,\n1\n11\n111 \n(1+11+111=123).",
          sampleInput: "3",
          sampleOutput: "123",
          testCases: [
            { input: "4", output: "1234", visible: true },
            { input: "5", output: "12345", visible: true },
            { input: "1", output: "1", visible: false },
            { input: "2", output: "12", visible: false },
            { input: "6", output: "123456", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10B-0010",
          title: "Sum of N terms in X series",
          difficulty: "Easy",
          description:
            "Given two numbers X and N,write a program to print the sum of N terms in the given series.",
          sampleInput: "7\n4",
          sampleOutput: "8638",
          testCases: [
            { input: "6\n2", output: "72", visible: true },
            { input: "3\n3", output: "369", visible: true },
            { input: "5\n1", output: "5", visible: false },
            { input: "2\n4", output: "2468", visible: false },
            { input: "9\n3", output: "1107", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10B-0011",
          title: "Sum of N Terms in X square series",
          difficulty: "Easy",
          description:
            "Given two numbers X and N,write a program to print the sum of N terms in the given series.",
          sampleInput: "4\n3",
          sampleOutput: "199088",
          testCases: [
            { input: "7\n4", output: "61091436", visible: true },
            { input: "3\n2", output: "1098", visible: true },
            { input: "5\n1", output: "25", visible: false },
            { input: "2\n3", output: "5476", visible: false },
            { input: "9\n2", output: "81882", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-10C",
      title: "Codingpractice-10C",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-10C-001",
          title: "Sum of N terms in power series",
          difficulty: "Easy",
          description:
            "Given two numbers X and N,write a program to print the sum of N terms in the given series.\nseries:x^1,x^3,x^5...N terms.\nInput:The first line of input contains an integer representing X.\nThe second line of input contains an integer representing N.\nOutput:The output should be a single line containing an integer that is the sum of the series from the first term to the Nth term.",
          sampleInput: "2\n6",
          sampleOutput: "2730",
          testCases: [
            { input: "5\n3", output: "3255", visible: true },
            { input: "2\n1", output: "2", visible: true },
            { input: "3\n2", output: "30", visible: false },
            { input: "4\n3", output: "1092", visible: false },
            { input: "1\n5", output: "5", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10C-002",
          title: "Sum of N terms in power series - 2",
          difficulty: "Easy",
          description:
            "Given two numbers X and N,write a program to print the sum of N terms in the given series.\nseries:x^2,x^4,x^6...N terms.\nInput:The first line of input contains an integer representing X.\nThe second line of input contains an integer representing N.\nOutput:The output should be a single line containing an integer that is the sum of the series from the first term to the Nth term.",
          sampleInput: "3\n4",
          sampleOutput: "7380",
          testCases: [
            { input: "-2\n6", output: "5460", visible: true },
            { input: "2\n3", output: "84", visible: true },
            { input: "3\n1", output: "9", visible: false },
            { input: "4\n2", output: "272", visible: false },
            { input: "1\n5", output: "5", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10C-003",
          title: "Sum of N terms in power series - 3",
          difficulty: "Easy",
          description:
            "Given two numbers X and N,write a program to print the sum of N terms in the given series.\nseries:x^2,-x^4,x^6,-x^8...N terms.\nInput:The first line of input contains an integer representing X.\nThe second line of input contains an integer representing N.\nOutput:The output should be a single line containing an integer that is the sum of the series from the first term to the Nth term.",
          sampleInput: "2\n6",
          sampleOutput: "-3276",
          testCases: [
            { input: "-7\n3", output: "115297", visible: true },
            { input: "2\n1", output: "4", visible: true },
            { input: "3\n2", output: "-72", visible: false },
            { input: "2\n6", output: "-3276", visible: false },
            { input: "1\n5", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10C-004",
          title: "Right angled triangle - 5",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the right angled triangle of N rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "  *\n **\n***",
          testCases: [
            { input: "2", output: " *\n**", visible: true },
            { input: "4", output: "   *\n  **\n ***\n****", visible: true },
            { input: "3", output: "  *\n **\n***", visible: false },
            { input: "1", output: "*", visible: false },
            {
              input: "5",
              output: "    *\n   **\n  ***\n ****\n*****",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10C-005",
          title: "Right angled triangle - 6",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the right angled triangle of N rows using stars(*).\nNote:There is a space after every star.",
          sampleInput: "3",
          sampleOutput: "    * \n  * * \n* * * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "  * \n* * ", visible: true },
            { input: "3", output: "    * \n  * * \n* * * ", visible: true },
            {
              input: "4",
              output: "      * \n    * * \n  * * * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "        * \n      * * \n    * * * \n  * * * * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10C-006",
          title: "Right angled triangle - 7",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the right angled triangle of N rows using stars(*) and hashes(#).\nThe last row contains hashes(#) and the remaining rows contain stars(*).",
          sampleInput: "3",
          sampleOutput: "  *\n **\n###",
          testCases: [
            { input: "2", output: " *\n##", visible: true },
            { input: "3", output: "  *\n **\n###", visible: true },
            { input: "4", output: "   *\n  **\n ***\n####", visible: false },
            { input: "2", output: " *\n##", visible: false },
            {
              input: "5",
              output: "    *\n   **\n  ***\n ****\n#####",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10C-007",
          title: "Pyramid",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a pyramid of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "    *  \n  * * * \n* * * * * ",
          testCases: [
            {
              input: "1",
              output: "* ",
              visible: true,
            },

            {
              input: "2",
              output: "  * \n* * * ",
              visible: true,
            },

            {
              input: "3",
              output: "    * \n  * * * \n* * * * * ",
              visible: true,
            },

            {
              input: "4",
              output: "      * \n    * * * \n  * * * * * \n* * * * * * * ",
              visible: false,
            },

            {
              input: "5",
              output:
                "        * \n      * * * \n    * * * * * \n  * * * * * * * \n* * * * * * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10C-008",
          title: "Pyramid - 2",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a pyramid of N rows using numbers.\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "    1  \n  2 2 2 \n3 3 3 3 3 ",
          testCases: [
            { input: "1", output: "1 ", visible: true },
            { input: "2", output: "  1 \n2 2 2 ", visible: true },
            {
              input: "3",
              output: "    1 \n  2 2 2 \n3 3 3 3 3 ",
              visible: true,
            },
            {
              input: "4",
              output: "      1 \n    2 2 2 \n  3 3 3 3 3 \n4 4 4 4 4 4 4 ",
              visible: false,
            },
            {
              input: "5",
              output:
                "        1 \n      2 2 2 \n    3 3 3 3 3 \n  4 4 4 4 4 4 4 \n5 5 5 5 5 5 5 5 5 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10C-009",
          title: "Inverted right angled triangle - 4",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print an Inverted right angled triangle of N rows using numbers.",
          sampleInput: "3",
          sampleOutput: "333\n 22\n  1",
          testCases: [
            { input: "1", output: "1", visible: true },
            { input: "2", output: "22\n 1", visible: true },
            { input: "3", output: "333\n 22\n  1", visible: true },
            { input: "4", output: "4444\n 333\n  22\n   1", visible: false },
            {
              input: "5",
              output: "55555\n 4444\n  333\n   22\n    1",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10C-0010",
          title: "Inverted right angled triangle - 5",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print an Inverted right angled triangle of N rows using numbers.\nNote:there is a space after every number.",
          sampleInput: "3",
          sampleOutput: "3 3 3 \n  2 2 \n    1 ",
          testCases: [
            { input: "1", output: "1 ", visible: true },
            { input: "2", output: "2 2 \n  1 ", visible: true },
            { input: "3", output: "3 3 3 \n  2 2 \n    1 ", visible: true },
            {
              input: "4",
              output: "4 4 4 4 \n  3 3 3 \n    2 2 \n      1 ",
              visible: false,
            },
            {
              input: "5",
              output:
                "5 5 5 5 5 \n  4 4 4 4 \n    3 3 3 \n      2 2 \n        1 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10C-0011",
          title: "Inverted Pyramid",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print an Inverted Pyramid of N rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "*****\n ***\n  *",
          testCases: [
            { input: "1", output: "*", visible: true },
            { input: "2", output: "***\n *", visible: true },
            { input: "3", output: "*****\n ***\n  *", visible: true },
            {
              input: "4",
              output: "*******\n *****\n  ***\n   *",
              visible: false,
            },
            {
              input: "5",
              output: "*********\n *******\n  *****\n   ***\n    *",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-10D",
      title: "Codingpractice-10D",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-10D-001",
          title: "M pattern with *",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print the letter M of N rows with two solid right angled triangles of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "*         * \n* *     * * \n* * * * * * ",
          testCases: [
            { input: "1", output: "* * ", visible: true },
            { input: "2", output: "*     * \n* * * * ", visible: true },
            {
              input: "3",
              output: "*         * \n* *     * * \n* * * * * * ",
              visible: false,
            },
            {
              input: "4",
              output:
                "*             * \n* *         * * \n* * *     * * * \n* * * * * * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "*                 * \n* *             * * \n* * *         * * * \n* * * *     * * * * \n* * * * * * * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10D-002",
          title: "Pyramid - 3",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a Pyramid of 2*N-1 rows using stars(*).\nThere is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "* \n* * \n* * * \n* * \n* ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "* \n* * \n* ", visible: true },
            {
              input: "3",
              output: "* \n* * \n* * * \n* * \n* ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n* * * * \n* * * \n* * \n* ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* \n* * \n* * * \n* * * * \n* * * * * \n* * * * \n* * * \n* * \n* ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10D-003",
          title: "Pyramid - 4",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a Pyramid of 2*N-1 rows using numbers.\nNote:There is a space after every number.",
          sampleInput: "2",
          sampleOutput: "1 \n2 2 \n1 \n",
          testCases: [
            { input: "1", output: "1 \n", visible: true },
            { input: "2", output: "1 \n2 2 \n1 \n", visible: true },
            {
              input: "3",
              output: "1 \n2 2 \n3 3 3 \n2 2 \n1 \n",
              visible: false,
            },
            {
              input: "4",
              output: "1 \n2 2 \n3 3 3 \n4 4 4 4 \n3 3 3 \n2 2 \n1 \n",
              visible: false,
            },
            {
              input: "5",
              output:
                "1 \n2 2 \n3 3 3 \n4 4 4 4 \n5 5 5 5 5 \n4 4 4 4 \n3 3 3 \n2 2 \n1 \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10D-004",
          title: "Pyramid - 5",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a Pyramid of 2*N-1 rows using pluses (+) and hashes (#).\nThe last column of the pyramid contains hashes(#),and the remaining columns contain pluses(+).",
          sampleInput: "2",
          sampleOutput: "  #\n+ #\n  #\n",
          testCases: [
            { input: "1", output: "#\n", visible: true },
            { input: "2", output: "  #\n+ #\n  #\n", visible: true },
            {
              input: "3",
              output: "    #\n  + #\n+ + #\n  + #\n    #\n",
              visible: false,
            },
            {
              input: "4",
              output:
                "      #\n    + #\n  + + #\n+ + + #\n  + + #\n    + #\n      #\n",
              visible: false,
            },
            {
              input: "5",
              output:
                "        #\n      + #\n    + + #\n  + + + #\n+ + + + #\n  + + + #\n    + + #\n      + #\n        #\n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10D-005",
          title: "Butterfly",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a Butterfly of (2*N)-1 rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "2",
          sampleOutput: "*     * \n* * * * \n*     * \n",
          testCases: [
            { input: "1", output: "* * \n", visible: true },

            {
              input: "2",
              output: "*     * \n* * * * \n*     * \n",
              visible: true,
            },

            {
              input: "3",
              output:
                "*         * \n* *     * * \n* * * * * * \n* *     * * \n*         * \n",
              visible: false,
            },

            {
              input: "4",
              output:
                "*             * \n* *         * * \n* * *     * * * \n* * * * * * * * \n* * *     * * * \n* *         * * \n*             * \n",
              visible: false,
            },

            {
              input: "5",
              output:
                "*                 * \n* *             * * \n* * *         * * * \n* * * *     * * * * \n* * * * * * * * * * \n* * * *     * * * * \n* * *         * * * \n* *             * * \n*                 * \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10D-006",
          title: "Pyramid - 6",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a Pyramid of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "4",
          sampleOutput: "   * \n  * * \n * * * \n* * * * \n",
          testCases: [
            { input: "1", output: "* \n", visible: true },

            { input: "2", output: " * \n* * \n", visible: true },

            { input: "3", output: "  * \n * * \n* * * \n", visible: false },

            {
              input: "4",
              output: "   * \n  * * \n * * * \n* * * * \n",
              visible: false,
            },

            {
              input: "5",
              output: "    * \n   * * \n  * * * \n * * * * \n* * * * * \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10D-007",
          title: "Pyramid - 7",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a Pyramid of N rows using numbers\nNote:There is a space after every number.",
          sampleInput: "4",
          sampleOutput: "   1 \n  2 2 \n 3 3 3 \n4 4 4 4 \n",
          testCases: [
            { input: "1", output: "1 \n", visible: true },

            { input: "2", output: " 1 \n2 2 \n", visible: true },

            { input: "3", output: "  1 \n 2 2 \n3 3 3 \n", visible: false },

            {
              input: "4",
              output: "   1 \n  2 2 \n 3 3 3 \n4 4 4 4 \n",
              visible: false,
            },

            {
              input: "5",
              output: "    1 \n   2 2 \n  3 3 3 \n 4 4 4 4 \n5 5 5 5 5 \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10D-008",
          title: "Inverted pyramid - 2",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print an Inverted pyramid of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "4",
          sampleOutput: "* * * * \n * * * \n  * * \n   * \n",
          testCases: [
            { input: "1", output: "* \n", visible: true },
            { input: "2", output: "* * \n * \n", visible: true },
            { input: "3", output: "* * * \n * * \n  * \n", visible: false },
            {
              input: "4",
              output: "* * * * \n * * * \n  * * \n   * \n",
              visible: false,
            },
            {
              input: "5",
              output: "* * * * * \n * * * * \n  * * * \n   * * \n    * \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10D-009",
          title: "Inverted pyramid - 3",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print an Inverted pyramid of N rows using stars(*) and pluses(+).\nThe first row of the pyramid contains pluses(+),and the remaining rows contain stars(*).\nThere is a space after every star(*) and every plus(+).",
          sampleInput: "4",
          sampleOutput: "+ + + + \n * * * \n  * * \n   * \n",
          testCases: [
            { input: "1", output: "+ \n", visible: true },

            { input: "2", output: "+ + \n * \n", visible: true },

            { input: "3", output: "+ + + \n * * \n  * \n", visible: false },

            {
              input: "4",
              output: "+ + + + \n * * * \n  * * \n   * \n",
              visible: false,
            },

            {
              input: "5",
              output: "+ + + + + \n * * * * \n  * * * \n   * * \n    * \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10D-0010",
          title: "Diamond",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a diamond of (2*N)-1 rows using stars(*).\nNote:There is a space after every star(*). ",
          sampleInput: "4",
          sampleOutput:
            "   * \n  * * \n * * * \n* * * * \n * * * \n  * * \n   * \n",
          testCases: [
            { input: "1", output: "* \n", visible: true },
            { input: "2", output: " * \n* * \n * \n", visible: true },
            {
              input: "3",
              output: "  * \n * * \n* * * \n * * \n  * \n",
              visible: false,
            },
            {
              input: "4",
              output:
                "   * \n  * * \n * * * \n* * * * \n * * * \n  * * \n   * \n",
              visible: false,
            },
            {
              input: "5",
              output:
                "    * \n   * * \n  * * * \n * * * * \n* * * * * \n * * * * \n  * * * \n   * * \n    * \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10D-0011",
          title: "M pattern with * - 2",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print the letter M of N rows with two solid pyramids using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "4",
          sampleOutput:
            "   *       * \n  * *     * * \n * * *   * * * \n* * * * * * * * \n",
          testCases: [
            { input: "1", output: "* * \n", visible: true },

            { input: "2", output: " *   * \n* * * * \n", visible: true },

            {
              input: "3",
              output: "  *     * \n * *   * * \n* * * * * * \n",
              visible: true,
            },

            {
              input: "4",
              output:
                "   *       * \n  * *     * * \n * * *   * * * \n* * * * * * * * \n",
              visible: false,
            },

            {
              input: "5",
              output:
                "    *         * \n   * *       * * \n  * * *     * * * \n * * * *   * * * * \n* * * * * * * * * * \n",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-10A",
      title: "Assignment-10A",
      description: "Loops",
      questions: [
        {
          id: "q-python-Assignment-10A-001",
          title: "Number of digits until N",
          difficulty: "Easy",
          description:
            "Write a program that reads the number N and finds the count of digits from 1 to N.\nNote:Numbers from 1 to 9 are single digits.\nNumbers from 10 to 99 are double digits and so on.",
          sampleInput: "10",
          sampleOutput: "11",
          testCases: [
            { input: "4", output: "4", visible: true },
            { input: "6", output: "6", visible: true },
            { input: "9", output: "9", visible: false },
            { input: "10", output: "11", visible: false },
            { input: "15", output: "21", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-10A-002",
          title: "Sum of N Terms in the series",
          difficulty: "Medium",
          description:
            "Given two numbers X and N,Write a program to print the sum of N terms in the given series.\nSeries:x, -x^3, x^5, -x^7, x^9,...N terms",
          sampleInput: "2\n5",
          sampleOutput: "410",
          testCases: [
            { input: "3\n2", output: "-24", visible: true },
            { input: "2\n2", output: "-6", visible: true },
            { input: "2\n3", output: "26", visible: false },
            { input: "2\n5", output: "410", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-10A-003",
          title: "More than two Factors",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to find the count of factors of N.print Number has more than 2 factors if the count of factors is greater than 2.Otherwise,print number doesn't have more than 2 factors.",
          sampleInput: "6",
          sampleOutput: "Number has more than 2 factors",
          testCases: [
            {
              input: "13",
              output: "Number doesn't have more than 2 factors",
              visible: true,
            },
            {
              input: "1",
              output: "Number doesn't have more than 2 factors",
              visible: true,
            },
            {
              input: "2",
              output: "Number doesn't have more than 2 factors",
              visible: false,
            },
            {
              input: "4",
              output: "Number has more than 2 factors",
              visible: false,
            },
            {
              input: "6",
              output: "Number has more than 2 factors",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-10A-004",
          title: "Right Angled Triangle - 8",
          difficulty: "Medium",
          description:
            "Write a program that reads a number N and print two right angled triangles,each of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "* \n* * \n* * * \n* \n* * \n* * * ",
          testCases: [
            { input: "1", output: "* \n* ", visible: true },
            { input: "2", output: "* \n* * \n* \n* * ", visible: true },
            {
              input: "3",
              output: "* \n* * \n* * * \n* \n* * \n* * * ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n* * * * \n* \n* * \n* * * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* \n* * \n* * * \n* * * * \n* * * * * \n* \n* * \n* * * \n* * * * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-10A-005",
          title: "Diamond - 2",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a diamond of 2*N-1 rows using numbers.\nNote:There is a space after every number.",
          sampleInput: "3",
          sampleOutput: "  1 \n 2 2 \n3 3 3 \n 2 2 \n  1 ",
          testCases: [
            { input: "1", output: "1 ", visible: true },
            { input: "2", output: " 1 \n2 2 \n 1 ", visible: true },
            {
              input: "3",
              output: "  1 \n 2 2 \n3 3 3 \n 2 2 \n  1 ",
              visible: false,
            },
            {
              input: "4",
              output:
                "   1 \n  2 2 \n 3 3 3 \n4 4 4 4 \n 3 3 3 \n  2 2 \n   1 ",
              visible: false,
            },
            {
              input: "5",
              output:
                "    1 \n   2 2 \n  3 3 3 \n 4 4 4 4 \n5 5 5 5 5 \n 4 4 4 4 \n  3 3 3 \n   2 2 \n    1 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-10A-006",
          title: "Inverted right angled triangle - 6",
          difficulty: "Medium",
          description:
            "Given a number N,write a program to print a right angled triangle of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "* * * \n  * * \n    * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "* * \n  * ", visible: true },
            { input: "3", output: "* * * \n  * * \n    * ", visible: false },
            {
              input: "4",
              output: "* * * * \n  * * * \n    * * \n      * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* * * * * \n  * * * * \n    * * * \n      * * \n        * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-10A-007",
          title: "W Shape with * - 2",
          difficulty: "Medium",
          description:
            "Given a number N,write a program to print the letter w of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "* * * * * \n * *   * * \n  * * * * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "* * * \n * * ", visible: true },
            {
              input: "3",
              output: "* * * * * \n * *   * * \n  * * * * ",
              visible: false,
            },
            {
              input: "4",
              output:
                "* * * * * * * \n * * *     * * * \n  * * *   * * * \n   * * * * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* * * * * * * * * \n * * * *       * * * * \n  * * * *     * * * * \n   * * * *   * * * * \n    * * * * * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-10E",
      title: "Codingpractice-10E",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-10E-001",
          title: "Square - 3",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a squre of N rows using stars(*) in the borders and zeros (0) inside the square.\nNote:There is a space after every star(*) and every zero (0).",
          sampleInput: "3",
          sampleOutput: "* * * \n* 0 *\n* * * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "* * \n* * ", visible: true },
            { input: "3", output: "* * * \n* 0 * \n* * * ", visible: false },
            {
              input: "4",
              output: "* * * * \n* 0 0 * \n* 0 0 * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* * * * * \n* 0 0 0 * \n* 0 0 0 * \n* 0 0 0 * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10E-002",
          title: "Rectangle - 4",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print a rectangle of M rows and N columns using stars(*)in the borders and zeros(0)inside the rectangle.\nNote:There is a space after every star(*) and every zero(0).",
          sampleInput: "3\n3",
          sampleOutput: "* * * \n* 0 * \n* * * ",
          testCases: [
            { input: "1\n1", output: "* ", visible: true },
            { input: "2\n3", output: "* * * \n* * * ", visible: true },
            { input: "3\n3", output: "* * * \n* 0 * \n* * * ", visible: false },
            {
              input: "4\n5",
              output: "* * * * * \n* 0 0 0 * \n* 0 0 0 * \n* * * * * ",
              visible: false,
            },
            {
              input: "5\n4",
              output: "* * * * \n* 0 0 * \n* 0 0 * \n* 0 0 * \n* * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10E-003",
          title: "Right angled triangle - 9",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a right angled triangle of N rows using dots(.)in the borders and zeros(0)inside the right angled triangle.",
          sampleInput: "3",
          sampleOutput: ". \n. .\n. . . ",
          testCases: [
            { input: "1", output: ". ", visible: true },
            { input: "2", output: ". \n. . ", visible: true },
            { input: "3", output: ". \n. .\n. . . ", visible: false },
            { input: "4", output: ". \n. .\n. 0 .\n. . . . ", visible: false },
            {
              input: "5",
              output: ". \n. .\n. 0 .\n. 0 0 .\n. . . . . ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10E-004",
          title: "Hollow Square",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Square of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "* * * \n*   *\n* * * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "* * \n* * ", visible: true },

            { input: "3", output: "* * * \n*   *\n* * * ", visible: false },
            {
              input: "4",
              output: "* * * * \n*     *\n*     *\n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output: "* * * * * \n*       *\n*       *\n*       *\n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10E-005",
          title: "Hollow Rectangle",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print a Rectangle of M rows and N columns using stars(*).",
          sampleInput: "4\n6",
          sampleOutput:
            "* * * * * * \n*         * \n*         * \n* * * * * * ",
          testCases: [
            {
              input: "8\n5",
              output:
                "* * * * * \n*       * \n*       * \n*       * \n*       * \n*       * \n*       * \n* * * * * ",
              visible: true,
            },
            {
              input: "4\n6",
              output: "* * * * * * \n*         * \n*         * \n* * * * * * ",
              visible: true,
            },
            {
              input: "5\n3",
              output: "* * * \n*   * \n*   * \n*   * \n* * * ",
              visible: false,
            },
            {
              input: "3\n7",
              output: "* * * * * * * \n*           * \n* * * * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10E-006",
          title: "Hollow Right Angled Triangle",
          difficulty: "Easy",
          description:
            "Given a number N,Write a program to print a right angled triangle of N rows using stars(*).",
          sampleInput: "4",
          sampleOutput: "* \n* * \n*   * \n* * * * ",
          testCases: [
            { input: "1", output: "* \n* ", visible: true },
            { input: "2", output: "* \n* * ", visible: true },
            { input: "3", output: "* \n* * \n* * * ", visible: false },
            {
              input: "4",
              output: "* \n* * \n*   * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output: "* \n* * \n*   * \n*     * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10E-007",
          title: "Hollow Right Angled Triangle - 2",
          difficulty: "Medium",
          description:
            "Given a number N,Write a program to print a right angled triangle of N rows using underscore(_),pipe(|),and forward slash(/).",
          sampleInput: "4",
          sampleOutput: "_____\n|   /\n|  /\n| /\n|/",
          testCases: [
            { input: "1", output: "__\n|/", visible: true },
            { input: "2", output: "___\n| /\n|/", visible: true },
            { input: "3", output: "____\n|  /\n| /\n|/", visible: false },
            {
              input: "4",
              output: "_____\n|   /\n|  /\n| /\n|/",
              visible: false,
            },
            {
              input: "5",
              output: "______\n|    /\n|   /\n|  /\n| /\n|/",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-10F",
      title: "Codingpractice-10F",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-10F-001",
          title: "Hollow Pyramid",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a hollow pyramid of N rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "  * \n * * \n* * * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: " * \n* * ", visible: true },
            { input: "3", output: "  * \n * * \n* * * ", visible: false },
            {
              input: "4",
              output: "   * \n  * * \n *   * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output: "    * \n   * * \n  *   * \n *     * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10F-002",
          title: "Hollow Right Angled Triangle - 4",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a Hollow Right Angled Triangle of N rows using pluses (+) and hashes (#).\nThe first line contains hashes(#) and the next N-1 lines contain pluses(+).",
          sampleInput: "3",
          sampleOutput: "# # # \n+ +\n+",
          testCases: [
            { input: "1", output: "# ", visible: true },

            { input: "2", output: "# # \n+", visible: true },

            { input: "3", output: "# # # \n+ +\n+", visible: false },

            { input: "4", output: "# # # # \n+   +\n+ +\n+", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10F-003",
          title: "Hollow Pyramid - 2",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a Hollow Pyramid of 2*N-1 rows using numbers.\nThere is a space after every number(1).",
          sampleInput: "4",
          sampleOutput: "1\n2  2\n3    3\n4      4\n3    3\n2  2\n1",
          testCases: [
            { input: "2", output: "1\n2 2\n1", visible: true },

            { input: "3", output: "1\n2 2\n3   3\n2 2\n1", visible: true },

            {
              input: "4",
              output: "1\n2 2\n3   3\n4     4\n3   3\n2 2\n1",
              visible: false,
            },

            {
              input: "5",
              output:
                "1\n2 2\n3   3\n4     4\n5       5\n4     4\n3   3\n2 2\n1",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10F-004",
          title: "Hollow Right Angled Triangle - 3",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a Hollow Right Angled Triangle of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "* * * \n* *\n*",
          testCases: [
            { input: "1", output: "* ", visible: true },

            { input: "2", output: "* * \n*", visible: true },

            { input: "3", output: "* * * \n* *\n*", visible: false },

            { input: "4", output: "* * * * \n*   *\n* *\n*", visible: false },

            {
              input: "5",
              output: "* * * * * \n*     *\n*   *\n* *\n*",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10F-005",
          title: "Hollow Right Angled Triangle - 5",
          difficulty: "Medium",
          description:
            "Given a number N, write a program to print a Hollow Right Angled Triangle of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "    *\n  * *\n* * * ",
          testCases: [
            { input: "2", output: "  *\n* * ", visible: true },
            { input: "3", output: "    *\n  * *\n* * * ", visible: true },
            {
              input: "4",
              output: "      *\n    * *\n  *   *\n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output: "        *\n      * *\n    *   *\n  *     *\n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-10F-006",
          title: "Hollow Right Angled Triangle - 6",
          difficulty: "Medium",
          description:
            "Given a number N, write a program to print a Hollow Inverted Right Angled Triangle of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "* * * \n  * * \n    * ",
          testCases: [
            {
              input: "4",
              output: "* * * * \n  *   * \n    * * \n      * ",
              visible: true,
            },

            { input: "2", output: "* * \n  * ", visible: true },

            { input: "3", output: "* * * \n  * * \n    * ", visible: false },

            {
              input: "4",
              output: "* * * * \n  *   * \n    * * \n      * ",
              visible: false,
            },

            {
              input: "5",
              output:
                "* * * * * \n  *     * \n    *   * \n      * * \n        * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10F-007",
          title: "Inverted hollow pyramid",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a Hollow Inverted Full Pyramid of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "4",
          sampleOutput: "* * * * \n *   * \n  * * \n   * ",
          testCases: [
            { input: "1", output: "* ", visible: true },

            { input: "2", output: "* * \n * ", visible: true },

            { input: "3", output: "* * * \n * * \n  * ", visible: false },

            {
              input: "4",
              output: "* * * * \n *   * \n  * * \n   * ",
              visible: false,
            },

            {
              input: "5",
              output: "* * * * * \n *     * \n  *   * \n   * * \n    * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-10F-008",
          title: "Hollow Diamond",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a Hollow Diamond of 2*N-1 rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "  *\n * *\n*   *\n * *\n  *",
          testCases: [
            { input: "1", output: "*", visible: true },
            { input: "2", output: " *\n* *\n *", visible: true },
            {
              input: "3",
              output: "  *\n * *\n*   *\n * *\n  *",
              visible: false,
            },
            {
              input: "4",
              output: "   *\n  * *\n *   *\n*     *\n *   *\n  * *\n   *",
              visible: false,
            },
            {
              input: "5",
              output:
                "    *\n   * *\n  *   *\n *     *\n*       *\n *     *\n  *   *\n   * *\n    *",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-10B",
      title: "Assignment-10B",
      description: "Loops",
      questions: [
        {
          id: "q-python-Assignment-10B-001",
          title: "Inverted Hollow Pyramid - 2",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print an Inverted Hollow Pyramid of 2*N-1 rows using numbers.\nNote:There is a space after every number(1).",
          sampleInput: "5",
          sampleOutput:
            "        1\n      2 2 \n    3   3 \n  4     4 \n5       5 \n  4     4\n    3   3\n      2 2\n        1 ",
          testCases: [
            { input: "1", output: "1", visible: true },

            { input: "2", output: "  1\n2 2 \n  1 ", visible: true },

            {
              input: "3",
              output: "    1\n  2 2 \n3   3 \n  2 2\n    1 ",
              visible: false,
            },

            {
              input: "4",
              output:
                "      1\n    2 2 \n  3   3 \n4     4 \n  3   3\n    2 2\n      1 ",
              visible: false,
            },

            {
              input: "5",
              output:
                "        1\n      2 2 \n    3   3 \n  4     4 \n5       5 \n  4     4\n    3   3\n      2 2\n        1 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-10B-002",
          title: "Two Triangles - 3",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print two right angled triangles of N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "3",
          sampleOutput: "*         *\n* *     * *\n* * * * * * ",
          testCases: [
            { input: "1", output: "* *", visible: true },
            { input: "2", output: "*     *\n* * * * ", visible: true },
            {
              input: "3",
              output: "*         *\n* *     * *\n* * * * * * ",
              visible: false,
            },

            {
              input: "4",
              output:
                "*             *\n* *         * *\n*   *     *   *\n* * * * * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-10B-003",
          title: "Hollow Butterfly",
          difficulty: "Easy",
          description:
            "Given a number N, write a program to print a Hollow Butterfly of 2*N rows using stars(*).\nNote:There is a space after every star(*).",
          sampleInput: "4",
          sampleOutput:
            "*             *\n* *         * *\n*   *     *   *\n*     * *     *\n*     * *     *\n*   *     *   *\n* *         * *\n*             *",
          testCases: [
            { input: "1", output: "* *\n* *", visible: true },

            {
              input: "2",
              output: "*     *\n* * * *\n* * * *\n*     *",
              visible: true,
            },

            {
              input: "4",
              output:
                "*             *\n* *         * *\n*   *     *   *\n*     * *     *\n*     * *     *\n*   *     *   *\n* *         * *\n*             *",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-10B-004",
          title: "Perfect Squares in a range",
          difficulty: "Easy",
          description:
            "You are given two numbers,A and B where 1<=A<=B,Write a program to find the number of perfect squares in the range A to B(including A and B).",
          sampleInput: "9\n100",
          sampleOutput: "8",
          testCases: [
            { input: "1\n1", output: "1", visible: true },
            { input: "1\n10", output: "3", visible: true },
            { input: "625\n1444", output: "14", visible: false },
            { input: "9\n100", output: "8", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-10B-005",
          title: "Solid and Hollow Diamond",
          difficulty: "Medium",
          description:
            "Given a number N,write a program to print a pyramid and an Inverted Hollow Pyramid in 2*N-1 rows using stars(*),.",
          sampleInput: "2",
          sampleOutput: " * \n* * \n *",
          testCases: [
            {
              input: "1",
              output: "* ",
              visible: true,
            },
            {
              input: "2",
              output: " * \n* * \n *",
              visible: true,
            },
            {
              input: "3",
              output: "  * \n * * \n* * * \n * *\n  *",
              visible: false,
            },
            {
              input: "4",
              output: "   * \n  * * \n * * * \n* * * * \n *   *\n  * *\n   *",
              visible: false,
            },
            {
              input: "5",
              output:
                "    * \n   * * \n  * * * \n * * * * \n* * * * * \n *     *\n  *   *\n   * *\n    *",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Assignment-10B-006",
          title: "Solid Right Angled Triangle - 2",
          difficulty: "Medium",
          description:
            "Given an integer number N as input.Write a program to print the right-angled triangular pattern of N lines as shown below.\nNote:There is a space after each asterisk(*)character.",
          sampleInput: "2",
          sampleOutput: "  * \n* * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "  * \n* * ", visible: true },
            { input: "3", output: "    * \n  * * \n* * * ", visible: false },
            {
              input: "4",
              output: "      * \n    * * \n  * * * \n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "        * \n      * * \n    * * * \n  * * * * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-11A",
      title: "Codingpractice-11A",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-11A-001",
          title: "Print Word",
          difficulty: "Easy",
          description:
            "Given a string,write a program to print only the alphabets in the given string.\nNote:In the given string there are two special characters before and two special characters after each letter.Ex:##P##Y##T##H##O##N##",
          sampleInput: "--c--a--r--",
          sampleOutput: "car",
          testCases: [
            { input: "--p--y--t--h--o--n--", output: "python", visible: true },
            {
              input: "@@d##o##g##",
              output: "dog",
              visible: true,
            },

            {
              input: "--a--n--t--",
              output: "ant",
              visible: false,
            },

            {
              input: "--c--a--t--",
              output: "cat",
              visible: false,
            },

            {
              input: "--m--o--u--s--e--",
              output: "mouse",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-11A-002",
          title: "pin number",
          difficulty: "Easy",
          description:
            "Given a string,write a program that checks if all the characters in the string are digits.Print True if all the characters in the string are digits.Otherwise,print False.",
          sampleInput: "5gnetwork",
          sampleOutput: "False",
          testCases: [
            { input: "1234", output: "True", visible: true },
            {
              input: "apple",
              output: "False",
              visible: true,
            },

            {
              input: "1256",
              output: "True",
              visible: false,
            },

            {
              input: "123",
              output: "True",
              visible: false,
            },

            {
              input: "cat",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-11A-003",
          title: "Strip Spaces",
          difficulty: "Easy",
          description:
            "Given a string S,Write a program that prints the modified string by removing the leading and trailing spaces from the string S.",
          sampleInput: "   network",
          sampleOutput: "network",
          testCases: [
            { input: "     gani", output: "gani", visible: true },
            {
              input: "    apple",
              output: "apple",
              visible: true,
            },

            {
              input: "    kite",
              output: "kite",
              visible: false,
            },

            {
              input: "  mic",
              output: "mic",
              visible: false,
            },

            {
              input: "       cat",
              output: "cat",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-11A-004",
          title: "Strip Stars",
          difficulty: "Easy",
          description:
            "Given a string S,Write a program that prints the modified string by removing the leading and trailing stars(*) from the string S.",
          sampleInput: "***network***",
          sampleOutput: "network",
          testCases: [
            { input: "****gani**", output: "gani", visible: true },
            {
              input: "*****apple**",
              output: "apple",
              visible: true,
            },

            {
              input: "***kite*",
              output: "kite",
              visible: false,
            },

            {
              input: "*****mic**",
              output: "mic",
              visible: false,
            },

            {
              input: "**cat**",
              output: "cat",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-11A-005",
          title: "Lower Case",
          difficulty: "Easy",
          description:
            "Given a string S,Write a program to print the string by converting all the characters in the string to lowercase.",
          sampleInput: "NOVEMBER",
          sampleOutput: "november",
          testCases: [
            { input: "GANI", output: "gani", visible: true },
            {
              input: "APPLE",
              output: "apple",
              visible: true,
            },

            {
              input: "KITE",
              output: "kite",
              visible: false,
            },

            {
              input: "MIC",
              output: "mic",
              visible: false,
            },

            {
              input: "CAT",
              output: "cat",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-11A-006",
          title: "Upper Case",
          difficulty: "Easy",
          description:
            "Given a string S,Write a program to check if all the characters in the string are in uppercase.\nPrint True if the string contains all uppercase characters,otherwise print False.",
          sampleInput: "NOVEMBER",
          sampleOutput: "True",
          testCases: [
            { input: "GANI", output: "True", visible: true },
            {
              input: "APPle",
              output: "False",
              visible: true,
            },

            {
              input: "KITE",
              output: "True",
              visible: false,
            },

            {
              input: "MIC",
              output: "True",
              visible: false,
            },

            {
              input: "CAT",
              output: "True",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-11A-007",
          title: "Date Format",
          difficulty: "Easy",
          description:
            "Given a string in the format dd-mm-yy S,Write a program to convert the string from dd-mm-yy format to dd/mm/yy format.",
          sampleInput: "01-11-2025",
          sampleOutput: "01/11/2025",
          testCases: [
            { input: "21-01-2025", output: "21/01/2025", visible: true },
            {
              input: "20-05-2025",
              output: "20/05/2025",
              visible: true,
            },

            {
              input: "11-02-2024",
              output: "11/02/2024",
              visible: false,
            },

            {
              input: "11-01-2016",
              output: "11/01/2016",
              visible: false,
            },

            {
              input: "12-02-2030",
              output: "12/02/2030",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-11A-008",
          title: "Lowercase and Uppercase",
          difficulty: "Easy",
          description:
            "Given a string S,write a program that prints the given string after converting all the characters to lowercase and uppercase.",
          sampleInput: "one",
          sampleOutput: "one\nONE",
          testCases: [
            { input: "heaven", output: "heaven\nHEAVEN", visible: true },
            {
              input: "some",
              output: "some\nSOME",
              visible: true,
            },

            {
              input: "letter",
              output: "letter\nLETTER",
              visible: false,
            },

            {
              input: "ant",
              output: "ant\nANT",
              visible: false,
            },

            {
              input: "flower",
              output: "flower\nFLOWER",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-11A-009",
          title: "Upper Case Letters",
          difficulty: "Easy",
          description:
            "Given a string,write a program that prints all the uppercase letters of the given string.",
          sampleInput: "onetoMany",
          sampleOutput: "ONETOMANY",
          testCases: [
            { input: "heaven", output: "HEAVEN", visible: true },
            {
              input: "someWHERE",
              output: "SOMEWHERE",
              visible: true,
            },

            {
              input: "letter",
              output: "LETTER",
              visible: false,
            },

            {
              input: "ant",
              output: "ANT",
              visible: false,
            },

            {
              input: "flower",
              output: "FLOWER",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-11B",
      title: "Codingpractice-11B",
      description: "Loops",
      questions: [
        {
          id: "q-python-Codingpractice-11B-001",
          title: "Secured URL",
          difficulty: "Easy",
          description:
            "Given an URL,write a program that checks if the given URL is a secured URL.\nPrint True if the given URL is a secured URL.Otherwise,print False.\nThe url that starts with https:// is a secured url.",
          sampleInput: "https://docs.google.com",
          sampleOutput: "True",
          testCases: [
            { input: "learning.ccbp.in", output: "False", visible: true },
            {
              input: "https://onesolutions.com",
              output: "True",
              visible: true,
            },

            {
              input: "amazon.in",
              output: "False",
              visible: false,
            },

            {
              input: "https://gani.com",
              output: "True",
              visible: false,
            },

            {
              input: "mic.com",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-11B-002",
          title: "Python File",
          difficulty: "Easy",
          description:
            "Given a file name with the file extension,write a program that checks if the given file is a python file.\nPrint True if the file is a python file.Otherwise,print False.\nA file extension is added to the end of a file name to identify the file's format.\nA python file has the extension `.py`.",
          sampleInput: "add_num.py",
          sampleOutput: "True",
          testCases: [
            { input: "learning.html", output: "False", visible: true },
            {
              input: "https://onesolutions.py",
              output: "True",
              visible: true,
            },

            {
              input: "amazon.html",
              output: "False",
              visible: false,
            },

            {
              input: "https://gani.py",
              output: "True",
              visible: false,
            },

            {
              input: "mic.com.html",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-11B-003",
          title: "Palindrome",
          difficulty: "Easy",
          description:
            "Given a string,check if the given string is a palindrome.\nA palindrome is a sequence of characters that can be read the same way whether you start from the beginning or the end.\nNote:Consider uppercase characters and lowercase characters as different.",
          sampleInput: "madam",
          sampleOutput: "True",
          testCases: [
            { input: "Noon", output: "False", visible: true },
            {
              input: "batsman",
              output: "False",
              visible: true,
            },

            {
              input: "hello",
              output: "False",
              visible: false,
            },

            {
              input: "madam",
              output: "True",
              visible: false,
            },

            {
              input: "bhumi",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-11B-004",
          title: "Palindrome - 2",
          difficulty: "Easy",
          description:
            "You are given a string,write a program to find whether the string is palindrome or not.\nNote:Treat uppercase letters and lowercase letters as same when comparing letters.",
          sampleInput: "Madam",
          sampleOutput: "True",
          testCases: [
            { input: "Noon", output: "False", visible: true },
            {
              input: "Madam",
              output: "True",
              visible: true,
            },

            {
              input: "hello",
              output: "False",
              visible: false,
            },

            {
              input: "Madam",
              output: "True",
              visible: false,
            },

            {
              input: "bhumi",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-11B-005",
          title: "Valid Password",
          difficulty: "Easy",
          description:
            "Given a password S,check if S is a valid password.\nThe password is valid only if it contains at least one digit.\nPrint Valid Password if S is a valid password.Otherwise,print Invalid Password.",
          sampleInput: "Madam23",
          sampleOutput: "valid password",
          testCases: [
            { input: "Noon12", output: "valid password", visible: true },
            {
              input: "Madam",
              output: "Invalid password",
              visible: true,
            },

            {
              input: "hello",
              output: "Invalid password",
              visible: false,
            },

            {
              input: "Madam",
              output: "Invalid password",
              visible: false,
            },

            {
              input: "bhumi",
              output: "Invalid password",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-11",
      title: "Assignment-11",
      description: "Loops",
      questions: [
        {
          id: "q-python-Assignment-11-001",
          title: "Palindrome - 3",
          difficulty: "Easy",
          description:
            "Given a string, write a program that checks if the given string is a palindrome.\nPrint palindrome if the given string is a palindrome.Otherwise,print not a palindrome.",
          sampleInput: "madam",
          sampleOutput: "palindrome",
          testCases: [
            { input: "heaven", output: "not a palindrome", visible: true },
            {
              input: "gadag",
              output: "palindrome",
              visible: true,
            },

            {
              input: "amazon",
              output: "not a palindrome",
              visible: false,
            },

            {
              input: "bag",
              output: "not a palindrome",
              visible: false,
            },

            {
              input: "com",
              output: "not a palindrome",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-11-002",
          title: "Remove Vowels in a sentence",
          difficulty: "Easy",
          description:
            "Given a sentence S.Write a program to remove all the vowels in the given sentence.\nNote:Vowels are A,E,I,O,U,a,e,i,o,u consider both uppercase and lowecase vowels.",
          sampleInput: "hello onesolutions",
          sampleOutput: "hll nsltns",
          testCases: [
            { input: "apple", output: "ppl", visible: true },
            { input: "education", output: "dctn", visible: true },
            { input: "Python", output: "Pythn", visible: false },
            { input: "hello world", output: "hll wrld", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-11-003",
          title: "First Part or Last Part",
          difficulty: "Easy",
          description:
            "Given two strings S1 and S2,write a program that checks if S2 is at the beginning or ending of S1.\nPrint True if S2 is at the beginning or ending of S1.Otherwise,print False.",
          sampleInput: "onesolutions\none",
          sampleOutput: "True",
          testCases: [
            {
              input: "cammel\nmme",
              output: "False",
              visible: true,
            },
            {
              input: "Programming\npro",
              output: "False",
              visible: true,
            },
            {
              input: "onesolutions\none",
              output: "True",
              visible: false,
            },
            {
              input: "HelloWorld\nHello",
              output: "True",
              visible: false,
            },
            {
              input: "BCDFG\nDF",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-11-004",
          title: "Letter,Digit or Special Character",
          difficulty: "Medium",
          description:
            "Given a character C,write a program to check if the C is a Lowercase Letter or Uppercase Letter or Digit or a Special Character.",
          sampleInput: "8",
          sampleOutput: "digit",
          testCases: [
            {
              input: "A",
              output: "uppercase letter",
              visible: true,
            },
            { input: "!", output: "special character", visible: true },
            { input: "a", output: "lowercase letter", visible: false },
            {
              input: "@",
              output: "special character",
              visible: false,
            },
            { input: "B", output: "uppercase letter", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-12",
      title: "Codingpractice-12",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-12-001",
          title: "Print Characters",
          difficulty: "Easy",
          description:
            "Given a string and N indices,where N is the length of the string.Write a program to print the character of the string present at each index of the given N indices.",
          sampleInput: "dlrow\n4\n3\n2\n1\n0",
          sampleOutput: "w\no\nr\nl\nd",
          testCases: [
            {
              input: "lleho\n3\n2\n0\n1\n4",
              output: "h\ne\nl\nl\no",
              visible: true,
            },

            {
              input: "nohtyp\n5\n4\n3\n2\n1\n0",
              output: "p\ny\nt\nh\no\nn",
              visible: true,
            },

            {
              input: "dlrow\n4\n3\n2\n1\n0",
              output: "w\no\nr\nl\nd",
              visible: false,
            },

            {
              input: "tcaer\n4\n3\n2\n1\n0",
              output: "r\ne\na\nc\nt",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-12-002",
          title: "Word Triangle",
          difficulty: "Easy",
          description:
            "Given a word,write a program that prints the letters of the word on N lines as shown in the sample output,where N is the length of the word.",
          sampleInput: "ganesh",
          sampleOutput: "g\nga\ngan\ngane\nganes\nganesh",
          testCases: [
            { input: "a", output: "a", visible: true },

            { input: "hi", output: "h\nhi", visible: true },

            { input: "code", output: "c\nco\ncod\ncode", visible: false },

            {
              input: "python",
              output: "p\npy\npyt\npyth\npytho\npython",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-12-003",
          title: "Count of Zeroes",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to find the count of 0's in N.\nPrint Count of zeroes is greater than three if there are more than 0's in the given number.otherwise,print count of zeroes is not greater than three.",
          sampleInput: "1030800",
          sampleOutput: "count of zeroes is greater  than three",
          testCases: [
            {
              input: "1030800",
              output: "count of zeroes is greater than three",
              visible: true,
            },

            {
              input: "101",
              output: "count of zeroes is not greater than three",
              visible: true,
            },

            {
              input: "100020",
              output: "count of zeroes is greater than three",
              visible: false,
            },

            {
              input: "1002",
              output: "count of zeroes is not greater than three",
              visible: false,
            },

            {
              input: "90909",
              output: "count of zeroes is not greater than three",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-12-004",
          title: "Prime number",
          difficulty: "Easy",
          description:
            "Write a program to check whether the given number is a prime number or not.\nNote:A prime number is a number that has  only two factors.The two factors of a prime number are 1 and itself.",
          sampleInput: "5",
          sampleOutput: "prime number",
          testCases: [
            {
              input: "7",
              output: "prime number",
              visible: true,
            },

            {
              input: "6",
              output: "not a prime number",
              visible: true,
            },

            {
              input: "4",
              output: "not a prime number",
              visible: false,
            },

            {
              input: "9",
              output: "not a prime number",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-12-005",
          title: "Numbers in square pattern - 2",
          difficulty: "Easy",
          description:
            "Write a program to print numbers from 1 to N in each column forming a square pattern of N rows and N columns.",
          sampleInput: "4",
          sampleOutput: "1 1 1 1 \n2 2 2 2 \n3 3 3 3 \n4 4 4 4 ",
          testCases: [
            { input: "1", output: "1 ", visible: true },

            { input: "2", output: "1 1 \n2 2 ", visible: true },

            { input: "3", output: "1 1 1 \n2 2 2 \n3 3 3 ", visible: false },

            {
              input: "5",
              output:
                "1 1 1 1 1 \n2 2 2 2 2 \n3 3 3 3 3 \n4 4 4 4 4 \n5 5 5 5 5 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-12-006",
          title: "Case Conversion",
          difficulty: "Easy",
          description:
            "Given a title case string,write a program to modify the string as given below.\nAdd a hyphen(-)before each uppercase character excluding the first uppercase character.\nConvert all uppercase characters into lowecase characters.\nNote:Title case is a writing style where the first letter of every word in a sentence is capitalized,except for certain words like articles and prepositions.",
          sampleInput: "TitleCase",
          sampleOutput: "title-case",
          testCases: [
            { input: "TitleCase", output: "title-case", visible: true },

            { input: "HelloWorld", output: "hello-world", visible: true },

            { input: "JavaScript", output: "java-script", visible: false },

            { input: "HTMLParser", output: "h-t-m-l-parser", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-12",
      title: "Assignment-12",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Assignment-12-001",
          title: "word triangle - 2",
          difficulty: "Easy",
          description:
            "Given a word W,write a program that prints the letters of the word in N rows as an Inverted Right Angled Triangle as shown in the sample output,where N is the length of the word W.",
          sampleInput: "game",
          sampleOutput: "game\ngam\nga\ng",
          testCases: [
            { input: "a", output: "a", visible: true },
            { input: "hi", output: "hi\nh", visible: true },
            { input: "game", output: "game\ngam\nga\ng", visible: false },

            { input: "code", output: "code\ncod\nco\nc", visible: false },

            {
              input: "python",
              output: "python\npytho\npyth\npyt\npy\np",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-12-002",
          title: "Inverted Right Angled Triangle - 8",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print an Inverted right angled triangle of N rows using stars(*).",
          sampleInput: "2",
          sampleOutput: "* * * \n    * ",
          testCases: [
            {
              input: "1",
              output: "* ",
              visible: true,
            },

            {
              input: "2",
              output: "* * * \n    * ",
              visible: true,
            },

            {
              input: "3",
              output: "* * * * * \n    * * * \n        * ",
              visible: true,
            },

            {
              input: "4",
              output:
                "* * * * * * * \n    * * * * * \n        * * * \n            * ",
              visible: false,
            },

            {
              input: "5",
              output:
                "* * * * * * * * * \n    * * * * * * * \n        * * * * * \n            * * * \n                * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-12-003",
          title: "Shuffle String - 2",
          difficulty: "Easy",
          description:
            "Given two strings S1 and S2 of equal length,write a program that prints a new string by appending characters from S1 first and then from S2 alternately.",
          sampleInput: "bring\ncamel",
          sampleOutput: "baieg",
          testCases: [
            {
              input: "APPRECIATE\nBACKPACKER",
              output: "AAPKEAIKTR",
              visible: true,
            },

            {
              input: "hello\nworld",
              output: "hollo",
              visible: true,
            },
            {
              input: "ABCDE\nabcde",
              output: "AbCdE",
              visible: false,
            },
            {
              input: "12345\n67890",
              output: "17395",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-12-004",
          title: "Hollow Rectangle - 2",
          difficulty: "Medium",
          description:
            "Given two numbers M and N,write a program to print a hollow rectangle of M+2 rows and N+2 columns using pluses(+),hyphens(-) and pipes(|).",
          sampleInput: "2\n3",
          sampleOutput: "+---+\n|   |\n|   |\n+---+",
          testCases: [
            {
              input: "1\n1",
              output: "+-+\n| |\n+-+",
              visible: true,
            },
            {
              input: "2\n3",
              output: "+---+\n|   |\n|   |\n+---+",
              visible: true,
            },
            {
              input: "3\n4",
              output: "+----+\n|    |\n|    |\n|    |\n+----+",
              visible: true,
            },
            {
              input: "1\n5",
              output: "+-----+\n|     |\n+-----+",
              visible: false,
            },
            {
              input: "4\n2",
              output: "+--+\n|  |\n|  |\n|  |\n|  |\n+--+",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-13A",
      title: "Codingpractice-13A",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-13A-001",
          title: "Numbers in Square",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a square of N rows using numbers starting from 1.\nNote:There is a space after every number.",
          sampleInput: "5",
          sampleOutput: "1 2 3 4 5\n1 2 3 4 5\n1 2 3 4 5\n1 2 3 4 5\n1 2 3 4 5",
          testCases: [
            { input: "1", output: "1 ", visible: true },

            { input: "2", output: "1 2 \n1 2 ", visible: true },

            { input: "3", output: "1 2 3 \n1 2 3 \n1 2 3 ", visible: false },

            {
              input: "4",
              output: "1 2 3 4 \n1 2 3 4 \n1 2 3 4 \n1 2 3 4 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-13A-002",
          title: "Numbers in Right Angled Triangle",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Right Angled Triangle of N rows using numbers starting from 1.",
          sampleInput: "3",
          sampleOutput: "1 \n1 2 \n1 2 3 ",
          testCases: [
            {
              input: "1",
              output: "1 ",
              visible: true,
            },
            {
              input: "2",
              output: "1 \n1 2 ",
              visible: true,
            },
            {
              input: "3",
              output: "1 \n1 2 \n1 2 3 ",
              visible: false,
            },
            {
              input: "4",
              output: "1 \n1 2 \n1 2 3 \n1 2 3 4 ",
              visible: false,
            },
            {
              input: "5",
              output: "1 \n1 2 \n1 2 3 \n1 2 3 4 \n1 2 3 4 5 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-13A-003",
          title: "Numbers in Pyramid",
          difficulty: "Easy",
          description:
            "Given two numbers S and N,write a program to print a Pyramid of N rows using numbers starting from S.",
          sampleInput: "3\n3",
          sampleOutput: "  3 \n 3 4 \n3 4 5 ",
          testCases: [
            { input: "1\n1", output: "1 ", visible: true },

            {
              input: "2\n4",
              output: "   2 \n  2 3 \n 2 3 4 \n2 3 4 5 ",
              visible: true,
            },
            { input: "3\n3", output: "  3 \n 3 4 \n3 4 5 ", visible: false },

            { input: "5\n2", output: " 5 \n5 6 ", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-13A-004",
          title: "Armstrong Numbers from 1 to N",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print Armstrong numbers from 1 to N each on a new line.",
          sampleInput: "200",
          sampleOutput: "1\n2\n3\n4\n5\n6\n7\n8\n9\n153",
          testCases: [
            {
              input: "10",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9",
              visible: true,
            },
            {
              input: "400",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9\n153\n370\n371",
              visible: true,
            },
            {
              input: "1",
              output: "1",
              visible: false,
            },
            {
              input: "200",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9\n153",
              visible: false,
            },

            {
              input: "1000",
              output: "1\n2\n3\n4\n5\n6\n7\n8\n9\n153\n370\n371\n407",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-13A-005",
          title: "Prime Numbers from M to N",
          difficulty: "Easy",
          description:
            "Given two numbers M and N.Write a program to print all the Prime numbers in the range from M to N.If no prime Numbers present in the given range print No Prime Numbers Found.",
          sampleInput: "3\n15",
          sampleOutput: "3 5 7 11 13",
          testCases: [
            {
              input: "3\n15",
              output: "3 5 7 11 13",
              visible: true,
            },
            {
              input: "1\n10",
              output: "2 3 5 7",
              visible: true,
            },
            {
              input: "14\n16",
              output: "No Prime Numbers Found",
              visible: true,
            },
            {
              input: "2\n2",
              output: "2",
              visible: false,
            },
            {
              input: "20\n30",
              output: "23 29",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-13A-006",
          title: "Numbers in Rectangle",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print a rectangle of M rows and N columns using numbers starting from 7.\n7 8 9 10\n7 8 9 10\n7 8 9 10\nNote:There is a space after every number.",
          sampleInput: "2\n3",
          sampleOutput: "7 8 9\n7 8 9",
          testCases: [
            {
              input: "5\n4",
              output: "7 8 9 10\n7 8 9 10\n7 8 9 10\n7 8 9 10\n7 8 9 10",
              visible: true,
            },
            {
              input: "2\n2",
              output: "7 8\n7 8",
              visible: true,
            },
            {
              input: "2\n3",
              output: "7 8 9\n7 8 9",
              visible: true,
            },
            {
              input: "2\n2",
              output: "7 8\n7 8",
              visible: false,
            },
            {
              input: "2\n1",
              output: "7\n7",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-13B",
      title: "Codingpractice-13B",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-13B-001",
          title: "Numbers in Square - 3",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a square of N rows using numbers starting from 1.\nNote:There is a space after every number.",
          sampleInput: "3",
          sampleOutput: "1 2 3 \n4 5 6 \n7 8 9 ",
          testCases: [
            { input: "1", output: "1 ", visible: true },

            { input: "2", output: "1 2 \n3 4 ", visible: true },

            { input: "3", output: "1 2 3 \n4 5 6 \n7 8 9 ", visible: false },

            {
              input: "4",
              output: "1 2 3 4 \n5 6 7 8 \n9 10 11 12 \n13 14 15 16 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-13B-002",
          title: "Numbers in Right Angled Triangle - 3",
          difficulty: "Medium",
          description:
            "Given two numbers S and N,write a program to print a Right Angled Triangle of N rows using numbers starting from S.",
          sampleInput: "5\n4",
          sampleOutput: "5 \n6 7 \n8 9 10 \n11 12 13 14 ",
          testCases: [
            {
              input: "1\n1",
              output: "1 ",
              visible: true,
            },
            {
              input: "5\n4",
              output: "5 \n6 7 \n8 9 10 \n11 12 13 14 ",
              visible: true,
            },
            {
              input: "1\n2",
              output: "1 \n2 3 ",
              visible: false,
            },
            {
              input: "3\n3",
              output: "3 \n4 5 \n6 7 8 ",
              visible: false,
            },

            {
              input: "10\n5",
              output: "10 \n11 12 \n13 14 15 \n16 17 18 19 \n20 21 22 23 24 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-13B-003",
          title: "Pair of Numbers",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the count of pairs containing numbers A,B from 1 to N such that the sum of the numbers is equal to N, where A<B.\nA is the first number,B is the second number in a pair.",
          sampleInput: "7",
          sampleOutput: "3",
          testCases: [
            {
              input: "3",
              output: "1",
              visible: true,
            },
            {
              input: "2",
              output: "0",
              visible: true,
            },

            {
              input: "4",
              output: "1",
              visible: false,
            },
            {
              input: "5",
              output: "2",
              visible: false,
            },
            {
              input: "10",
              output: "4",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-13B-004",
          title: "Triplets of Numbers",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the count of triplets containing numbers A,B and C from 1 to N such that the sum of the numbers is equal to N,Where A<B<C.\nA is the first number,B is the second number,and C is the third number in a triplet.",
          sampleInput: "10",
          sampleOutput: "4",
          testCases: [
            {
              input: "8",
              output: "2",
              visible: true,
            },
            {
              input: "6",
              output: "1",
              visible: true,
            },

            {
              input: "10",
              output: "4",
              visible: false,
            },
            {
              input: "12",
              output: "7",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-13B-005",
          title: "Identify the mistake-Inverted Half Pyramid - 2",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print an Inverted Right Angled Triangle of N rows using numbers.\nNote:There is no space after every number.",
          sampleInput: "3",
          sampleOutput: "321\n21\n1",
          testCases: [
            {
              input: "1",
              output: "1",
              visible: true,
            },
            {
              input: "2",
              output: "21\n1",
              visible: true,
            },
            {
              input: "3",
              output: "321\n21\n1",
              visible: false,
            },
            {
              input: "4",
              output: "4321\n321\n21\n1",
              visible: false,
            },
            {
              input: "5",
              output: "54321\n4321\n321\n21\n1",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 5,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-13",
      title: "Assignment-13",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Assignment-13-001",
          title: "Pythagoras Triplets",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the count of Pythagorean Triplets containing numbers A,B and C from 1 to N such that the sum of squares of the numbers A and B is equal to the square of C,where A<B<C.\nA is the first number,B is the second number,and C is the third number in a triplet.\nNote:A pythagorean triplet is a set of three integers A,B,and C such that A^2+B^2=C^2.",
          sampleInput: "5",
          sampleOutput: "1",
          testCases: [
            { input: "10", output: "2", visible: true },
            { input: "13", output: "3", visible: true },
            { input: "15", output: "4", visible: false },
            { input: "5", output: "1", visible: false },
            { input: "20", output: "6", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-13-002",
          title: "Numbers in Inverted Right Angled Triangle - 3",
          difficulty: "Easy",
          description:
            "Given two numbers S and N,write a program to print an Inverted Right Angled Triangle of N rows using numbers starting from K+S-1 and ending with S.K is the count of numbers that can be printed in N rows of an Inverted Right Angled Triangle.",
          sampleInput: "5\n2",
          sampleOutput: "7 6 \n5 ",
          testCases: [
            { input: "1\n3", output: "6 5 4 \n3 2 \n1 ", visible: true },
            { input: "2\n3", output: "7 6 5 \n4 3 \n2 ", visible: true },
            { input: "1\n1", output: "1 ", visible: false },
            {
              input: "3\n4",
              output: "12 11 10 9 \n8 7 6 \n5 4 \n3 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-13-003",
          title: "Numbers in Inverted Pyramid",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print an Inverted Pyramid of N rows using numbers starting from 1.",
          sampleInput: "4",
          sampleOutput: "1 2 3 4 \n 1 2 3 \n  1 2 \n   1 ",
          testCases: [
            {
              input: "3",
              output: "1 2 3 \n 1 2 \n  1 ",
              visible: true,
            },
            {
              input: "1",
              output: "1 ",
              visible: false,
            },
            {
              input: "2",
              output: "1 2 \n 1 ",
              visible: false,
            },
            {
              input: "5",
              output: "1 2 3 4 5 \n 1 2 3 4 \n  1 2 3 \n   1 2 \n    1 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-13-004",
          title: "Number Diamond",
          difficulty: "Medium",
          description:
            "Given a number N,write a program to print a Diamond of 2*N-1 rows using numbers starting from 1.",
          sampleInput: "3",
          sampleOutput: "  1 \n 1 2 \n1 2 3 \n 1 2 \n  1 ",
          testCases: [
            {
              input: "1",
              output: "1 ",
              visible: true,
            },
            {
              input: "2",
              output: " 1 \n1 2 \n 1 ",
              visible: true,
            },
            {
              input: "3",
              output: "  1 \n 1 2 \n1 2 3 \n 1 2 \n  1 ",
              visible: false,
            },
            {
              input: "4",
              output:
                "   1 \n  1 2 \n 1 2 3 \n1 2 3 4 \n 1 2 3 \n  1 2 \n   1 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-13-005",
          title: "Armstrong numbers between two intervals",
          difficulty: "Medium",
          description:
            "Given two numbers M and N,write a program to print all the Armstrong Numbers starting from M to N.If there are no Armstrong numbers,print -1.",
          sampleInput: "1\n100",
          sampleOutput: "1 2 3 4 5 6 7 8 9 ",
          testCases: [
            {
              input: "100\n500",
              output: "153 370 371 407 ",
              visible: true,
            },
            {
              input: "10\n99",
              output: "-1",
              visible: true,
            },
            {
              input: "370\n371",
              output: "370 371 ",
              visible: false,
            },
            {
              input: "1\n1",
              output: "1 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-14A",
      title: "Codingpractice-14A",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-14A-001",
          title: "Numbers in Hollow Square",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Hollow Square of N rows and N columns using numbers starting from 1.\nNote:There is a space after every number.",
          sampleInput: "4",
          sampleOutput: "1 2 3 4 \n1     4\n1     4\n1 2 3 4 ",
          testCases: [
            { input: "1", output: "1 ", visible: true },

            { input: "2", output: "1 2 \n1 2 ", visible: true },

            { input: "3", output: "1 2 3 \n1   3\n1 2 3 ", visible: false },

            {
              input: "4",
              output: "1 2 3 4 \n1     4\n1     4\n1 2 3 4 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-14A-002",
          title: "Numbers in Hollow Right Angled Triangle",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Hollow Right Angled Triangle of N rows using numbers starting from 1.",
          sampleInput: "3",
          sampleOutput: "1\n1 2\n1 2 3 ",
          testCases: [
            { input: "1", output: "1", visible: true },

            { input: "2", output: "1\n1 2 ", visible: true },

            { input: "3", output: "1\n1 2\n1 2 3 ", visible: false },

            { input: "4", output: "1\n1 2\n1   3\n1 2 3 4 ", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-14A-003",
          title: "Numbers in Hollow Rectangle",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print a Hollow Rectangle of M rows and N columns using numbers starting from 7.",
          sampleInput: "4\n4",
          sampleOutput: "7 8 9 10 \n7     10\n7     10\n7 8 9 10 ",
          testCases: [
            {
              input: "2\n2",
              output: "7 8 \n7 8 ",
              visible: true,
            },
            {
              input: "3\n3",
              output: "7 8 9 \n7   9\n7 8 9 ",
              visible: true,
            },
            {
              input: "4\n4",
              output: "7 8 9 10 \n7     10\n7     10\n7 8 9 10 ",
              visible: false,
            },
            {
              input: "5\n5",
              output:
                "7 8 9 10 11 \n7       11\n7       11\n7       11\n7 8 9 10 11 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-14A-004",
          title: "hollow Full Pyramid - 1",
          difficulty: "Easy",
          description:
            "Given the number of rows N,write a program to print the hallow full pyramid pattern similar to the pattern shown below.",
          sampleInput: "4",
          sampleOutput: "   *\n  * *\n *   *\n* * * * ",
          testCases: [
            {
              input: "2",
              output: " *\n* * ",
              visible: true,
            },
            {
              input: "3",
              output: "  *\n * *\n* * * ",
              visible: true,
            },
            {
              input: "4",
              output: "   *\n  * *\n *   *\n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output: "    *\n   * *\n  *   *\n *     *\n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-14A-005",
          title: "hollow Full Pyramid - 2",
          difficulty: "Easy",
          description:
            "Given the number of rows N,write a program to print the hallow full pyramid pattern similar to the pattern shown below.",
          sampleInput: "4",
          sampleOutput: "   1 \n  1 2 \n 1   3 \n1 2 3 4 ",
          testCases: [
            {
              input: "2",
              output: " 1 \n1 2 ",
              visible: true,
            },
            {
              input: "3",
              output: "  1 \n 1 2 \n1 2 3 ",
              visible: true,
            },
            {
              input: "4",
              output: "   1 \n  1 2 \n 1   3 \n1 2 3 4 ",
              visible: false,
            },
            {
              input: "5",
              output: "    1 \n   1 2 \n  1   3 \n 1     4 \n1 2 3 4 5 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-14A-006",
          title: "Full Pyramid - 2",
          difficulty: "Easy",
          description:
            "Given the number of rows N,write a program to print the full pyramid pattern similar to the pattern shown below.",
          sampleInput: "4",
          sampleOutput: "   1 \n  1 2 \n 1 2 3 \n1 2 3 4 ",
          testCases: [
            {
              input: "2",
              output: " 1 \n1 2 ",
              visible: true,
            },
            {
              input: "3",
              output: "  1 \n 1 2 \n1 2 3 ",
              visible: true,
            },
            {
              input: "3",
              output: "  1 \n 1 2 \n1 2 3 ",
              visible: false,
            },
            {
              input: "3",
              output: "  1 \n 1 2 \n1 2 3 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-14B",
      title: "Codingpractice-14B",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-14B-001",
          title: "Numbers in Inverted Hollow Right Angled Triangle",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a an Inverted Hollow Right Angled Triangle of N rows using numbers starting from 1.\nNote:There is a space after every number.",
          sampleInput: "4",
          sampleOutput: "1 2 3 4 \n5   7\n8 9\n10",
          testCases: [
            { input: "1", output: "1 \n2", visible: true },

            { input: "3", output: "1 2 3 \n4 5\n6", visible: true },

            { input: "4", output: "1 2 3 4 \n5   7\n8 9\n10", visible: false },

            {
              input: "5",
              output: "1 2 3 4 5 \n6     9\n10   12\n13 14\n15",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-14B-002",
          title: "Numbers in Hollow Square - 3",
          difficulty: "Easy",
          description:
            "Given two numbers S and N,write a program to print a Hollow Square of N rows and N columns using numbers starting from S.",
          sampleInput: "5\n4",
          sampleOutput: "5 6 7 8 \n9     12 \n13     16 \n17 18 19 20 ",
          testCases: [
            { input: "1\n1", output: "1 ", visible: true },
            { input: "1\n2", output: "1 2 \n3 4 ", visible: true },
            { input: "1\n3", output: "1 2 3 \n4   6 \n7 8 9 ", visible: false },
            {
              input: "5\n4",
              output: "5 6 7 8 \n9     12 \n13     16 \n17 18 19 20 ",
              visible: false,
            },
            {
              input: "10\n5",
              output:
                "10 11 12 13 14 \n15       19 \n20       24 \n25       29 \n30 31 32 33 34 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-14B-003",
          title: "Sum of Prime Numbers in Range",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print the sum of the prime numbers from M to N.",
          sampleInput: "10\n20",
          sampleOutput: "60",
          testCases: [
            { input: "1\n1", output: "0", visible: true },
            { input: "1\n10", output: "17", visible: true },
            { input: "2\n5", output: "10", visible: false },
            { input: "10\n20", output: "60", visible: false },
            { input: "20\n30", output: "52", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-14B-004",
          title: "Armstrong Numbers in inputs",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N inputs and prints the Armstrong Numbers in the given inputs each on a new line.",
          sampleInput: "4\n8\n27\n153\n374",
          sampleOutput: "8\n153",
          testCases: [
            { input: "1\n5", output: "5", visible: true },
            { input: "3\n1\n153\n10", output: "1\n153", visible: true },
            {
              input: "4\n0\n370\n371\n407",
              output: "0\n370\n371\n407",
              visible: false,
            },
            { input: "3\n153\n100\n200", output: "153", visible: false },
            {
              input: "5\n9\n10\n153\n9474\n9475",
              output: "9\n153\n9474",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-14",
      title: "Assignment-14",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Assignment-14-001",
          title: "Numbers in Inverted Hollow Right Angled Triangle - 2",
          difficulty: "Easy",
          description:
            "Given two numbers S and N,write a program to print a Hollow Inverted Right Angled Triangle of N rows using numbers.\nThe numbers start from S on the N th row and increase by 1 until the 1st row.",
          sampleInput: "5\n3",
          sampleOutput: "10 9 8 \n  7 6\n    5",
          testCases: [
            { input: "5\n1", output: "5 ", visible: true },

            { input: "5\n2", output: "7 6 \n  5", visible: true },

            { input: "5\n3", output: "10 9 8 \n  7 6\n    5", visible: false },

            { input: "3\n3", output: "8 7 6 \n  5 4\n    3", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-14-002",
          title: "Numbers in Inverted Hollow Pyramid",
          difficulty: "Easy",
          description:
            "Given two numbers S and N,write a program to print a Inverted Hollow Pyramid of N rows using numbers starting from S.",
          sampleInput: "10\n2",
          sampleOutput: "10 11 \n 12",
          testCases: [
            {
              input: "5\n4",
              output: "5 6 7 8 \n 9   11\n  12 13\n   14",
              visible: true,
            },

            { input: "10\n2", output: "10 11 \n 12", visible: false },

            {
              input: "3\n5",
              output: "3 4 5 6 7 \n 8     11\n  12   14\n   15 16\n    17",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-14-003",
          title: "Numbers in Hollow Diamond",
          difficulty: "Easy",
          description:
            "Given two numbers S and N,write a program to print a Inverted Hollow Pyramid of N rows using numbers starting from S.",
          sampleInput: "3",
          sampleOutput: "  1\n 1 2\n1   3\n 1 2\n  1",
          testCases: [
            { input: "1", output: "1", visible: true },
            { input: "2", output: " 1\n1 2\n 1", visible: true },
            {
              input: "3",
              output: "  1\n 1 2\n1   3\n 1 2\n  1",
              visible: false,
            },

            {
              input: "5",
              output:
                "    1\n   1 2\n  1   3\n 1     4\n1       5\n 1     4\n  1   3\n   1 2\n    1",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-14-004",
          title: "Sum of prime Numbers in Inputs",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N numbers and prints the sum of prime numbers among the given numbers.",
          sampleInput: "4\n5\n7\n11\n13",
          sampleOutput: "36",
          testCases: [
            { input: "1\n2", output: "2", visible: true },
            { input: "3\n1\n2\n3", output: "5", visible: true },
            { input: "5\n4\n6\n8\n9\n10", output: "0", visible: false },
            { input: "4\n5\n7\n11\n13", output: "36", visible: false },
            { input: "6\n1\n2\n3\n4\n5\n6", output: "10", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-15A",
      title: "Codingpractice-15A",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-15A-001",
          title: "Solid Half Diamond",
          difficulty: "Easy",
          description:
            "Given an Integer N,write a program to print the solid half diamond pattern in (2*N-1) rows and N columns,similar to the pattern shown below.",
          sampleInput: "2",
          sampleOutput: "* \n* * \n* ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "* \n* * \n* ", visible: true },
            {
              input: "3",
              output: "* \n* * \n* * * \n* * \n* ",
              visible: false,
            },
            {
              input: "4",
              output: "* \n* * \n* * * \n* * * * \n* * * \n* * \n* ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* \n* * \n* * * \n* * * * \n* * * * * \n* * * * \n* * * \n* * \n* ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15A-002",
          title: "Butterfly - 2",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Butterfly of 2*N rows using stars(*).",
          sampleInput: "3",
          sampleOutput:
            "*         * \n* *     * * \n* * * * * * \n* * * * * * \n* *     * * \n*         * ",
          testCases: [
            { input: "1", output: "* * \n* * ", visible: true },
            {
              input: "2",
              output: "*     * \n* * * * \n* * * * \n*     * ",
              visible: true,
            },
            {
              input: "3",
              output:
                "*         * \n* *     * * \n* * * * * * \n* * * * * * \n* *     * * \n*         * ",
              visible: false,
            },
            {
              input: "4",
              output:
                "*             * \n* *         * * \n* * *     * * * \n* * * * * * * * \n* * * * * * * * \n* * *     * * * \n* *         * * \n*             * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "*                 * \n* *             * * \n* * *         * * * \n* * * *     * * * * \n* * * * * * * * * * \n* * * * * * * * * * \n* * * *     * * * * \n* * *         * * * \n* *             * * \n*                 * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15A-003",
          title: "Numbers in Pyramid - 3",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Pyramid inside a rectangle of N rows using ones(1) to represent the pyramid and zeros(0) in the remaining places of the rectangle.",
          sampleInput: "3",
          sampleOutput: "0 0 1 0 0 \n0 1 1 1 0 \n1 1 1 1 1 ",
          testCases: [
            { input: "1", output: "1 ", visible: true },
            { input: "2", output: "0 1 0 \n1 1 1 ", visible: true },
            {
              input: "3",
              output: "0 0 1 0 0 \n0 1 1 1 0 \n1 1 1 1 1 ",
              visible: false,
            },
            {
              input: "4",
              output:
                "0 0 0 1 0 0 0 \n0 0 1 1 1 0 0 \n0 1 1 1 1 1 0 \n1 1 1 1 1 1 1 ",
              visible: false,
            },
            {
              input: "5",
              output:
                "0 0 0 0 1 0 0 0 0 \n0 0 0 1 1 1 0 0 0 \n0 0 1 1 1 1 1 0 0 \n0 1 1 1 1 1 1 1 0 \n1 1 1 1 1 1 1 1 1 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15A-004",
          title: "alphabets in Square",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Square of N rows using letters.",
          sampleInput: "3",
          sampleOutput: "A B C \nA B C \nA B C ",
          testCases: [
            { input: "1", output: "A ", visible: true },
            { input: "2", output: "A B \nA B ", visible: true },
            { input: "3", output: "A B C \nA B C \nA B C ", visible: false },
            {
              input: "4",
              output: "A B C D \nA B C D \nA B C D \nA B C D ",
              visible: false,
            },
            {
              input: "5",
              output:
                "A B C D E \nA B C D E \nA B C D E \nA B C D E \nA B C D E ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15A-005",
          title: "alphabets in Inverted Right Angled Triangle",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print an Inverted Right Angled Triangle of N rows using letters.",
          sampleInput: "3",
          sampleOutput: "A B C \nA B \nA ",
          testCases: [
            { input: "1", output: "A ", visible: true },
            { input: "2", output: "A B \nA ", visible: true },
            { input: "3", output: "A B C \nA B \nA ", visible: false },
            {
              input: "4",
              output: "A B C D \nA B C \nA B \nA ",
              visible: false,
            },
            {
              input: "5",
              output: "A B C D E \nA B C D \nA B C \nA B \nA ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-15B",
      title: "Codingpractice-15B",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-15B-001",
          title: "Largest Factor of a Number",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the largest factor of N that is less than the number N.",
          sampleInput: "8",
          sampleOutput: "4",
          testCases: [
            { input: "2", output: "1", visible: true },
            { input: "6", output: "3", visible: true },
            { input: "8", output: "4", visible: false },
            { input: "15", output: "5", visible: false },
            { input: "21", output: "7", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15B-002",
          title: "Digit 9",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the digit 9 in <strong>2*N-1</strong> rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "* * * \n*   *\n* * * \n    *\n* * * ",
          testCases: [
            {
              input: "4",
              output:
                "* * * * \n*     *\n*     *\n* * * * \n      *\n      *\n* * * * ",
              visible: true,
            },
            { input: "2", output: "* * \n* * \n* * ", visible: true },
            {
              input: "3",
              output: "* * * \n*   *\n* * * \n    *\n* * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* * * * * \n*       *\n*       *\n*       *\n* * * * * \n        *\n        *\n        *\n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15B-003",
          title: "Pyramid - 9",
          difficulty: "Medium",
          description:
            "Given a number N,write a program to print a Pyramid inside a rectangle of N rows using zeroes(0) to represent the Pyramid and dots(.) in the remaining places of the rectangle.",
          sampleInput: "3",
          sampleOutput: ". . 0 . . \n. 0 0 0 . \n0 0 0 0 0 ",
          testCases: [
            { input: "1", output: "0 ", visible: true },
            { input: "2", output: ". 0 . \n0 0 0 ", visible: true },
            {
              input: "3",
              output: ". . 0 . . \n. 0 0 0 . \n0 0 0 0 0 ",
              visible: true,
            },
            {
              input: "4",
              output:
                ". . . 0 . . . \n. . 0 0 0 . . \n. 0 0 0 0 0 . \n0 0 0 0 0 0 0 ",
              visible: false,
            },
            {
              input: "5",
              output:
                ". . . . 0 . . . . \n. . . 0 0 0 . . . \n. . 0 0 0 0 0 . . \n. 0 0 0 0 0 0 0 . \n0 0 0 0 0 0 0 0 0 ",
              visible: false,
            },
            {
              input: "3",
              output: ". . 0 . . \n. 0 0 0 . \n0 0 0 0 0 ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15B-004",
          title: "Digit 3",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print the digit 3 in 2*N-1 rows using stars(*).",
          sampleInput: "3",
          sampleOutput: "* * * \n    *\n* * * \n    *\n* * * ",
          testCases: [
            { input: "1", output: "* ", visible: true },
            { input: "2", output: "* * \n* * \n* * ", visible: true },
            {
              input: "3",
              output: "* * * \n    *\n* * * \n    *\n* * * ",
              visible: false,
            },
            {
              input: "4",
              output:
                "* * * * \n      *\n      *\n* * * * \n      *\n      *\n* * * * ",
              visible: false,
            },
            {
              input: "5",
              output:
                "* * * * * \n        *\n        *\n        *\n* * * * * \n        *\n        *\n        *\n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-15B-005",
          title: "alphabets in Hollow Rectangle",
          difficulty: "Medium",
          description:
            "Given two numbers M and N,write a program to print a hollow rectangle of M rows and N columns using letters.",
          sampleInput: "3\n3",
          sampleOutput: "A B C \nD   F\nG H I ",
          testCases: [
            { input: "1\n1", output: "A ", visible: true },
            { input: "2\n2", output: "A B \nC D ", visible: true },
            { input: "3\n2", output: "A B \nC D\nE F ", visible: false },
            { input: "3\n3", output: "A B C \nD   F\nG H I ", visible: false },
            {
              input: "4\n3",
              output: "A B C \nD   F\nG   I\nJ K L ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-16",
      title: "Codingpractice-16",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Codingpractice-16-001",
          title: "First Uppercase Letter",
          difficulty: "Easy",
          description:
            "Given a string S,write program to print the uppercase letter that appears first in the string S.",
          sampleInput: "OneSolution",
          sampleOutput: "O",
          testCases: [
            { input: "Hello", output: "H", visible: true },
            { input: "abcDef", output: "D", visible: true },
            { input: "pythonJAVA", output: "J", visible: false },
            { input: "aBcDe", output: "B", visible: false },
            { input: "Lowercase", output: "L", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-16-002",
          title: "First Word",
          difficulty: "Easy",
          description:
            "Given a sentence S containing space-separated words,write a program to print the first word among the words in the sentence S.",
          sampleInput: "welcome to OneSolution",
          sampleOutput: "welcome",
          testCases: [
            { input: "Hello World", output: "Hello", visible: true },
            {
              input: "Python Programming Language",
              output: "Python",
              visible: true,
            },
            { input: "SingleWord", output: "SingleWord", visible: false },
            { input: "Hi there everyone", output: "Hi", visible: false },
            { input: "ChatGPT is powerful", output: "ChatGPT", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-16-003",
          title: "First Negative Number",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N inputs and prints the first negative number among the N inputs.",
          sampleInput: "3\n2\n-4\n3",
          sampleOutput: "-4",
          testCases: [
            { input: "1\n-5", output: "-5", visible: true },
            { input: "3\n4\n-2\n6", output: "-2", visible: true },
            { input: "5\n1\n2\n3\n-9\n10", output: "-9", visible: false },
            { input: "4\n-5\n6\n7\n8", output: "-5", visible: false },
            { input: "6\n10\n20\n-1\n-5\n3\n4", output: "-1", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-16-004",
          title: "First Even Number",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N inputs and prints the first Even number among the N inputs.\nInput:The first line of inputs contains an integer representing N.\nThe next N lines of input contain integers.\nOutput:The output should be a single line containing an integer that is the first Even number among the given N inputs.",
          sampleInput: "3\n2\n7\n9",
          sampleOutput: "2",
          testCases: [
            { input: "1\n2", output: "2", visible: true },
            { input: "4\n1\n3\n4\n6", output: "4", visible: true },
            { input: "3\n2\n4\n6", output: "2", visible: false },
            { input: "1\n4", output: "4", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-16-005",
          title: "Greatest Common Divisor(GCD)",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print the GCD of the numbers M and N.",
          sampleInput: "100\n25",
          sampleOutput: "25",
          testCases: [
            { input: "10\n5", output: "5", visible: true },
            { input: "12\n18", output: "6", visible: true },
            { input: "7\n3", output: "1", visible: false },
            { input: "20\n20", output: "20", visible: false },
            { input: "100\n25", output: "25", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-16",
      title: "Assignment-16",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Assignment-16-001",
          title: "Kth Largest Factor - 2",
          difficulty: "Easy",
          description:
            "Given two numbers N and K,write a program to print the Kth largest factor of the number N.",
          sampleInput: "12\n3",
          sampleOutput: "4",
          testCases: [
            { input: "12\n7", output: "1", visible: true },
            { input: "10\n2", output: "5", visible: true },
            { input: "10\n3", output: "2", visible: false },
            { input: "10\n4", output: "1", visible: false },
            { input: "10\n5", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-16-002",
          title: "First Prime Number",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to read N inputs and print the first Prime number among the given N inputs.",
          sampleInput: "6\n9\n15\n21\n22\n23\n24",
          sampleOutput: "23",
          testCases: [
            { input: "5\n4\n6\n8\n7\n9", output: "7", visible: true },
            { input: "4\n1\n2\n3\n4", output: "2", visible: true },
            { input: "6\n9\n15\n21\n22\n23\n24", output: "23", visible: false },
            { input: "1\n7", output: "7", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-16-003",
          title: "multiple of 5",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to read N inputs and print the given numbers until you encounter a multiple of 5,each on a new line.",
          sampleInput: "6\n2\n4\n6\n8\n10\n12",
          sampleOutput: "2\n4\n6\n8",
          testCases: [
            { input: "5\n1\n2\n3\n4\n5", output: "1\n2\n3\n4", visible: true },
            { input: "4\n7\n9\n11\n15", output: "7\n9\n11", visible: true },
            {
              input: "5\n6\n7\n8\n9\n10",
              output: "6\n7\n8\n9",
              visible: false,
            },
            { input: "4\n1\n3\n5\n7", output: "1\n3", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-16-004",
          title: "Alphabets in Right Angled Triangle",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Right Angled Triangle of N rows using alphabets starting from A.",
          sampleInput: "4",
          sampleOutput: "      A \n    A B \n  A B C \nA B C D ",
          testCases: [
            { input: "1", output: "A ", visible: true },

            { input: "2", output: "  A \nA B ", visible: true },

            { input: "3", output: "    A \n  A B \nA B C ", visible: false },

            {
              input: "4",
              output: "      A \n    A B \n  A B C \nA B C D ",
              visible: false,
            },

            {
              input: "5",
              output:
                "        A \n      A B \n    A B C \n  A B C D \nA B C D E ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Python-Grand-Assignment-2",
      title: "Grand-Assignment-2",
      description: "Loop control Statements",
      questions: [
        {
          id: "q-python-Grand-Assignment-2-001",
          title: "Even and Odds",
          difficulty: "Easy",
          description:
            "write a program to count even and odd numbers in given range[M,N].Both M,N are inclusive in [M,N].\nNote:1st line of output contains no of odd numbers \n2nd line of output contains no of even numbers.",
          sampleInput: "-5\n7",
          sampleOutput: "7\n6",
          testCases: [
            { input: "1\n10", output: "5\n5", visible: true },
            { input: "2\n9", output: "4\n4", visible: true },
            { input: "5\n5", output: "1\n0", visible: false },
            { input: "6\n6", output: "0\n1", visible: false },
            { input: "0\n0", output: "0\n1", visible: false },
            { input: "7\n12", output: "3\n3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-2-002",
          title: "Special Characters",
          difficulty: "Easy",
          description:
            "write a program to count Vowels and Consonants in string.\nNote:Note:1st line of output contains no of Vowels in the given string.\n2nd line of output contains no of Consonants in the given string.",
          sampleInput: "Hello",
          sampleOutput: "2\n3",
          testCases: [
            { input: "hello world", output: "3\n7", visible: true },
            { input: "aeiou", output: "5\n0", visible: true },
            { input: "python", output: "1\n5", visible: false },
            { input: "a i o u e", output: "5\n0", visible: false },
            { input: "bc df", output: "0\n4", visible: false },
            { input: "Hello", output: "2\n3", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-2-003",
          title: "One Color",
          difficulty: "Easy",
          description:
            "Given a string of Length N,made up of only uppercase characters `R` and `G`,where `R`stands for Red and `G`stands for Green.Find out the minimum number of character you need to change to make the whole string of the same colour.",
          sampleInput: "RRGGG",
          sampleOutput: "2",
          testCases: [
            { input: "RRGG", output: "2", visible: true },
            { input: "RRRR", output: "0", visible: true },
            { input: "GGGGG", output: "0", visible: false },
            { input: "RGRGR", output: "2", visible: false },
            { input: "RG", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-2-004",
          title: "Case Conversion",
          difficulty: "Easy",
          description:
            "Given a string in camel case, write a python program to convert the given string from camel case to snake case.",
          sampleInput: "PythonProgram",
          sampleOutput: "python_program",
          testCases: [
            { input: "CamelCase", output: "camel_case", visible: true },
            { input: "StudentName", output: "student_name", visible: true },
            {
              input: "MyVariableName",
              output: "my_variable_name",
              visible: false,
            },
            {
              input: "PythonProgram",
              output: "python_program",
              visible: false,
            },
            { input: "A", output: "a", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-2-005",
          title: "Sandglass Star",
          difficulty: "Easy",
          description:
            "Given a integer N, write a program to print the Sandglass star pattern,similar to the pattern shown below.",
          sampleInput: "4",
          sampleOutput:
            "* * * * \n * * * \n  * * \n   * \n  * * \n * * * \n* * * * ",
          testCases: [
            { input: "1", output: "* ", visible: true },

            { input: "2", output: "* * \n * \n* * ", visible: true },

            {
              input: "3",
              output: "* * * \n * * \n  * \n * * \n* * * ",
              visible: true,
            },

            {
              input: "4",
              output:
                "* * * * \n * * * \n  * * \n   * \n  * * \n * * * \n* * * * ",
              visible: false,
            },

            {
              input: "5",
              output:
                "* * * * * \n * * * * \n  * * * \n   * * \n    * \n   * * \n  * * * \n * * * * \n* * * * * ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-17A",
      title: "Codingpractice-17A",
      description: "Comparing Strings and Naming Variables",
      questions: [
        {
          id: "q-python-Codingpractice-17A-001",
          title: "Print Unicode Values",
          difficulty: "Easy",
          description:
            "Given a string S,write a program to print the unicode values of all the characters in S,each on a new line.",
          sampleInput: "Hi",
          sampleOutput: "72\n105",
          testCases: [
            { input: "ABC", output: "65\n66\n67", visible: true },
            { input: "abc", output: "97\n98\n99", visible: true },
            { input: "a1", output: "97\n49", visible: false },
            { input: "Z", output: "90", visible: false },
            { input: "Hi", output: "72\n105", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-17A-002",
          title: "Count of Characters",
          difficulty: "Easy",
          description:
            "Given a string S and a number N,write a program to print the count of character in S whose Unicode value is equal to the given number N.",
          sampleInput: "test\n120",
          sampleOutput: "0",
          testCases: [
            { input: "apple\n97", output: "1", visible: true },
            { input: "banana\n97", output: "3", visible: true },
            { input: "ABCDA\n65", output: "2", visible: false },
            { input: "hello\n108", output: "2", visible: false },
            { input: "test\n120", output: "0", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-17A-003",
          title: "Print Smallest Letter",
          difficulty: "Easy",
          description:
            "Given a string S,Write a program to print the character with the smallest Unicode value in the string S.",
          sampleInput: "hello",
          sampleOutput: "e",
          testCases: [
            { input: "dcba", output: "a", visible: true },
            { input: "Zebra", output: "Z", visible: true },
            { input: "hello", output: "e", visible: false },
            { input: "aA", output: "A", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-17B",
      title: "Codingpractice-17B",
      description: "Comparing Strings and Naming Variables",
      questions: [
        {
          id: "q-python-Codingpractice-17B-001",
          title: "Next Characters",
          difficulty: "Easy",
          description:
            "Given a string S,write a program to print the next characters of all characters in S bases on the Unicode value,each on a new line.",
          sampleInput: "Az",
          sampleOutput: "B\n{",
          testCases: [
            { input: "abc", output: "b\nc\nd", visible: true },
            { input: "XYZ", output: "Y\nZ\n[", visible: true },
            { input: "a1", output: "b\n2", visible: false },
            { input: "Az", output: "B\n{", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-17B-002",
          title: "Previous Characters",
          difficulty: "Easy",
          description:
            "Given a string S,write a program to print the Previous characters of all characters in S bases on the Unicode value,each on a new line.\nNote:Do not consider space.",
          sampleInput: "Az",
          sampleOutput: "B\n{",
          testCases: [
            { input: "b  cd", output: "a\nb\nc", visible: true },
            { input: "BCD", output: "A\nB\nC", visible: true },
            { input: "a1", output: "`\n0", visible: false },
            { input: "1", output: "0", visible: false },
            { input: "Az", output: "@\ny", visible: false },
            { input: "a b", output: "`\na", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-17B-003",
          title: "First word in dictionary Order",
          difficulty: "Easy",
          description:
            "Given a sentence S contains space-separated words,write a program to print the word that comes first when the words are in dictionary order.",
          sampleInput: "Python java Cpp",
          sampleOutput: "Cpp",
          testCases: [
            { input: "Apple banana Cherry", output: "Apple", visible: true },

            { input: "dog Cat elephant", output: "Cat", visible: true },

            { input: "Zebra ant Lion", output: "ant", visible: true },

            { input: "Python java Cpp", output: "Cpp", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-17B-004",
          title: "Valid Variable Name",
          difficulty: "Easy",
          description:
            "Given a variable name S,check if S is a valid variable name.The variable name is valid if it contains only upper case letters,lower case letters,and digits.\nPrint True if S is a valid variable name.Otherwise,print False.",
          sampleInput: "ABCdef",
          sampleOutput: "True",
          testCases: [
            { input: "abc123", output: "True", visible: true },
            { input: "Hello2025", output: "True", visible: true },
            { input: "ABCdef", output: "True", visible: false },
            { input: "abc_123", output: "False", visible: false },
            { input: "hello world", output: "False", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-17",
      title: "Assignment-17",
      description: "Comparing Strings and Naming Variables",
      questions: [
        {
          id: "q-python-Assignment-17-001",
          title: "Print characters - 4",
          difficulty: "Easy",
          description:
            "Given a string S and two numbers M and N,write a program to print the characters of S that have Unicode values from M to N separated by a space.\nNote:Unicode values are unique numbers that are given to every character,symbol and digit.",
          sampleInput: "ABCdef\n97\n122",
          sampleOutput: "d e f ",
          testCases: [
            { input: "abcXYZ\n65\n90", output: "X Y Z ", visible: true },

            { input: "hello123\n97\n122", output: "h e l l o ", visible: true },

            { input: "Python3\n48\n57", output: "3 ", visible: true },

            { input: "ABCdef\n97\n122", output: "d e f ", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-17-002",
          title: "Unicode Value of First Digit",
          difficulty: "Easy",
          description:
            "Given a string S,Write a program to print the unicode value of the first digit in the given string.",
          sampleInput: "7seven",
          sampleOutput: "55",
          testCases: [
            { input: "abc1def", output: "49", visible: true },

            { input: "hello9", output: "57", visible: true },

            { input: "7seven", output: "55", visible: false },

            { input: "noDigitsHere5", output: "53", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-17-003",
          title: "Replacing Characters of Sentence",
          difficulty: "Medium",
          description:
            "You are given a string S.Write a program to replace each letter of the string with the next letter that comes in the english alphabet.\nNote:Ensure that while replacing the letters,uppercase should be replaced with uppercase letters,and lowercase should be replaced with lowercase letters.",
          sampleInput: "Hello World",
          sampleOutput: "Ifmmp Xpsme",
          testCases: [
            { input: "abc", output: "bcd", visible: true },

            { input: "a z", output: "b {", visible: true },

            { input: "XYZ", output: "YZ[", visible: false },

            { input: "Hello World", output: "Ifmmp Xpsme", visible: false },

            { input: "123", output: "234", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-17-004",
          title: "Print Characters in Dictionary Order",
          difficulty: "Easy",
          description:
            "Given a string S ,Write a program that prints the character with the least unicode value and the character with the highest unicode value separated by a space.",
          sampleInput: "Zebra",
          sampleOutput: "Z r",
          testCases: [
            { input: "abc", output: "a c", visible: true },

            { input: "cba", output: "a c", visible: true },

            { input: "Zebra", output: "Z r", visible: false },

            { input: "Hello", output: "H o", visible: false },

            { input: "a1B@", output: "1 a", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-18",
      title: "Codingpractice-18",
      description: "Comparing Strings and Naming Variables",
      questions: [
        {
          id: "q-python-Codingpractice-18-001",
          title: "Rounding Inputs",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N numbers and prints each of the given N numbers by rounding upto 2 decimals on a new line.",
          sampleInput: "2\n1.234\n5.6789",
          sampleOutput: "1.23\n5.68",
          testCases: [
            {
              input: "3\n3.14159\n2.5\n9.999",
              output: "3.14\n2.5\n10.0",
              visible: true,
            },

            { input: "1\n7.126", output: "7.13", visible: true },

            { input: "2\n1.234\n5.6789", output: "1.23\n5.68", visible: false },

            {
              input: "4\n0.1\n0.105\n2.555\n-3.456",
              output: "0.1\n0.1\n2.56\n-3.46",
              visible: false,
            },

            {
              input: "2\n100.999\n200.001",
              output: "101.0\n200.0",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-18-002",
          title: "Average of Numbers from M to N",
          difficulty: "Easy",
          description:
            "Given two numbers M and N,write a program to print the sum and average of the numbers from M to N each on a new line.",
          sampleInput: "10\n10",
          sampleOutput: "10\n10.0",
          testCases: [
            { input: "1\n5", output: "15\n3.0", visible: true },

            { input: "3\n7", output: "25\n5.0", visible: true },

            { input: "10\n10", output: "10\n10.0", visible: false },

            { input: "-2\n2", output: "0\n0.0", visible: false },

            { input: "5\n9", output: "35\n7.0", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-18-003",
          title: "Sum of N Inputs",
          difficulty: "Easy",
          description:
            "Given two numbers N and S,write a program to find the sum of the given N numbers and round it up to 3 decimals.Check whether the sum that is rounded up to 3 decimals is equal to S or not.\nPrint True if the sum of N inputs rounded up to 3 decimals is equal to S.Otherwise,Print False.",
          sampleInput: "3\n6.001\n1.0\n2.0\n3.0",
          sampleOutput: "False",
          testCases: [
            { input: "2\n5.500\n2.25\n3.25", output: "True", visible: true },

            {
              input: "4\n10.123\n2.5\n2.5\n2.5\n2.623",
              output: "True",
              visible: true,
            },
            { input: "3\n6.000\n1.0\n2.0\n3.0", output: "True", visible: true },
            {
              input: "2\n4.000\n1.999\n2.000",
              output: "False",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-18-004",
          title: "Time Conversion",
          difficulty: "Easy",
          description:
            "Given a time T in either Minutes(M) or Seconds (S). Example:220M,3S.\nIf the last character in the T is M,it is Minutes.\nIf the last character in the T is S,it is Seconds.\nWrite a program to convert the given time T in Minutes(M) or Seconds(S)into Hours (H) rounded up to 2 decimals.\nThe last character of the output should be H representing time in Hours.",
          sampleInput: "180M",
          sampleOutput: "3.0H",
          testCases: [
            { input: "3600S", output: "1.0H", visible: true },

            { input: "7200S", output: "2.0H", visible: true },

            { input: "180M", output: "3.0H", visible: false },

            { input: "90M", output: "1.5H", visible: false },

            { input: "4500S", output: "1.25H", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-18-005",
          title: "Diamond - 3",
          difficulty: "Medium",
          description:
            "Given an integer value N,write a program to print a number diamond of `2*N-1` rows as shown below.",
          sampleInput: "3",
          sampleOutput:
            ". . 0 . . \n. 0 0 0 . \n0 0 0 0 0 \n. 0 0 0 . \n. . 0 . . ",
          testCases: [
            {
              input: "1",
              output: "0 ",
              visible: true,
            },

            {
              input: "2",
              output: ". 0 . \n0 0 0 \n. 0 . ",
              visible: true,
            },

            {
              input: "3",
              output:
                ". . 0 . . \n. 0 0 0 . \n0 0 0 0 0 \n. 0 0 0 . \n. . 0 . . ",
              visible: true,
            },

            {
              input: "4",
              output:
                ". . . 0 . . . \n. . 0 0 0 . . \n. 0 0 0 0 0 . \n0 0 0 0 0 0 0 \n. 0 0 0 0 0 . \n. . 0 0 0 . . \n. . . 0 . . . ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-18",
      title: "Assignment-18",
      description: "Comparing Strings and Naming Variables",
      questions: [
        {
          id: "q-python-Assignment-18-001",
          title: "Alphabets in Hollow Diamond",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print hollow Diamond of 2*N-1 rows using letters.",
          sampleInput: "3",
          sampleOutput: "  A\n B C\nD   E\n B C\n  A",
          testCases: [
            {
              input: "1",
              output: "A",
              visible: true,
            },

            {
              input: "2",
              output: " A\nB C\n A",
              visible: true,
            },

            {
              input: "3",
              output: "  A\n B C\nD   E\n B C\n  A",
              visible: true,
            },

            {
              input: "4",
              output: "   A\n  B C\n D   E\nF     G\n D   E\n  B C\n   A",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-18-002",
          title: "temperature Conversion",
          difficulty: "Medium",
          description:
            "You are given the temperature T of an object in one of Celsius,Fahrenheit,and Kelvin scales.\nWrite a program to print T in all scales viz Celsius,Fahrenheit,and Kelvin.\nFormula to convert from Fahrenheit F to Celsius C is :C=(F - 32) * 5/9.\nFormula to convert from Kelvin K to Celsius C is : C=K - 273.\nHere `C`,`F`,`K` represent that the temperature scale is  in Celsius,Fahrenheit and Kelvin scales respectively.\nThe input contains the temperature ( a number) and the unit of the temperature scale (C,F,K) without any space.\nThe output contains temperature in Celsius,Fahrenheit and Kelvin scales in each line in the format similar to input and the value of the temperature is rounded to 2 decimal places.",
          sampleInput: "273K",
          sampleOutput: "0.0C\n32.0F\n273.0K",
          testCases: [
            {
              input: "32F",
              output: "0.0C\n32.0F\n273.0K",
              visible: true,
            },

            {
              input: "100C",
              output: "100.0C\n212.0F\n373.0K",
              visible: true,
            },

            {
              input: "273K",
              output: "0.0C\n32.0F\n273.0K",
              visible: false,
            },

            {
              input: "0C",
              output: "0.0C\n32.0F\n273.0K",
              visible: false,
            },

            {
              input: "212F",
              output: "100.0C\n212.0F\n373.0K",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-18-003",
          title: "Sum of N terms in Harmonic series",
          difficulty: "Easy",
          description:
            "Given integer N as input,write a program to display the sum of the first N terms in Harmonic series.\nThe series is:1+1/2+1/3+1/4.....1/N(N terms).",
          sampleInput: "5",
          sampleOutput: "2.28",
          testCases: [
            { input: "1", output: "1.0", visible: true },

            { input: "2", output: "1.5", visible: true },

            { input: "3", output: "1.83", visible: false },

            { input: "5", output: "2.28", visible: false },

            { input: "10", output: "2.93", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-18-004",
          title: "Roots of a quadratic equation",
          difficulty: "Easy",
          description:
            "You are given coefficients a , b and c of a quadratic equation ax^2+bx+c=0.Find the roots r1,r2 of the equation.\nNote:r1 and r2 should be rounded upto 2 decimal places.",
          sampleInput: "1\n-5\n6",
          sampleOutput: "3.0\n2.0",
          testCases: [
            { input: "0\n2\n-4", output: "2.0", visible: true },

            { input: "1\n-2\n1", output: "1.0", visible: true },

            { input: "1\n1\n1", output: "no roots", visible: false },

            { input: "1\n-5\n6", output: "3.0\n2.0", visible: false },

            { input: "2\n-7\n3", output: "3.0\n0.5", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-19",
      title: "Codingpractice-19",
      description: "Comparing Strings and Naming Variables",
      questions: [
        {
          id: "q-python-Codingpractice-19-001",
          title: "Division with 17",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N inputs and prints the number without decimals of the quotient of N inputs when each input is divided by 17,each on a new line.",
          sampleInput: "4\n0\n16\n18\n170",
          sampleOutput: "0\n0\n1\n10",
          testCases: [
            { input: "3\n34\n17\n5", output: "2\n1\n0", visible: true },

            { input: "1\n17", output: "1", visible: true },

            {
              input: "4\n0\n16\n18\n170",
              output: "0\n0\n1\n10",
              visible: false,
            },

            { input: "2\n-34\n34", output: "-2\n2", visible: false },

            { input: "3\n100\n255\n289", output: "5\n15\n17", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-19-002",
          title: "Double Char",
          difficulty: "Easy",
          description:
            "Given a String,write a program to double all the characters in the given string.",
          sampleInput: "Hello",
          sampleOutput: "HHeelllloo",
          testCases: [
            { input: "abc", output: "aabbcc", visible: true },

            { input: "a1$", output: "aa11$$", visible: true },

            { input: "Hello", output: "HHeelllloo", visible: false },

            { input: "Py3", output: "PPyy33", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-19-003",
          title: "separate Characters with Comma",
          difficulty: "Easy",
          description:
            "Given a String S,write a program that prints a string obtained by adding a comma(,) between the characters of the given string S.",
          sampleInput: "hello",
          sampleOutput: "h,e,l,l,o",
          testCases: [
            { input: "abc", output: "a,b,c", visible: true },

            { input: "A1$", output: "A,1,$", visible: true },

            { input: "hello", output: "h,e,l,l,o", visible: false },

            { input: "x", output: "x", visible: false },

            { input: "123", output: "1,2,3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-19-004",
          title: "cumulative Sum",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to read N numbers and print the cumulative sum after each input,each on a new line.\nNote:cumulative sum is the sum of all the Previous inputs and the current input.",
          sampleInput: "4\n10\n-5\n2\n3",
          sampleOutput: "10\n5\n7\n10",
          testCases: [
            { input: "3\n1\n2\n3", output: "1\n3\n6", visible: true },

            { input: "1\n5", output: "5", visible: true },

            {
              input: "4\n10\n-5\n2\n3",
              output: "10\n5\n7\n10",
              visible: false,
            },

            { input: "2\n0\n0", output: "0\n0", visible: false },

            { input: "3\n-1\n-2\n-3", output: "-1\n-3\n-6", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-19-005",
          title: "Hollow Pyramid - 3",
          difficulty: "Easy",
          description:
            "Given a number N,write a program to print a Hollow Pyramid of 2*N rows using pipes(|),backward slashes(),and forward slashes(/).",
          sampleInput: "3",
          sampleOutput: "|\n| \\\n|  \\\n|  /\n| /\n|",
          testCases: [
            {
              input: "1",
              output: "|\n|",
              visible: true,
            },

            {
              input: "2",
              output: "|\n| \\\n| /\n|",
              visible: true,
            },

            {
              input: "3",
              output: "|\n| \\\n|  \\\n|  /\n| /\n|",
              visible: false,
            },

            {
              input: "4",
              output: "|\n| \\\n|  \\\n|   \\\n|   /\n|  /\n| /\n|",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-19",
      title: "Assignment-19",
      description: "Comparing Strings and Naming Variables",
      questions: [
        {
          id: "q-python-Assignment-19-001",
          title: "Hyphenate Letters",
          difficulty: "Easy",
          description:
            "You are given a word W as input.Print W by adding a hyphen (-) between each letter in the word.",
          sampleInput: "python",
          sampleOutput: "p-y-t-h-o-n",
          testCases: [
            { input: "abc", output: "a-b-c", visible: true },

            { input: "A1$", output: "A-1-$", visible: true },

            { input: "hello", output: "h-e-l-l-o", visible: false },

            { input: "x", output: "x", visible: false },

            { input: "12 3", output: "1-2- -3", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-19-002",
          title: "Maximum",
          difficulty: "Easy",
          description:
            "You are given N number of inputs.Print the Maximum of them after each input.",
          sampleInput: "1\n100",
          sampleOutput: "100",
          testCases: [
            { input: "3\n1\n2\n3", output: "1\n2\n3", visible: true },

            {
              input: "5\n5\n3\n8\n2\n7",
              output: "5\n5\n8\n8\n8",
              visible: true,
            },

            {
              input: "4\n10\n9\n8\n7",
              output: "10\n10\n10\n10",
              visible: false,
            },

            { input: "1\n100", output: "100", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-19-003",
          title: "Diamond Crystal",
          difficulty: "Easy",
          description:
            "Given an integer value N,write a program to print a diamond pattern of 2*N rows as shown below.",
          sampleInput: "3",
          sampleOutput: "  /\\\n /  \\\n/    \\\n\\    /\n \\  /\n  \\/",
          testCases: [
            {
              input: "1",
              output: "/\\\n\\/",
              visible: true,
            },

            {
              input: "2",
              output: " /\\\n/  \\\n\\  /\n \\/",
              visible: true,
            },

            {
              input: "3",
              output: "  /\\\n /  \\\n/    \\\n\\    /\n \\  /\n  \\/",
              visible: false,
            },

            {
              input: "4",
              output:
                "   /\\\n  /  \\\n /    \\\n/      \\\n\\      /\n \\    /\n  \\  /\n   \\/",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-20",
      title: "Coding Practice - 20",
      description: "Lists",
      questions: [
        {
          id: "q-python-Codingpractice-20-001",
          title: "Create and Print List",
          difficulty: "Easy",
          description:
            "Write a program to print a list with the given elements `ROSE`,183,148,123.64,False.",
          sampleInput: "",
          sampleOutput: "['Rose', 183, 148, 123.64, False]",
          testCases: [
            {
              input: "",
              output: "['Rose', 183, 148, 123.64, False]",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 10,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-20-002",
          title: "List Indexing",
          difficulty: "Easy",
          description:
            "For this problem, Given a list.Write a program to print the element at the given index location.\ncolor_list = [Red, Orange, Yellow, Pink, Green, Blue, Purple, Black, White].",
          sampleInput: "3",
          sampleOutput: "Pink",
          testCases: [
            { input: "0", output: "Red", visible: true },
            { input: "3", output: "Pink", visible: true },
            { input: "5", output: "Blue", visible: false },
            { input: "8", output: "White", visible: false },
          ],
          defaultCode: `color_list = ["Red", "Orange", "Yellow", "Pink", "Green", "Blue", "Purple", "Black", "White"]
          # Write your code here`,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-20-003",
          title: "List Indexing - 2",
          difficulty: "Easy",
          description:
            "For this problem, Given a list.You need to write a program to read N integers,and print the elements at the index locations represented by those integers.\nprogramming_languages_list = [Python, Java, Ruby, C, C++, Go, R, JavaScript, Swift, PHP, Kotlin, Perl].",
          sampleInput: "4\n5\n7\n9\n11",
          sampleOutput: "Go\nJavaScript\nPHP\nPerl",
          testCases: [
            {
              input: "3\n0\n1\n2",
              output: "Python\nJava\nRuby",
              visible: true,
            },
            { input: "2\n3\n4", output: "C\nC++", visible: true },
            {
              input: "4\n5\n7\n9\n11",
              output: "Go\nJavaScript\nPHP\nPerl",
              visible: false,
            },
            { input: "1\n10", output: "Kotlin", visible: false },
          ],
          defaultCode: `programming_languages_list = ["Python", "Java", "Ruby", "C", "C++", "Go", "R", "JavaScript", "Swift", "PHP", "Kotlin", "Perl"]
          # Write your code here`,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-20-004",
          title: "Find Element in List",
          difficulty: "Easy",
          description:
            "A list L is given in the prefilled code.\nWrite a program that reads a string S and checks if S is in the given list L.Print True if S is present in L else,Print False.\nL=[`5`,`Eat`,`9.80`,`Water`,`Python`,`-678`,`7685.26`,`-2.5`,`Sing`]",
          sampleInput: "Water",
          sampleOutput: "True",
          testCases: [
            { input: "Eat", output: "True", visible: true },
            { input: "Hello", output: "False", visible: true },
            { input: "Water", output: "True", visible: false },
            { input: "Python", output: "True", visible: false },
          ],
          defaultCode: `L = ["5","Eat","9.80","Water","Python","-678","7685.26","-2.5","Sing"]

          # Write your code here`,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-20-005",
          title: "List Concatenation",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a list.You need to concatenate the given number to the list.The first list should have the number concatenated at the beginning.The second list should have the number concatenated at the end.",
          sampleInput: "250",
          sampleOutput: "[250, 10, 20, 40, 100]\n[10, 20, 40, 100, 250]",
          testCases: [
            {
              input: "5",
              output: "[5, 10, 20, 40, 100]\n[10, 20, 40, 100, 5]",
              visible: true,
            },
            {
              input: "0",
              output: "[0, 10, 20, 40, 100]\n[10, 20, 40, 100, 0]",
              visible: true,
            },
            {
              input: "-3",
              output: "[-3, 10, 20, 40, 100]\n[10, 20, 40, 100, -3]",
              visible: false,
            },
            {
              input: "250",
              output: "[250, 10, 20, 40, 100]\n[10, 20, 40, 100, 250]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-20-006",
          title: "Create and Print List - 2",
          difficulty: "Easy",
          description:
            "Write a program to print a list with the given N inputs.",
          sampleInput: "2\nHello\nWorld",
          sampleOutput: "['Hello', 'World']",
          testCases: [
            {
              input: "3\napple\nbanana\ncherry",
              output: "['apple', 'banana', 'cherry']",
              visible: true,
            },
            { input: "1\npython", output: "['python']", visible: true },
            {
              input: "4\n10\n20\n30\n40",
              output: "['10', '20', '30', '40']",
              visible: false,
            },
            {
              input: "2\nHello\nWorld",
              output: "['Hello', 'World']",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-20-007",
          title: "List Repetition",
          difficulty: "Easy",
          description:
            "A list L is given in the prefilled code.\nGiven a number N,write a program that prints the list by repeating the prefilled list N times.\nL=[1,`two`,`3`,4.0]",
          sampleInput: "3",
          sampleOutput:
            "[1, 'two', '3', 4.0, 1, 'two', '3', 4.0, 1, 'two', '3', 4.0]",
          testCases: [
            { input: "1", output: "[1, 'two', '3', 4.0]", visible: true },
            {
              input: "2",
              output: "[1, 'two', '3', 4.0, 1, 'two', '3', 4.0]",
              visible: true,
            },
            { input: "0", output: "[]", visible: false },
            {
              input: "3",
              output:
                "[1, 'two', '3', 4.0, 1, 'two', '3', 4.0, 1, 'two', '3', 4.0]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-20-008",
          title: "Reverse Order",
          difficulty: "Easy",
          description:
            "Given an integer N,Write a program to print the given N inputs in the reverse order.",
          sampleInput: "2\nHello\nWorld",
          sampleOutput: "World\nHello",
          testCases: [
            {
              input: "3\napple\nbanana\ncherry",
              output: "cherry\nbanana\napple",
              visible: true,
            },
            { input: "1\npython", output: "python", visible: true },
            {
              input: "4\n10\n20\n30\n40",
              output: "40\n30\n20\n10",
              visible: false,
            },
            {
              input: "2\nHello\nWorld",
              output: "World\nHello",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-20",
      title: "Assignment-20",
      description: "Lists",
      questions: [
        {
          id: "q-python-Assignment-20-001",
          title: "Swap Elements in List",
          difficulty: "Easy",
          description:
            "A list L is given in the prefilled code.Write a program that reads the two indices L1 and L2.\n* Replace the element in the L1 th index with the element in L2 th index.\n* Replace the element in the L2 th index with the element in L1 th index.\nL=[1,`two`,9,5.09,`three`,-558,`four`,-93.7,`six`]",
          sampleInput: "3\n8",
          sampleOutput:
            "[1, 'two', 9, 'six', 'Three', -558, 'four', -93.7, 5.09]",
          testCases: [
            {
              input: "0\n1",
              output:
                "['two', 1, 9, 5.09, 'Three', -558, 'four', -93.7, 'six']",
              visible: true,
            },
            {
              input: "2\n4",
              output:
                "[1, 'two', 'Three', 5.09, 9, -558, 'four', -93.7, 'six']",
              visible: true,
            },
            {
              input: "5\n7",
              output:
                "[1, 'two', 9, 5.09, 'Three', -93.7, 'four', -558, 'six']",
              visible: false,
            },
            {
              input: "3\n8",
              output:
                "[1, 'two', 9, 'six', 'Three', -558, 'four', -93.7, 5.09]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-20-002",
          title: "List Indexing - 3",
          difficulty: "Easy",
          description:
            "Given N numbers,and an index, write a program to store the numbers in a list and print the number at the given index.For this problem,each input will contain T test cases.Each test case will give an index Ki as input,which should be considered to print the number.",
          sampleInput: "4\n1\n100\n200\n300\n400\n3",
          sampleOutput: "400",
          testCases: [
            {
              input: "5\n3\n10\n20\n30\n40\n50\n0\n2\n4",
              output: "10\n30\n50",
              visible: true,
            },
            { input: "3\n2\n7\n8\n9\n1\n0", output: "8\n7", visible: true },
            {
              input: "4\n1\n100\n200\n300\n400\n3",
              output: "400",
              visible: false,
            },
            {
              input: "6\n4\n5\n15\n25\n35\n45\n55\n5\n3\n1\n0",
              output: "55\n35\n15\n5",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-20-003",
          title: "First and last elements of list",
          difficulty: "Easy",
          description:
            "You are given an integer N as input.Write a program to read N integers and print a list containing the first and last two inputs.",
          sampleInput: "3\n7\n8\n9",
          sampleOutput: "[7, 8, 8, 9]",
          testCases: [
            {
              input: "5\n10\n20\n30\n40\n50",
              output: "[10, 20, 40, 50]",
              visible: true,
            },
            { input: "4\n1\n2\n3\n4", output: "[1, 2, 3, 4]", visible: true },
            {
              input: "6\n5\n15\n25\n35\n45\n55",
              output: "[5, 15, 45, 55]",
              visible: false,
            },
            { input: "3\n7\n8\n9", output: "[7, 8, 8, 9]", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-20-004",
          title: "Divisible by 5",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N numbers and prints a list of numbers that are divisible by 5.",
          sampleInput: "4\n-5\n-10\n6\n11",
          sampleOutput: "[-5, -10]",
          testCases: [
            {
              input: "5\n10\n12\n25\n33\n40",
              output: "[10, 25, 40]",
              visible: true,
            },
            { input: "3\n1\n2\n3", output: "[]", visible: true },
            {
              input: "6\n5\n15\n20\n22\n7\n30",
              output: "[5, 15, 20, 30]",
              visible: false,
            },
            { input: "4\n-5\n-10\n6\n11", output: "[-5, -10]", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-21A",
      title: "Codingpractice-21A",
      description: "Functions",
      questions: [
        {
          id: "q-python-Codingpractice-21A-001",
          title: "Split the sentence",
          difficulty: "Easy",
          description:
            "Given a sentence S.The words in the sentence S are separated by a space.Write a program that prints a list containing the words in the sentence.",
          sampleInput: "Python is easy",
          sampleOutput: "['Python', 'is', 'easy']",
          testCases: [
            {
              input: "Hello World",
              output: "['Hello', 'World']",
              visible: true,
            },
            {
              input: "Python is easy",
              output: "['Python', 'is', 'easy']",
              visible: true,
            },
            {
              input: "Split   by   spaces",
              output: "['Split', 'by', 'spaces']",
              visible: false,
            },
            { input: "one", output: "['one']", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-21A-002",
          title: "Split the sentence - 2",
          difficulty: "Easy",
          description:
            "Given a list of N words,write a program to print each word in a line.",
          sampleInput: "Split   by   spaces",
          sampleOutput: "Split\nby\nspaces",
          testCases: [
            { input: "hello world", output: "hello\nworld", visible: true },

            {
              input: "Python is fun",
              output: "Python\nis\nfun",
              visible: true,
            },

            { input: "single", output: "single", visible: false },

            {
              input: "split these words now",
              output: "split\nthese\nwords\nnow",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-21A-003",
          title: "Split Numbers",
          difficulty: "Easy",
          description:
            "Given space-separated numbers,write a program to print a list containing the given numbers.",
          sampleInput: "-5 -10 15",
          sampleOutput: "[-5, -10, 15]",
          testCases: [
            { input: "1 2 3 4 5", output: "[1, 2, 3, 4, 5]", visible: true },
            {
              input: "10 20 -30 40",
              output: "[10, 20, -30, 40]",
              visible: true,
            },
            { input: "0", output: "[0]", visible: false },
            { input: "-5 -10 15", output: "[-5, -10, 15]", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-21A-004",
          title: "Sum of List Elements",
          difficulty: "Easy",
          description:
            "Given a list of numbers,write a program to print the sum of the numbers in the list.",
          sampleInput: "-1 -2 -3",
          sampleOutput: "-6",
          testCases: [
            { input: "1 2 3 4", output: "10", visible: true },
            { input: "10 20 -5", output: "25", visible: true },
            { input: "0", output: "0", visible: false },
            { input: "-1 -2 -3", output: "-6", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-21A-005",
          title: "Divisible by 3",
          difficulty: "Easy",
          description:
            "Given space-separated numbers,write a program to print a list containing the given numbers that are divisible by 3.",
          sampleInput: "-6 -5 -4 15",
          sampleOutput: "[-6, 15]",
          testCases: [
            { input: "3 6 7 9 10", output: "[3, 6, 9]", visible: true },
            { input: "1 2 4 5", output: "[]", visible: true },
            { input: "0 12 -3 8", output: "[0, 12, -3]", visible: false },
            { input: "-6 -5 -4 15", output: "[-6, 15]", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-21A-006",
          title: "Smallest Number in the List",
          difficulty: "Easy",
          description:
            "Given space-separated numbers,write a program to print the smallest number among the given numbers.",
          sampleInput: "-1 -5 0 4",
          sampleOutput: "-5",
          testCases: [
            { input: "5 3 8 2 9", output: "2", visible: true },
            { input: "10 20 30", output: "10", visible: true },
            { input: "-1 -5 0 4", output: "-5", visible: false },
            { input: "7", output: "7", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-21B",
      title: "Codingpractice-21B",
      description: "Functions",
      questions: [
        {
          id: "q-python-Codingpractice-21B-001",
          title: "Check First Letter and Last letter of Word",
          difficulty: "Easy",
          description:
            "Given space-separated words,write a program to check if the first letter and last letter of each word are the same.\nNote:Consider both uppercase and lowercase letters as the same.",
          sampleInput: "Madam Racecar apple",
          sampleOutput: "True\nTrue\nFalse",
          testCases: [
            {
              input: "Anna civic level",
              output: "True\nTrue\nTrue",
              visible: true,
            },
            { input: "Hello World", output: "False\nFalse", visible: true },
            {
              input: "Madam Racecar apple",
              output: "True\nTrue\nFalse",
              visible: false,
            },
            { input: "a bb cdc", output: "True\nTrue\nTrue", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-21B-002",
          title: "Reverse the Sentence",
          difficulty: "Easy",
          description:
            "Given a sentence S,write a program to print the reverse of the sentence.",
          sampleInput: "hello world",
          sampleOutput: "dlrow olleh",
          testCases: [
            { input: "hello", output: "olleh", visible: true },
            { input: "Python", output: "nohtyP", visible: true },
            { input: "12345", output: "54321", visible: false },
            { input: "hello world", output: "dlrow olleh", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-21B-003",
          title: "Reverse Words in List",
          difficulty: "Easy",
          description:
            "Given a List of words,write a program to reverse the words in the list.",
          sampleInput: "one two three four",
          sampleOutput: "['four', 'three', 'two', 'one']",
          testCases: [
            {
              input: "hello world",
              output: "['world', 'hello']",
              visible: true,
            },
            {
              input: "Python is fun",
              output: "['fun', 'is', 'Python']",
              visible: true,
            },
            {
              input: "one two three four",
              output: "['four', 'three', 'two', 'one']",
              visible: false,
            },
            { input: "single", output: "['single']", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-21B-004",
          title: "First half words of list",
          difficulty: "Easy",
          description:
            "Given space-separated words,write a program that Creates a list using space-separated words and prints the first half of the words in the list as a new list.\nNote:If the given number of words is an odd number,add one to it such that it becomes an even number and count half of the number of words.",
          sampleInput: "single",
          sampleOutput: "['single']",
          testCases: [
            {
              input: "one two three four",
              output: "['one', 'two']",
              visible: true,
            },
            {
              input: "apple banana cherry",
              output: "['apple', 'banana']",
              visible: true,
            },
            { input: "a b c d e f", output: "['a', 'b', 'c']", visible: false },
            { input: "single", output: "['single']", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-21B-005",
          title: "First half Numbers of List",
          difficulty: "Easy",
          description:
            "Given space-separated numbers,write a program that creates a list using space-separated numbers and prints the first half of the numbers of the list as a new list.\nNote:If the given number of words is an odd number,add one to it such that it becomes an even number and count half of the number of words.",
          sampleInput: "5 6 7 8 9 10",
          sampleOutput: "[5, 6, 7]",
          testCases: [
            { input: "1 2 3 4", output: "[1, 2]", visible: true },
            { input: "10 20 30", output: "[10, 20]", visible: true },
            { input: "5 6 7 8 9 10", output: "[5, 6, 7]", visible: false },
            { input: "42", output: "[42]", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-21",
      title: "Assignment-21",
      description: "Functions",
      questions: [
        {
          id: "q-python-Assignment-21-001",
          title: "Reverse words in sentence",
          difficulty: "Easy",
          description:
            "You are given a string S as input,write a program to print the string after reversing the words of the given sentence.",
          sampleInput: "one two three four",
          sampleOutput: "four three two one",
          testCases: [
            { input: "hello world", output: "world hello", visible: true },
            { input: "Python is fun", output: "fun is Python", visible: true },
            {
              input: "one two three four",
              output: "four three two one",
              visible: false,
            },
            { input: "single", output: "single", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-21-002",
          title: "Last half of List",
          difficulty: "Easy",
          description:
            "You are given an integer N as input.Write a program to read N inputs and print a list containing the elements in the last half of the list.",
          sampleInput: "7\n5 10 15 20 25 30 35",
          sampleOutput: "[20, 25, 30, 35]",
          testCases: [
            { input: "5\n1 2 3 4 5", output: "[4, 5]", visible: true },
            { input: "6\n1 2 3 4 5 6", output: "[4, 5, 6]", visible: true },

            { input: "4\n10 20 30 40", output: "[30, 40]", visible: true },

            { input: "5\n1 2 3 4 5", output: "[4, 5]", visible: false },

            { input: "2\n7 9", output: "[9]", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-21-003",
          title: "Average of given numbers",
          difficulty: "Easy",
          description:
            "You are given space-separated integers as input.write a program to print the average of the given numbers.",
          sampleInput: "5 10 15 20",
          sampleOutput: "12.5",
          testCases: [
            { input: "10 20 30", output: "20.0", visible: true },
            { input: "1 2", output: "1.5", visible: true },
            { input: "5 10 15 20", output: "12.5", visible: false },
            { input: "3 3 4", output: "3.33", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-21-004",
          title: "Acronyms",
          difficulty: "Medium",
          description:
            "You are given some abbreviations as input.write a program to print the acronyms separated by a dot(.)of those abbreviations.",
          sampleInput: "United States of America",
          sampleOutput: "U.S.o.A",
          testCases: [
            { input: "Hello World", output: "H.W", visible: true },
            { input: "Python is easy", output: "P.i.e", visible: true },
            {
              input: "United States of America",
              output: "U.S.o.A",
              visible: false,
            },
            { input: "single", output: "s", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-22A",
      title: "Codingpractice-22A",
      description: "Functions",
      questions: [
        {
          id: "q-python-Codingpractice-22A-001",
          title: "Print the input - 5",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes the word S as an argument.\nWrite a program that reads a word S and print the given word by calling the function.",
          sampleInput: "Hello World!",
          sampleOutput: "Hello World!",
          testCases: [
            { input: "Hello", output: "Hello", visible: true },
            {
              input: "Python Programming",
              output: "Python Programming",
              visible: true,
            },
            { input: "12345", output: "12345", visible: false },
            { input: "Hello World!", output: "Hello World!", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22A-002",
          title: "Welcome Message",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.write a program to concatenate the message `welcome` followed by the given name.",
          sampleInput: "python",
          sampleOutput: "Welcome python",
          testCases: [
            { input: "Ganesh", output: "Welcome Ganesh", visible: true },
            { input: "Alice", output: "Welcome Alice", visible: true },
            { input: "John Doe", output: "Welcome John Doe", visible: false },
            { input: "123", output: "Welcome 123", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22A-003",
          title: "Multiply with Three",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.Write a program that the given function will Multiply the number N with three.",
          sampleInput: "-4",
          sampleOutput: "-12",
          testCases: [
            { input: "5", output: "15", visible: true },
            { input: "0", output: "0", visible: true },
            { input: "-4", output: "-12", visible: false },
            { input: "10", output: "30", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22A-004",
          title: "Divisible by seven - 2",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.Write a program that the given function will check if the number N is divisible by 7.",
          sampleInput: "10",
          sampleOutput: "False",
          testCases: [
            { input: "14", output: "True", visible: true },
            { input: "7", output: "True", visible: true },
            { input: "10", output: "False", visible: false },
            { input: "-21", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22A-005",
          title: "Even Number or Odd Numbers",
          difficulty: "Easy",
          description:
            "Write a function with the name show_numbers that takes a number(N) and print all the numbers from 0 to N with a label to identify the even and odd numbers as shown below.\n0 Even\n1 Odd\n2 Even\n3 Odd",
          sampleInput: "1",
          sampleOutput: "0 EVEN\n1 ODD",
          testCases: [
            {
              input: "3",
              output: "0 EVEN\n1 ODD\n2 EVEN\n3 ODD",
              visible: true,
            },
            { input: "0", output: "0 EVEN", visible: true },
            {
              input: "5",
              output: "0 EVEN\n1 ODD\n2 EVEN\n3 ODD\n4 EVEN\n5 ODD",
              visible: false,
            },
            { input: "1", output: "0 EVEN\n1 ODD", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-22B",
      title: "Codingpractice-22B",
      description: "Functions",
      questions: [
        {
          id: "q-python-Codingpractice-22B-001",
          title: "Return the given Argument",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.write a program to return the value passed to the function.",
          sampleInput: "42",
          sampleOutput: "42",
          testCases: [
            { input: "5", output: "5", visible: true },
            { input: "0", output: "0", visible: true },
            { input: "-10", output: "-10", visible: false },
            { input: "42", output: "42", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22B-002",
          title: "Perimeter of Square",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.Write a program that the given function will return the perimeter of the square.\nThe sum of lengths of the four sides of a square is the perimeter of the square.",
          sampleInput: "10",
          sampleOutput: "40",
          testCases: [
            { input: "5", output: "20", visible: true },
            { input: "1", output: "4", visible: true },
            { input: "0", output: "0", visible: false },
            { input: "10", output: "40", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22B-003",
          title: "Second character in the word",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.Write a program that the given function will return the second character in the word passed to the function.",
          sampleInput: "open",
          sampleOutput: "p",
          testCases: [
            { input: "Python", output: "y", visible: true },
            { input: "Hello", output: "e", visible: true },
            { input: "AB", output: "B", visible: false },
            { input: "OpenAI", output: "p", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22B-004",
          title: "Percentage - 4",
          difficulty: "Easy",
          description:
            "A function is given in prefilled code that takes a number N as an argument.\nWrite a program that checks if N is less than 1000.\nReturn 5% of the N if N is less than 1000.Otherwise,return 10% of the N.",
          sampleInput: "2500",
          sampleOutput: "250.0",
          testCases: [
            { input: "500", output: "25.0", visible: true },
            { input: "999", output: "49.95", visible: true },
            { input: "1000", output: "100.0", visible: false },
            { input: "2500", output: "250.0", visible: false },
          ],
          defaultCode: ``,
          score: 25,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-22B-005",
          title: "Count the upper case letters",
          difficulty: "Easy",
          description:
            "A function is given in prefilled code that takes a string S as an argument.Write a program that prints the count of uppercase letters in the- given string S.",
          sampleInput: "Hello",
          sampleOutput: "1",
          testCases: [
            { input: "HelloWorld", output: "2", visible: true },
            { input: "PYTHON", output: "6", visible: true },
            { input: "python", output: "0", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-22",
      title: "Assignment-22",
      description: "Functions",
      questions: [
        {
          id: "q-python-Assignment-22-001",
          title: "ATM PIN Code Validation",
          difficulty: "Easy",
          description:
            "Write a function with the name Validate_atm_pin_code that takes a word as an argument.ATM PIN is considered valid only if the given word contains,\nExactly 4 or 6 characters\nAll the characters should be digits",
          sampleInput: "12345",
          sampleOutput: "Invalid PIN Code",
          testCases: [
            { input: "1234", output: "Valid PIN Code", visible: true },
            { input: "987654", output: "Valid PIN Code", visible: true },
            { input: "12a4", output: "Invalid PIN Code", visible: false },
            { input: "12345", output: "Invalid PIN Code", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-22-002",
          title: "Calculate Bill",
          difficulty: "Easy",
          description:
            "Write a function with the name calculate_bill that takes the bill amount as an argument.\nIf the bill amount is less than 500,the discount should be 5%.\nIf the bill amount is greater than or equal to 500 and less than 2500,the discount should be 10%.\nIf the bill amount is greater than or equal to 2500,the discount should be 20%.\n Calculate the bill amount with the appropriate discount and print it.",
          sampleInput: "3000",
          sampleOutput: "2400.0",
          testCases: [
            { input: "400", output: "380.0", visible: true },
            { input: "500", output: "450.0", visible: true },
            { input: "2000", output: "1800.0", visible: false },
            { input: "3000", output: "2400.0", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-22-003",
          title: "Fizz Buzz",
          difficulty: "Easy",
          description:
            "Write a function with the name fizz_buzz that takes a number as an argument.\nIf the number is divisible by 3,it should return `Fizz`.\nIf it is divisible by 5,it should return `Buzz`.\nIf it is divisible by both 3 and 5,it should return `FizzBuzz`.\nOtherwise,it should return the same number.",
          sampleInput: "3000",
          sampleOutput: "2400.0",
          testCases: [
            { input: "15", output: "FizzBuzz", visible: true },
            { input: "9", output: "Fizz", visible: true },
            { input: "10", output: "Buzz", visible: false },
            { input: "7", output: "7", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-22-004",
          title: "Count of Lowercase and Uppercase letters",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.write a program to count the number of uppercase and lowercase letters in the given word.",
          sampleInput: "3000",
          sampleOutput: "2400.0",
          testCases: [
            { input: "HelloWorld", output: "2\n8", visible: true },
            { input: "PYTHON", output: "6\n0", visible: true },
            { input: "python", output: "0\n6", visible: false },
            { input: "OpenAI", output: "3\n3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-23A",
      title: "Codingpractice-23A",
      description: "Functions",
      questions: [
        {
          id: "q-python-Codingpractice-23A-001",
          title: "Sum of two numbers - 3",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.write a program that the given function will return the sum of the values passed to the function.",
          sampleInput: "100\n200",
          sampleOutput: "300",
          testCases: [
            { input: "5\n7", output: "12", visible: true },
            { input: "0\n0", output: "0", visible: true },
            { input: "-3\n10", output: "7", visible: false },
            { input: "100\n200", output: "300", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-23A-002",
          title: "Printing Message",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.write a function with two arguments that prints the message as expected.\nUday is 24 years old.",
          sampleInput: "Sam\n1",
          sampleOutput: "Sam is 1 years old.",
          testCases: [
            {
              input: "Ganesh\n22",
              output: "Ganesh is 22 years old.",
              visible: true,
            },
            {
              input: "Alice\n30",
              output: "Alice is 30 years old.",
              visible: true,
            },
            {
              input: "John Doe\n45",
              output: "John Doe is 45 years old.",
              visible: false,
            },
            { input: "Sam\n0", output: "Sam is 0 years old.", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-23A-003",
          title: "Indexing - 2",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a function.write a program that the given function will return the character present at the index N in the word W.",
          sampleInput: "ABCDE\n2",
          sampleOutput: "C",
          testCases: [
            { input: "Python\n0", output: "P", visible: true },
            { input: "Hello\n1", output: "e", visible: true },
            { input: "World\n4", output: "d", visible: false },
            { input: "ABCDE\n2", output: "C", visible: false },
          ],
          defaultCode: ``,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-23A-004",
          title: "Divisible by Nine",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes three numbers N1,N2, and N3 as arguments.\nWrite a program that returns True if atleast one of the given numbers N1,N2,and N3 is divisible by 9.Otherwise,return False.",
          sampleInput: "-27\n2\n3",
          sampleOutput: "True",
          testCases: [
            { input: "9\n5\n7", output: "True", visible: true },
            { input: "10\n18\n25", output: "True", visible: true },
            { input: "4\n8\n14", output: "False", visible: false },
            { input: "-27\n2\n3", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-23B",
      title: "Codingpractice-23B",
      description: "Functions",
      questions: [
        {
          id: "q-python-Codingpractice-23B-001",
          title: "Factors of a Number - 3",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes a number N as an argument.\nWrite a program that returns the factors of the given number N separated by a space as shown in the sample output.",
          sampleInput: "13",
          sampleOutput: "1 13",
          testCases: [
            { input: "6", output: "1 2 3 6", visible: true },
            { input: "10", output: "1 2 5 10", visible: true },
            { input: "13", output: "1 13", visible: false },
            { input: "1", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-23B-002",
          title: "Prime number - 3",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes a number N as an arument.\nWrite a program to check if the given number N is prime or not.\nPrint Prime number if the number is prime.Otherwise,print not a prime number.",
          sampleInput: "13",
          sampleOutput: "Prime Number",
          testCases: [
            { input: "7", output: "Prime Number", visible: true },
            { input: "10", output: "Not a Prime Number", visible: true },
            { input: "1", output: "Not a Prime Number", visible: false },
            { input: "13", output: "Prime Number", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-23B-003",
          title: "Count of even numbers",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes N space-separated integers as an argument.\nWrite a program to return the count of even numbers among the given N space-separated numbers.",
          sampleInput: "0 -2 4 9",
          sampleOutput: "3",
          testCases: [
            { input: "1 2 3 4 5 6", output: "3", visible: true },
            { input: "10 20 30", output: "3", visible: true },
            { input: "1 3 5 7", output: "0", visible: false },
            { input: "0 -2 4 9", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-23B-004",
          title: "First Uppercase letter - 2",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes a string S as an argument.\nWrite a program to return the first uppercase letter in the given string S.",
          sampleInput: "Hello",
          sampleOutput: "H",
          testCases: [
            { input: "helloWorld", output: "W", visible: true },
            { input: "Python", output: "P", visible: true },
            { input: "openAI", output: "A", visible: false },
            { input: "TestCase", output: "T", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-23",
      title: "Assignment-23",
      description: "Functions",
      questions: [
        {
          id: "q-python-Assignment-23-001",
          title: "Team Points",
          difficulty: "Easy",
          description:
            "Write a function with the name calculate_league_points that takes the number of wins,draws,and losses and calculates the number of points a football team has obtained so far.\nEach win is equal to 4 points.\nEach draw is equal to 2 points.\nEach loss is equal to -1 point.",
          sampleInput: "1,1,3",
          sampleOutput: "3",
          testCases: [
            { input: "3,2,1", output: "15", visible: true },
            { input: "0,5,0", output: "10", visible: true },
            { input: "4,0,2", output: "14", visible: false },
            { input: "1,1,3", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-23-002",
          title: "Sum of Cubes from M to N",
          difficulty: "Easy",
          description:
            "Write a function with name sum_of_cubes_m_to_n that takes two integers(M and N)and sum the cubes from M to N.",
          sampleInput: "0\n2",
          sampleOutput: "9",
          testCases: [
            { input: "1\n3", output: "36", visible: true },
            { input: "2\n4", output: "99", visible: true },
            { input: "1\n1", output: "1", visible: false },
            { input: "0\n2", output: "9", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-23-003",
          title: "Prime Numbers from M to N - 2",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes two numbers M and N as arguments.\nWrite a program that returns all the prime numbers from M to N separated by a space.",
          sampleInput: "10\n20",
          sampleOutput: "11 13 17 19 ",
          testCases: [
            { input: "1\n10", output: "2 3 5 7 ", visible: true },
            { input: "10\n20", output: "11 13 17 19 ", visible: false },
            { input: "0\n3", output: "2 3 ", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-23-004",
          title: "Four Passengers and a Driver",
          difficulty: "Easy",
          description:
            "A Typical car can hold four Passengers and one driver,allowing five people to travel around.\nWrite a function with the name number_of_cars_needed that takes a number of people (N) and return how many cars are needed to seat everyone comfortably.",
          sampleInput: "20",
          sampleOutput: "4",
          testCases: [
            { input: "5", output: "1", visible: true },
            { input: "12", output: "3", visible: true },
            { input: "1", output: "1", visible: false },
            { input: "20", output: "4", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-24",
      title: "Codingpractice-24",
      description: "Recursion",
      questions: [
        {
          id: "q-python-Codingpractice-24-001",
          title: "Sum of Numbers in the List",
          difficulty: "Easy",
          description:
            "Given space-separated numbers,write a program to print the sum of the given numbers.",
          sampleInput: "-5 5 10",
          sampleOutput: "10",
          testCases: [
            { input: "1 2 3 4", output: "10", visible: true },
            { input: "10 20 30", output: "60", visible: true },
            { input: "0 0 0", output: "0", visible: false },
            { input: "-5 5 10", output: "10", visible: false },
          ],
          defaultCode: ``,
          score: 15,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-24-002",
          title: "Largest number in the List - 2",
          difficulty: "Easy",
          description:
            "Write a program to print the largest number in the list.",
          sampleInput: "-5 5 10",
          sampleOutput: "10",
          testCases: [
            { input: "1,2,3,4,5", output: "5", visible: true },
            { input: "10,25,7,3", output: "25", visible: true },
            { input: "1,2,3,4,5", output: "5", visible: false },

            { input: "10,25,3,7", output: "25", visible: false },

            { input: "5,5,5,5", output: "5", visible: false },

            { input: "100,20,300,40", output: "300", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-24-003",
          title: "Smallest number in the List - 2",
          difficulty: "Easy",
          description:
            "Write a program to print the smallest number in the list.",
          sampleInput: "-5 5 10",
          sampleOutput: "-5",
          testCases: [
            { input: "1,2,3,4,5", output: "1", visible: true },
            { input: "10,25,7,3", output: "3", visible: true },
            { input: "-5,-10,-3", output: "-10", visible: false },
            { input: "100", output: "100", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-24-004",
          title: "Sort Numbers in the List",
          difficulty: "Easy",
          description:
            "Given comma-separated numbers,write a program to print a list containing the given numbers in Ascending order.",
          sampleInput: "-1,-5,3,0",
          sampleOutput: "[-5, -1, 0, 3]",
          testCases: [
            { input: "3,1,4,2", output: "[1, 2, 3, 4]", visible: true },
            { input: "10,5,20", output: "[5, 10, 20]", visible: true },
            { input: "-1,-5,3,0", output: "[-5, -1, 0, 3]", visible: false },
            { input: "7", output: "[7]", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-24-005",
          title: "Extract Digits",
          difficulty: "Easy",
          description:
            "Write a program to Extract the numbers in a given string and print the sum,minimum and Maximum of those numbers.",
          sampleInput: "abc5def0g2",
          sampleOutput: "7\n0\n5",
          testCases: [
            { input: "a1b2c3", output: "6\n1\n3", visible: true },
            { input: "9x8y7", output: "24\n7\n9", visible: true },
            { input: "abc5def0g2", output: "7\n0\n5", visible: false },
            { input: "1a2b3c4d5", output: "15\n1\n5", visible: false },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-24",
      title: "Assignment-24",
      description: "Recursion",
      questions: [
        {
          id: "q-python-Assignment-24-001",
          title: "Find Mean",
          difficulty: "Easy",
          description:
            "Given comma-separated numbers,write a program to print the Mean of the given numbers.",
          sampleInput: "-5 5 10",
          sampleOutput: "3.3333333333333335",
          testCases: [
            { input: "1,2,3,4", output: "2.5", visible: true },
            { input: "10,20,30", output: "20.0", visible: true },
            { input: "5", output: "5.0", visible: false },
            { input: "-5,5,10", output: "3.3333333333333335", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-24-002",
          title: "Median of Numbers in the List",
          difficulty: "Easy",
          description:
            "Given comma-separated numbers,write a program to print the Median of the given numbers.",
          sampleInput: "10,20",
          sampleOutput: "15.0",
          testCases: [
            { input: "1,3,2", output: "2", visible: true },
            { input: "4,1,3,2", output: "2.5", visible: true },
            { input: "7,9,5,3,1", output: "5", visible: false },
            { input: "10,20", output: "15.0", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-24-003",
          title: "Smallest Numbers in the List - 3",
          difficulty: "Easy",
          description:
            "Given comma-separated numbers and an index I , write a program to print the Smallest number among the  numbers from the given index I to the end of the list.",
          sampleInput: "1,2,3,4\n0",
          sampleOutput: "1",
          testCases: [
            { input: "5,3,8,1,9\n2", output: "1", visible: true },
            { input: "10,20,30,40\n1", output: "20", visible: true },
            { input: "7,6,5,4,3\n3", output: "3", visible: false },
            { input: "1,2,3,4\n0", output: "1", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-24-004",
          title: "Smallest Sum of N Elements",
          difficulty: "Easy",
          description:
            "Given comma-separated numbers and a number N,write a program to print the smallest possible sum with N numbers of the given comma-separated numbers.",
          sampleInput: "1,2,3,4,5\n5",
          sampleOutput: "15",
          testCases: [
            { input: "5,3,8,1,9\n2", output: "4", visible: true },
            { input: "10,20,30,40\n3", output: "60", visible: true },
            { input: "7,6,5,4,3\n1", output: "3", visible: false },
            { input: "1,2,3,4,5\n5", output: "15", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-25",
      title: "Codingpractice-25",
      description: "Recursion",
      questions: [
        {
          id: "q-python-Codingpractice-25-001",
          title: "Identify the mistake - sum of first N natural number",
          difficulty: "Easy",
          description:
            "Write a program to recursively compute the sum of the numbers from 1 to N.",
          sampleInput: "3",
          sampleOutput: "6",
          testCases: [
            { input: "1", output: "1", visible: true },
            { input: "5", output: "15", visible: true },
            { input: "10", output: "55", visible: false },
            { input: "3", output: "6", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-25-002",
          title: "Sum of Numbers",
          difficulty: "Easy",
          description:
            "A functtion is given in the prefilled code that takes a list L as an argument.Write a program that returns the sum of the numbers in the list L using Recursion.",
          sampleInput: "10 20 -5",
          sampleOutput: "25",
          testCases: [
            { input: "1 2 3 4", output: "10", visible: true },
            { input: "5", output: "5", visible: true },
            { input: "10 20 -5", output: "25", visible: false },
            { input: "0 0 0", output: "0", visible: false },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-25-003",
          title: "Factorial - 2",
          difficulty: "Easy",
          description:
            "Write a program to print the factorial of N.factorial is the product of all positive integers less than or equal to N.\nNote:Factorial of 0 is 1.",
          sampleInput: "10 20 -5",
          sampleOutput: "25",
          testCases: [
            { input: "0", output: "1", visible: true },
            { input: "5", output: "120", visible: true },
            { input: "1", output: "1", visible: false },
            { input: "3", output: "6", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-25-004",
          title: "Sum of Squares of Numbers",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes a list L as an argument.\nWrite a program that returns the sum of the squares of the numbers in the list L using Recursion.",
          sampleInput: "2 4 6",
          sampleOutput: "56",
          testCases: [
            { input: "1 2 3", output: "14", visible: true },
            { input: "5", output: "25", visible: true },
            { input: "2 4 6", output: "56", visible: false },
            { input: "-1 3", output: "10", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-25",
      title: "Assignment-25",
      description: "Recursion",
      questions: [
        {
          id: "q-python-Assignment-25-001",
          title: "Sum of N terms in Harmonic series - 2",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes a number N as an argument.\nWrite a program that returns the sum of the given series up to N terms using Recursion.The sum should be rounded up to 2 decimals.",
          sampleInput: "5",
          sampleOutput: "2.28",
          testCases: [
            { input: "1", output: "1.0", visible: true },
            { input: "2", output: "1.5", visible: true },
            { input: "3", output: "1.83", visible: false },
            { input: "5", output: "2.28", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-25-002",
          title: "Find the first element in list",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes a list L and a number N as arguments.Write a program that returns the index of the first occurrence of the given number N in the list L using Recursion.",
          sampleInput: "2 4 6 8 10\n8",
          sampleOutput: "3",
          testCases: [
            { input: "1 2 3 4 5\n3", output: "2", visible: true },
            { input: "10 20 30 40\n10", output: "0", visible: true },
            { input: "5 6 7 8\n6", output: "1", visible: false },
            { input: "2 4 6 8 10\n8", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-25-003",
          title: "Palindrome",
          difficulty: "Easy",
          description:
            "A function is given in the prefilled code that takes a string S as an argument.Write a program that checks if S is a Palindrome using Recursion.Return True if S is a Palindrome.Otherwise,return False.",
          sampleInput: "hello",
          sampleOutput: "False",
          testCases: [
            { input: "madam", output: "True", visible: true },
            { input: "RaceCar", output: "True", visible: true },
            { input: "hello", output: "False", visible: false },
            { input: "A", output: "True", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-26",
      title: "Codingpractice-26",
      description: "Recursion",
      questions: [
        {
          id: "q-python-Codingpractice-26-001",
          title: "list append",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a list.Write a  program to add the given word at the end of the list.",
          sampleInput: "Kabaddi",
          sampleOutput:
            "['Cricket', 'Hockey', 'Football', 'Badminton', 'Kabaddi']",
          testCases: [
            {
              input: "Tennis",
              output:
                "['Cricket', 'Hockey', 'Football', 'Badminton', 'Tennis']",
              visible: true,
            },
            {
              input: "Basketball",
              output:
                "['Cricket', 'Hockey', 'Football', 'Badminton', 'Basketball']",
              visible: true,
            },
            {
              input: "Volleyball",
              output:
                "['Cricket', 'Hockey', 'Football', 'Badminton', 'Volleyball']",
              visible: false,
            },
            {
              input: "Kabaddi",
              output:
                "['Cricket', 'Hockey', 'Football', 'Badminton', 'Kabaddi']",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-26-002",
          title: "Extend the List",
          difficulty: "Easy",
          description:
            "A list L is given in the prefilled code.\nWrite a program that reads space-separated strings and prints a list obtained by adding given space-separated strings to the end of the list L.\nL=[`5`,`7`,`rohit`,`virat`,`dhoni`]",
          sampleInput: "Shubman Gill Iyer",
          sampleOutput:
            "['5', '7', 'Rohit', 'Virat', 'Dhoni', 'Shubman', 'Gill', 'Iyer']",
          testCases: [
            {
              input: "Hardik Rahul",
              output:
                "['5', '7', 'Rohit', 'Virat', 'Dhoni', 'Hardik', 'Rahul']",
              visible: true,
            },
            {
              input: "MS ABD",
              output: "['5', '7', 'Rohit', 'Virat', 'Dhoni', 'MS', 'ABD']",
              visible: true,
            },
            {
              input: "KL",
              output: "['5', '7', 'Rohit', 'Virat', 'Dhoni', 'KL']",
              visible: false,
            },
            {
              input: "Shubman Gill Iyer",
              output:
                "['5', '7', 'Rohit', 'Virat', 'Dhoni', 'Shubman', 'Gill', 'Iyer']",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-26-003",
          title: "Insert an element",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a list.Write a program to insert a number(N)at the given index (I) location in the list.",
          sampleInput: "70\n5",
          sampleOutput: "[10, 20, 40, 50, 60, 70]",
          testCases: [
            {
              input: "30\n2",
              output: "[10, 20, 30, 40, 50, 60]",
              visible: true,
            },
            { input: "5\n0", output: "[5, 10, 20, 40, 50, 60]", visible: true },
            {
              input: "70\n5",
              output: "[10, 20, 40, 50, 60, 70]",
              visible: false,
            },
            {
              input: "25\n1",
              output: "[10, 25, 20, 40, 50, 60]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-26-004",
          title: "Remove the last items",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a list.Write a program to remove the last N items in the list.\nL=[`python`,`c`,`java`,`ruby`,`c++`,`CSS`,`HTML`,`Bash`,`perl`,`R`,`Swift`]",
          sampleInput: "5",
          sampleOutput:
            "['Python', 'C', 'Java', 'Ruby', 'C++', 'CSS', 'HTML', 'Bash', 'Perl']",
          testCases: [
            {
              input: "1",
              output:
                "['Python', 'C', 'Java', 'Ruby', 'C++', 'CSS', 'HTML', 'Bash', 'Perl', 'R', 'Swift', 'SQL', 'PHP']",
              visible: true,
            },
            {
              input: "3",
              output:
                "['Python', 'C', 'Java', 'Ruby', 'C++', 'CSS', 'HTML', 'Bash', 'Perl', 'R', 'Swift']",
              visible: true,
            },
            {
              input: "0",
              output:
                "['Python', 'C', 'Java', 'Ruby', 'C++', 'CSS', 'HTML', 'Bash', 'Perl', 'R', 'Swift', 'SQL', 'PHP', 'JavaScript']",
              visible: false,
            },
            {
              input: "5",
              output:
                "['Python', 'C', 'Java', 'Ruby', 'C++', 'CSS', 'HTML', 'Bash', 'Perl']",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-Assignment-26",
      title: "Assignment-26",
      description: "Recursion",
      questions: [
        {
          id: "q-python-Assignment-26-001",
          title: "Even and Odd Numbers",
          difficulty: "Easy",
          description:
            "Given space-separated numbers,write a program to find even numbers and odd numbers among the given numbers and print then even numbers in one list sorted in Ascending order and print odd numbers in another list sorted in ascending order.",
          sampleInput: "10 7 8 3 2",
          sampleOutput: "[2, 8, 10]\n[3, 7]",
          testCases: [
            {
              input: "1 2 3 4 5 6",
              output: "[2, 4, 6]\n[1, 3, 5]",
              visible: true,
            },
            {
              input: "10 7 8 3 2",
              output: "[2, 8, 10]\n[3, 7]",
              visible: true,
            },
            { input: "1 3 5 7", output: "[]\n[1, 3, 5, 7]", visible: false },
            { input: "4 2 8 6", output: "[2, 4, 6, 8]\n[]", visible: false },
          ],
          defaultCode: ``,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-26-002",
          title: "Extend the List - 2",
          difficulty: "Easy",
          description:
            "Given a number N,write a program that reads N lines of input containing space-separated strings and prints a list of all the strings on N lines sorted in ascending order.",
          sampleInput: "4\na b\nc d\ne f\ng h",
          sampleOutput: "['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']",
          testCases: [
            {
              input: "2\nhello world\npython code",
              output: "['code', 'hello', 'python', 'world']",
              visible: true,
            },
            {
              input: "3\napple banana\ncat\nzebra dog",
              output: "['apple', 'banana', 'cat', 'dog', 'zebra']",
              visible: true,
            },
            {
              input: "1\nsingle line",
              output: "['line', 'single']",
              visible: false,
            },
            {
              input: "4\na b\nc d\ne f\ng h",
              output: "['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-26-003",
          title: "Merge the Lists",
          difficulty: "Easy",
          description:
            "Given lists A and B of space-separated elements,each on a new line of the same length.Write a program to insert the elements of list B into list A at odd indices.",
          sampleInput: "one two\nalpha beta",
          sampleOutput: "['one', 'alpha', 'two', 'beta']",
          testCases: [
            {
              input: "a b c\n1 2 3",
              output: "['a', '1', 'b', '2', 'c', '3']",
              visible: true,
            },
            {
              input: "apple banana\nred yellow",
              output: "['apple', 'red', 'banana', 'yellow']",
              visible: true,
            },
            {
              input: "x y z\n10 20 30",
              output: "['x', '10', 'y', '20', 'z', '30']",
              visible: false,
            },
            {
              input: "one two\nalpha beta",
              output: "['one', 'alpha', 'two', 'beta']",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Assignment-26-004",
          title: "List of Words",
          difficulty: "Easy",
          description:
            "Given a sentence S that contains space-separated words,write a program to print a list of words that do not start with the lowercase letter a.",
          sampleInput: "alpha beta gamma",
          sampleOutput: "['beta', 'gamma']",
          testCases: [
            {
              input: "apple ball cat",
              output: "['ball', 'cat']",
              visible: true,
            },
            {
              input: "ant dog elephant",
              output: "['dog', 'elephant']",
              visible: true,
            },
            {
              input: "alpha beta gamma",
              output: "['beta', 'gamma']",
              visible: false,
            },
            { input: "apple ant", output: "[]", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-27",
      title: "Codingpractice-27",
      description: "Tuples and Sets",
      questions: [
        {
          id: "q-python-Codingpractice-27-001",
          title: "Replace the element",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a list of tuples.Write a program to replace the last number of each tuple in the list with the given number(N).",
          sampleInput: "100",
          sampleOutput: "[(10, 20, 100), (1, 100), (5, 10, 15, 100)]",
          testCases: [
            {
              input: "99",
              output: "[(10, 20, 99), (1, 99), (5, 10, 15, 99)]",
              visible: true,
            },
            {
              input: "0",
              output: "[(10, 20, 0), (1, 0), (5, 10, 15, 0)]",
              visible: true,
            },
            {
              input: "-5",
              output: "[(10, 20, -5), (1, -5), (5, 10, 15, -5)]",
              visible: false,
            },
            {
              input: "100",
              output: "[(10, 20, 100), (1, 100), (5, 10, 15, 100)]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-27-002",
          title: "Remove Duplicates",
          difficulty: "Easy",
          description:
            "Write a program to remove duplicate numbers in the list.",
          sampleInput: "-1 -2 -1 0",
          sampleOutput: "[-2, -1, 0]",
          testCases: [
            { input: "1 2 3 2 1", output: "[1, 2, 3]", visible: true },
            { input: "5 5 5 5", output: "[5]", visible: true },
            { input: "10 3 10 2 3", output: "[2, 3, 10]", visible: false },
            { input: "-1 -2 -1 0", output: "[-2, -1, 0]", visible: false },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-27-003",
          title: "Remove multiple Items",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a set.Write a program to remove a list of numbers if present in the set.",
          sampleInput: "15 25",
          sampleOutput: "[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]",
          testCases: [
            {
              input: "10 20",
              output: "[30, 40, 50, 60, 70, 80, 90, 100]",
              visible: true,
            },
            {
              input: "50 100 30",
              output: "[10, 20, 40, 60, 70, 80, 90]",
              visible: true,
            },
            {
              input: "15 25",
              output: "[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]",
              visible: false,
            },
            {
              input: "10 20 30 40 50 60 70 80 90 100",
              output: "[]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-27-004",
          title: "Common Elements",
          difficulty: "Easy",
          description:
            "Given two lines of comma-separated integers,write a program to print the numbers that are present in both of the lines.",
          sampleInput: "1,2,2,3\n2,2,4",
          sampleOutput: "[2]",
          testCases: [
            { input: "1,2,3,4\n3,4,5,6", output: "[3, 4]", visible: true },
            { input: "10,20,30\n30,40,50", output: "[30]", visible: true },
            { input: "5,6,7\n1,2,3", output: "[]", visible: false },
            { input: "1,2,2,3\n2,2,4", output: "[2]", visible: false },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-28",
      title: "Codingpractice-28",
      description: "Dictionaries",
      questions: [
        {
          id: "q-python-Codingpractice-28-001",
          title: "same elements",
          difficulty: "Easy",
          description:
            "Write a program to check if all the elements in a given list are same.\nInput:The input will be a single line containing space-separated integers.\nOutput:The output should be a single line containing either `True` or list of unique elements sorted in ascending order.",
          sampleInput: "7 7 7 7 7",
          sampleOutput: "True",
          testCases: [
            { input: "5 5 5", output: "True", visible: true },
            { input: "1 2 3", output: "[1, 2, 3]", visible: true },
            { input: "7 7 7 7 7", output: "True", visible: false },
            { input: "4 2 4 3 2", output: "[2, 3, 4]", visible: false },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-28-002",
          title: "Extract Numbers",
          difficulty: "Easy",
          description:
            "Write a program to remove the elements other than numbers in the list.",
          sampleInput: "a,b,c",
          sampleOutput: "[]",
          testCases: [
            { input: "1,2,three,4", output: "[1, 2, 4]", visible: true },
            { input: "10,abc,20,30", output: "[10, 20, 30]", visible: true },
            { input: "a,b,c", output: "[]", visible: false },
            { input: "5,6.7,8,9", output: "[5, 8, 9]", visible: false },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-28-003",
          title: "missing numbers",
          difficulty: "Easy",
          description:
            "Write a program to find the missing numbers from 1 to the maximum number in the list.",
          sampleInput: "1 3 5",
          sampleOutput: "[2, 4]",
          testCases: [
            { input: "1 2 4 6", output: "[3, 5]", visible: true },
            { input: "1 3 5", output: "[2, 4]", visible: true },
            { input: "1 2 3 4 5", output: "[]", visible: false },
            { input: "2 4 6 8", output: "[1, 3, 5, 7]", visible: false },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-28-004",
          title: "set relation",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a set.Write a program to check the following relations with the given set.\n1.Superset\n2.Subset\n3.Disjoint Set",
          sampleInput: "10 11 12",
          sampleOutput: "Disjoint Set",
          testCases: [
            { input: "1 2 3", output: "Superset", visible: true },
            { input: "1 2 3 4 5 6 7 8 9 10", output: "Subset", visible: true },
            { input: "10 11 12", output: "Disjoint Set", visible: false },
            { input: "5 6 7 8 9", output: "Superset", visible: false },
          ],
          defaultCode: `num_set = {1, 2, 3, 4, 5, 6, 7, 8, 9}
          # Write your code here`,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-29",
      title: "Codingpractice-29",
      description: "Dictionaries",
      questions: [
        {
          id: "q-python-Codingpractice-29-001",
          title: "Nested List",
          difficulty: "Easy",
          description:
            "Write a program to read N lines of inputs and create a nested list with each line as a list.\nInput:The first line of input will contain a positive integer N.The next N lines will contain space-separated integers.\nOutput:The output should be a single line containing the nested list.",
          sampleInput: "4\n1\n2\n3\n4",
          sampleOutput: "[[1], [2], [3], [4]]",
          testCases: [
            {
              input: "2\n1 2 3\n4 5",
              output: "[[1, 2, 3], [4, 5]]",
              visible: true,
            },
            {
              input: "3\n10\n20 30\n40 50 60",
              output: "[[10], [20, 30], [40, 50, 60]]",
              visible: true,
            },
            { input: "1\n7 8 9", output: "[[7, 8, 9]]", visible: false },
            {
              input: "4\n1\n2\n3\n4",
              output: "[[1], [2], [3], [4]]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-29-002",
          title: "List of maximum values",
          difficulty: "Easy",
          description:
            "Write a program to create a list with maximum values in each list.\nInput:The first line of input will contain a positive integer N.The next N lines will contain space-separated integers.\nOutput:The output should be a single line containing the list of maximum values in each list.",
          sampleInput: "4\n1\n2 3\n4 5 6\n7 0",
          sampleOutput: "[1, 3, 6, 7]",
          testCases: [
            { input: "2\n1 2 3\n4 5 6", output: "[3, 6]", visible: true },
            {
              input: "3\n10\n20 30\n5 15 25",
              output: "[10, 30, 25]",
              visible: true,
            },
            { input: "1\n7 8 9", output: "[9]", visible: false },
            {
              input: "4\n1\n2 3\n4 5 6\n7 0",
              output: "[1, 3, 6, 7]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-29-003",
          title: "List of lists to list of tuples",
          difficulty: "Easy",
          description:
            "Write a program to convert the list of lists to a list of tuples.",
          sampleInput: "1\n7 8 9",
          sampleOutput: "[(7, 8, 9)]",
          testCases: [
            {
              input: "2\n1 2 3\n4 5",
              output: "[(1, 2, 3), (4, 5)]",
              visible: true,
            },
            {
              input: "3\n10\n20 30\n40 50 60",
              output: "[(10,), (20, 30), (40, 50, 60)]",
              visible: true,
            },
            { input: "1\n7 8 9", output: "[(7, 8, 9)]", visible: false },
            {
              input: "4\n1\n2\n3\n4",
              output: "[(1,), (2,), (3,), (4,)]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-29-004",
          title: "List of Unique Tuples",
          difficulty: "Easy",
          description:
            "Write a program to print the lists which contain the unique elements in the given list of lists.",
          sampleInput: "4\n1 2\n2 2\n3 4 5\n5 5 6",
          sampleOutput: "[[1, 2], [3, 4, 5]]",
          testCases: [
            {
              input: "3\n1 2 3\n4 4 5\n6 7 8",
              output: "[[1, 2, 3], [6, 7, 8]]",
              visible: true,
            },
            {
              input: "2\n10 20 30\n1 1 1",
              output: "[[10, 20, 30]]",
              visible: true,
            },
            {
              input: "4\n1 2\n2 2\n3 4 5\n5 5 6",
              output: "[[1, 2], [3, 4, 5]]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-30",
      title: "Codingpractice-30",
      description: "Dictionaries",
      questions: [
        {
          id: "q-python-Codingpractice-30-001",
          title: "Maximum,Minimum and Sum of Matrix",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain an M x N matrix.Write a program to print the maximum,minimum and sum of all elements in the matrix.\nInput:\nThe first line of input will contain two space-separated integers,denoting the M and N.\nThe next M following lines will contain N space-separated integers,denoting the elements of each list.\nOutput:\nThe first line of output should be the maximum of all elements in the matrix.\nThe second line of output should be the minimum of all elements in the matrix.\nThe third line of output should be the sum of all elements in the matrix.",
          sampleInput: "2 2\n-1 -2\n3 4",
          sampleOutput: "4\n-2\n4",
          testCases: [
            { input: "2 3\n1 2 3\n4 5 6", output: "6\n1\n21", visible: true },
            {
              input: "3 2\n10 20\n5 15\n0 25",
              output: "25\n0\n75",
              visible: true,
            },
            { input: "1 4\n7 8 9 10", output: "10\n7\n34", visible: false },
            { input: "2 2\n-1 -2\n3 4", output: "4\n-2\n4", visible: false },
          ],
          defaultCode: `def get_sum_of_matrix(nested_list):
          total = 0
          for each_list in nested_list:
              total += sum(each_list)
          return total
      
      def convert_string_to_int(list_a):
          new_list = []
          for item in list_a:
              num = int(item)
              new_list.append(num)
          return new_list
      
      
      m, n = input().split()
      m, n = int(m), int(n)
      num_list = []
      
      for i in range(m):
          list_a = input().split()
          list_a = convert_string_to_int(list_a)
          num_list.append(list_a)
          # Write your code here`,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-30-002",
          title: "Row and Column with Maximum",
          difficulty: "Easy",
          description:
            "An M*N matrix is given in the prefilled code.\nWrite a program that finds the maximum element in the matrix and prints all the elements of the corresponding row and the column that has the maximum element.",
          sampleInput: "3 3\n1 9 3\n4 5 6\n7 8 2",
          sampleOutput: "[1, 9, 3]\n[9, 5, 8]",
          testCases: [
            {
              input: "2 3\n1 2 3\n4 5 6",
              output: "[4, 5, 6]\n[3, 6]",
              visible: true,
            },
            {
              input: "3 2\n10 20\n5 15\n30 25",
              output: "[30, 25]\n[10, 5, 30]",
              visible: true,
            },
            {
              input: "1 4\n7 8 9 10",
              output: "[7, 8, 9, 10]\n[10]",
              visible: false,
            },
            {
              input: "3 3\n1 9 3\n4 5 6\n7 8 2",
              output: "[1, 9, 3]\n[9, 5, 8]",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 60,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-30-003",
          title: "Transpose Matrix",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain an MxN matrix.Write a program to print the transpose of the matrix.\nTranspose of a matrix is obtained by changing rows to columns and columns to rows.",
          sampleInput: "2 2\n1 2\n3 4",
          sampleOutput: "[1, 3]\n[2, 4]",
          testCases: [
            {
              input: "2 3\n1 2 3\n4 5 6",
              output: "[1, 4]\n[2, 5]\n[3, 6]",
              visible: true,
            },
            {
              input: "3 2\n10 20\n30 40\n50 60",
              output: "[10, 30, 50]\n[20, 40, 60]",
              visible: true,
            },
            {
              input: "1 4\n7 8 9 10",
              output: "[7]\n[8]\n[9]\n[10]",
              visible: false,
            },
            {
              input: "2 2\n1 2\n3 4",
              output: "[1, 3]\n[2, 4]",
              visible: false,
            },
          ],
          defaultCode: `def get_transpose_of_matrix(matrix, m, n):
          # Complete this function
          transpose_matrix = []
          for i in range(n):
              row = []
              
              for j in range(m):
                  #here the inner loop it iterates m which is 2 times
                  row.append(matrix[j][i]) 
                   #this will give idea for you how program executes index values for matrix problems   
              transpose_matrix.append(row)
              
          return transpose_matrix  
      
      def convert_string_to_int(list_a):
          new_list = []
          for item in list_a:
              num = int(item)
              new_list.append(num)
          return new_list
      
      
      m, n = input().split()
      m, n = int(m), int(n)
      num_list = []
      
      for i in range(m):
          list_a = input().split()
          list_a = convert_string_to_int(list_a)
          num_list.append(list_a)
      
      # Call the get_transpose_of_matrix function`,
          score: 65,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-30-004",
          title: "Add two matrices",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain two MxN matrices.Write a program to add the given two matrices.\nTo add two matrices,just add the corresponding entries,and place this sum in the corresponding position in the result matrix.",
          sampleInput: "2 2\n-1 -2\n3 4\n1 2\n-3 -4",
          sampleOutput: "[0, 0]\n[0, 0]",
          testCases: [
            {
              input: "2 3\n1 2 3\n4 5 6\n6 5 4\n3 2 1",
              output: "[7, 7, 7]\n[7, 7, 7]",
              visible: true,
            },
            {
              input: "3 2\n1 2\n3 4\n5 6\n6 5\n4 3\n2 1",
              output: "[7, 7]\n[7, 7]\n[7, 7]",
              visible: true,
            },
            {
              input: "1 4\n7 8 9 10\n1 2 3 4",
              output: "[8, 10, 12, 14]",
              visible: false,
            },
            {
              input: "2 2\n-1 -2\n3 4\n1 2\n-3 -4",
              output: "[0, 0]\n[0, 0]",
              visible: false,
            },
          ],
          defaultCode: `def add_two_matrices(first_matrix, second_matrix, m, n):
          # Complete this function
          
          
          
          
          def convert_string_to_int(list_a):
    new_list = []
    for item in list_a:
        num = int(item)
        new_list.append(num)
    return new_list


def read_matrix_inputs(m):
    num_list = []
    for i in range(m):
        list_a = input().split()
        list_a = convert_string_to_int(list_a)
        num_list.append(list_a)
    return num_list


m, n = input().split()
m, n = int(m), int(n)

first_matrix = read_matrix_inputs(m)
second_matrix = read_matrix_inputs(m)

# call the add_two_matrices matrices`,
          score: 65,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-31",
      title: "Codingpractice-31",
      description: "Dictionaries",
      questions: [
        {
          id: "q-python-Codingpractice-31-001",
          title: "Add a Key",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a dictionary.Write a program to add a Key-Value pair to the dictionary.",
          sampleInput: "Amit Chess",
          sampleOutput:
            "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Amit': 'Chess'}",
          testCases: [
            {
              input: "Sita Badminton",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Sita': 'Badminton'}",
              visible: true,
            },
            {
              input: "Ram Hockey",
              output:
                "{'Ram': 'Hockey', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket'}",
              visible: true,
            },
            {
              input: "Amit Chess",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Amit': 'Chess'}",
              visible: false,
            },
            {
              input: "Vani Volleyball",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Volleyball', 'Rahim': 'Cricket'}",
              visible: false,
            },
          ],
          defaultCode: `students_dict = {
            "Ram": "Cricket",
            "Naresh": "Football",
            "Vani": "Tennis",
            "Rahim": "Cricket"
        }
        
        # Write your code here`,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-31-002",
          title: "Update Value of Key",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a dictionary.Write a program to update the value of a given key.",
          sampleInput: "Deepak Wrestling",
          sampleOutput:
            "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Wrestling'}",
          testCases: [
            {
              input: "Sita Badminton",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Boxing', 'Sita': 'Badminton'}",
              visible: true,
            },
            {
              input: "Ram Hockey",
              output:
                "{'Ram': 'Hockey', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Boxing'}",
              visible: true,
            },
            {
              input: "Amit Chess",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Boxing', 'Amit': 'Chess'}",
              visible: false,
            },
            {
              input: "Deepak Wrestling",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Wrestling'}",
              visible: false,
            },
          ],
          defaultCode: `students_dict = {
            "Ram": "Cricket",
            "Naresh": "Football",
            "Vani": "Tennis",
            "Rahim": "Cricket",
            "Deepak": "Boxing"
        }
        
        # Write your code here`,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-31-003",
          title: "Remove a Key",
          difficulty: "Easy",
          description:
            "For this problem,the prefilled code will contain a dictionary.Write a program to Remove a key.\nstudents_dict=`Ram`: Cricket \n `Naresh`: Football\n `Vani`: Tennis\n `Rahim`: Cricket \n`Deepak`:boxing",
          sampleInput: "Naresh",
          sampleOutput:
            "{'Ram': 'Cricket', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Boxing'}",
          testCases: [
            {
              input: "Ram",
              output:
                "{'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Boxing'}",
              visible: true,
            },
            {
              input: "Deepak",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Vani': 'Tennis', 'Rahim': 'Cricket'}",
              visible: true,
            },
            {
              input: "Vani",
              output:
                "{'Ram': 'Cricket', 'Naresh': 'Football', 'Rahim': 'Cricket', 'Deepak': 'Boxing'}",
              visible: false,
            },
            {
              input: "Naresh",
              output:
                "{'Ram': 'Cricket', 'Vani': 'Tennis', 'Rahim': 'Cricket', 'Deepak': 'Boxing'}",
              visible: false,
            },
          ],
          defaultCode: `students_dict = {
            "Ram": "Cricket",
            "Naresh": "Football",
            "Vani": "Tennis",
            "Rahim": "Cricket",
            "Deepak": "Boxing"
        }
        
        # Write your code here`,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-31-004",
          title: "Squares",
          difficulty: "Easy",
          description:
            "Write a program to create a dictionary that contains keys as numbers from 1 to N and values are square of keys.",
          sampleInput: "5",
          sampleOutput: "{1: 1, 2: 4, 3: 9, 4: 16, 5: 25}",
          testCases: [
            { input: "3", output: "{1: 1, 2: 4, 3: 9}", visible: true },
            { input: "1", output: "{1: 1}", visible: true },
            {
              input: "5",
              output: "{1: 1, 2: 4, 3: 9, 4: 16, 5: 25}",
              visible: false,
            },
            { input: "0", output: "{}", visible: false },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Python-Grand-Assignment-3",
      title: "Grand-Assignment-3",
      description: "Dictionaries",
      questions: [
        {
          id: "q-python-Grand-Assignment-3-001",
          title: "Remove Words",
          difficulty: "Easy",
          description:
            "Given a string,write a program to remove all the words with K length.\nInput:\nThe first line of input will contain a string A.The second line of input will contain an integer K.\nOutput:\nThe output should contain a string after removing all the words whose length is equal to K.",
          sampleInput: "hello world hi bye\n5",
          sampleOutput: "hi bye ",
          testCases: [
            {
              input: "this is a test sentence\n2",
              output: "this a test sentence ",
              visible: true,
            },
            {
              input: "python java c cpp\n1",
              output: "python java cpp ",
              visible: true,
            },
            {
              input: "one two three four\n3",
              output: "three four ",
              visible: false,
            },
            {
              input: "hello world hi bye\n5",
              output: "hi bye ",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-3-002",
          title: "Shift Numbers",
          difficulty: "Easy",
          description:
            "Given a string,write a program to move all the numbers in it to its end.",
          sampleInput: "1a2b3c",
          sampleOutput: "abc123",
          testCases: [
            { input: "a1b2c3", output: "abc123", visible: true },
            { input: "python123", output: "python123", visible: true },
            { input: "1a2b3c", output: "abc123", visible: false },
            { input: "12345", output: "12345", visible: false },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-3-003",
          title: "Tic-Tac-Toe game",
          difficulty: "Easy",
          description:
            "Uday and Ekam are playing a game called Tic-Tac-Toe.The game is played on a square board with 3 rows and 3 columns.\nUday chooses the letter o and Ekam chooses the letter X.They take turns putting their letters in empty spaces on the board.\nThe first player to get three of their letters in a row,columnc,or diagonal wins the game.\nIf all spaces on the board are filled and no player has won,the game ends in a tie.",
          sampleInput: "X O O\nO X X\nO X X",
          sampleOutput: "Ekam Wins",
          testCases: [
            {
              input: "X X X\nO O X\nO X O",
              output: "Ekam Wins",
              visible: true,
            },
            {
              input: "O X X\nO X X\nO O X",
              output: "Uday Wins",
              visible: true,
            },
            { input: "X O X\nO X O\nO X O", output: "Tie", visible: false },
            {
              input: "X O O\nO X X\nO X X",
              output: "Ekam Wins",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Python-Grand-Assignment-4",
      title: "Grand-Assignment-4",
      description: "Dictionaries",
      questions: [
        {
          id: "q-python-Grand-Assignment-4-001",
          title: "String Rotation",
          difficulty: "Easy",
          description:
            "Write a program that reads two words S1 and S2 and checks if S2 is a rotation of S1.\nPrint the number of times S1 rotates to match S2,if S2 is a rotation of S1.Otherwise,print No Match.",
          sampleInput: "hello\nworld",
          sampleOutput: "No Match",
          testCases: [
            { input: "apple\nbanana", output: "No Match", visible: true },
            { input: "python\npython", output: "0", visible: true },
            { input: "hello\nworld", output: "No Match", visible: false },
            { input: "cat\ncar", output: "0", visible: false },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-4-002",
          title: "Ordered Matrix",
          difficulty: "Easy",
          description:
            "Given a MxN matrix,write a program to print the matrix after ordering all the elements of the matrix in increasing order.",
          sampleInput: "2 2\n-1 4\n3 0",
          sampleOutput: "-1 0 \n3 4 ",
          testCases: [
            {
              input: "2 3\n3 1 2\n6 5 4",
              output: "1 2 3 \n4 5 6 ",
              visible: true,
            },
            {
              input: "3 2\n9 8\n7 6\n5 4",
              output: "4 5 \n6 7 \n8 9 ",
              visible: true,
            },
            { input: "1 4\n10 3 7 1", output: "1 3 7 10 ", visible: false },
            { input: "2 2\n-1 4\n3 0", output: "-1 0 \n3 4 ", visible: false },
          ],
          defaultCode: ``,
          score: 60,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Grand-Assignment-4-003",
          title: "Numbers in String -1",
          difficulty: "Easy",
          description:
            "Given a string,write a program to return the sum and average of the digits of all numbers that appear in the string,ignoring all other characters.",
          sampleInput: "1a2b3c4d5",
          sampleOutput: "15\n3.0",
          testCases: [
            { input: "a1b2c3", output: "6\n2.0", visible: true },
            { input: "9x8y7", output: "24\n8.0", visible: true },
            { input: "abc5def0g2", output: "7\n2.33", visible: false },
            { input: "1a2b3c4d5", output: "15\n3.0", visible: false },
          ],
          defaultCode: ``,
          score: 70,
          status: "unsolved",
          attempts: [],
        },
      ],
    },

    // //OOPS CORE START
    // {
    //   id: "Coding-practice-python-oops",
    //   title: "Coding practice OOPS",
    //   description: "Introduction to Object Oriented Programming",
    //   questions: [
    //     {
    //       id: "q-python-Codingpractice-32-001",
    //       title: "Car",
    //       difficulty: "Easy",
    //       description:
    //         "complete the given Car class by adding new features by following the given Instructions.\nExisting car Class:\nThe existing Car class has only a pass Statement.Remove pass statement and add the new features as mentioned in the given Instructions.\nFeatures to be added to car class.\nPoints to Note:\nThe output of the testCase checking default Tests is given by the default_test function in the prefilled code.\nThis coding question does not have the usual input/output testcases.The class defined by you will be tested internally whether the attributes are present or not.So in testcases results you will be shown the rough description of the tests that will be verified.",
    //       sampleInput: "Checking default Tests",
    //       sampleOutput: "Red\n250\n10\n3",
    //       testCases: [{ input: "", output: "Red\n250\n10\n3", visible: true }],
    //       defaultCode: ``,
    //       score: 40,
    //       status: "unsolved",
    //       attempts: [],
    //     },
    //     {
    //       id: "q-python-Codingpractice-32-002",
    //       title: "Car - 2",
    //       difficulty: "Easy",
    //       description:
    //         "complete the given Car class by adding new features according to the Instructions provided.\nExisting car Class:\nIn the Previous question,you added the attributes below to the Car class:\ncolor,\nmax_speed,\nacceleration,\ntyre_friction.\nNow,let's add a few more new features to the car class.\nFeatures to be added to the car class.\nNote:You can copy the code from the Previous question and add new features on top of that code.",
    //       sampleInput: "Checking default Tests",
    //       sampleOutput: "False\nTrue\nFalse",
    //       testCases: [
    //         { input: "", output: "False\nTrue\nFalse", visible: true },
    //       ],
    //       defaultCode: ``,
    //       score: 40,
    //       status: "unsolved",
    //       attempts: [],
    //     },
    //     {
    //       id: "q-python-Codingpractice-32-003",
    //       title: "Car - 3",
    //       difficulty: "Easy",
    //       description:
    //         "complete the given Car class by adding new features by following the given Instructions.\nExisting car Class:\nIn the Previous question,you have added the attributes and methods below in the car class.\nATTRIBUTES:\ncolor\nmax_speed\nacceleration\ntyre_friction\nis_engine_started\nMETHODS\nstart_engine\nstop_engine\nNowc,let's add a few new features to the car class.\nNote:You can copy the code from the Previous question and add new features on top of that code.",
    //       sampleInput: "Checking default Tests",
    //       sampleOutput: "Car has not started yet\n0\n10\n20\n30\n40\n50",
    //       testCases: [
    //         {
    //           input: "",
    //           output: "Car has not started yet\n0\n10\n20\n30\n40\n50",
    //           visible: true,
    //         },
    //       ],
    //       defaultCode: ``,
    //       score: 40,
    //       status: "unsolved",
    //       attempts: [],
    //     },
    //   ],
    // },
    // {
    //   id: "Coding-practice-python-Miscellaneous",
    //   title: "Coding Practice Miscellaneous",
    //   description: "Introduction to Object Oriented Programming",
    //   questions: [
    //     {
    //       id: "q-python-Codingpractice-32-001",
    //       title: "Car",
    //       difficulty: "Easy",
    //       description:
    //         "complete the given Car class by adding new features by following the given Instructions.\nExisting car Class:\nThe existing Car class has only a pass Statement.Remove pass statement and add the new features as mentioned in the given Instructions.\nFeatures to be added to car class.\nPoints to Note:\nThe output of the testCase checking default Tests is given by the default_test function in the prefilled code.\nThis coding question does not have the usual input/output testcases.The class defined by you will be tested internally whether the attributes are present or not.So in testcases results you will be shown the rough description of the tests that will be verified.",
    //       sampleInput: "Checking default Tests",
    //       sampleOutput: "Red\n250\n10\n3",
    //       testCases: [{ input: "", output: "Red\n250\n10\n3", visible: true }],
    //       defaultCode: ``,
    //       score: 40,
    //       status: "unsolved",
    //       attempts: [],
    //     },
    //     {
    //       id: "q-python-Codingpractice-32-002",
    //       title: "Car - 2",
    //       difficulty: "Easy",
    //       description:
    //         "complete the given Car class by adding new features according to the Instructions provided.\nExisting car Class:\nIn the Previous question,you added the attributes below to the Car class:\ncolor,\nmax_speed,\nacceleration,\ntyre_friction.\nNow,let's add a few more new features to the car class.\nFeatures to be added to the car class.\nNote:You can copy the code from the Previous question and add new features on top of that code.",
    //       sampleInput: "Checking default Tests",
    //       sampleOutput: "False\nTrue\nFalse",
    //       testCases: [
    //         { input: "", output: "False\nTrue\nFalse", visible: true },
    //       ],
    //       defaultCode: ``,
    //       score: 40,
    //       status: "unsolved",
    //       attempts: [],
    //     },
    //     {
    //       id: "q-python-Codingpractice-32-003",
    //       title: "Car - 3",
    //       difficulty: "Easy",
    //       description:
    //         "complete the given Car class by adding new features by following the given Instructions.\nExisting car Class:\nIn the Previous question,you have added the attributes and methods below in the car class.\nATTRIBUTES:\ncolor\nmax_speed\nacceleration\ntyre_friction\nis_engine_started\nMETHODS\nstart_engine\nstop_engine\nNowc,let's add a few new features to the car class.\nNote:You can copy the code from the Previous question and add new features on top of that code.",
    //       sampleInput: "Checking default Tests",
    //       sampleOutput: "Car has not started yet\n0\n10\n20\n30\n40\n50",
    //       testCases: [
    //         {
    //           input: "",
    //           output: "Car has not started yet\n0\n10\n20\n30\n40\n50",
    //           visible: true,
    //         },
    //       ],
    //       defaultCode: ``,
    //       score: 40,
    //       status: "unsolved",
    //       attempts: [],
    //     },
    //   ],
    // },
    // //OOPS CORE END

    {
      id: "Codingpractice-python-32",
      title: "Codingpractice-32",
      description: "Introduction to Object Oriented Programming",
      questions: [
        {
          accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-32-001",
          title: "Car",
          difficulty: "Easy",
          description:
            "complete the given Car class by adding new features by following the given Instructions.\nExisting car Class:\nThe existing Car class has only a pass Statement.Remove pass statement and add the new features as mentioned in the given Instructions.\nFeatures to be added to car class.\nPoints to Note:\nThe output of the testCase checking default Tests is given by the default_test function in the prefilled code.\nThis coding question does not have the usual input/output testcases.The class defined by you will be tested internally whether the attributes are present or not.So in testcases results you will be shown the rough description of the tests that will be verified.",
          sampleInput: "Checking default Tests",
          sampleOutput: "Red\n250\n10\n3",
          testCases: [{ input: "", output: "Red\n250\n10\n3", visible: true }],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-32-002",
          title: "Car - 2",
          difficulty: "Easy",
          description:
            "complete the given Car class by adding new features according to the Instructions provided.\nExisting car Class:\nIn the Previous question,you added the attributes below to the Car class:\ncolor,\nmax_speed,\nacceleration,\ntyre_friction.\nNow,let's add a few more new features to the car class.\nFeatures to be added to the car class.\nNote:You can copy the code from the Previous question and add new features on top of that code.",
          sampleInput: "Checking default Tests",
          sampleOutput: "False\nTrue\nFalse",
          testCases: [
            { input: "", output: "False\nTrue\nFalse", visible: true },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-32-003",
          title: "Car - 3",
          difficulty: "Easy",
          description:
            "complete the given Car class by adding new features by following the given Instructions.\nExisting car Class:\nIn the Previous question,you have added the attributes and methods below in the car class.\nATTRIBUTES:\ncolor\nmax_speed\nacceleration\ntyre_friction\nis_engine_started\nMETHODS\nstart_engine\nstop_engine\nNowc,let's add a few new features to the car class.\nNote:You can copy the code from the Previous question and add new features on top of that code.",
          sampleInput: "Checking default Tests",
          sampleOutput: "Car has not started yet\n0\n10\n20\n30\n40\n50",
          testCases: [
            {
              input: "",
              output: "Car has not started yet\n0\n10\n20\n30\n40\n50",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-33",
      title: "Codingpractice-33",
      description: "Introduction to Object Oriented Programming",
      questions: [
        {
          id: "q-python-Codingpractice-33-001",
          title: "Truck",
          difficulty: "Easy",
          description:
            "complete the given Car and truck classes by adding new features by following the given Instructions.\nA Truck is a Car but with additional behaviours.Inherit the Car class into Truck class and add new features.\nExisting car class.\nFeatures to be added to the truck class.",
          sampleInput: "Checking default Tests",
          sampleOutput:
            "False\n50\n25\n0\nCannot load cargo more than max limit: 100\nTrue\nCannot load cargo during motion\nCannot unload cargo during motion\nHonk Honk\nCar has not started yet",
          testCases: [
            {
              input: "",
              output:
                "False\n50\n25\n0\nCannot load cargo more than max limit: 100\nTrue\nCannot load cargo during motion\nCannot unload cargo during motion\nHonk Honk\nCar has not started yet",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-33-002",
          title: "Race Car",
          difficulty: "Easy",
          description:
            "Now we need a Race Car in our cars world.\nYou are given two incomplete classes Car and RaceCar.\nA RaceCar is a Car but with the additional behaviours.\nInherit the Car class into RaceCar class and build the additional features.\nGo through the comments in the prefilled code to implement the car and RaceCar classes with the described attributes and methods.",
          sampleInput: "Checking default Tests",
          sampleOutput:
            "140\n2\n250\n1\n250\n0\n220\n0\n250\n0\nPeep Peep\nBeep Beep",
          testCases: [
            {
              input: "",
              output:
                "140\n2\n250\n1\n250\n0\n220\n0\n250\n0\nPeep Peep\nBeep Beep",
              visible: true,
            },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Codingpractice-python-34",
      title: "Codingpractice-34",
      description: "Miscellaneous Topics",
      questions: [
        {
          id: "q-python-Codingpractice-34-001",
          title: "Parsing Datetime",
          difficulty: "Easy",
          description:
            "Write a program to convert the date in the given string format to a Datetime object.The date in string format is like `8 Feb 2021`.",
          sampleInput: "29 Feb 2024",
          sampleOutput: "2024-02-29 00:00:00",
          testCases: [
            {
              input: "15 Aug 2023",
              output: "2023-08-15 00:00:00",
              visible: true,
            },
            {
              input: "01 Jan 2020",
              output: "2020-01-01 00:00:00",
              visible: true,
            },
            {
              input: "31 Dec 1999",
              output: "1999-12-31 00:00:00",
              visible: false,
            },
            {
              input: "29 Feb 2024",
              output: "2024-02-29 00:00:00",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-Codingpractice-34-002",
          title: "Formatting Datetime",
          difficulty: "Easy",
          description:
            "Write a program to convert the date in string format to another string format.\nThe input date string format is like `jul 01 2014 02:43PM`\nThe output date string format should be like `DD/MM/YYYY HH:MM:SS`.",
          sampleInput: "Feb 29 2024 01:05AM",
          sampleOutput: "29/02/2024 01:05:00",
          testCases: [
            {
              input: "Aug 15 2023 02:30PM",
              output: "15/08/2023 14:30:00",
              visible: true,
            },
            {
              input: "Jan 01 2020 12:00AM",
              output: "01/01/2020 00:00:00",
              visible: true,
            },
            {
              input: "Dec 31 1999 11:59PM",
              output: "31/12/1999 23:59:00",
              visible: false,
            },
            {
              input: "Feb 29 2024 01:05AM",
              output: "29/02/2024 01:05:00",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-34-003",
          title: "Print Dates",
          difficulty: "Easy",
          description:
            "Write a program to print the previous day of D,the current day D,and the next day of D.\nThe date in string format is like `8 Feb 2021`.",
          sampleInput: "29 Feb 2024",
          sampleOutput:
            "2024-02-28 00:00:00\n2024-02-29 00:00:00\n2024-03-01 00:00:00",
          testCases: [
            {
              input: "15 Aug 2023",
              output:
                "2023-08-14 00:00:00\n2023-08-15 00:00:00\n2023-08-16 00:00:00",
              visible: true,
            },
            {
              input: "01 Jan 2020",
              output:
                "2019-12-31 00:00:00\n2020-01-01 00:00:00\n2020-01-02 00:00:00",
              visible: true,
            },
            {
              input: "31 Dec 1999",
              output:
                "1999-12-30 00:00:00\n1999-12-31 00:00:00\n2000-01-01 00:00:00",
              visible: false,
            },
            {
              input: "29 Feb 2024",
              output:
                "2024-02-28 00:00:00\n2024-02-29 00:00:00\n2024-03-01 00:00:00",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-34-004",
          title: "Name of the Weekday",
          difficulty: "Easy",
          description:
            "Write a program to print the name of the weekday of a given date.\nThe date in string format is like `8 Feb 2021`.",
          sampleInput: "31 Dec 1999",
          sampleOutput: "Friday",
          testCases: [
            { input: "15 Aug 2023", output: "Tuesday", visible: true },
            { input: "01 Jan 2020", output: "Wednesday", visible: true },
            { input: "31 Dec 1999", output: "Friday", visible: false },
            { input: "29 Feb 2024", output: "Thursday", visible: false },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Codingpractice-34-005",
          title: "Count of Mondays",
          difficulty: "Medium",
          description:
            "You are given two years A and B.\nWrite a program to count the number of mondays M,which is the 1st day of the month from year A to year B(including B).",
          sampleInput: "2000 2000",
          sampleOutput: "1",
          testCases: [
            { input: "2023 2023", output: "1", visible: true },

            { input: "2020 2021", output: "4", visible: true },

            { input: "2016 2016", output: "2", visible: false },

            { input: "2019 2022", output: "7", visible: false },

            { input: "2000 2005", output: "10", visible: false },
          ],
          defaultCode: ``,
          score: 45,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Python-Grand-Assignment-5",
      title: "Grand-Assignment-5",
      description: "Miscellaneous Topics",
      questions: [
        {
          id: "q-python-Grand-Assignment-5-001",
          title: "Weekends",
          difficulty: "Easy",
          description:
            "Given two dates D1 and D2,write a program to count the number of saturdays and sundays from D1 to D2(including D1 and D2).\nThe date in string format is like `8 Feb 2021`.",
          sampleInput: "29 Feb 2024\n29 Feb 2024",
          sampleOutput: "Saturday: 0\nSunday: 0",
          testCases: [
            {
              input: "01 Jan 2023\n31 Jan 2023",
              output: "Saturday: 4\nSunday: 5",
              visible: true,
            },
            {
              input: "01 Aug 2023\n31 Aug 2023",
              output: "Saturday: 4\nSunday: 4",
              visible: true,
            },
            {
              input: "25 Dec 2023\n31 Dec 2023",
              output: "Saturday: 1\nSunday: 1",
              visible: false,
            },
            {
              input: "29 Feb 2024\n29 Feb 2024",
              output: "Saturday: 0\nSunday: 0",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Grand-Assignment-5-002",
          title: "New Year countdown",
          difficulty: "Easy",
          description:
            "Given date-time D,write a program to print the time left for the next new year.",
          sampleInput: "Dec 31 2020 11:30 PM",
          sampleOutput: "0 hours 30 minutes",
          testCases: [
            {
              input: "Jan 01 2021 12:00 AM",
              output: "0 hours 0 minutes",
              visible: true,
            },
            {
              input: "Dec 31 2020 11:00 PM",
              output: "1 hours 0 minutes",
              visible: true,
            },
            {
              input: "Dec 31 2020 10:30 PM",
              output: "1 hours 30 minutes",
              visible: false,
            },
            {
              input: "Dec 30 2020 12:00 AM",
              output: "48 hours 0 minutes",
              visible: false,
            },
            {
              input: "Jan 01 2020 12:00 AM",
              output: "8784 hours 0 minutes",
              visible: false,
            },
          ],
          defaultCode: ``,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
          id: "q-python-Grand-Assignment-5-003",
          title: "smallest missing number",
          difficulty: "Easy",
          description:
            "Given a list of numbers,write a program to print the smallest positive integer missing in the given numbers.",
          sampleInput: "1 2 4 6",
          sampleOutput: "3",
          testCases: [
            { input: "2 3 4", output: "1", visible: true },
            { input: "1 3 4 5", output: "2", visible: true },
            { input: "1 2 4 6", output: "3", visible: false },
          ],
          defaultCode: ``,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
      ],
    },

    {
      accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
      id: "Coding-practice-python-OOPCore-01",
      title: "Coding Practice OOP Core 01",
      description: "Foundations of Object-Oriented Programming",
      questions: [
        {
          id: "q-python-OOPCore-001",
          title: "Create a Class",
          difficulty: "Easy",
          description:
            "Write a program to create a class named Mobile with attributes model and camera. Create an object and print both attributes.",
          sampleInput: "iPhone 12 12MP",
          sampleOutput: "Model: iPhone 12\nCamera: 12MP",
          testCases: [
            {
              input: "Galaxy M51 64MP",
              output: "Model: Galaxy M51\nCamera: 64MP",
              visible: true,
            },
            {
              input: "Redmi Note 10 48MP",
              output: "Model: Redmi Note 10\nCamera: 48MP",
              visible: true,
            },
            {
              input: "Pixel 7 50MP",
              output: "Model: Pixel 7\nCamera: 50MP",
              visible: false,
            },
          ],

          defaultCode: `
# Read input
data = input().split()

camera = data[-1]              # last value
model = " ".join(data[:-1])    # remaining values

class Mobile:
    # Write your code here

# Create object
mobile = Mobile(model, camera)

# Print output
print("Model:", mobile.model)
print("Camera:", mobile.camera)



          `,
          score: 30,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-OOP-002",
          title: "Calling Class Method",
          difficulty: "Easy",
          description:
            "Write a program to create a class Car with attributes brand and model. Add a method display_info() that prints brand and model.",
          sampleInput: "Toyota Corolla",
          sampleOutput: "Toyota Corolla",
          testCases: [
            {
              input: "Honda Civic",
              output: "Honda Civic",
              visible: true,
            },
            {
              input: "Hyundai Creta",
              output: "Hyundai Creta",
              visible: true,
            },
            {
              input: "Tata Nexon",
              output: "Tata Nexon",
              visible: false,
            },
            {
              input: "Toyota Fortuner",
              output: "Toyota Fortuner",
              visible: false,
            },
          ],

          defaultCode: `
# Read input
data = input().split()

model = data[-1]              # last word
brand = " ".join(data[:-1])   # remaining words

class Car:
    # Write your code here
    

# Create object
car = Car(brand, model)

# Call method
car.display_info()
`,
          score: 40,
          status: "unsolved",
          attempts: [],
        },

        {
          id: "q-python-OOP-003",
          title: "Update Attribute Value",
          difficulty: "Easy",
          description:
            "Write a program to create a class Car with attribute model. Add a method update_model(new_model) to update the model and print updated value.",
          sampleInput: "Corolla Camry",
          sampleOutput: "Camry",
          testCases: [
            {
              input: "Civic Accord",
              output: "Accord",
              visible: true,
            },
            {
              input: "Swift Baleno",
              output: "Baleno",
              visible: false,
            },
            {
              input: "Altroz Punch",
              output: "Punch",
              visible: false,
            },
          ],
          defaultCode: `
# Read input
input_data = input().split()

old_model = input_data[0]
new_model = input_data[1]

class Car:
    def __init__(self, model):
        self.model = model

    # Write your code here
        


car = Car(old_model)
car.update_model(new_model)
          
          `,
          score: 35,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-OOP-004",
          title: "Object Identity",
          difficulty: "Medium",
          description:
            "Write a program to create two objects of class Mobile and print their unique identities using id().",
          sampleInput: "iPhone 12 12MP\nGalaxy M51 64MP",
          sampleOutput: "Different IDs",
          testCases: [
            {
              input: "Redmi 10 48MP\nRealme 8 64MP",
              output: "Different IDs",
              visible: true,
            },
            {
              input: "Pixel 6 50MP\nPixel 7 50MP",
              output: "Different IDs",
              visible: true,
            },
            {
              input: "Moto G 48MP\nNokia 7 48MP",
              output: "Different IDs",
              visible: false,
            },
            {
              input: "OnePlus 11 50MP\nOnePlus 12 50MP",
              output: "Different IDs",
              visible: false,
            },
          ],
          defaultCode: `
# Read input
mobile1 = input()
mobile2 = input()

class Mobile:
    def __init__(self, details):
        self.details = details

# Create two objects
m1 = Mobile(mobile1)
m2 = Mobile(mobile2)

# Write your code here


`,
          score: 45,
          status: "unsolved",
          attempts: [],
        },

        {
          id: "q-python-OOP-005",
          title: "Shopping Cart Total",
          difficulty: "Medium",
          description:
            "Create a class Cart that stores items with price and quantity. Add items and print total price.\nHINT: total = total + (price × quantity)",
          sampleInput: "Laptop 50000 1\nMouse 500 2",
          sampleOutput: "51000",
          testCases: [
            {
              input: "Keyboard 1500 1\nMouse 500 1",
              output: "2000",
              visible: true,
            },
            {
              input: "Monitor 12000 2\nCable 500 2",
              output: "25000",
              visible: true,
            },
            {
              input: "Tablet 20000 1\nCover 1000 2",
              output: "22000",
              visible: false,
            },
            {
              input: "Phone 15000 1\nCharger 1000 1",
              output: "16000",
              visible: false,
            },
          ],

          defaultCode: `
# Read input
item1 = input().split()
item2 = input().split()

class Cart:
    def __init__(self):
        self.total = 0

    def add_item(self, price, quantity):
        # write code here
       

    def print_total(self):
        # write code here
        

      
# Create object
cart = Cart()

# Add items
cart.add_item(int(item1[1]), int(item1[2]))
cart.add_item(int(item2[1]), int(item2[2]))

# Print total
cart.print_total()
      
`,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
    {
      id: "Coding-practice-python-Miscellaneous-Core",
      title: "Coding practice Miscellaneous",
      description: "Miscellaneous",
      questions: [
        {
          id: "q-python-INH-001",
          title: "Basic Inheritance",
          difficulty: "Easy",
          description:
            "Create a base class Product with attribute price. Create a child class Electronic that inherits Product and prints the price.",
          sampleInput: "45000",
          sampleOutput: "Price: 45000",
          testCases: [
            {
              input: "30000",
              output: "Price: 30000",
              visible: true,
            },
            {
              input: "15000",
              output: "Price: 15000",
              visible: true,
            },
            {
              input: "60000",
              output: "Price: 60000",
              visible: false,
            },
          ],
          defaultCode: `
# Read input
price = int(input())

class Product:
    def __init__(self, price):
        self.price = price

class Electronic(Product):
    # Write your code here
    


# Create object
item = Electronic(price)
item.display_price()
          
`,
          score: 40,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-INH-002",
          title: "Method Overriding",
          difficulty: "Medium",
          description:
            "Create a parent class Product with method display(). Override it in child class Grocery to print 'Grocery Item'.",
          sampleInput: "Rice",
          sampleOutput: "Grocery Item",
          testCases: [
            {
              input: "Wheat",
              output: "Grocery Item",
              visible: true,
            },
            {
              input: "Sugar",
              output: "Grocery Item",
              visible: true,
            },
            {
              input: "Salt",
              output: "Grocery Item",
              visible: false,
            },
            {
              input: "Rice",
              output: "Grocery Item",
              visible: false,
            },
            {
              input: "Oil",
              output: "Grocery Item",
              visible: false,
            },
          ],
          defaultCode: `
# Read input
item = input()

class Product:
    def display(self):
        print("Product")

class Grocery(Product):
    # Write your code here
    

g = Grocery()
g.display()
        `,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-INH-003",
          title: "Multi-Level Inheritance",
          difficulty: "Medium",
          description:
            "Create a class Product. Create Electronic inheriting Product. Create Mobile inheriting Electronic. Print 'Mobile Product'.",
          sampleInput: "iPhone",
          sampleOutput: "Mobile Product",
          testCases: [
            {
              input: "Samsung",
              output: "Mobile Product",
              visible: true,
            },
            {
              input: "OnePlus",
              output: "Mobile Product",
              visible: true,
            },
            {
              input: "Pixel",
              output: "Mobile Product",
              visible: false,
            },
          ],
          defaultCode: `
# Read input
name = input()

class Product:
    pass

class Electronic(Product):
    pass

class Mobile(Electronic):
    # Write your code here
    

m = Mobile()
m.show()
        `,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-COMP-004",
          title: "Composition Example",
          difficulty: "Medium",
          description:
            "Create a class Engine with attribute power. Create a class Car that HAS an Engine and prints engine power.",
          sampleInput: "150",
          sampleOutput: "Engine Power: 150",
          testCases: [
            {
              input: "120",
              output: "Engine Power: 120",
              visible: true,
            },
            {
              input: "200",
              output: "Engine Power: 200",
              visible: true,
            },
            {
              input: "300",
              output: "Engine Power: 300",
              visible: false,
            },
            {
              input: "180",
              output: "Engine Power: 180",
              visible: false,
            },
            {
              input: "250",
              output: "Engine Power: 250",
              visible: false,
            },
          ],
          defaultCode: `
# Read input
power = int(input())

class Engine:
    def __init__(self, power):
        self.power = power

class Car:
    def __init__(self, engine):
        self.engine = engine

    # Write your code here
    

engine = Engine(power)
car = Car(engine)
car.show_power()
        `,
          score: 50,
          status: "unsolved",
          attempts: [],
        },
        {
          id: "q-python-LIB-005",
          title: "Math Library",
          difficulty: "Easy",
          description:
            "Use math module to print square root of a given number.",
          sampleInput: "25",
          sampleOutput: "5.0",
          testCases: [
            {
              input: "16",
              output: "4.0",
              visible: true,
            },
            {
              input: "36",
              output: "6.0",
              visible: true,
            },
          ],
          defaultCode: `
import math  # You must import the math module

# Read input
num = int(input())

# Write your code here

        `,
          score: 20,
          status: "unsolved",
          attempts: [],
        },
      ],
    },
  ],
};
